// tslint:disable
/**
 * CEB Tablet Banking MW
 * CEB Tablet Banking MW API 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountInfoData
 */
export interface AccountInfoData {
    /**
     * branch code
     * @type {string}
     * @memberof AccountInfoData
     */
    branchCode: string;
    /**
     * Account Number
     * @type {string}
     * @memberof AccountInfoData
     */
    accountNumber: string;
    /**
     * Opening Date
     * @type {string}
     * @memberof AccountInfoData
     */
    openingDate: string;
    /**
     * Closing Date
     * @type {string}
     * @memberof AccountInfoData
     */
    closingDate?: string;
    /**
     * Currency Code
     * @type {string}
     * @memberof AccountInfoData
     */
    currency: string;
    /**
     * Summa
     * @type {string}
     * @memberof AccountInfoData
     */
    summa: string;
    /**
     * Manager Name
     * @type {string}
     * @memberof AccountInfoData
     */
    managerName?: string;
    /**
     * Channel
     * @type {string}
     * @memberof AccountInfoData
     */
    channel: string;
    /**
     * Account OID
     * @type {string}
     * @memberof AccountInfoData
     */
    accountOID: string;
    /**
     * Balance
     * @type {string}
     * @memberof AccountInfoData
     */
    balance: string;
    /**
     * Account Sub Type
     * @type {string}
     * @memberof AccountInfoData
     */
    accountSubType: string;
    /**
     * Account Type
     * @type {string}
     * @memberof AccountInfoData
     */
    accountType: string;
}
/**
 * 
 * @export
 * @interface AdditionalJobInfoResponse
 */
export interface AdditionalJobInfoResponse extends Response {
    /**
     * company name
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    companyName?: string;
    /**
     * job title code
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    jobTitleCode?: string;
    /**
     * occupation code
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    occupationCode?: string;
    /**
     * job sector code
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    jobSectorCode?: string;
    /**
     * business line code
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    businessLineCode?: string;
    /**
     * employee number code
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    employeeNumberCode?: string;
    /**
     * number of work places for last 3 years
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    jobNumberForLast3Years?: string;
    /**
     * true if state is checked
     * @type {boolean}
     * @memberof AdditionalJobInfoResponse
     */
    isGovernmentOrganisation?: boolean;
    /**
     * limit amount
     * @type {number}
     * @memberof AdditionalJobInfoResponse
     */
    requestedLimit?: number;
    /**
     * income
     * @type {number}
     * @memberof AdditionalJobInfoResponse
     */
    income?: number;
    /**
     * other income
     * @type {number}
     * @memberof AdditionalJobInfoResponse
     */
    otherIncome?: number;
    /**
     * 1 if 2Ndfl Certificate is provided
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    is2NdflCertificateProvided?: string;
    /**
     * Beginning month of current work
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    currentWorkBeginningMonth?: string;
    /**
     * Beginning year of current work
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    currentWorkBeginningYear?: string;
    /**
     * Beginning month of work life
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    workLifeBeginningMonth?: string;
    /**
     * Beginning year of current year
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    workLifeBeginningYear?: string;
    /**
     * Work INN
     * @type {string}
     * @memberof AdditionalJobInfoResponse
     */
    workInn?: string;
}
/**
 * 
 * @export
 * @interface AddressData
 */
export interface AddressData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressData
     */
    country?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressData
     */
    region?: DictionaryLine;
    /**
     * city
     * @type {string}
     * @memberof AddressData
     */
    city?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressData
     */
    district?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressData
     */
    streetType?: DictionaryLine;
    /**
     * Street
     * @type {string}
     * @memberof AddressData
     */
    street?: string;
    /**
     * House Number
     * @type {string}
     * @memberof AddressData
     */
    houseNumber?: string;
    /**
     * Building Info
     * @type {string}
     * @memberof AddressData
     */
    buildingInfo?: string;
    /**
     * ZipCode
     * @type {string}
     * @memberof AddressData
     */
    zipCode?: string;
    /**
     * Flat Number
     * @type {string}
     * @memberof AddressData
     */
    flatNumber?: string;
}
/**
 * 
 * @export
 * @interface AddressPageData
 */
export interface AddressPageData {
    /**
     * 
     * @type {Array<AddressPageRowData>}
     * @memberof AddressPageData
     */
    adressList?: Array<AddressPageRowData>;
}
/**
 * 
 * @export
 * @interface AddressPageDataResponse
 */
export interface AddressPageDataResponse extends Response {
    /**
     * 
     * @type {AddressPageData}
     * @memberof AddressPageDataResponse
     */
    pageData?: AddressPageData;
}
/**
 * 
 * @export
 * @interface AddressPageRowData
 */
export interface AddressPageRowData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressPageRowData
     */
    addressType: DictionaryLine;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof AddressPageRowData
     */
    isRegistration: boolean;
    /**
     * Address Query of Fias
     * @type {string}
     * @memberof AddressPageRowData
     */
    addressQuery?: string;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof AddressPageRowData
     */
    manualAddress?: boolean;
    /**
     * Registration Date
     * @type {string}
     * @memberof AddressPageRowData
     */
    registrationDate: string;
    /**
     * 
     * @type {AddressData}
     * @memberof AddressPageRowData
     */
    selectedSuggestion?: AddressData;
    /**
     * Address Id
     * @type {string}
     * @memberof AddressPageRowData
     */
    addressId?: string;
    /**
     * Flat Number
     * @type {string}
     * @memberof AddressPageRowData
     */
    flatNumber?: string;
    /**
     * true if address is new
     * @type {boolean}
     * @memberof AddressPageRowData
     */
    isAddressNew?: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressPageRowData
     */
    country: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressPageRowData
     */
    region: DictionaryLine;
    /**
     * city
     * @type {string}
     * @memberof AddressPageRowData
     */
    city: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressPageRowData
     */
    district?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressPageRowData
     */
    streetType: DictionaryLine;
    /**
     * Street
     * @type {string}
     * @memberof AddressPageRowData
     */
    street?: string;
    /**
     * House Number
     * @type {string}
     * @memberof AddressPageRowData
     */
    houseNumber?: string;
    /**
     * Building Info
     * @type {string}
     * @memberof AddressPageRowData
     */
    buildingInfo?: string;
    /**
     * ZipCode
     * @type {string}
     * @memberof AddressPageRowData
     */
    zipCode?: string;
    /**
     * true if address is correspondence
     * @type {boolean}
     * @memberof AddressPageRowData
     */
    hasCorrespondenceFlag: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof AddressPageRowData
     */
    addressHomeOwnerType?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface AllAccountObservationRequest
 */
export interface AllAccountObservationRequest extends PaginationRequest {
    /**
     * Customer Id
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    customerId: string;
    /**
     * AccountNumber
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    accountNumber?: string;
    /**
     * AccountState
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    accountState?: string;
    /**
     * AccountType
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    accountType?: string;
    /**
     * Branch Code
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    branchCode?: string;
    /**
     * Currency
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    currency?: string;
    /**
     * AccountMask
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    accountMask?: string;
    /**
     * Channel Code
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    channelCode?: string;
    /**
     * Date
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    openingDateFrom?: string;
    /**
     * Date
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    openingDateTo?: string;
    /**
     * Date
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    closingDateFrom?: string;
    /**
     * Date
     * @type {string}
     * @memberof AllAccountObservationRequest
     */
    closingDateTo?: string;
}
/**
 * 
 * @export
 * @interface AllAccountObservationResponse
 */
export interface AllAccountObservationResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<AccountInfoData>}
     * @memberof AllAccountObservationResponse
     */
    accountInfoList: Array<AccountInfoData>;
}
/**
 * 
 * @export
 * @interface ApplicationDocumentPageData
 */
export interface ApplicationDocumentPageData {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof ApplicationDocumentPageData
     */
    documentUploadDataList?: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface ApplicationDocumentPageDataResponse
 */
export interface ApplicationDocumentPageDataResponse extends Response {
    /**
     * 
     * @type {ApplicationDocumentPageData}
     * @memberof ApplicationDocumentPageDataResponse
     */
    pageData?: ApplicationDocumentPageData;
}
/**
 * 
 * @export
 * @interface ApplicationInfoPageData
 */
export interface ApplicationInfoPageData {
    /**
     * true if checked
     * @type {boolean}
     * @memberof ApplicationInfoPageData
     */
    isNewAccount?: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ApplicationInfoPageData
     */
    customerAccount?: DictionaryLine;
    /**
     * true if checked
     * @type {boolean}
     * @memberof ApplicationInfoPageData
     */
    isNoNameCard?: boolean;
    /**
     * Name on the Card
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    cardEmbossedName?: string;
    /**
     * The Unique Card Number
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    cardNumber?: string;
    /**
     * Last 4 Digits
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    lastFourDigits?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ApplicationInfoPageData
     */
    promotionName?: DictionaryLine;
    /**
     * Number of Promotion Days
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    promotionDaysNumber?: string;
    /**
     * Salary Company Code
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    salaryCompanyCode?: string;
    /**
     * Delivery Channel Code
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    deliveryChannelCode?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ApplicationInfoPageData
     */
    branch: DictionaryLine;
    /**
     * Metro Card Number
     * @type {string}
     * @memberof ApplicationInfoPageData
     */
    metroCardNumber?: string;
    /**
     * Consent to the request to the BKI
     * @type {boolean}
     * @memberof ApplicationInfoPageData
     */
    consentBik?: boolean;
    /**
     * true if checked
     * @type {boolean}
     * @memberof ApplicationInfoPageData
     */
    agreementToMarketing?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationInfoPageDataResponse
 */
export interface ApplicationInfoPageDataResponse extends Response {
    /**
     * 
     * @type {ApplicationInfoPageData}
     * @memberof ApplicationInfoPageDataResponse
     */
    pageData?: ApplicationInfoPageData;
}
/**
 * 
 * @export
 * @interface BackOfficePosResponse
 */
export interface BackOfficePosResponse extends Response {
    /**
     * true if pos is for back office
     * @type {boolean}
     * @memberof BackOfficePosResponse
     */
    isBackOfficePos?: boolean;
}
/**
 * 
 * @export
 * @interface BenefitsThirdPartyData
 */
export interface BenefitsThirdPartyData {
    /**
     * beneficiary name
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    beneficiaryName: string;
    /**
     * birth place
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    birthPlace: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    birthDate: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof BenefitsThirdPartyData
     */
    identityType: DictionaryLine;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    identityDocumentSerialCode: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    identityDocumentSerialNumber: string;
    /**
     * Issue Date
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    issueDate: string;
    /**
     * Issued By
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    issuedBy: string;
    /**
     * Code of Issue Place
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    unitCode: string;
    /**
     * Given Country
     * @type {string}
     * @memberof BenefitsThirdPartyData
     */
    inn: string;
}
/**
 * 
 * @export
 * @interface BenefitsThirdPartyPageData
 */
export interface BenefitsThirdPartyPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof BenefitsThirdPartyPageData
     */
    hasBenefitsThirdParty: DictionaryLine;
    /**
     * 
     * @type {BenefitsThirdPartyData}
     * @memberof BenefitsThirdPartyPageData
     */
    benefitsThirdParty?: BenefitsThirdPartyData;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof BenefitsThirdPartyPageData
     */
    hasControlPerson: DictionaryLine;
    /**
     * 
     * @type {BenefitsThirdPartyData}
     * @memberof BenefitsThirdPartyPageData
     */
    controlPerson?: BenefitsThirdPartyData;
}
/**
 * 
 * @export
 * @interface BenefitsThirdPartyPageDataResponse
 */
export interface BenefitsThirdPartyPageDataResponse extends Response {
    /**
     * 
     * @type {BenefitsThirdPartyPageData}
     * @memberof BenefitsThirdPartyPageDataResponse
     */
    pageData?: BenefitsThirdPartyPageData;
}
/**
 * 
 * @export
 * @interface CallCenterInfoRBSAgreementBlockUserRequest
 */
export interface CallCenterInfoRBSAgreementBlockUserRequest {
    /**
     * Reason For Blocking Access
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementBlockUserRequest
     */
    reasonForBlockingAccess: string;
    /**
     * Comment
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementBlockUserRequest
     */
    comment: string;
}
/**
 * 
 * @export
 * @interface CallCenterInfoRBSAgreementBlockUserResponse
 */
export interface CallCenterInfoRBSAgreementBlockUserResponse extends Response {
}
/**
 * 
 * @export
 * @interface CallCenterInfoRBSAgreementSearchAccessInfoData
 */
export interface CallCenterInfoRBSAgreementSearchAccessInfoData {
    /**
     * Process Date
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoData
     */
    date: string;
    /**
     * Process Time
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoData
     */
    time: string;
    /**
     * Ip Number
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoData
     */
    ip: string;
    /**
     * Login Result
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoData
     */
    loginResult: string;
}
/**
 * 
 * @export
 * @interface CallCenterInfoRBSAgreementSearchAccessInfoRequest
 */
export interface CallCenterInfoRBSAgreementSearchAccessInfoRequest extends PaginationRequest {
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoRequest
     */
    startDate: string;
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoRequest
     */
    endDate: string;
}
/**
 * 
 * @export
 * @interface CallCenterInfoRBSAgreementSearchAccessInfoResponse
 */
export interface CallCenterInfoRBSAgreementSearchAccessInfoResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterInfoRBSAgreementSearchAccessInfoData>}
     * @memberof CallCenterInfoRBSAgreementSearchAccessInfoResponse
     */
    accessInfoList?: Array<CallCenterInfoRBSAgreementSearchAccessInfoData>;
}
/**
 * 
 * @export
 * @interface CallCenterInfoRBSAgreementUserInfoResponse
 */
export interface CallCenterInfoRBSAgreementUserInfoResponse extends Response {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    customerId: string;
    /**
     * IB Login
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    ibLogin: string;
    /**
     * Contract Number
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    contractNumber: string;
    /**
     * Access Status
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    accessStatus: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    reasonForBlockingAccess: DictionaryLine;
    /**
     * Access Type
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    accessType: string;
    /**
     * Contract Status
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    contractStatus: string;
    /**
     * Date of Conclusion of the Contract
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    dateOfConclusionOfTheContract: string;
    /**
     * Closing Date
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    closingDate?: string;
    /**
     * Explanation
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    comment?: string;
    /**
     * Registration Date
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    registrationDate: string;
    /**
     * Salary Client
     * @type {string}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    salaryClient: string;
    /**
     * true If send button is disabled
     * @type {boolean}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    buttonDisabled?: boolean;
    /**
     * true If the block reason is disabled
     * @type {boolean}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    blockReasonDisabled?: boolean;
    /**
     * true If the comment is disabled
     * @type {boolean}
     * @memberof CallCenterInfoRBSAgreementUserInfoResponse
     */
    commentDisabled?: boolean;
}
/**
 * 
 * @export
 * @interface CallCenterInterbankCurrentAccountsRequest
 */
export interface CallCenterInterbankCurrentAccountsRequest extends PaginationRequest {
}
/**
 * 
 * @export
 * @interface CallCenterInterbankCurrentAccountsResponse
 */
export interface CallCenterInterbankCurrentAccountsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterInterbankCurrentAccountsResponseData>}
     * @memberof CallCenterInterbankCurrentAccountsResponse
     */
    accountList: Array<CallCenterInterbankCurrentAccountsResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterInterbankCurrentAccountsResponseData
 */
export interface CallCenterInterbankCurrentAccountsResponseData {
    /**
     * Account Number
     * @type {string}
     * @memberof CallCenterInterbankCurrentAccountsResponseData
     */
    accountNumber: string;
    /**
     * currency
     * @type {string}
     * @memberof CallCenterInterbankCurrentAccountsResponseData
     */
    currency: string;
    /**
     * Department Code
     * @type {string}
     * @memberof CallCenterInterbankCurrentAccountsResponseData
     */
    departmentCode: string;
    /**
     * Available Balance
     * @type {string}
     * @memberof CallCenterInterbankCurrentAccountsResponseData
     */
    availableBalance: string;
    /**
     * Status
     * @type {string}
     * @memberof CallCenterInterbankCurrentAccountsResponseData
     */
    status: string;
    /**
     * Opening Date
     * @type {string}
     * @memberof CallCenterInterbankCurrentAccountsResponseData
     */
    openingDate: string;
}
/**
 * 
 * @export
 * @interface CallCenterInterbankMoneyTransferHistoryRequest
 */
export interface CallCenterInterbankMoneyTransferHistoryRequest extends PaginationRequest {
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryRequest
     */
    startDate?: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryRequest
     */
    endDate: string;
    /**
     * Account Number
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryRequest
     */
    accountNo: string;
}
/**
 * 
 * @export
 * @interface CallCenterInterbankMoneyTransferHistoryResponse
 */
export interface CallCenterInterbankMoneyTransferHistoryResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterInterbankMoneyTransferHistoryResponseData>}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponse
     */
    transferList: Array<CallCenterInterbankMoneyTransferHistoryResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterInterbankMoneyTransferHistoryResponseData
 */
export interface CallCenterInterbankMoneyTransferHistoryResponseData {
    /**
     * Payment Date
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    paymentDate: string;
    /**
     * Creation Time
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    creationTime: string;
    /**
     * Status
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    status: string;
    /**
     * Document Number
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    documentNumber: string;
    /**
     * Direction
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    direction: string;
    /**
     * Product
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    product: string;
    /**
     * Amount
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    amount: string;
    /**
     * Recipient Account
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    recipientAccount: string;
    /**
     * Bic Recipent
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    bicRecipent: string;
    /**
     * Customer Comment
     * @type {string}
     * @memberof CallCenterInterbankMoneyTransferHistoryResponseData
     */
    customerComment: string;
}
/**
 * 
 * @export
 * @interface CallCenterInternetOperationsRequest
 */
export interface CallCenterInternetOperationsRequest extends PaginationRequest {
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterInternetOperationsRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterInternetOperationsRequest
     */
    endDate: string;
    /**
     * Operation Type Code
     * @type {string}
     * @memberof CallCenterInternetOperationsRequest
     */
    operationTypeCode?: string;
    /**
     * min amount
     * @type {number}
     * @memberof CallCenterInternetOperationsRequest
     */
    minAmount?: number;
    /**
     * limit amount
     * @type {number}
     * @memberof CallCenterInternetOperationsRequest
     */
    maxAmount?: number;
}
/**
 * 
 * @export
 * @interface CallCenterInternetOperationsResponse
 */
export interface CallCenterInternetOperationsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterInternetOperationsResponseData>}
     * @memberof CallCenterInternetOperationsResponse
     */
    operationList: Array<CallCenterInternetOperationsResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterInternetOperationsResponseData
 */
export interface CallCenterInternetOperationsResponseData {
    /**
     * Recipient
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    recipient: string;
    /**
     * Transaction Date
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    date: string;
    /**
     * Operation Type
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    operationType: string;
    /**
     * Document Code
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    document: string;
    /**
     * amount
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    amount: string;
    /**
     * Comment
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    comment: string;
    /**
     * Status
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    status: string;
    /**
     * Bank Comments
     * @type {string}
     * @memberof CallCenterInternetOperationsResponseData
     */
    bankComments: string;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankCurrentAccountsRequest
 */
export interface CallCenterIntrabankCurrentAccountsRequest extends PaginationRequest {
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankCurrentAccountsResponse
 */
export interface CallCenterIntrabankCurrentAccountsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterIntrabankCurrentAccountsResponseData>}
     * @memberof CallCenterIntrabankCurrentAccountsResponse
     */
    accountList: Array<CallCenterIntrabankCurrentAccountsResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankCurrentAccountsResponseData
 */
export interface CallCenterIntrabankCurrentAccountsResponseData {
    /**
     * Account Number
     * @type {string}
     * @memberof CallCenterIntrabankCurrentAccountsResponseData
     */
    accountNumber: string;
    /**
     * currency
     * @type {string}
     * @memberof CallCenterIntrabankCurrentAccountsResponseData
     */
    currency: string;
    /**
     * Department Code
     * @type {string}
     * @memberof CallCenterIntrabankCurrentAccountsResponseData
     */
    departmentCode: string;
    /**
     * Available Balance
     * @type {string}
     * @memberof CallCenterIntrabankCurrentAccountsResponseData
     */
    availableBalance: string;
    /**
     * Status
     * @type {string}
     * @memberof CallCenterIntrabankCurrentAccountsResponseData
     */
    status: string;
    /**
     * Opening Date
     * @type {string}
     * @memberof CallCenterIntrabankCurrentAccountsResponseData
     */
    openingDate: string;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankMoneyTransferDetailsRequest
 */
export interface CallCenterIntrabankMoneyTransferDetailsRequest extends PaginationRequest {
    /**
     * Slip
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsRequest
     */
    slip: string;
    /**
     * Reference Number
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankMoneyTransferDetailsResponse
 */
export interface CallCenterIntrabankMoneyTransferDetailsResponse extends PaginationResponse {
    /**
     * Product
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponse
     */
    product: string;
    /**
     * Product Operation
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponse
     */
    productOperation: string;
    /**
     * Application Date
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponse
     */
    applicationDate: string;
    /**
     * Transaction Date
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponse
     */
    transactionDate: string;
    /**
     * Channel
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponse
     */
    channel: string;
    /**
     * 
     * @type {Array<CallCenterIntrabankMoneyTransferDetailsResponseData>}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponse
     */
    detailTransferList: Array<CallCenterIntrabankMoneyTransferDetailsResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankMoneyTransferDetailsResponseData
 */
export interface CallCenterIntrabankMoneyTransferDetailsResponseData {
    /**
     * Account Number
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponseData
     */
    account: string;
    /**
     * Account Name
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponseData
     */
    accountName: string;
    /**
     * Currency
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponseData
     */
    currency: string;
    /**
     * Account Type
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponseData
     */
    type: string;
    /**
     * Currency Amount
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponseData
     */
    currencyAmount: string;
    /**
     * Amount
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferDetailsResponseData
     */
    amount: string;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankMoneyTransferHistoryRequest
 */
export interface CallCenterIntrabankMoneyTransferHistoryRequest extends PaginationRequest {
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryRequest
     */
    endDate: string;
    /**
     * Account Number
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryRequest
     */
    accountNo: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CallCenterIntrabankMoneyTransferHistoryRequest
     */
    accountType?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CallCenterIntrabankMoneyTransferHistoryRequest
     */
    product?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankMoneyTransferHistoryResponse
 */
export interface CallCenterIntrabankMoneyTransferHistoryResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterIntrabankMoneyTransferHistoryResponseData>}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponse
     */
    transferList: Array<CallCenterIntrabankMoneyTransferHistoryResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankMoneyTransferHistoryResponseData
 */
export interface CallCenterIntrabankMoneyTransferHistoryResponseData {
    /**
     * Document Number
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    documentNumber: string;
    /**
     * Transaction Date
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    transactionDate: string;
    /**
     * Loan Account Number
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    loanAccountNumber: string;
    /**
     * Comment
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    comment: string;
    /**
     * Debit Turnover
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    debitTurnover: string;
    /**
     * Loan Amount
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    loanAmount: string;
    /**
     * Reduced Value
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    reducedValue: string;
    /**
     * Slip
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    slip: string;
    /**
     * Reference Number
     * @type {string}
     * @memberof CallCenterIntrabankMoneyTransferHistoryResponseData
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface CallCenterIntrabankProductComboResponse
 */
export interface CallCenterIntrabankProductComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof CallCenterIntrabankProductComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface CallCenterLogScreenRequest
 */
export interface CallCenterLogScreenRequest {
    /**
     * Screen Code
     * @type {string}
     * @memberof CallCenterLogScreenRequest
     */
    screenCode: string;
}
/**
 * 
 * @export
 * @interface CallCenterLogScreenResponse
 */
export interface CallCenterLogScreenResponse extends Response {
}
/**
 * 
 * @export
 * @interface CallCenterMobileOperationLogsRequest
 */
export interface CallCenterMobileOperationLogsRequest extends PaginationRequest {
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterMobileOperationLogsRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterMobileOperationLogsRequest
     */
    endDate: string;
    /**
     * Operation Type Code
     * @type {string}
     * @memberof CallCenterMobileOperationLogsRequest
     */
    operationTypeCode?: string;
    /**
     * Operation Status Code
     * @type {string}
     * @memberof CallCenterMobileOperationLogsRequest
     */
    operationStatusCode?: string;
}
/**
 * 
 * @export
 * @interface CallCenterMobileOperationLogsResponse
 */
export interface CallCenterMobileOperationLogsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterMobileOperationLogsResponseData>}
     * @memberof CallCenterMobileOperationLogsResponse
     */
    operationLogList: Array<CallCenterMobileOperationLogsResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterMobileOperationLogsResponseData
 */
export interface CallCenterMobileOperationLogsResponseData {
    /**
     * Operation Type
     * @type {string}
     * @memberof CallCenterMobileOperationLogsResponseData
     */
    operationType: string;
    /**
     * Operation Status
     * @type {string}
     * @memberof CallCenterMobileOperationLogsResponseData
     */
    operationStatus: string;
    /**
     * Message
     * @type {string}
     * @memberof CallCenterMobileOperationLogsResponseData
     */
    message: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterMobileOperationLogsResponseData
     */
    date: string;
    /**
     * Time
     * @type {string}
     * @memberof CallCenterMobileOperationLogsResponseData
     */
    time: string;
}
/**
 * 
 * @export
 * @interface CallCenterMobileSessionLogsRequest
 */
export interface CallCenterMobileSessionLogsRequest extends PaginationRequest {
    /**
     * Start Date
     * @type {string}
     * @memberof CallCenterMobileSessionLogsRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterMobileSessionLogsRequest
     */
    endDate: string;
    /**
     * Session Status Code
     * @type {string}
     * @memberof CallCenterMobileSessionLogsRequest
     */
    sessionStatusCode?: string;
}
/**
 * 
 * @export
 * @interface CallCenterMobileSessionLogsResponse
 */
export interface CallCenterMobileSessionLogsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CallCenterMobileSessionLogsResponseData>}
     * @memberof CallCenterMobileSessionLogsResponse
     */
    sessionLogList: Array<CallCenterMobileSessionLogsResponseData>;
}
/**
 * 
 * @export
 * @interface CallCenterMobileSessionLogsResponseData
 */
export interface CallCenterMobileSessionLogsResponseData {
    /**
     * Mobile Phone
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    mobilePhone: string;
    /**
     * Ip Number
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    ipNumber: string;
    /**
     * Operating System
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    operatingSystem: string;
    /**
     * Application Version
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    appVersion: string;
    /**
     * End Date
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    date: string;
    /**
     * Time
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    time: string;
    /**
     * Session Status
     * @type {string}
     * @memberof CallCenterMobileSessionLogsResponseData
     */
    sessionStatus: string;
}
/**
 * 
 * @export
 * @interface CancelProductOperationRequest
 */
export interface CancelProductOperationRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof CancelProductOperationRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface CancelProductOperationResponse
 */
export interface CancelProductOperationResponse extends Response {
}
/**
 * 
 * @export
 * @interface CaptchaResponse
 */
export interface CaptchaResponse extends Response {
    /**
     * Base64 encoded captcha image
     * @type {string}
     * @memberof CaptchaResponse
     */
    captchaImage: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CardActivationType {
    POS = 'POS',
    OBSERVATION = 'OBSERVATION',
    REISSUE = 'REISSUE'
}

/**
 * 
 * @export
 * @interface CardApplicationInfoValidationRequest
 */
export interface CardApplicationInfoValidationRequest {
    /**
     * The Unique Card Number
     * @type {string}
     * @memberof CardApplicationInfoValidationRequest
     */
    cardNumber: string;
    /**
     * Last 4 Digits
     * @type {string}
     * @memberof CardApplicationInfoValidationRequest
     */
    lastFourDigits: string;
}
/**
 * 
 * @export
 * @interface CardApplicationInfoValidationResponse
 */
export interface CardApplicationInfoValidationResponse extends Response {
}
/**
 * 
 * @export
 * @interface CardApplicationRequest
 */
export interface CardApplicationRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof CardApplicationRequest
     */
    documentList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface CardApplicationResponse
 */
export interface CardApplicationResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof CardApplicationResponse
     */
    applicationResultMessage: string;
    /**
     * 
     * @type {ScoringResultType}
     * @memberof CardApplicationResponse
     */
    scoringResultType?: ScoringResultType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CardApplicationScreenType {
    CARDAPPLICATION = 'CARD_APPLICATION',
    CLIENTINFOCHANGE = 'CLIENT_INFO_CHANGE'
}

/**
 * 
 * @export
 * @interface CardCurrentAccountsResponse
 */
export interface CardCurrentAccountsResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof CardCurrentAccountsResponse
     */
    currentAccountList?: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface CardCustomerInfoResponse
 */
export interface CardCustomerInfoResponse extends Response {
    /**
     * Customer Number
     * @type {string}
     * @memberof CardCustomerInfoResponse
     */
    customerNumber: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof CardCustomerInfoResponse
     */
    customerName: string;
}
/**
 * 
 * @export
 * @interface CardDeliveryComboRequest
 */
export interface CardDeliveryComboRequest {
    /**
     * delivery address code
     * @type {string}
     * @memberof CardDeliveryComboRequest
     */
    cardDeliveryAddressCode: string;
}
/**
 * 
 * @export
 * @interface CardDeliveryComboResponse
 */
export interface CardDeliveryComboResponse extends Response {
    /**
     * 
     * @type {CardDeliveryComboType}
     * @memberof CardDeliveryComboResponse
     */
    cardDeliveryComboType: CardDeliveryComboType;
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof CardDeliveryComboResponse
     */
    parameterDataList?: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CardDeliveryComboType {
    BRANCH = 'BRANCH',
    COURIER = 'COURIER',
    POS = 'POS',
    NONE = 'NONE'
}

/**
 * 
 * @export
 * @interface CardEmbossedInfoResponse
 */
export interface CardEmbossedInfoResponse extends Response {
    /**
     * Name on the Card
     * @type {string}
     * @memberof CardEmbossedInfoResponse
     */
    cardEmbossedName: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CardEmbossedInfoResponse
     */
    promotionName?: DictionaryLine;
    /**
     * Number of Promotion Days
     * @type {string}
     * @memberof CardEmbossedInfoResponse
     */
    promotionDaysNumber?: string;
    /**
     * Max length of embossed name
     * @type {number}
     * @memberof CardEmbossedInfoResponse
     */
    cardEmbossedNameMaxLength?: number;
    /**
     * true if card type is no name
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isCardTypeNoName?: boolean;
    /**
     * true if salary company code area will be visible
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isSalaryCompanyCodeVisible?: boolean;
    /**
     * true if delivery channel code area will be visible
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isDeliveryChannelCodeVisible?: boolean;
    /**
     * true if branch will be enable
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isBranchEnable?: boolean;
    /**
     * branch code
     * @type {string}
     * @memberof CardEmbossedInfoResponse
     */
    branchCode?: string;
    /**
     * true if metro card number area will be visible
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isMetroCardNumberVisible?: boolean;
    /**
     * Max Length
     * @type {number}
     * @memberof CardEmbossedInfoResponse
     */
    metroCardNumberMaxLength?: number;
    /**
     * true if product is card plus
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isCardPlus?: boolean;
    /**
     * true if open new account label is visible
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isOpenNewAccountLabelVisible?: boolean;
    /**
     * true if open new account check box is visible
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isOpenNewAccountCheckboxVisible?: boolean;
    /**
     * true if open new account checkbox is checked and disabled
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    willOpenNewAccountCheckboxCheckedAndDisabled?: boolean;
    /**
     * true if current account combo is visible
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isCurrentAccountComboVisible?: boolean;
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof CardEmbossedInfoResponse
     */
    currentAccountList?: Array<DictionaryLine>;
    /**
     * Consent to the request to the BKI
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    isConsentBik?: boolean;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardEmbossedInfoResponse
     */
    agreementToMarketing?: boolean;
}
/**
 * 
 * @export
 * @interface CardImageRequest
 */
export interface CardImageRequest {
    /**
     * Fill Point Id
     * @type {string}
     * @memberof CardImageRequest
     */
    fillPointId: string;
    /**
     * 
     * @type {CardSelectionType}
     * @memberof CardImageRequest
     */
    cardSelectionType: CardSelectionType;
    /**
     * Print Type
     * @type {string}
     * @memberof CardImageRequest
     */
    printType: string;
}
/**
 * 
 * @export
 * @interface CardImageResponse
 */
export interface CardImageResponse extends Response {
    /**
     * 
     * @type {Array<CardImageResponseData>}
     * @memberof CardImageResponse
     */
    cardList: Array<CardImageResponseData>;
}
/**
 * 
 * @export
 * @interface CardImageResponseData
 */
export interface CardImageResponseData {
    /**
     * Card Image Id
     * @type {string}
     * @memberof CardImageResponseData
     */
    cardImageId: string;
    /**
     * Card Image Path
     * @type {string}
     * @memberof CardImageResponseData
     */
    cardImagePath: string;
    /**
     * Card Name
     * @type {string}
     * @memberof CardImageResponseData
     */
    cardName: string;
    /**
     * Card Information
     * @type {string}
     * @memberof CardImageResponseData
     */
    cardInformation: string;
    /**
     * Brand Owner Type Code
     * @type {string}
     * @memberof CardImageResponseData
     */
    brandOwnerTypeCode: string;
    /**
     * Card Type Code
     * @type {string}
     * @memberof CardImageResponseData
     */
    cardTypeCode: string;
}
/**
 * 
 * @export
 * @interface CardListData
 */
export interface CardListData {
    /**
     * Card Id
     * @type {string}
     * @memberof CardListData
     */
    cardId: string;
    /**
     * Card Number
     * @type {string}
     * @memberof CardListData
     */
    cardNumber: string;
    /**
     * status
     * @type {string}
     * @memberof CardListData
     */
    status: string;
    /**
     * currency
     * @type {string}
     * @memberof CardListData
     */
    currency: string;
    /**
     * Expired Date
     * @type {string}
     * @memberof CardListData
     */
    expiredDate: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof CardListData
     */
    customerNumber?: string;
}
/**
 * 
 * @export
 * @interface CardListRequest
 */
export interface CardListRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof CardListRequest
     */
    customerNumber?: string;
    /**
     * 
     * @type {CardSelectionType}
     * @memberof CardListRequest
     */
    cardSelectionType: CardSelectionType;
}
/**
 * 
 * @export
 * @interface CardListResponse
 */
export interface CardListResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CardListData>}
     * @memberof CardListResponse
     */
    cardList: Array<CardListData>;
}
/**
 * 
 * @export
 * @interface CardNSPKConcentInfoResponse
 */
export interface CardNSPKConcentInfoResponse extends Response {
    /**
     * true if current account combo is visible
     * @type {boolean}
     * @memberof CardNSPKConcentInfoResponse
     */
    isCardNSPKConcentVisible: boolean;
}
/**
 * 
 * @export
 * @interface CardPreApplicationResponse
 */
export interface CardPreApplicationResponse extends Response {
    /**
     * Document Id
     * @type {string}
     * @memberof CardPreApplicationResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CardSelectionType {
    DEBIT = 'DEBIT',
    CREDITCARD = 'CREDIT_CARD',
    DEFAULT = 'DEFAULT'
}

/**
 * 
 * @export
 * @interface CardSendingInfoResponse
 */
export interface CardSendingInfoResponse extends Response {
    /**
     * true if sms alert will be checked
     * @type {boolean}
     * @memberof CardSendingInfoResponse
     */
    smsAlert: boolean;
    /**
     * true if instant embossing will be checked
     * @type {boolean}
     * @memberof CardSendingInfoResponse
     */
    instantEmbossing: boolean;
    /**
     * branch code
     * @type {string}
     * @memberof CardSendingInfoResponse
     */
    cardDeliveryBranchCode?: string;
    /**
     * delivery address code
     * @type {string}
     * @memberof CardSendingInfoResponse
     */
    cardDeliveryAddressCode?: string;
    /**
     * delivery address code
     * @type {string}
     * @memberof CardSendingInfoResponse
     */
    pinCodeDeliveryBranchCode?: string;
    /**
     * branch code
     * @type {string}
     * @memberof CardSendingInfoResponse
     */
    pinCodeDeliveryAddressCode?: string;
    /**
     * true if card delivery branch will be enable
     * @type {boolean}
     * @memberof CardSendingInfoResponse
     */
    enableCardDeliveryBranch?: boolean;
    /**
     * true if card delivery address will be enable
     * @type {boolean}
     * @memberof CardSendingInfoResponse
     */
    enableCardDeliveryAddress?: boolean;
    /**
     * true if card pin code delivery branch will be enable
     * @type {boolean}
     * @memberof CardSendingInfoResponse
     */
    enablePinCodeDeliveryBranch?: boolean;
    /**
     * true if pin code delivery address will be enable
     * @type {boolean}
     * @memberof CardSendingInfoResponse
     */
    enablePinCodeDeliveryAddress?: boolean;
}
/**
 * 
 * @export
 * @interface CardSendingPageData
 */
export interface CardSendingPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CardSendingPageData
     */
    cardDeliveryAddress: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CardSendingPageData
     */
    cardDeliveryBranch?: DictionaryLine;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    instantEmbossing?: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CardSendingPageData
     */
    pinCodeDeliveryAddress?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CardSendingPageData
     */
    pinCodeDeliveryBranch?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CardSendingPageData
     */
    statementPeriod?: DictionaryLine;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    sendViaEmail?: boolean;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    smsAlert?: boolean;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    lifeInsurance?: boolean;
    /**
     * true if salary campaign is checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    isCampaignFlag?: boolean;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    consentCommunicationsNspk?: boolean;
    /**
     * true if checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    consentCheckRegistrationNumber?: boolean;
    /**
     * true if scoring consent is checked
     * @type {boolean}
     * @memberof CardSendingPageData
     */
    consentScoring?: boolean;
}
/**
 * 
 * @export
 * @interface CardSendingPageDataResponse
 */
export interface CardSendingPageDataResponse extends Response {
    /**
     * 
     * @type {CardSendingPageData}
     * @memberof CardSendingPageDataResponse
     */
    pageData?: CardSendingPageData;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CardUsageType {
    PRIMARY = 'PRIMARY',
    SUPPLEMENTARY = 'SUPPLEMENTARY'
}

/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * Old Password
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    oldPassword: string;
    /**
     * New Password
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    newPassword: string;
    /**
     * Repeat New Password
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    reNewPassword: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordResponse
 */
export interface ChangePasswordResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof ChangePasswordResponse
     */
    changePasswordResultMessage?: string;
    /**
     * 
     * @type {Array<Menu>}
     * @memberof ChangePasswordResponse
     */
    menuList?: Array<Menu>;
    /**
     * 
     * @type {Array<Menu>}
     * @memberof ChangePasswordResponse
     */
    profileMenuList?: Array<Menu>;
}
/**
 * 
 * @export
 * @interface CheckClientBaseData
 */
export interface CheckClientBaseData {
    /**
     * Customer Id
     * @type {string}
     * @memberof CheckClientBaseData
     */
    customerId: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof CheckClientBaseData
     */
    customerSurname: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof CheckClientBaseData
     */
    customerName: string;
    /**
     * Second Name
     * @type {string}
     * @memberof CheckClientBaseData
     */
    customerSecondName: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof CheckClientBaseData
     */
    birthDate: string;
}
/**
 * 
 * @export
 * @interface CheckClientInfoIndividualRequest
 */
export interface CheckClientInfoIndividualRequest extends CheckClientBaseData {
}
/**
 * 
 * @export
 * @interface CheckClientInfoIndividualResponse
 */
export interface CheckClientInfoIndividualResponse extends Response {
}
/**
 * 
 * @export
 * @interface CheckContactInfoIndividualRequest
 */
export interface CheckContactInfoIndividualRequest extends CheckClientBaseData {
}
/**
 * 
 * @export
 * @interface CheckContactInfoIndividualResponse
 */
export interface CheckContactInfoIndividualResponse extends Response {
}
/**
 * 
 * @export
 * @interface ClientInfoDocumentPageData
 */
export interface ClientInfoDocumentPageData {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof ClientInfoDocumentPageData
     */
    documentUploadDataList?: Array<DocumentPageUploadData>;
    /**
     * true if client info change button is clicked
     * @type {boolean}
     * @memberof ClientInfoDocumentPageData
     */
    isClientInfoChangeButtonClicked?: boolean;
}
/**
 * 
 * @export
 * @interface ClientInfoDocumentPageDataResponse
 */
export interface ClientInfoDocumentPageDataResponse extends Response {
    /**
     * 
     * @type {ClientInfoDocumentPageData}
     * @memberof ClientInfoDocumentPageDataResponse
     */
    pageData?: ClientInfoDocumentPageData;
}
/**
 * 
 * @export
 * @interface ClientInfoDocumentRequest
 */
export interface ClientInfoDocumentRequest {
    /**
     * 
     * @type {ScreenProcessType}
     * @memberof ClientInfoDocumentRequest
     */
    screenProcessType?: ScreenProcessType;
}
/**
 * 
 * @export
 * @interface ClientInfoDocumentResponse
 */
export interface ClientInfoDocumentResponse extends Response {
    /**
     * Document Id
     * @type {string}
     * @memberof ClientInfoDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface ClientInfoIndividualPageDataResponse
 */
export interface ClientInfoIndividualPageDataResponse extends Response {
    /**
     * 
     * @type {IndividualPageData}
     * @memberof ClientInfoIndividualPageDataResponse
     */
    pageData?: IndividualPageData;
}
/**
 * 
 * @export
 * @interface ClientInfoNameRequest
 */
export interface ClientInfoNameRequest {
    /**
     * Customer Surname
     * @type {string}
     * @memberof ClientInfoNameRequest
     */
    customerSurname?: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof ClientInfoNameRequest
     */
    customerName?: string;
    /**
     * Second Name
     * @type {string}
     * @memberof ClientInfoNameRequest
     */
    customerSecondName?: string;
}
/**
 * 
 * @export
 * @interface ClientInfoNameResponse
 */
export interface ClientInfoNameResponse extends Response {
    /**
     * Customer Name
     * @type {string}
     * @memberof ClientInfoNameResponse
     */
    clientName: string;
}
/**
 * 
 * @export
 * @interface ClientInfoTaxPageDataResponse
 */
export interface ClientInfoTaxPageDataResponse extends Response {
    /**
     * 
     * @type {TaxPageData}
     * @memberof ClientInfoTaxPageDataResponse
     */
    pageData?: TaxPageData;
}
/**
 * 
 * @export
 * @interface ClientInfoUpdateRequest
 */
export interface ClientInfoUpdateRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof ClientInfoUpdateRequest
     */
    documentUploadDataList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface ClientInfoUpdateResponse
 */
export interface ClientInfoUpdateResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof ClientInfoUpdateResponse
     */
    updateResultMessage: string;
}
/**
 * 
 * @export
 * @interface ContactIndividualPageData
 */
export interface ContactIndividualPageData {
    /**
     * 
     * @type {IndividualPageData}
     * @memberof ContactIndividualPageData
     */
    individualData?: IndividualPageData;
    /**
     * 
     * @type {Array<DocumentPageIdentityData>}
     * @memberof ContactIndividualPageData
     */
    documentIdentityDataList?: Array<DocumentPageIdentityData>;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeData
 */
export interface ContactInfoChangeData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ContactInfoChangeData
     */
    countryCode: DictionaryLine;
    /**
     * Field code
     * @type {string}
     * @memberof ContactInfoChangeData
     */
    fieldCode: string;
    /**
     * Phone number
     * @type {string}
     * @memberof ContactInfoChangeData
     */
    telephoneNo: string;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeDocumentRequest
 */
export interface ContactInfoChangeDocumentRequest {
    /**
     * 
     * @type {ScreenProcessType}
     * @memberof ContactInfoChangeDocumentRequest
     */
    screenProcessType?: ScreenProcessType;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeDocumentResponse
 */
export interface ContactInfoChangeDocumentResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof ContactInfoChangeDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface ContactInfoChangePageDataResponse
 */
export interface ContactInfoChangePageDataResponse extends Response {
    /**
     * 
     * @type {ContactInfoChangeData}
     * @memberof ContactInfoChangePageDataResponse
     */
    pageData?: ContactInfoChangeData;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeRequest
 */
export interface ContactInfoChangeRequest {
    /**
     * Customer Id
     * @type {string}
     * @memberof ContactInfoChangeRequest
     */
    customerId: string;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeResponse
 */
export interface ContactInfoChangeResponse extends Response {
    /**
     * Country Code
     * @type {string}
     * @memberof ContactInfoChangeResponse
     */
    countryCode: string;
    /**
     * Field code
     * @type {string}
     * @memberof ContactInfoChangeResponse
     */
    fieldCode: string;
    /**
     * Phone number
     * @type {string}
     * @memberof ContactInfoChangeResponse
     */
    telephoneNo: string;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeUpdateRequest
 */
export interface ContactInfoChangeUpdateRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof ContactInfoChangeUpdateRequest
     */
    documentUploadDataList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface ContactInfoChangeUpdateResponse
 */
export interface ContactInfoChangeUpdateResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof ContactInfoChangeUpdateResponse
     */
    updateResultMessage: string;
}
/**
 * 
 * @export
 * @interface ContactInfoIndividualPageDataResponse
 */
export interface ContactInfoIndividualPageDataResponse extends Response {
    /**
     * 
     * @type {ContactIndividualPageData}
     * @memberof ContactInfoIndividualPageDataResponse
     */
    pageData?: ContactIndividualPageData;
}
/**
 * 
 * @export
 * @interface ContactInfoPageData
 */
export interface ContactInfoPageData {
    /**
     * customer email
     * @type {string}
     * @memberof ContactInfoPageData
     */
    emailAddress?: string;
    /**
     * 
     * @type {PhoneInfoPageData}
     * @memberof ContactInfoPageData
     */
    mobilePhone: PhoneInfoPageData;
    /**
     * 
     * @type {PhoneInfoPageData}
     * @memberof ContactInfoPageData
     */
    actualLivingAddressPhone?: PhoneInfoPageData;
    /**
     * 
     * @type {PhoneInfoPageData}
     * @memberof ContactInfoPageData
     */
    workPhone?: PhoneInfoPageData;
    /**
     * 
     * @type {PhoneInfoPageData}
     * @memberof ContactInfoPageData
     */
    contactPersonMobilePhone1?: PhoneInfoPageData;
    /**
     * 
     * @type {PhoneInfoPageData}
     * @memberof ContactInfoPageData
     */
    contactPersonMobilePhone2?: PhoneInfoPageData;
}
/**
 * 
 * @export
 * @interface ContactInfoPageDataResponse
 */
export interface ContactInfoPageDataResponse extends Response {
    /**
     * 
     * @type {ContactInfoPageData}
     * @memberof ContactInfoPageDataResponse
     */
    pageData?: ContactInfoPageData;
}
/**
 * 
 * @export
 * @interface CustomerAddressData
 */
export interface CustomerAddressData {
    /**
     * Address Id
     * @type {string}
     * @memberof CustomerAddressData
     */
    addressId: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerAddressData
     */
    addressType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerAddressData
     */
    country: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerAddressData
     */
    region: DictionaryLine;
    /**
     * city
     * @type {string}
     * @memberof CustomerAddressData
     */
    city: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerAddressData
     */
    district: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerAddressData
     */
    streetType: DictionaryLine;
    /**
     * Street
     * @type {string}
     * @memberof CustomerAddressData
     */
    street: string;
    /**
     * Building Info
     * @type {string}
     * @memberof CustomerAddressData
     */
    buildingInfo: string;
    /**
     * Flat Number
     * @type {string}
     * @memberof CustomerAddressData
     */
    flatNumber: string;
    /**
     * House Number
     * @type {string}
     * @memberof CustomerAddressData
     */
    houseNumber: string;
    /**
     * ZipCode
     * @type {string}
     * @memberof CustomerAddressData
     */
    zipCode: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerAddressData
     */
    addressHomeOwnerType: DictionaryLine;
    /**
     * true if address has correspondence flag
     * @type {boolean}
     * @memberof CustomerAddressData
     */
    hasCorrespondenceFlag: boolean;
    /**
     * Registration Date
     * @type {string}
     * @memberof CustomerAddressData
     */
    registrationDate?: string;
    /**
     * true if address is new
     * @type {boolean}
     * @memberof CustomerAddressData
     */
    isAddressNew: boolean;
}
/**
 * 
 * @export
 * @interface CustomerAddressRegionResponse
 */
export interface CustomerAddressRegionResponse extends Response {
    /**
     * Region Code
     * @type {string}
     * @memberof CustomerAddressRegionResponse
     */
    regionCode?: string;
}
/**
 * 
 * @export
 * @interface CustomerAddressRequest
 */
export interface CustomerAddressRequest extends PaginationRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerAddressRequest
     */
    customerId: string;
}
/**
 * 
 * @export
 * @interface CustomerAddressResponse
 */
export interface CustomerAddressResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CustomerAddressData>}
     * @memberof CustomerAddressResponse
     */
    customerAddressList?: Array<CustomerAddressData>;
}
/**
 * 
 * @export
 * @interface CustomerContactInfoFormatRequest
 */
export interface CustomerContactInfoFormatRequest {
    /**
     * 
     * @type {PhoneType}
     * @memberof CustomerContactInfoFormatRequest
     */
    phoneType: PhoneType;
    /**
     * Country Code
     * @type {string}
     * @memberof CustomerContactInfoFormatRequest
     */
    countryCode: string;
}
/**
 * 
 * @export
 * @interface CustomerContactInfoFormatResponse
 */
export interface CustomerContactInfoFormatResponse extends Response {
    /**
     * Minimum Field Code Length
     * @type {number}
     * @memberof CustomerContactInfoFormatResponse
     */
    minFieldCodeLength: number;
    /**
     * Maximum Field Code  Length
     * @type {number}
     * @memberof CustomerContactInfoFormatResponse
     */
    maxFieldCodeLength: number;
    /**
     * Minimum Telephone No Length
     * @type {number}
     * @memberof CustomerContactInfoFormatResponse
     */
    minTelephoneNoLength: number;
    /**
     * Maximum Telephone No Length
     * @type {number}
     * @memberof CustomerContactInfoFormatResponse
     */
    maxTelephoneNoLength: number;
}
/**
 * 
 * @export
 * @interface CustomerContactInfoRequest
 */
export interface CustomerContactInfoRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerContactInfoRequest
     */
    customerId: string;
}
/**
 * 
 * @export
 * @interface CustomerContactInfoResponse
 */
export interface CustomerContactInfoResponse extends Response {
    /**
     * Email Address
     * @type {string}
     * @memberof CustomerContactInfoResponse
     */
    emailAddress?: string;
    /**
     * Email Address Id
     * @type {string}
     * @memberof CustomerContactInfoResponse
     */
    emailAddressId?: string;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof CustomerContactInfoResponse
     */
    mobilePhone?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof CustomerContactInfoResponse
     */
    actualLivingAddressPhone?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof CustomerContactInfoResponse
     */
    workPhone?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof CustomerContactInfoResponse
     */
    contactPersonMobilePhone1?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof CustomerContactInfoResponse
     */
    contactPersonMobilePhone2?: PhoneDetailData;
}
/**
 * 
 * @export
 * @interface CustomerCreateResponse
 */
export interface CustomerCreateResponse extends Response {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerCreateResponse
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface CustomerDetailForCardApplicationRequest
 */
export interface CustomerDetailForCardApplicationRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerDetailForCardApplicationRequest
     */
    customerId: string;
    /**
     * 
     * @type {CardApplicationScreenType}
     * @memberof CustomerDetailForCardApplicationRequest
     */
    cardApplicationScreenType?: CardApplicationScreenType;
}
/**
 * 
 * @export
 * @interface CustomerDetailForCardApplicationResponse
 */
export interface CustomerDetailForCardApplicationResponse extends Response {
    /**
     * Customer Name
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    customerName?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    customerSurname?: string;
    /**
     * Customer Second Name
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    customerSecondName?: string;
    /**
     * Customer Surname non-resident
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    customerSurnameNonresident?: string;
    /**
     * Customer Name non-resident
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    customerNameNonresident?: string;
    /**
     * Second Name non-resident
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    customerSecondNameNonresident?: string;
    /**
     * Gender
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    gender?: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    birthDate?: string;
    /**
     * Place of Birth Country
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    birthPlaceCountry?: string;
    /**
     * Citizenship
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    citizenship?: string;
    /**
     * Place of Birth Region
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    birthPlaceRegion?: string;
    /**
     * Country of Residence
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    residence?: string;
    /**
     * Place of Birth Text
     * @type {string}
     * @memberof CustomerDetailForCardApplicationResponse
     */
    birthPlaceText?: string;
}
/**
 * 
 * @export
 * @interface CustomerDetailForLoanApplicationRequest
 */
export interface CustomerDetailForLoanApplicationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface CustomerDetailForLoanApplicationResponse
 */
export interface CustomerDetailForLoanApplicationResponse extends Response {
    /**
     * Customer Name
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    customerName?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    customerSurname?: string;
    /**
     * Customer Second Name
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    customerSecondName?: string;
    /**
     * Gender
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    gender?: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    birthDate?: string;
    /**
     * Place of Birth Country
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    birthPlaceCountry?: string;
    /**
     * Citizenship
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    citizenship?: string;
    /**
     * Place of Birth Region
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    birthPlaceRegion?: string;
    /**
     * Country of Residence
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    residence?: string;
    /**
     * Place of Birth Text
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    birthPlaceText?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    hasPreviousSurname?: DictionaryLine;
    /**
     * Previous Surname
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    previousSurname?: string;
    /**
     * Code Word For The Customer Support Centre
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    codeWordForSupportCentre?: string;
    /**
     * true if it is civil servant
     * @type {boolean}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    isCivilServant?: boolean;
    /**
     * snils
     * @type {string}
     * @memberof CustomerDetailForLoanApplicationResponse
     */
    snils?: string;
}
/**
 * 
 * @export
 * @interface CustomerDetailInfoResponse
 */
export interface CustomerDetailInfoResponse extends Response {
    /**
     * Marital Status Code
     * @type {string}
     * @memberof CustomerDetailInfoResponse
     */
    maritalStatusCode: string;
    /**
     * Education Status Code
     * @type {string}
     * @memberof CustomerDetailInfoResponse
     */
    educationStatusCode: string;
    /**
     * Number of Children
     * @type {number}
     * @memberof CustomerDetailInfoResponse
     */
    numberOfChildren?: number;
}
/**
 * 
 * @export
 * @interface CustomerDetailPageData
 */
export interface CustomerDetailPageData {
    /**
     * true if customer did not pass face control
     * @type {boolean}
     * @memberof CustomerDetailPageData
     */
    faceControl?: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailPageData
     */
    maritalStatus: DictionaryLine;
    /**
     * Number of Children
     * @type {number}
     * @memberof CustomerDetailPageData
     */
    numberOfChildren?: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailPageData
     */
    educationStatus?: DictionaryLine;
    /**
     * true if customer is a government officer
     * @type {boolean}
     * @memberof CustomerDetailPageData
     */
    isGovernmentOfficer?: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailPageData
     */
    hasRelativeForeignPublicOffical: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailPageData
     */
    hasUSAPermit: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailPageData
     */
    hasTravelPassport?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof CustomerDetailPageData
     */
    hasCEBLoanOfRelatives?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface CustomerDetailPageDataResponse
 */
export interface CustomerDetailPageDataResponse extends Response {
    /**
     * 
     * @type {CustomerDetailPageData}
     * @memberof CustomerDetailPageDataResponse
     */
    pageData?: CustomerDetailPageData;
}
/**
 * 
 * @export
 * @interface CustomerIdentityData
 */
export interface CustomerIdentityData {
    /**
     * Customer Identity Id
     * @type {string}
     * @memberof CustomerIdentityData
     */
    customerIdentityId: string;
    /**
     * Series code
     * @type {string}
     * @memberof CustomerIdentityData
     */
    series: string;
    /**
     * Serial Code
     * @type {string}
     * @memberof CustomerIdentityData
     */
    serialCode: string;
    /**
     * Date Of Issue
     * @type {string}
     * @memberof CustomerIdentityData
     */
    issueDate: string;
    /**
     * Document Type
     * @type {string}
     * @memberof CustomerIdentityData
     */
    documentType: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof CustomerIdentityData
     */
    expirationDate?: string;
    /**
     * Issued By
     * @type {string}
     * @memberof CustomerIdentityData
     */
    issuedBy: string;
    /**
     * Given Country
     * @type {string}
     * @memberof CustomerIdentityData
     */
    givenCountry?: string;
    /**
     * Code of Issue Place
     * @type {string}
     * @memberof CustomerIdentityData
     */
    unitCode?: string;
    /**
     * True if it is used before
     * @type {boolean}
     * @memberof CustomerIdentityData
     */
    hasUsed: boolean;
    /**
     * True if the document is active
     * @type {boolean}
     * @memberof CustomerIdentityData
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerIdentityRequest
 */
export interface CustomerIdentityRequest extends PaginationRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerIdentityRequest
     */
    customerId?: string;
    /**
     * 
     * @type {CardApplicationScreenType}
     * @memberof CustomerIdentityRequest
     */
    cardApplicationScreenType?: CardApplicationScreenType;
    /**
     * return only active identity
     * @type {boolean}
     * @memberof CustomerIdentityRequest
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerIdentityResponse
 */
export interface CustomerIdentityResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<CustomerIdentityData>}
     * @memberof CustomerIdentityResponse
     */
    customerIdentityList?: Array<CustomerIdentityData>;
}
/**
 * 
 * @export
 * @interface CustomerLoanDetailInfoResponse
 */
export interface CustomerLoanDetailInfoResponse extends Response {
    /**
     * Marital Status Code
     * @type {string}
     * @memberof CustomerLoanDetailInfoResponse
     */
    maritalStatusCode: string;
    /**
     * Education Status Code
     * @type {string}
     * @memberof CustomerLoanDetailInfoResponse
     */
    educationStatusCode: string;
    /**
     * Number of Children
     * @type {number}
     * @memberof CustomerLoanDetailInfoResponse
     */
    numberOfChildren?: number;
    /**
     * Monthly Income
     * @type {number}
     * @memberof CustomerLoanDetailInfoResponse
     */
    monthlyIncome: number;
    /**
     * Spouse Surname
     * @type {string}
     * @memberof CustomerLoanDetailInfoResponse
     */
    spouseSurname?: string;
    /**
     * Spouse Name
     * @type {string}
     * @memberof CustomerLoanDetailInfoResponse
     */
    spouseName?: string;
    /**
     * Spouse Second Name
     * @type {string}
     * @memberof CustomerLoanDetailInfoResponse
     */
    spouseSecondName?: string;
    /**
     * Spouse Type Of Employment
     * @type {string}
     * @memberof CustomerLoanDetailInfoResponse
     */
    spouseTypeOfEmployment?: string;
}
/**
 * 
 * @export
 * @interface CustomerLoanTaxInformationRequest
 */
export interface CustomerLoanTaxInformationRequest extends PaginationRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerLoanTaxInformationRequest
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface CustomerLoanTaxInformationResponse
 */
export interface CustomerLoanTaxInformationResponse extends PaginationResponse {
    /**
     * Tax Number
     * @type {string}
     * @memberof CustomerLoanTaxInformationResponse
     */
    taxNumber?: string;
    /**
     * True if tax residence can be added to table
     * @type {boolean}
     * @memberof CustomerLoanTaxInformationResponse
     */
    enableTaxResidencyList?: boolean;
    /**
     * 
     * @type {Array<TaxResidencyData>}
     * @memberof CustomerLoanTaxInformationResponse
     */
    taxResidencyList?: Array<TaxResidencyData>;
}
/**
 * 
 * @export
 * @interface CustomerResponseData
 */
export interface CustomerResponseData {
    /**
     * Customer Name
     * @type {string}
     * @memberof CustomerResponseData
     */
    customerName: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof CustomerResponseData
     */
    customerSurname: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof CustomerResponseData
     */
    birthDate: string;
    /**
     * Second Name
     * @type {string}
     * @memberof CustomerResponseData
     */
    customerSecondName?: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof CustomerResponseData
     */
    identityDocumentSerialCode?: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof CustomerResponseData
     */
    identityDocumentSerialNumber?: string;
    /**
     * Customer Surname non-resident
     * @type {string}
     * @memberof CustomerResponseData
     */
    customerSurnameNonresident?: string;
    /**
     * Customer Name non-resident
     * @type {string}
     * @memberof CustomerResponseData
     */
    customerNameNonresident?: string;
    /**
     * Second Name non-resident
     * @type {string}
     * @memberof CustomerResponseData
     */
    customerSecondNameNonresident?: string;
    /**
     * Customer is resident RF
     * @type {boolean}
     * @memberof CustomerResponseData
     */
    isResidentRF?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerSearchCriteria
 */
export interface CustomerSearchCriteria {
    /**
     * true if search with client info flag is checked
     * @type {boolean}
     * @memberof CustomerSearchCriteria
     */
    searchWithClientInfoFlag?: boolean;
    /**
     * Customer Name
     * @type {string}
     * @memberof CustomerSearchCriteria
     */
    customerName?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof CustomerSearchCriteria
     */
    customerSurname?: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof CustomerSearchCriteria
     */
    birthDate?: string;
    /**
     * Second Name
     * @type {string}
     * @memberof CustomerSearchCriteria
     */
    customerSecondName?: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof CustomerSearchCriteria
     */
    identityDocumentSerialCode?: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof CustomerSearchCriteria
     */
    identityDocumentSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface CustomerTaxInfoFormatRequest
 */
export interface CustomerTaxInfoFormatRequest {
    /**
     * Country Code
     * @type {string}
     * @memberof CustomerTaxInfoFormatRequest
     */
    countryCode: string;
}
/**
 * 
 * @export
 * @interface CustomerTaxInfoFormatResponse
 */
export interface CustomerTaxInfoFormatResponse extends Response {
    /**
     * Minimum Length
     * @type {number}
     * @memberof CustomerTaxInfoFormatResponse
     */
    innMinLength: number;
    /**
     * Maximum Length
     * @type {number}
     * @memberof CustomerTaxInfoFormatResponse
     */
    innMaxLength: number;
    /**
     * Tool Tip
     * @type {string}
     * @memberof CustomerTaxInfoFormatResponse
     */
    innToolTip: string;
    /**
     * Minimum Analogue Inn Length
     * @type {number}
     * @memberof CustomerTaxInfoFormatResponse
     */
    analogueInnMinLength?: number;
    /**
     * Maximum Analogue Inn Length
     * @type {number}
     * @memberof CustomerTaxInfoFormatResponse
     */
    analogueInnMaxLength?: number;
    /**
     * Tool Tip
     * @type {string}
     * @memberof CustomerTaxInfoFormatResponse
     */
    analogueInnToolTip?: string;
    /**
     * true if country has different number
     * @type {boolean}
     * @memberof CustomerTaxInfoFormatResponse
     */
    hasDifferentNumber: boolean;
}
/**
 * 
 * @export
 * @interface CustomerTaxInformationRequest
 */
export interface CustomerTaxInformationRequest extends PaginationRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof CustomerTaxInformationRequest
     */
    customerId?: string;
    /**
     * 
     * @type {CardApplicationScreenType}
     * @memberof CustomerTaxInformationRequest
     */
    cardApplicationScreenType?: CardApplicationScreenType;
}
/**
 * 
 * @export
 * @interface CustomerTaxInformationResponse
 */
export interface CustomerTaxInformationResponse extends PaginationResponse {
    /**
     * Tax Number
     * @type {string}
     * @memberof CustomerTaxInformationResponse
     */
    taxNumber?: string;
    /**
     * True if tax residence can be added to table
     * @type {boolean}
     * @memberof CustomerTaxInformationResponse
     */
    enableTaxResidencyList?: boolean;
    /**
     * 
     * @type {Array<TaxResidencyData>}
     * @memberof CustomerTaxInformationResponse
     */
    taxResidencyList?: Array<TaxResidencyData>;
}
/**
 * 
 * @export
 * @interface CustomerUpdateResponse
 */
export interface CustomerUpdateResponse extends Response {
}
/**
 * 
 * @export
 * @interface DeleteDocumentRequest
 */
export interface DeleteDocumentRequest {
    /**
     * Document Id
     * @type {string}
     * @memberof DeleteDocumentRequest
     */
    documentId?: string;
    /**
     * 
     * @type {UploadType}
     * @memberof DeleteDocumentRequest
     */
    uploadType?: UploadType;
}
/**
 * 
 * @export
 * @interface DictionaryLine
 */
export interface DictionaryLine {
    /**
     * 
     * @type {string}
     * @memberof DictionaryLine
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryLine
     */
    value: string;
}
/**
 * 
 * @export
 * @interface DocumentBaseData
 */
export interface DocumentBaseData {
    /**
     * id
     * @type {string}
     * @memberof DocumentBaseData
     */
    documentId: string;
    /**
     * User free explanation text
     * @type {string}
     * @memberof DocumentBaseData
     */
    explanation?: string;
    /**
     * true if the document is old
     * @type {boolean}
     * @memberof DocumentBaseData
     */
    isOldDocument: boolean;
    /**
     * Create Date
     * @type {string}
     * @memberof DocumentBaseData
     */
    createDate: string;
    /**
     * document name which is created by core service
     * @type {string}
     * @memberof DocumentBaseData
     */
    documentName: string;
}
/**
 * 
 * @export
 * @interface DocumentData
 */
export interface DocumentData {
    /**
     * Document Id
     * @type {string}
     * @memberof DocumentData
     */
    documentId: string;
    /**
     * Create Date
     * @type {string}
     * @memberof DocumentData
     */
    createDate: string;
    /**
     * User free explanation text
     * @type {string}
     * @memberof DocumentData
     */
    explanation: string;
    /**
     * Document Type
     * @type {string}
     * @memberof DocumentData
     */
    documentType: string;
    /**
     * true if the document is old
     * @type {boolean}
     * @memberof DocumentData
     */
    isOldDocument: boolean;
    /**
     * document name which is created by core service
     * @type {string}
     * @memberof DocumentData
     */
    documentName: string;
    /**
     * Physical File Name
     * @type {string}
     * @memberof DocumentData
     */
    physicalFileName?: string;
}
/**
 * 
 * @export
 * @interface DocumentLinkParameterData
 */
export interface DocumentLinkParameterData {
    /**
     * Order Number
     * @type {number}
     * @memberof DocumentLinkParameterData
     */
    orderNumber: number;
    /**
     * Text
     * @type {string}
     * @memberof DocumentLinkParameterData
     */
    text: string;
    /**
     * Link
     * @type {string}
     * @memberof DocumentLinkParameterData
     */
    link: string;
}
/**
 * 
 * @export
 * @interface DocumentLinkParameterRequest
 */
export interface DocumentLinkParameterRequest {
    /**
     * 
     * @type {DocumentLinkParameterType}
     * @memberof DocumentLinkParameterRequest
     */
    documentLinkParameterType: DocumentLinkParameterType;
}
/**
 * 
 * @export
 * @interface DocumentLinkParameterResponse
 */
export interface DocumentLinkParameterResponse extends Response {
    /**
     * 
     * @type {Array<DocumentLinkParameterData>}
     * @memberof DocumentLinkParameterResponse
     */
    documentLinkParameterDataList?: Array<DocumentLinkParameterData>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DocumentLinkParameterType {
    USERMANUAL = 'USER_MANUAL'
}

/**
 * 
 * @export
 * @interface DocumentPageBaseComponent
 */
export interface DocumentPageBaseComponent {
    /**
     * true if it is enabled
     * @type {boolean}
     * @memberof DocumentPageBaseComponent
     */
    enabled?: boolean;
    /**
     * true if it is required
     * @type {boolean}
     * @memberof DocumentPageBaseComponent
     */
    required?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentPageComboBox
 */
export interface DocumentPageComboBox extends DocumentPageBaseComponent {
}
/**
 * 
 * @export
 * @interface DocumentPageData
 */
export interface DocumentPageData {
    /**
     * 
     * @type {Array<DocumentPageIdentityData>}
     * @memberof DocumentPageData
     */
    documentIdentityDataList?: Array<DocumentPageIdentityData>;
}
/**
 * 
 * @export
 * @interface DocumentPageDataResponse
 */
export interface DocumentPageDataResponse extends Response {
    /**
     * 
     * @type {DocumentPageData}
     * @memberof DocumentPageDataResponse
     */
    pageData?: DocumentPageData;
}
/**
 * 
 * @export
 * @interface DocumentPageDatePicker
 */
export interface DocumentPageDatePicker extends DocumentPageBaseComponent {
}
/**
 * 
 * @export
 * @interface DocumentPageIdentityData
 */
export interface DocumentPageIdentityData {
    /**
     * id
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    customerIdentityId?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof DocumentPageIdentityData
     */
    identityType: DictionaryLine;
    /**
     * Serial code
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    identityDocumentSerialCode?: string;
    /**
     * Serial Number
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    identityDocumentSerialNumber?: string;
    /**
     * Date Of Issue
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    issueDate?: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    expireDate?: string;
    /**
     * Issued By
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    issuedBy?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof DocumentPageIdentityData
     */
    issueCountry?: DictionaryLine;
    /**
     * Code of Issue Place
     * @type {string}
     * @memberof DocumentPageIdentityData
     */
    unitCode?: string;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof DocumentPageIdentityData
     */
    isNew?: boolean;
    /**
     * true if document is active
     * @type {boolean}
     * @memberof DocumentPageIdentityData
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentPageTextBox
 */
export interface DocumentPageTextBox extends DocumentPageBaseComponent {
    /**
     * minimum Length
     * @type {number}
     * @memberof DocumentPageTextBox
     */
    minimumLength?: number;
    /**
     * maximum Length
     * @type {number}
     * @memberof DocumentPageTextBox
     */
    maximumLength?: number;
    /**
     * mask format
     * @type {string}
     * @memberof DocumentPageTextBox
     */
    maskFormat?: string;
    /**
     * 
     * @type {DocumentPageValidationDataType}
     * @memberof DocumentPageTextBox
     */
    dataType?: DocumentPageValidationDataType;
}
/**
 * 
 * @export
 * @interface DocumentPageUploadData
 */
export interface DocumentPageUploadData extends DocumentBaseData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof DocumentPageUploadData
     */
    documentType: DictionaryLine;
}
/**
 * 
 * @export
 * @interface DocumentPageUploadDataRequest
 */
export interface DocumentPageUploadDataRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof DocumentPageUploadDataRequest
     */
    documentUploadDataList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface DocumentPageValidationComponentsRequest
 */
export interface DocumentPageValidationComponentsRequest {
    /**
     * 
     * @type {CardApplicationScreenType}
     * @memberof DocumentPageValidationComponentsRequest
     */
    cardApplicationScreenType: CardApplicationScreenType;
}
/**
 * 
 * @export
 * @interface DocumentPageValidationComponentsResponse
 */
export interface DocumentPageValidationComponentsResponse extends Response {
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof DocumentPageValidationComponentsResponse
     */
    series: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof DocumentPageValidationComponentsResponse
     */
    documentNumber: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageDatePicker}
     * @memberof DocumentPageValidationComponentsResponse
     */
    issueDate: DocumentPageDatePicker;
    /**
     * 
     * @type {DocumentPageDatePicker}
     * @memberof DocumentPageValidationComponentsResponse
     */
    expireDate?: DocumentPageDatePicker;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof DocumentPageValidationComponentsResponse
     */
    issuedBy: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageComboBox}
     * @memberof DocumentPageValidationComponentsResponse
     */
    country?: DocumentPageComboBox;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof DocumentPageValidationComponentsResponse
     */
    unitCode: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof DocumentPageValidationComponentsResponse
     */
    inn?: DocumentPageTextBox;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DocumentPageValidationDataType {
    NUMERIC = 'NUMERIC',
    ALPHANUMERIC = 'ALPHANUMERIC',
    FREETEXT = 'FREETEXT'
}

/**
 * 
 * @export
 * @interface DocumentResponse
 */
export interface DocumentResponse extends Response {
    /**
     * Create Date
     * @type {string}
     * @memberof DocumentResponse
     */
    createDate: string;
    /**
     * Document Id
     * @type {string}
     * @memberof DocumentResponse
     */
    documentId: string;
    /**
     * User free explanation text
     * @type {string}
     * @memberof DocumentResponse
     */
    explanation: string;
    /**
     * Document Type
     * @type {string}
     * @memberof DocumentResponse
     */
    documentType: string;
    /**
     * true if the document is old
     * @type {boolean}
     * @memberof DocumentResponse
     */
    isOldDocument: boolean;
    /**
     * document name which is created by core service
     * @type {string}
     * @memberof DocumentResponse
     */
    documentName: string;
}
/**
 * 
 * @export
 * @interface DocumentStorageRequest
 */
export interface DocumentStorageRequest {
    /**
     * Document Id
     * @type {string}
     * @memberof DocumentStorageRequest
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface DocumentStorageResponse
 */
export interface DocumentStorageResponse extends Response {
    /**
     * Base64 encoded document image
     * @type {string}
     * @memberof DocumentStorageResponse
     */
    documentData: string;
}
/**
 * 
 * @export
 * @interface DocumentTypeRequest
 */
export interface DocumentTypeRequest {
    /**
     * 
     * @type {CardApplicationScreenType}
     * @memberof DocumentTypeRequest
     */
    cardApplicationScreenType?: CardApplicationScreenType;
}
/**
 * 
 * @export
 * @interface DocumentTypeResponse
 */
export interface DocumentTypeResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof DocumentTypeResponse
     */
    documentTypeList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface DocumentUploadCardListData
 */
export interface DocumentUploadCardListData {
    /**
     * Card Number
     * @type {string}
     * @memberof DocumentUploadCardListData
     */
    cardNumber: string;
    /**
     * Name on the Card
     * @type {string}
     * @memberof DocumentUploadCardListData
     */
    cardEmbossedName: string;
    /**
     * Card Status
     * @type {string}
     * @memberof DocumentUploadCardListData
     */
    cardStatus?: string;
    /**
     * Expire Date
     * @type {string}
     * @memberof DocumentUploadCardListData
     */
    expireDate?: string;
    /**
     * Card Id
     * @type {string}
     * @memberof DocumentUploadCardListData
     */
    cardId: string;
    /**
     * Card Account Number
     * @type {string}
     * @memberof DocumentUploadCardListData
     */
    cardAccountNumber: string;
}
/**
 * 
 * @export
 * @interface DocumentUploadCardRequest
 */
export interface DocumentUploadCardRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof DocumentUploadCardRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface DocumentUploadCardResponse
 */
export interface DocumentUploadCardResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<DocumentUploadCardListData>}
     * @memberof DocumentUploadCardResponse
     */
    cardList: Array<DocumentUploadCardListData>;
}
/**
 * 
 * @export
 * @interface DocumentUploadClientInfoRequest
 */
export interface DocumentUploadClientInfoRequest {
    /**
     * Customer Surname
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    customerSurname: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    customerName: string;
    /**
     * Second Name
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    customerSecondName: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    customerNumber: string;
    /**
     * Customer Id
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    customerId: string;
    /**
     * Card Number
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    cardNumber?: string;
    /**
     * Credit Code
     * @type {string}
     * @memberof DocumentUploadClientInfoRequest
     */
    creditId?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof DocumentUploadClientInfoRequest
     */
    uploadDocumentFormType: DictionaryLine;
}
/**
 * 
 * @export
 * @interface DocumentUploadClientInfoResponse
 */
export interface DocumentUploadClientInfoResponse extends Response {
    /**
     * Upload Document Form Type Value
     * @type {string}
     * @memberof DocumentUploadClientInfoResponse
     */
    uploadDocumentFormTypeValue: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof DocumentUploadClientInfoResponse
     */
    clientName: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof DocumentUploadClientInfoResponse
     */
    customerNumber: string;
    /**
     * True if card number will be visible
     * @type {boolean}
     * @memberof DocumentUploadClientInfoResponse
     */
    isCardNumberVisible: boolean;
    /**
     * Card Number
     * @type {string}
     * @memberof DocumentUploadClientInfoResponse
     */
    cardNumber?: string;
    /**
     * True if contract number will be visible
     * @type {boolean}
     * @memberof DocumentUploadClientInfoResponse
     */
    isContractNumberVisible?: boolean;
    /**
     * Contract Number
     * @type {string}
     * @memberof DocumentUploadClientInfoResponse
     */
    contractNumber?: string;
    /**
     * True if note field is enable
     * @type {boolean}
     * @memberof DocumentUploadClientInfoResponse
     */
    enableNote: boolean;
}
/**
 * 
 * @export
 * @interface DocumentUploadData
 */
export interface DocumentUploadData extends DocumentBaseData {
    /**
     * Document Type
     * @type {string}
     * @memberof DocumentUploadData
     */
    documentType: string;
    /**
     * Physical File Name
     * @type {string}
     * @memberof DocumentUploadData
     */
    physicalFileName?: string;
}
/**
 * 
 * @export
 * @interface DocumentUploadDocTypeRequest
 */
export interface DocumentUploadDocTypeRequest {
    /**
     * Product Code
     * @type {string}
     * @memberof DocumentUploadDocTypeRequest
     */
    productCode?: string;
}
/**
 * 
 * @export
 * @interface DocumentUploadDocTypeResponse
 */
export interface DocumentUploadDocTypeResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof DocumentUploadDocTypeResponse
     */
    documentTypeList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ErrorType {
    COREERROR = 'CORE_ERROR',
    MIDDLEWAREERROR = 'MIDDLEWARE_ERROR',
    CAPTCHAERROR = 'CAPTCHA_ERROR',
    FILEUPLOADERROR = 'FILE_UPLOAD_ERROR',
    AUTHENTICATIONERROR = 'AUTHENTICATION_ERROR',
    REGISTRATIONERROR = 'REGISTRATION_ERROR',
    RECOVERYERROR = 'RECOVERY_ERROR',
    GENERALERROR = 'GENERAL_ERROR',
    FILEUPLOADSIZEERROR = 'FILE_UPLOAD_SIZE_ERROR'
}

/**
 * 
 * @export
 * @interface ExceptionResponse
 */
export interface ExceptionResponse {
    /**
     * 
     * @type {string}
     * @memberof ExceptionResponse
     */
    timestamp?: string;
    /**
     * 
     * @type {Result}
     * @memberof ExceptionResponse
     */
    result: Result;
    /**
     * 
     * @type {Error}
     * @memberof ExceptionResponse
     */
    error?: Error;
    /**
     * 
     * @type {boolean}
     * @memberof ExceptionResponse
     */
    showCaptcha?: boolean;
}
/**
 * 
 * @export
 * @interface ExchangeRate
 */
export interface ExchangeRate {
    /**
     * Currency
     * @type {string}
     * @memberof ExchangeRate
     */
    exchangeType: string;
    /**
     * Symbol of Currency
     * @type {string}
     * @memberof ExchangeRate
     */
    exchangeSymbol: string;
    /**
     * 
     * @type {Rate}
     * @memberof ExchangeRate
     */
    centralBank?: Rate;
    /**
     * 
     * @type {Rate}
     * @memberof ExchangeRate
     */
    sale?: Rate;
    /**
     * 
     * @type {Rate}
     * @memberof ExchangeRate
     */
    purchase?: Rate;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ExchangeRateDirection {
    DOWN = 'DOWN',
    HOLD = 'HOLD',
    UP = 'UP'
}

/**
 * 
 * @export
 * @interface ExchangeRateResponse
 */
export interface ExchangeRateResponse extends Response {
    /**
     * 
     * @type {Array<ExchangeRate>}
     * @memberof ExchangeRateResponse
     */
    exchangeRateList: Array<ExchangeRate>;
}
/**
 * 
 * @export
 * @interface FiasAddressData
 */
export interface FiasAddressData {
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    country_iso_code?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    postal_code?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    street_type_full?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    house?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    block?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    region_kladr_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    settlement_with_type?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    flat?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressData
     */
    area_with_type?: string;
}
/**
 * 
 * @export
 * @interface FiasAddressRequest
 */
export interface FiasAddressRequest {
    /**
     * Query text
     * @type {string}
     * @memberof FiasAddressRequest
     */
    query?: string;
    /**
     * Number of results. default 10, max 20
     * @type {number}
     * @memberof FiasAddressRequest
     */
    count?: number;
    /**
     * Response language
     * @type {string}
     * @memberof FiasAddressRequest
     */
    language?: string;
}
/**
 * 
 * @export
 * @interface FiasAddressResponse
 */
export interface FiasAddressResponse extends Response {
    /**
     * 
     * @type {Array<FiasAddressSuggestion>}
     * @memberof FiasAddressResponse
     */
    suggestions?: Array<FiasAddressSuggestion>;
}
/**
 * 
 * @export
 * @interface FiasAddressSuggestion
 */
export interface FiasAddressSuggestion {
    /**
     * 
     * @type {string}
     * @memberof FiasAddressSuggestion
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressSuggestion
     */
    unrestricted_value?: string;
    /**
     * 
     * @type {FiasAddressData}
     * @memberof FiasAddressSuggestion
     */
    data?: FiasAddressData;
}
/**
 * 
 * @export
 * @interface FnsSearchRequest
 */
export interface FnsSearchRequest {
    /**
     * Текст запроса (наименование, ИНН и т.д.)
     * @type {string}
     * @memberof FnsSearchRequest
     */
    q: string;
    /**
     * Номер страницы результата
     * @type {number}
     * @memberof FnsSearchRequest
     */
    page?: number;
}
/**
 * 
 * @export
 * @interface FnsSearchResponse
 */
export interface FnsSearchResponse {
    /**
     * Список найденных записей
     * @type {Array<LegalEntity>}
     * @memberof FnsSearchResponse
     */
    items?: Array<LegalEntity>;
    /**
     * Общее количество записей
     * @type {number}
     * @memberof FnsSearchResponse
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetDocumentRequest
 */
export interface GetDocumentRequest {
    /**
     * Document Id
     * @type {string}
     * @memberof GetDocumentRequest
     */
    documentId: string;
    /**
     * document name which is created by core service
     * @type {string}
     * @memberof GetDocumentRequest
     */
    documentName: string;
}
/**
 * 
 * @export
 * @interface GetDocumentResponse
 */
export interface GetDocumentResponse extends Response {
    /**
     * Base64 encoded document image
     * @type {string}
     * @memberof GetDocumentResponse
     */
    documentData: string;
}
/**
 * 
 * @export
 * @interface GlobalBonusUserInfoRequest
 */
export interface GlobalBonusUserInfoRequest {
    /**
     * Employee Number
     * @type {string}
     * @memberof GlobalBonusUserInfoRequest
     */
    employeeNumber: string;
}
/**
 * 
 * @export
 * @interface GlobalBonusUserInfoResponse
 */
export interface GlobalBonusUserInfoResponse extends Response {
    /**
     * Full Name
     * @type {string}
     * @memberof GlobalBonusUserInfoResponse
     */
    fullName?: string;
    /**
     * Employee Number
     * @type {string}
     * @memberof GlobalBonusUserInfoResponse
     */
    employeeNumber?: string;
}
/**
 * 
 * @export
 * @interface GlobalBonusVisibilityResponse
 */
export interface GlobalBonusVisibilityResponse extends Response {
    /**
     * true if global bonus is visible
     * @type {boolean}
     * @memberof GlobalBonusVisibilityResponse
     */
    isGlobalBonusVisible?: boolean;
}
/**
 * 
 * @export
 * @interface IndividualPageData
 */
export interface IndividualPageData {
    /**
     * Customer Id
     * @type {string}
     * @memberof IndividualPageData
     */
    customerId?: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof IndividualPageData
     */
    customerNumber?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof IndividualPageData
     */
    customerSurname: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof IndividualPageData
     */
    customerName: string;
    /**
     * Second Name
     * @type {string}
     * @memberof IndividualPageData
     */
    customerSecondName: string;
    /**
     * Customer Surname non-resident
     * @type {string}
     * @memberof IndividualPageData
     */
    customerSurnameNonresident?: string;
    /**
     * Customer Name non-resident
     * @type {string}
     * @memberof IndividualPageData
     */
    customerNameNonresident?: string;
    /**
     * Second Name non-resident
     * @type {string}
     * @memberof IndividualPageData
     */
    customerSecondNameNonresident?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof IndividualPageData
     */
    customerGender?: DictionaryLine;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof IndividualPageData
     */
    birthDate: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof IndividualPageData
     */
    birthPlaceCountry?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof IndividualPageData
     */
    citizenship: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof IndividualPageData
     */
    birthPlaceRegion: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof IndividualPageData
     */
    residenceCountry: DictionaryLine;
    /**
     * City of Birth Place
     * @type {string}
     * @memberof IndividualPageData
     */
    birthPlaceCity: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof IndividualPageData
     */
    hasPreviousSurname?: DictionaryLine;
    /**
     * Previous Surname
     * @type {string}
     * @memberof IndividualPageData
     */
    previousSurname?: string;
    /**
     * keeps enable property of country fields
     * @type {boolean}
     * @memberof IndividualPageData
     */
    isCountryFieldsEnable?: boolean;
    /**
     * true if it is product offer
     * @type {boolean}
     * @memberof IndividualPageData
     */
    isProductOffer?: boolean;
}
/**
 * 
 * @export
 * @interface IndividualPageDataResponse
 */
export interface IndividualPageDataResponse extends Response {
    /**
     * 
     * @type {IndividualPageData}
     * @memberof IndividualPageDataResponse
     */
    pageData?: IndividualPageData;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum InputType {
    NUMERIC = 'NUMERIC',
    ALPHANUMERIC = 'ALPHANUMERIC',
    FREETEXT = 'FREETEXT',
    DATE = 'DATE',
    CURRENCY = 'CURRENCY'
}

/**
 * 
 * @export
 * @interface InstantEmbossResponse
 */
export interface InstantEmbossResponse extends Response {
    /**
     * branch code
     * @type {string}
     * @memberof InstantEmbossResponse
     */
    branchCode: string;
    /**
     * delivery address code
     * @type {string}
     * @memberof InstantEmbossResponse
     */
    cardDeliveryAddressCode: string;
    /**
     * delivery address code
     * @type {string}
     * @memberof InstantEmbossResponse
     */
    pinCodeDeliveryBranchCode: string;
    /**
     * branch code
     * @type {string}
     * @memberof InstantEmbossResponse
     */
    pinCodeDeliveryAddressCode: string;
}
/**
 * Юридическое лицо (ключ \"ЮЛ\")
 * @export
 * @interface LegalEntity
 */
export interface LegalEntity {
    /**
     * Инн + наименование
     * @type {string}
     * @memberof LegalEntity
     */
    value?: string;
    /**
     * ИНН организации
     * @type {string}
     * @memberof LegalEntity
     */
    inn: string;
    /**
     * Краткое наименование организации
     * @type {string}
     * @memberof LegalEntity
     */
    shortName: string;
}
/**
 * 
 * @export
 * @interface LoanActionComboRequest
 */
export interface LoanActionComboRequest {
    /**
     * Loan Type Code
     * @type {string}
     * @memberof LoanActionComboRequest
     */
    loanTypeCode: string;
    /**
     * Retail Outlet Code
     * @type {string}
     * @memberof LoanActionComboRequest
     */
    retailOutletCode: string;
}
/**
 * 
 * @export
 * @interface LoanActionComboResponse
 */
export interface LoanActionComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof LoanActionComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface LoanAdditionalEquipmentPageData
 */
export interface LoanAdditionalEquipmentPageData {
    /**
     * 
     * @type {Array<LoanAdditionalEquipmentPageDataList>}
     * @memberof LoanAdditionalEquipmentPageData
     */
    loanAdditionalEquipmentList: Array<LoanAdditionalEquipmentPageDataList>;
}
/**
 * 
 * @export
 * @interface LoanAdditionalEquipmentPageDataList
 */
export interface LoanAdditionalEquipmentPageDataList {
    /**
     * Additional Equipment
     * @type {string}
     * @memberof LoanAdditionalEquipmentPageDataList
     */
    additionalEquipment: string;
    /**
     * Price
     * @type {number}
     * @memberof LoanAdditionalEquipmentPageDataList
     */
    price: number;
    /**
     * currency
     * @type {string}
     * @memberof LoanAdditionalEquipmentPageDataList
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface LoanAdditionalEquipmentPageDataResponse
 */
export interface LoanAdditionalEquipmentPageDataResponse extends Response {
    /**
     * 
     * @type {LoanAdditionalEquipmentPageData}
     * @memberof LoanAdditionalEquipmentPageDataResponse
     */
    pageData?: LoanAdditionalEquipmentPageData;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesGlobalBonusPageData
 */
export interface LoanAdditionalServicesGlobalBonusPageData {
    /**
     * Employee Number
     * @type {string}
     * @memberof LoanAdditionalServicesGlobalBonusPageData
     */
    employeeNumber: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAdditionalServicesGlobalBonusPageData
     */
    connection: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesGlobalBonusPageDataResponse
 */
export interface LoanAdditionalServicesGlobalBonusPageDataResponse extends Response {
    /**
     * 
     * @type {LoanAdditionalServicesGlobalBonusPageData}
     * @memberof LoanAdditionalServicesGlobalBonusPageDataResponse
     */
    pageData?: LoanAdditionalServicesGlobalBonusPageData;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesPageData
 */
export interface LoanAdditionalServicesPageData {
    /**
     * 
     * @type {Array<LoanAdditionalServicesPageDataList>}
     * @memberof LoanAdditionalServicesPageData
     */
    loanAdditionalServicesList?: Array<LoanAdditionalServicesPageDataList>;
    /**
     * true if life insurance has been checked
     * @type {boolean}
     * @memberof LoanAdditionalServicesPageData
     */
    lifeInsurance: boolean;
    /**
     * true if sms information has been checked
     * @type {boolean}
     * @memberof LoanAdditionalServicesPageData
     */
    smsInformation: boolean;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesPageDataList
 */
export interface LoanAdditionalServicesPageDataList {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAdditionalServicesPageDataList
     */
    service: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAdditionalServicesPageDataList
     */
    organization: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAdditionalServicesPageDataList
     */
    product: DictionaryLine;
    /**
     * Price
     * @type {number}
     * @memberof LoanAdditionalServicesPageDataList
     */
    price: number;
    /**
     * Employee Number
     * @type {string}
     * @memberof LoanAdditionalServicesPageDataList
     */
    employeeNumber?: string;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesPageDataResponse
 */
export interface LoanAdditionalServicesPageDataResponse extends Response {
    /**
     * 
     * @type {LoanAdditionalServicesPageData}
     * @memberof LoanAdditionalServicesPageDataResponse
     */
    pageData?: LoanAdditionalServicesPageData;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesProductPriceRequest
 */
export interface LoanAdditionalServicesProductPriceRequest {
    /**
     * Product Code
     * @type {string}
     * @memberof LoanAdditionalServicesProductPriceRequest
     */
    productCode: string;
    /**
     * Service Code
     * @type {string}
     * @memberof LoanAdditionalServicesProductPriceRequest
     */
    serviceCode: string;
    /**
     * Organization Code
     * @type {string}
     * @memberof LoanAdditionalServicesProductPriceRequest
     */
    organizationCode: string;
}
/**
 * 
 * @export
 * @interface LoanAdditionalServicesProductPriceResponse
 */
export interface LoanAdditionalServicesProductPriceResponse extends Response {
    /**
     * Price
     * @type {string}
     * @memberof LoanAdditionalServicesProductPriceResponse
     */
    price: string;
}
/**
 * 
 * @export
 * @interface LoanAddressData
 */
export interface LoanAddressData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressData
     */
    country?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressData
     */
    region?: DictionaryLine;
    /**
     * city
     * @type {string}
     * @memberof LoanAddressData
     */
    city?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressData
     */
    district?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressData
     */
    streetType?: DictionaryLine;
    /**
     * Street
     * @type {string}
     * @memberof LoanAddressData
     */
    street?: string;
    /**
     * House Number
     * @type {string}
     * @memberof LoanAddressData
     */
    houseNumber?: string;
    /**
     * Building Info
     * @type {string}
     * @memberof LoanAddressData
     */
    buildingInfo?: string;
    /**
     * ZipCode
     * @type {string}
     * @memberof LoanAddressData
     */
    zipCode?: string;
    /**
     * Flat Number
     * @type {string}
     * @memberof LoanAddressData
     */
    flatNumber?: string;
}
/**
 * 
 * @export
 * @interface LoanAddressPageData
 */
export interface LoanAddressPageData {
    /**
     * 
     * @type {Array<LoanAddressPageRowData>}
     * @memberof LoanAddressPageData
     */
    adressList?: Array<LoanAddressPageRowData>;
}
/**
 * 
 * @export
 * @interface LoanAddressPageDataResponse
 */
export interface LoanAddressPageDataResponse extends Response {
    /**
     * 
     * @type {LoanAddressPageData}
     * @memberof LoanAddressPageDataResponse
     */
    pageData?: LoanAddressPageData;
}
/**
 * 
 * @export
 * @interface LoanAddressPageRowData
 */
export interface LoanAddressPageRowData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressPageRowData
     */
    addressType: DictionaryLine;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof LoanAddressPageRowData
     */
    isRegistration: boolean;
    /**
     * Address Query of Fias
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    addressQuery?: string;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof LoanAddressPageRowData
     */
    manualAddress?: boolean;
    /**
     * Registration Date
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    registrationDate: string;
    /**
     * 
     * @type {LoanAddressData}
     * @memberof LoanAddressPageRowData
     */
    selectedSuggestion?: LoanAddressData;
    /**
     * Address Id
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    addressId?: string;
    /**
     * Flat Number
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    flatNumber?: string;
    /**
     * true if address is new
     * @type {boolean}
     * @memberof LoanAddressPageRowData
     */
    isAddressNew?: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressPageRowData
     */
    country: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressPageRowData
     */
    region: DictionaryLine;
    /**
     * city
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    city: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressPageRowData
     */
    district?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressPageRowData
     */
    streetType: DictionaryLine;
    /**
     * Street
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    street?: string;
    /**
     * House Number
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    houseNumber?: string;
    /**
     * Building Info
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    buildingInfo?: string;
    /**
     * ZipCode
     * @type {string}
     * @memberof LoanAddressPageRowData
     */
    zipCode?: string;
    /**
     * true if address is correspondence
     * @type {boolean}
     * @memberof LoanAddressPageRowData
     */
    hasCorrespondenceFlag: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanAddressPageRowData
     */
    addressHomeOwnerType?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanApplicationApplyRequest
 */
export interface LoanApplicationApplyRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof LoanApplicationApplyRequest
     */
    documentList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface LoanApplicationApplyResponse
 */
export interface LoanApplicationApplyResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof LoanApplicationApplyResponse
     */
    applicationResultMessage: string;
    /**
     * 
     * @type {ScoringResultType}
     * @memberof LoanApplicationApplyResponse
     */
    scoringResultType?: ScoringResultType;
}
/**
 * 
 * @export
 * @interface LoanApplicationDocumentPageData
 */
export interface LoanApplicationDocumentPageData {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof LoanApplicationDocumentPageData
     */
    documentUploadDataList?: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface LoanApplicationDocumentPageDataResponse
 */
export interface LoanApplicationDocumentPageDataResponse extends Response {
    /**
     * 
     * @type {LoanApplicationDocumentPageData}
     * @memberof LoanApplicationDocumentPageDataResponse
     */
    pageData?: LoanApplicationDocumentPageData;
}
/**
 * 
 * @export
 * @interface LoanApplicationPrintApplicationDocumentResponse
 */
export interface LoanApplicationPrintApplicationDocumentResponse extends Response {
    /**
     * Document Id
     * @type {string}
     * @memberof LoanApplicationPrintApplicationDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface LoanApplicationPrintPowerOfAttorneyDocumentResponse
 */
export interface LoanApplicationPrintPowerOfAttorneyDocumentResponse extends Response {
    /**
     * Document Id
     * @type {string}
     * @memberof LoanApplicationPrintPowerOfAttorneyDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface LoanBenefitsThirdPartyData
 */
export interface LoanBenefitsThirdPartyData {
    /**
     * beneficiary name
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    beneficiaryName: string;
    /**
     * birth place
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    birthPlace: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    birthDate: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanBenefitsThirdPartyData
     */
    identityType: DictionaryLine;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    identityDocumentSerialCode: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    identityDocumentSerialNumber: string;
    /**
     * Issue Date
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    issueDate: string;
    /**
     * Issued By
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    issuedBy: string;
    /**
     * Code of Issue Place
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    unitCode: string;
    /**
     * Given Country
     * @type {string}
     * @memberof LoanBenefitsThirdPartyData
     */
    inn: string;
}
/**
 * 
 * @export
 * @interface LoanBenefitsThirdPartyPageData
 */
export interface LoanBenefitsThirdPartyPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanBenefitsThirdPartyPageData
     */
    hasBenefitsThirdParty: DictionaryLine;
    /**
     * 
     * @type {LoanBenefitsThirdPartyData}
     * @memberof LoanBenefitsThirdPartyPageData
     */
    benefitsThirdParty?: LoanBenefitsThirdPartyData;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanBenefitsThirdPartyPageData
     */
    hasControlPerson: DictionaryLine;
    /**
     * 
     * @type {LoanBenefitsThirdPartyData}
     * @memberof LoanBenefitsThirdPartyPageData
     */
    controlPerson?: LoanBenefitsThirdPartyData;
}
/**
 * 
 * @export
 * @interface LoanBenefitsThirdPartyPageDataResponse
 */
export interface LoanBenefitsThirdPartyPageDataResponse extends Response {
    /**
     * 
     * @type {LoanBenefitsThirdPartyPageData}
     * @memberof LoanBenefitsThirdPartyPageDataResponse
     */
    pageData?: LoanBenefitsThirdPartyPageData;
}
/**
 * 
 * @export
 * @interface LoanCarBrandComboRequest
 */
export interface LoanCarBrandComboRequest {
    /**
     * Loan Car Vehicle Code
     * @type {string}
     * @memberof LoanCarBrandComboRequest
     */
    vehicleCode: string;
    /**
     * Loan Service Group Code
     * @type {string}
     * @memberof LoanCarBrandComboRequest
     */
    serviceGroupCode: string;
}
/**
 * 
 * @export
 * @interface LoanCarBrandComboResponse
 */
export interface LoanCarBrandComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof LoanCarBrandComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface LoanCarDocumentsPageData
 */
export interface LoanCarDocumentsPageData {
    /**
     * true if A copy of your passport check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    documentCopyPassport: boolean;
    /**
     * true if Questionnaire check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    questionnaire: boolean;
    /**
     * true if Driver\'s license check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    driverLicense: boolean;
    /**
     * true if A copy of the Certificate confirming the ownership right check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    ownerShipRight: boolean;
    /**
     * true if Certificate of registration of INN check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    certificateINN: boolean;
    /**
     * true if Balance sheet and income statement for the last year check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    balanceSheet: boolean;
    /**
     * true if A copy of the income book (at least for the past 6 months) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    incomeBook: boolean;
    /**
     * true if A copy of the cash register check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    cashRegister: boolean;
    /**
     * true if A copy of the tax return (at least for the last 6 months) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    taxReturn: boolean;
    /**
     * true if Extract from the tax inspectorate on open accounts (for amounts over RUR 3 million) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    taxInspectorate: boolean;
    /**
     * true if A copy of the license (if it is necessary for conducting this type of business check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    license: boolean;
    /**
     * true if Statement from all bank accounts for the last 6 months (monthly) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    statementBankAccounts: boolean;
    /**
     * true if Confirmation of the absence of overdue loans (Card File 2) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    confirmationOverdueLoans: boolean;
    /**
     * true if If the Borrower has a loan (s) in other banks - a certificate from this bank confirming the risk check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    hasLoan: boolean;
    /**
     * true if A copy of your passport (Guarantor) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    guarantorCopyPassport: boolean;
    /**
     * true if Certificate of income 2 personal income tax for the last 6 months or the last certificate of 3 personal income tax check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    certificateIncomeTax: boolean;
    /**
     * true if Proof of income (one of the following documents) check
     * @type {boolean}
     * @memberof LoanCarDocumentsPageData
     */
    proofOfIncome: boolean;
}
/**
 * 
 * @export
 * @interface LoanCarDocumentsPageDataResponse
 */
export interface LoanCarDocumentsPageDataResponse extends Response {
    /**
     * 
     * @type {LoanCarDocumentsPageData}
     * @memberof LoanCarDocumentsPageDataResponse
     */
    pageData?: LoanCarDocumentsPageData;
}
/**
 * 
 * @export
 * @interface LoanCarTotalCostPageData
 */
export interface LoanCarTotalCostPageData {
    /**
     * Interest Rate
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    interestRate: string;
    /**
     * Differentiated Interest Rate
     * @type {boolean}
     * @memberof LoanCarTotalCostPageData
     */
    differentiatedInterestRate?: boolean;
    /**
     * Loan Amount
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    loanAmount: number;
    /**
     * Currency Code
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    currency: string;
    /**
     * Down Payment Amount
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    downPaymentAmount?: number;
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    downPaymentRate?: string;
    /**
     * Interest Rate in case of non-fulfillment of insurance obligations
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    alternativeActionRate?: string;
    /**
     * Commission for issuing a loan
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    commissionAmount?: number;
    /**
     * Interest Accrual Scheme
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    interestScheme?: string;
    /**
     * Account Maintenance Fee
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    periodicCommissionAmount?: number;
    /**
     * Initial Deposit Amount
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    depositAmount: number;
    /**
     * Commission for consideration of the application
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    fixedCommissionAmount?: number;
    /**
     * Interest Payable
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    accruedInterest?: string;
    /**
     * Early Payment Fee
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    earlyPaymentCommisionAmount?: string;
    /**
     * Commission For Life Insurance
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    insuranceAmount?: number;
    /**
     * Opening Date
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    openingDate?: string;
    /**
     * Product Price
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    productPrice: number;
    /**
     * Additional Services Amount
     * @type {number}
     * @memberof LoanCarTotalCostPageData
     */
    additionalServicesAmount: number;
    /**
     * Period Code
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    period: string;
    /**
     * Comments
     * @type {string}
     * @memberof LoanCarTotalCostPageData
     */
    comments?: string;
}
/**
 * 
 * @export
 * @interface LoanCarTotalCostPageDataResponse
 */
export interface LoanCarTotalCostPageDataResponse extends Response {
    /**
     * 
     * @type {LoanCarTotalCostPageData}
     * @memberof LoanCarTotalCostPageDataResponse
     */
    pageData?: LoanCarTotalCostPageData;
}
/**
 * 
 * @export
 * @interface LoanContactInfoPageData
 */
export interface LoanContactInfoPageData {
    /**
     * customer email
     * @type {string}
     * @memberof LoanContactInfoPageData
     */
    emailAddress?: string;
    /**
     * 
     * @type {LoanPhoneInfoPageData}
     * @memberof LoanContactInfoPageData
     */
    mobilePhone: LoanPhoneInfoPageData;
    /**
     * 
     * @type {LoanPhoneInfoPageData}
     * @memberof LoanContactInfoPageData
     */
    actualLivingAddressPhone?: LoanPhoneInfoPageData;
    /**
     * 
     * @type {LoanPhoneInfoPageData}
     * @memberof LoanContactInfoPageData
     */
    workPhone?: LoanPhoneInfoPageData;
    /**
     * 
     * @type {LoanPhoneInfoPageData}
     * @memberof LoanContactInfoPageData
     */
    registrationAddressPhone?: LoanPhoneInfoPageData;
    /**
     * 
     * @type {LoanPhoneInfoPageData}
     * @memberof LoanContactInfoPageData
     */
    contactPersonMobilePhone1?: LoanPhoneInfoPageData;
    /**
     * 
     * @type {LoanPhoneInfoPageData}
     * @memberof LoanContactInfoPageData
     */
    contactPersonMobilePhone2?: LoanPhoneInfoPageData;
}
/**
 * 
 * @export
 * @interface LoanContactInfoPageDataResponse
 */
export interface LoanContactInfoPageDataResponse extends Response {
    /**
     * 
     * @type {LoanContactInfoPageData}
     * @memberof LoanContactInfoPageDataResponse
     */
    pageData?: LoanContactInfoPageData;
}
/**
 * 
 * @export
 * @interface LoanCustomerContactInfoRequest
 */
export interface LoanCustomerContactInfoRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof LoanCustomerContactInfoRequest
     */
    customerId: string;
}
/**
 * 
 * @export
 * @interface LoanCustomerContactInfoResponse
 */
export interface LoanCustomerContactInfoResponse extends Response {
    /**
     * Email Address
     * @type {string}
     * @memberof LoanCustomerContactInfoResponse
     */
    emailAddress?: string;
    /**
     * Email Address Id
     * @type {string}
     * @memberof LoanCustomerContactInfoResponse
     */
    emailAddressId: string;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof LoanCustomerContactInfoResponse
     */
    mobilePhone?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof LoanCustomerContactInfoResponse
     */
    actualLivingAddressPhone?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof LoanCustomerContactInfoResponse
     */
    workPhone?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof LoanCustomerContactInfoResponse
     */
    contactPersonMobilePhone1?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof LoanCustomerContactInfoResponse
     */
    contactPersonMobilePhone2?: PhoneDetailData;
    /**
     * 
     * @type {PhoneDetailData}
     * @memberof LoanCustomerContactInfoResponse
     */
    registrationAddressPhone?: PhoneDetailData;
}
/**
 * 
 * @export
 * @interface LoanCustomerCreateResponse
 */
export interface LoanCustomerCreateResponse extends Response {
    /**
     * Customer Oid
     * @type {string}
     * @memberof LoanCustomerCreateResponse
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface LoanCustomerDetailPageData
 */
export interface LoanCustomerDetailPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    maritalStatus: DictionaryLine;
    /**
     * Number of Children
     * @type {number}
     * @memberof LoanCustomerDetailPageData
     */
    numberOfChildren?: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    educationStatus: DictionaryLine;
    /**
     * Monthly Income
     * @type {number}
     * @memberof LoanCustomerDetailPageData
     */
    monthlyIncome: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    hasUSAPermit: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    hasRelativeForeignPublicOffical: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    repaymentWithThreePerson: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    bringDebtLettersByCourier: DictionaryLine;
    /**
     * Spouse Surname
     * @type {string}
     * @memberof LoanCustomerDetailPageData
     */
    spouseSurname?: string;
    /**
     * Spouse Name
     * @type {string}
     * @memberof LoanCustomerDetailPageData
     */
    spouseName?: string;
    /**
     * Spouse Second Name
     * @type {string}
     * @memberof LoanCustomerDetailPageData
     */
    spouseSecondName?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanCustomerDetailPageData
     */
    spouseTypeOfEmployment?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanCustomerDetailPageDataResponse
 */
export interface LoanCustomerDetailPageDataResponse extends Response {
    /**
     * 
     * @type {LoanCustomerDetailPageData}
     * @memberof LoanCustomerDetailPageDataResponse
     */
    pageData?: LoanCustomerDetailPageData;
}
/**
 * 
 * @export
 * @interface LoanCustomerUpdateResponse
 */
export interface LoanCustomerUpdateResponse extends Response {
}
/**
 * 
 * @export
 * @interface LoanDetailsPageConfigDataResponse
 */
export interface LoanDetailsPageConfigDataResponse extends Response {
    /**
     * true if customer receipt channel is editable
     * @type {boolean}
     * @memberof LoanDetailsPageConfigDataResponse
     */
    enableReceiptChannel?: boolean;
}
/**
 * 
 * @export
 * @interface LoanDetailsPageData
 */
export interface LoanDetailsPageData {
    /**
     * true if customer did not pass face control
     * @type {boolean}
     * @memberof LoanDetailsPageData
     */
    faceControl: boolean;
    /**
     * true if customer share credit history
     * @type {boolean}
     * @memberof LoanDetailsPageData
     */
    shareCreditHistory: boolean;
    /**
     * Credit History Subject Code
     * @type {string}
     * @memberof LoanDetailsPageData
     */
    creditHistorySubjectCode?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    merchantOrganization: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    registrationBranch: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    loanType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    actionType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    currencyType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    creditPeriod: DictionaryLine;
    /**
     * Number Of Aggreement
     * @type {string}
     * @memberof LoanDetailsPageData
     */
    numberOfAgreement?: string;
    /**
     * Income Amount
     * @type {number}
     * @memberof LoanDetailsPageData
     */
    incomeAmount?: number;
    /**
     * true if customer share promotion code
     * @type {boolean}
     * @memberof LoanDetailsPageData
     */
    sharePromotionCode?: boolean;
    /**
     * Promotion Code
     * @type {string}
     * @memberof LoanDetailsPageData
     */
    promotionCode?: string;
    /**
     * Current Accounts
     * @type {string}
     * @memberof LoanDetailsPageData
     */
    currentAccounts?: string;
    /**
     * Organization Id
     * @type {string}
     * @memberof LoanDetailsPageData
     */
    organizationId?: string;
    /**
     * Payment Recipient
     * @type {string}
     * @memberof LoanDetailsPageData
     */
    paymentRecipient?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDetailsPageData
     */
    broker?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanDetailsPageDataResponse
 */
export interface LoanDetailsPageDataResponse extends Response {
    /**
     * 
     * @type {LoanDetailsPageData}
     * @memberof LoanDetailsPageDataResponse
     */
    pageData?: LoanDetailsPageData;
}
/**
 * 
 * @export
 * @interface LoanDocumentPageData
 */
export interface LoanDocumentPageData {
    /**
     * 
     * @type {Array<LoanDocumentPageIdentityData>}
     * @memberof LoanDocumentPageData
     */
    documentIdentityDataList?: Array<LoanDocumentPageIdentityData>;
}
/**
 * 
 * @export
 * @interface LoanDocumentPageDataResponse
 */
export interface LoanDocumentPageDataResponse extends Response {
    /**
     * 
     * @type {LoanDocumentPageData}
     * @memberof LoanDocumentPageDataResponse
     */
    pageData?: LoanDocumentPageData;
}
/**
 * 
 * @export
 * @interface LoanDocumentPageIdentityData
 */
export interface LoanDocumentPageIdentityData {
    /**
     * id
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    customerIdentityId?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanDocumentPageIdentityData
     */
    identityType: DictionaryLine;
    /**
     * Serial code
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    identityDocumentSerialCode?: string;
    /**
     * Serial Number
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    identityDocumentSerialNumber?: string;
    /**
     * Date Of Issue
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    issueDate?: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    expireDate?: string;
    /**
     * Issued By
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    issuedBy?: string;
    /**
     * Code of Issue Place
     * @type {string}
     * @memberof LoanDocumentPageIdentityData
     */
    unitCode?: string;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof LoanDocumentPageIdentityData
     */
    isNew?: boolean;
    /**
     * true if document is active
     * @type {boolean}
     * @memberof LoanDocumentPageIdentityData
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface LoanDocumentPageValidationComponentsResponse
 */
export interface LoanDocumentPageValidationComponentsResponse extends Response {
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    series: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    documentNumber: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageDatePicker}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    issueDate: DocumentPageDatePicker;
    /**
     * 
     * @type {DocumentPageDatePicker}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    expireDate?: DocumentPageDatePicker;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    issuedBy: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageComboBox}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    country?: DocumentPageComboBox;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    unitCode: DocumentPageTextBox;
    /**
     * 
     * @type {DocumentPageTextBox}
     * @memberof LoanDocumentPageValidationComponentsResponse
     */
    inn?: DocumentPageTextBox;
}
/**
 * 
 * @export
 * @interface LoanDocumentTypeResponse
 */
export interface LoanDocumentTypeResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof LoanDocumentTypeResponse
     */
    loanDocumentTypeList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface LoanGoodsPageData
 */
export interface LoanGoodsPageData {
    /**
     * 
     * @type {Array<LoanGoodsPageDataList>}
     * @memberof LoanGoodsPageData
     */
    loanGoodsList?: Array<LoanGoodsPageDataList>;
}
/**
 * 
 * @export
 * @interface LoanGoodsPageDataList
 */
export interface LoanGoodsPageDataList {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanGoodsPageDataList
     */
    goodsProductGroup: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanGoodsPageDataList
     */
    goodsProduct: DictionaryLine;
    /**
     * Description
     * @type {string}
     * @memberof LoanGoodsPageDataList
     */
    description: string;
    /**
     * Price
     * @type {number}
     * @memberof LoanGoodsPageDataList
     */
    price: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanGoodsPageDataList
     */
    quantity: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanGoodsPageDataResponse
 */
export interface LoanGoodsPageDataResponse extends Response {
    /**
     * 
     * @type {LoanGoodsPageData}
     * @memberof LoanGoodsPageDataResponse
     */
    pageData?: LoanGoodsPageData;
}
/**
 * 
 * @export
 * @interface LoanGuarantorPageData
 */
export interface LoanGuarantorPageData {
    /**
     * true if co barrower check
     * @type {boolean}
     * @memberof LoanGuarantorPageData
     */
    isGuarantor: boolean;
    /**
     * Customer Id
     * @type {string}
     * @memberof LoanGuarantorPageData
     */
    customerId: string;
}
/**
 * 
 * @export
 * @interface LoanGuarantorPageDataResponse
 */
export interface LoanGuarantorPageDataResponse extends Response {
    /**
     * 
     * @type {LoanGuarantorPageData}
     * @memberof LoanGuarantorPageDataResponse
     */
    pageData?: LoanGuarantorPageData;
}
/**
 * 
 * @export
 * @interface LoanHolidayPageData
 */
export interface LoanHolidayPageData {
    /**
     * true if it is vacation credit
     * @type {boolean}
     * @memberof LoanHolidayPageData
     */
    isVacationCredit: boolean;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanHolidayPageData
     */
    destinationCountry: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanHolidayPageData
     */
    numberOfPeople: DictionaryLine;
    /**
     * Departure Date
     * @type {string}
     * @memberof LoanHolidayPageData
     */
    departureDate: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanHolidayPageData
     */
    groupComposition: DictionaryLine;
    /**
     * Duration
     * @type {string}
     * @memberof LoanHolidayPageData
     */
    duration: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanHolidayPageData
     */
    tourSource: DictionaryLine;
    /**
     * Price
     * @type {number}
     * @memberof LoanHolidayPageData
     */
    price: number;
    /**
     * Total Cost
     * @type {number}
     * @memberof LoanHolidayPageData
     */
    totalCost: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanHolidayPageData
     */
    organizationName?: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanHolidayPageDataResponse
 */
export interface LoanHolidayPageDataResponse extends Response {
    /**
     * 
     * @type {LoanHolidayPageData}
     * @memberof LoanHolidayPageDataResponse
     */
    pageData?: LoanHolidayPageData;
}
/**
 * 
 * @export
 * @interface LoanIndividualPageData
 */
export interface LoanIndividualPageData {
    /**
     * Customer Id
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    customerId?: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    customerNumber?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    customerSurname: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    customerName: string;
    /**
     * Second Name
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    customerSecondName: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanIndividualPageData
     */
    customerGender: DictionaryLine;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    birthDate: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanIndividualPageData
     */
    birthPlaceCountry?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanIndividualPageData
     */
    citizenship: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanIndividualPageData
     */
    birthPlaceRegion: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanIndividualPageData
     */
    residenceCountry: DictionaryLine;
    /**
     * City of Birth Place
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    birthPlaceCity: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanIndividualPageData
     */
    hasPreviousSurname: DictionaryLine;
    /**
     * Previous Surname
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    previousSurname?: string;
    /**
     * Code Word For The Customer Support Centre
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    codeWordForSupportCentre?: string;
    /**
     * snils
     * @type {string}
     * @memberof LoanIndividualPageData
     */
    snils?: string;
    /**
     * true if it is civil servant
     * @type {boolean}
     * @memberof LoanIndividualPageData
     */
    isCivilServant: boolean;
    /**
     * true if it is new customer
     * @type {boolean}
     * @memberof LoanIndividualPageData
     */
    isNew?: boolean;
}
/**
 * 
 * @export
 * @interface LoanIndividualPageDataResponse
 */
export interface LoanIndividualPageDataResponse extends Response {
    /**
     * 
     * @type {LoanIndividualPageData}
     * @memberof LoanIndividualPageDataResponse
     */
    pageData?: LoanIndividualPageData;
}
/**
 * 
 * @export
 * @interface LoanInsurancePageData
 */
export interface LoanInsurancePageData {
    /**
     * 
     * @type {Array<LoanInsurancePageDataList>}
     * @memberof LoanInsurancePageData
     */
    loanInsuranceList: Array<LoanInsurancePageDataList>;
}
/**
 * 
 * @export
 * @interface LoanInsurancePageDataList
 */
export interface LoanInsurancePageDataList {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanInsurancePageDataList
     */
    insurancePackage: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanInsurancePageDataList
     */
    insuranceType: DictionaryLine;
    /**
     * Price
     * @type {number}
     * @memberof LoanInsurancePageDataList
     */
    price: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanInsurancePageDataList
     */
    currencyType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanInsurancePageDataList
     */
    insurancePeriod: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanInsurancePageDataList
     */
    paymentMethod: DictionaryLine;
    /**
     * Policy Number
     * @type {string}
     * @memberof LoanInsurancePageDataList
     */
    policyNumber?: string;
    /**
     * Employee Number
     * @type {string}
     * @memberof LoanInsurancePageDataList
     */
    employeeNumber?: string;
}
/**
 * 
 * @export
 * @interface LoanInsurancePageDataResponse
 */
export interface LoanInsurancePageDataResponse extends Response {
    /**
     * 
     * @type {LoanInsurancePageData}
     * @memberof LoanInsurancePageDataResponse
     */
    pageData?: LoanInsurancePageData;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimActionComboRequest
 */
export interface LoanPaymentPlanSimActionComboRequest {
    /**
     * Loan Type Code
     * @type {string}
     * @memberof LoanPaymentPlanSimActionComboRequest
     */
    loanTypeCode: string;
    /**
     * Retail Outlet Code
     * @type {string}
     * @memberof LoanPaymentPlanSimActionComboRequest
     */
    retailOutletCode: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimActionComboResponse
 */
export interface LoanPaymentPlanSimActionComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof LoanPaymentPlanSimActionComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimAuchanCalculateRequest
 */
export interface LoanPaymentPlanSimAuchanCalculateRequest extends LoanPaymentPlanSimBaseCalculateRequest {
    /**
     * Auchan Cost
     * @type {string}
     * @memberof LoanPaymentPlanSimAuchanCalculateRequest
     */
    cost: string;
    /**
     * Life Insurance Code
     * @type {string}
     * @memberof LoanPaymentPlanSimAuchanCalculateRequest
     */
    lifeInsuranceCode: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimAuchanCalculateResponse
 */
export interface LoanPaymentPlanSimAuchanCalculateResponse extends LoanPaymentPlanSimBaseCalculateResponse {
    /**
     * Life Comm
     * @type {string}
     * @memberof LoanPaymentPlanSimAuchanCalculateResponse
     */
    lifeComm: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimBaseCalculateRequest
 */
export interface LoanPaymentPlanSimBaseCalculateRequest {
    /**
     * Loan Type Code
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    loanTypeCode: string;
    /**
     * Retail Outlet Code
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    retailOutletCode: string;
    /**
     * Action Type Code
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    actionTypeCode: string;
    /**
     * Currency Type Code
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    currencyTypeCode: string;
    /**
     * Credit Period Code
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    creditPeriodCode: string;
    /**
     * Initial Payment Rate
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    initialPaymentRate?: string;
    /**
     * Initial Payment Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    initialPaymentAmount?: string;
    /**
     * Additional Service Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateRequest
     */
    additionalServiceAmount?: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimBaseCalculateResponse
 */
export interface LoanPaymentPlanSimBaseCalculateResponse extends Response {
    /**
     * Loan Interest Rate
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateResponse
     */
    loanInterestRate: string;
    /**
     * Loan Payment Monthy
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateResponse
     */
    loanPaymentMonthly: string;
    /**
     * Initial Payment Rate
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateResponse
     */
    initialPaymentRate: string;
    /**
     * Initial Payment Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateResponse
     */
    initialPaymentAmount: string;
    /**
     * Loan Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateResponse
     */
    loanAmount: string;
    /**
     * Full Loan Cost
     * @type {string}
     * @memberof LoanPaymentPlanSimBaseCalculateResponse
     */
    fullLoanCost: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimCarCalculateRequest
 */
export interface LoanPaymentPlanSimCarCalculateRequest extends LoanPaymentPlanSimBaseCalculateRequest {
    /**
     * Car Cost
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    carCost: string;
    /**
     * Additional Equipment Cost
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    additionalEquipmentCost?: string;
    /**
     * Kasko Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    kaskoAmount: string;
    /**
     * Kasko Period Code
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    kaskoPeriodCode: string;
    /**
     * Osago Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    osagoAmount: string;
    /**
     * Osago Period Code
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    osagoPeriodCode: string;
    /**
     * Dago Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    dagoAmount?: string;
    /**
     * Dago Period Code
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    dagoPeriodCode?: string;
    /**
     * Policy Cost With Loan Amount
     * @type {string}
     * @memberof LoanPaymentPlanSimCarCalculateRequest
     */
    policyCostWithLoanAmount: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimCarCalculateResponse
 */
export interface LoanPaymentPlanSimCarCalculateResponse extends LoanPaymentPlanSimBaseCalculateResponse {
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimHolidayCalculateRequest
 */
export interface LoanPaymentPlanSimHolidayCalculateRequest extends LoanPaymentPlanSimBaseCalculateRequest {
    /**
     * Holiday Cost
     * @type {string}
     * @memberof LoanPaymentPlanSimHolidayCalculateRequest
     */
    cost: string;
    /**
     * Life Insurance Code
     * @type {string}
     * @memberof LoanPaymentPlanSimHolidayCalculateRequest
     */
    lifeInsuranceCode: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimHolidayCalculateResponse
 */
export interface LoanPaymentPlanSimHolidayCalculateResponse extends LoanPaymentPlanSimBaseCalculateResponse {
    /**
     * Life Comm
     * @type {string}
     * @memberof LoanPaymentPlanSimHolidayCalculateResponse
     */
    lifeComm: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimInitialPaymentRateRequest
 */
export interface LoanPaymentPlanSimInitialPaymentRateRequest {
    /**
     * Action Type Code
     * @type {string}
     * @memberof LoanPaymentPlanSimInitialPaymentRateRequest
     */
    actionTypeCode: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimInitialPaymentRateResponse
 */
export interface LoanPaymentPlanSimInitialPaymentRateResponse extends Response {
    /**
     * Initial Payment Rate
     * @type {string}
     * @memberof LoanPaymentPlanSimInitialPaymentRateResponse
     */
    initialPayment: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimInstantCalculateRequest
 */
export interface LoanPaymentPlanSimInstantCalculateRequest extends LoanPaymentPlanSimBaseCalculateRequest {
    /**
     * Instant Cost
     * @type {string}
     * @memberof LoanPaymentPlanSimInstantCalculateRequest
     */
    cost: string;
    /**
     * Life Insurance Code
     * @type {string}
     * @memberof LoanPaymentPlanSimInstantCalculateRequest
     */
    lifeInsuranceCode: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimInstantCalculateResponse
 */
export interface LoanPaymentPlanSimInstantCalculateResponse extends LoanPaymentPlanSimBaseCalculateResponse {
    /**
     * Life Comm
     * @type {string}
     * @memberof LoanPaymentPlanSimInstantCalculateResponse
     */
    lifeComm: string;
}
/**
 * 
 * @export
 * @interface LoanPaymentPlanSimPrintResponse
 */
export interface LoanPaymentPlanSimPrintResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof LoanPaymentPlanSimPrintResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface LoanPhoneInfoPageData
 */
export interface LoanPhoneInfoPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanPhoneInfoPageData
     */
    countryCode: DictionaryLine;
    /**
     * Field code
     * @type {string}
     * @memberof LoanPhoneInfoPageData
     */
    fieldCode: string;
    /**
     * Phone number
     * @type {string}
     * @memberof LoanPhoneInfoPageData
     */
    telephoneNo: string;
}
/**
 * 
 * @export
 * @interface LoanProductGlobalBonusPageData
 */
export interface LoanProductGlobalBonusPageData {
    /**
     * Employee Number
     * @type {string}
     * @memberof LoanProductGlobalBonusPageData
     */
    employeeNumber: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanProductGlobalBonusPageData
     */
    connection: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanProductGlobalBonusPageDataResponse
 */
export interface LoanProductGlobalBonusPageDataResponse extends Response {
    /**
     * 
     * @type {LoanProductGlobalBonusPageData}
     * @memberof LoanProductGlobalBonusPageDataResponse
     */
    pageData?: LoanProductGlobalBonusPageData;
}
/**
 * 
 * @export
 * @interface LoanProductPageData
 */
export interface LoanProductPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanProductPageData
     */
    loanType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanProductPageData
     */
    retailOutlet: DictionaryLine;
}
/**
 * 
 * @export
 * @interface LoanProductPageDataResponse
 */
export interface LoanProductPageDataResponse extends Response {
    /**
     * 
     * @type {LoanProductPageData}
     * @memberof LoanProductPageDataResponse
     */
    pageData?: LoanProductPageData;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnAddPoolRequest
 */
export interface LoanPurchaseReturnAddPoolRequest {
    /**
     * Credit Code
     * @type {string}
     * @memberof LoanPurchaseReturnAddPoolRequest
     */
    creditId: string;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnAddPoolResponse
 */
export interface LoanPurchaseReturnAddPoolResponse extends Response {
    /**
     * Result message
     * @type {string}
     * @memberof LoanPurchaseReturnAddPoolResponse
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnCheckDocumentData
 */
export interface LoanPurchaseReturnCheckDocumentData {
    /**
     * Document Type
     * @type {string}
     * @memberof LoanPurchaseReturnCheckDocumentData
     */
    documentType: string;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnCheckDocumentRequest
 */
export interface LoanPurchaseReturnCheckDocumentRequest {
    /**
     * Loan Type Code
     * @type {string}
     * @memberof LoanPurchaseReturnCheckDocumentRequest
     */
    loanType: string;
    /**
     * 
     * @type {Array<LoanPurchaseReturnCheckDocumentData>}
     * @memberof LoanPurchaseReturnCheckDocumentRequest
     */
    documentList: Array<LoanPurchaseReturnCheckDocumentData>;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnCheckDocumentResponse
 */
export interface LoanPurchaseReturnCheckDocumentResponse extends Response {
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnGetRelatedDocsData
 */
export interface LoanPurchaseReturnGetRelatedDocsData {
    /**
     * Document Type
     * @type {string}
     * @memberof LoanPurchaseReturnGetRelatedDocsData
     */
    documentType: string;
    /**
     * Note
     * @type {string}
     * @memberof LoanPurchaseReturnGetRelatedDocsData
     */
    note: string;
    /**
     * Document Uploaded Date
     * @type {string}
     * @memberof LoanPurchaseReturnGetRelatedDocsData
     */
    uploadedDate: string;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnGetRelatedDocsResponse
 */
export interface LoanPurchaseReturnGetRelatedDocsResponse extends Response {
    /**
     * 
     * @type {Array<LoanPurchaseReturnGetRelatedDocsData>}
     * @memberof LoanPurchaseReturnGetRelatedDocsResponse
     */
    documentList?: Array<LoanPurchaseReturnGetRelatedDocsData>;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnLoanInfoRequest
 */
export interface LoanPurchaseReturnLoanInfoRequest {
    /**
     * Credit Code
     * @type {string}
     * @memberof LoanPurchaseReturnLoanInfoRequest
     */
    creditId: string;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnLoanInfoResponse
 */
export interface LoanPurchaseReturnLoanInfoResponse extends Response {
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnQueryLoanRequest
 */
export interface LoanPurchaseReturnQueryLoanRequest extends PaginationRequest {
    /**
     * Loan Type Code
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    loanType?: string;
    /**
     * Retail Outlet Code
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    retailOutletCode?: string;
    /**
     * Start Date
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    endDate: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    customerNumber?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    surname?: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    name?: string;
    /**
     * Second Name
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    secondName?: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    birthDate?: string;
    /**
     * Loan Reference Branch
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    loanReferenceBranch?: string;
    /**
     * Loan Reference Type
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    loanReferenceType?: string;
    /**
     * loanReferenceNumber
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanRequest
     */
    loanReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnQueryLoanResponse
 */
export interface LoanPurchaseReturnQueryLoanResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<LoanPurchaseReturnQueryLoanResponseData>}
     * @memberof LoanPurchaseReturnQueryLoanResponse
     */
    loanList: Array<LoanPurchaseReturnQueryLoanResponseData>;
}
/**
 * 
 * @export
 * @interface LoanPurchaseReturnQueryLoanResponseData
 */
export interface LoanPurchaseReturnQueryLoanResponseData {
    /**
     * Credit Status
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    status: string;
    /**
     * Credit Code
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    creditId: string;
    /**
     * Reference Number
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    loanReference: string;
    /**
     * Client Full Name
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    nameSurname?: string;
    /**
     * Action Type
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    actionType: string;
    /**
     * Currency
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    currency: string;
    /**
     * Date Of Issue
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    issueDate: string;
    /**
     * Credit Amount
     * @type {string}
     * @memberof LoanPurchaseReturnQueryLoanResponseData
     */
    loanAmount: string;
}
/**
 * 
 * @export
 * @interface LoanScoringAdditionalJobInfoResponse
 */
export interface LoanScoringAdditionalJobInfoResponse extends Response {
    /**
     * company name
     * @type {string}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    companyName?: string;
    /**
     * job title code
     * @type {string}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    jobTitleCode?: string;
    /**
     * occupation code
     * @type {string}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    occupationCode?: string;
    /**
     * job sector code
     * @type {string}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    jobSectorCode?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    currentWorkExperience?: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    totalWorkExperience?: DictionaryLine;
    /**
     * true if state is checked
     * @type {boolean}
     * @memberof LoanScoringAdditionalJobInfoResponse
     */
    isGovernmentOrganisation?: boolean;
}
/**
 * 
 * @export
 * @interface LoanScoringJobPageData
 */
export interface LoanScoringJobPageData {
    /**
     * company name
     * @type {string}
     * @memberof LoanScoringJobPageData
     */
    companyName: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringJobPageData
     */
    jobTitle: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringJobPageData
     */
    occupation: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringJobPageData
     */
    jobSector: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringJobPageData
     */
    currentWorkExperience: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanScoringJobPageData
     */
    totalWorkExperience: DictionaryLine;
    /**
     * true if state is checked
     * @type {boolean}
     * @memberof LoanScoringJobPageData
     */
    isGovernmentOrganisation: boolean;
}
/**
 * 
 * @export
 * @interface LoanScoringJobPageDataResponse
 */
export interface LoanScoringJobPageDataResponse extends Response {
    /**
     * 
     * @type {LoanScoringJobPageData}
     * @memberof LoanScoringJobPageDataResponse
     */
    pageData?: LoanScoringJobPageData;
}
/**
 * 
 * @export
 * @interface LoanSummaryAdditionalServicesData
 */
export interface LoanSummaryAdditionalServicesData {
    /**
     * Service
     * @type {string}
     * @memberof LoanSummaryAdditionalServicesData
     */
    service: string;
    /**
     * Organization
     * @type {string}
     * @memberof LoanSummaryAdditionalServicesData
     */
    organization: string;
    /**
     * Product
     * @type {string}
     * @memberof LoanSummaryAdditionalServicesData
     */
    product: string;
    /**
     * Price
     * @type {string}
     * @memberof LoanSummaryAdditionalServicesData
     */
    price: string;
    /**
     * Employee Number
     * @type {string}
     * @memberof LoanSummaryAdditionalServicesData
     */
    employeeNumber: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryAdditionalServicesInfoData
 */
export interface LoanSummaryAdditionalServicesInfoData {
    /**
     * 
     * @type {Array<LoanSummaryAdditionalServicesData>}
     * @memberof LoanSummaryAdditionalServicesInfoData
     */
    additionalServiceList?: Array<LoanSummaryAdditionalServicesData>;
}
/**
 * 
 * @export
 * @interface LoanSummaryAddressData
 */
export interface LoanSummaryAddressData {
    /**
     * Address Type
     * @type {string}
     * @memberof LoanSummaryAddressData
     */
    addressType: string;
    /**
     * Address Info
     * @type {string}
     * @memberof LoanSummaryAddressData
     */
    addressInfo: string;
    /**
     * Zip Code
     * @type {string}
     * @memberof LoanSummaryAddressData
     */
    zipCode: string;
    /**
     * text exists if address is the correspondence one
     * @type {string}
     * @memberof LoanSummaryAddressData
     */
    hasCorrespondenceFlag?: string;
    /**
     * Resident Type
     * @type {string}
     * @memberof LoanSummaryAddressData
     */
    addressHomeOwnerType?: string;
    /**
     * Registration Date
     * @type {string}
     * @memberof LoanSummaryAddressData
     */
    registrationDate?: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryAddressInfoData
 */
export interface LoanSummaryAddressInfoData {
    /**
     * 
     * @type {Array<LoanSummaryAddressData>}
     * @memberof LoanSummaryAddressInfoData
     */
    addressList: Array<LoanSummaryAddressData>;
}
/**
 * 
 * @export
 * @interface LoanSummaryBenefitsThirdPartyInfoPage
 */
export interface LoanSummaryBenefitsThirdPartyInfoPage {
    /**
     * Has Benefits Third Party
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPartyInfoPage
     */
    hasBenefitsThirdParty: string;
    /**
     * 
     * @type {LoanSummaryBenefitsThirdPersonInfoData}
     * @memberof LoanSummaryBenefitsThirdPartyInfoPage
     */
    loanSummaryBenefitsThirdPartyInfoData?: LoanSummaryBenefitsThirdPersonInfoData;
    /**
     * Has Control Person
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPartyInfoPage
     */
    hasControlPerson: string;
    /**
     * 
     * @type {LoanSummaryBenefitsThirdPersonInfoData}
     * @memberof LoanSummaryBenefitsThirdPartyInfoPage
     */
    loanSummaryControlPersonInfoData?: LoanSummaryBenefitsThirdPersonInfoData;
}
/**
 * 
 * @export
 * @interface LoanSummaryBenefitsThirdPersonInfoData
 */
export interface LoanSummaryBenefitsThirdPersonInfoData {
    /**
     * Beneficiary Name
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    beneficiaryName: string;
    /**
     * Birth Place
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    birthPlace: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    birthDate: string;
    /**
     * Identity Type
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    identityType: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    identityDocumentSerialCode: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    identityDocumentSerialNumber: string;
    /**
     * Issued By
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    issuedBy: string;
    /**
     * Issue Date
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    issueDate: string;
    /**
     * Unit Code
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    unitCode: string;
    /**
     * Inn
     * @type {string}
     * @memberof LoanSummaryBenefitsThirdPersonInfoData
     */
    inn: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryContactDetailInfoData
 */
export interface LoanSummaryContactDetailInfoData {
    /**
     * Mobile Phone Number
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    mobilePhoneNumber: string;
    /**
     * Home Phone Number
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    homePhoneNumber: string;
    /**
     * Work Phone Number
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    workPhoneNumber: string;
    /**
     * Contact Phone 1 Number
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    contactPhone1Number: string;
    /**
     * Contact Phone 2 Number
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    contactPhone2Number: string;
    /**
     * Registration Address Number
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    registrationAddressNumber: string;
    /**
     * Email Address
     * @type {string}
     * @memberof LoanSummaryContactDetailInfoData
     */
    emailAddress?: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryContactInfoPage
 */
export interface LoanSummaryContactInfoPage {
    /**
     * 
     * @type {LoanSummaryAddressInfoData}
     * @memberof LoanSummaryContactInfoPage
     */
    loanSummaryAddressInfoData: LoanSummaryAddressInfoData;
    /**
     * 
     * @type {LoanSummaryContactDetailInfoData}
     * @memberof LoanSummaryContactInfoPage
     */
    loanSummaryContactDetailInfoData: LoanSummaryContactDetailInfoData;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerDetailInfoData
 */
export interface LoanSummaryCustomerDetailInfoData {
    /**
     * Marital Status
     * @type {string}
     * @memberof LoanSummaryCustomerDetailInfoData
     */
    maritalStatus: string;
    /**
     * Education Status
     * @type {string}
     * @memberof LoanSummaryCustomerDetailInfoData
     */
    educationStatus: string;
    /**
     * Number of Children
     * @type {number}
     * @memberof LoanSummaryCustomerDetailInfoData
     */
    numberOfChildren: number;
    /**
     * Monthly Income
     * @type {string}
     * @memberof LoanSummaryCustomerDetailInfoData
     */
    montlyIncome: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerDetailInfoPage
 */
export interface LoanSummaryCustomerDetailInfoPage {
    /**
     * 
     * @type {LoanSummaryCustomerTaxInfoData}
     * @memberof LoanSummaryCustomerDetailInfoPage
     */
    loanSummaryCustomerTaxInfoData: LoanSummaryCustomerTaxInfoData;
    /**
     * 
     * @type {LoanSummaryCustomerDetailInfoData}
     * @memberof LoanSummaryCustomerDetailInfoPage
     */
    loanSummaryCustomerDetailInfoData: LoanSummaryCustomerDetailInfoData;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerDocumentInfo
 */
export interface LoanSummaryCustomerDocumentInfo {
    /**
     * 
     * @type {Array<LoanSummaryCustomerDocumentInfoData>}
     * @memberof LoanSummaryCustomerDocumentInfo
     */
    documentInfoDataList: Array<LoanSummaryCustomerDocumentInfoData>;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerDocumentInfoData
 */
export interface LoanSummaryCustomerDocumentInfoData {
    /**
     * Document Type
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    documentType: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    identityDocumentSerialCode: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    identityDocumentSerialNumber: string;
    /**
     * Issued By
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    issuedBy: string;
    /**
     * Issue Date
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    issueDate: string;
    /**
     * Expire Date
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    expireDate: string;
    /**
     * Unit Code
     * @type {string}
     * @memberof LoanSummaryCustomerDocumentInfoData
     */
    unitCode: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerIndividualInfoData
 */
export interface LoanSummaryCustomerIndividualInfoData {
    /**
     * Customer Surname
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    customerSurname: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    customerName: string;
    /**
     * Customer Second Name
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    customerSecondName: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    birthDate: string;
    /**
     * Customer Gender
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    customerGender: string;
    /**
     * Citizenship
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    citizenship: string;
    /**
     * Residence Country
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    residenceCountry: string;
    /**
     * Place Of Birth
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    birthPlaceCity: string;
    /**
     * Previous Surname
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    previousSurname: string;
    /**
     * Code Word For The Customer Support Centre
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    codeWordForSupportCentre?: string;
    /**
     * snils
     * @type {string}
     * @memberof LoanSummaryCustomerIndividualInfoData
     */
    snils?: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerInfoPage
 */
export interface LoanSummaryCustomerInfoPage {
    /**
     * 
     * @type {LoanSummaryCustomerIndividualInfoData}
     * @memberof LoanSummaryCustomerInfoPage
     */
    loanSummaryCustomerIndividualInfoData: LoanSummaryCustomerIndividualInfoData;
    /**
     * 
     * @type {LoanSummaryCustomerDocumentInfo}
     * @memberof LoanSummaryCustomerInfoPage
     */
    loanSummaryCustomerDocumentInfo: LoanSummaryCustomerDocumentInfo;
}
/**
 * 
 * @export
 * @interface LoanSummaryCustomerTaxInfoData
 */
export interface LoanSummaryCustomerTaxInfoData {
    /**
     * Tax Number
     * @type {string}
     * @memberof LoanSummaryCustomerTaxInfoData
     */
    taxNumber: string;
    /**
     * 
     * @type {Array<LoanSummaryTaxResidencyData>}
     * @memberof LoanSummaryCustomerTaxInfoData
     */
    taxResidencyList: Array<LoanSummaryTaxResidencyData>;
}
/**
 * 
 * @export
 * @interface LoanSummaryGoodsInfoData
 */
export interface LoanSummaryGoodsInfoData {
    /**
     * 
     * @type {Array<LoanSummaryGoodsPageData>}
     * @memberof LoanSummaryGoodsInfoData
     */
    goodsList: Array<LoanSummaryGoodsPageData>;
}
/**
 * 
 * @export
 * @interface LoanSummaryGoodsPageData
 */
export interface LoanSummaryGoodsPageData {
    /**
     * Product Group
     * @type {string}
     * @memberof LoanSummaryGoodsPageData
     */
    goodsProductGroup: string;
    /**
     * Product
     * @type {string}
     * @memberof LoanSummaryGoodsPageData
     */
    goodsProduct: string;
    /**
     * Description
     * @type {string}
     * @memberof LoanSummaryGoodsPageData
     */
    description: string;
    /**
     * Price
     * @type {string}
     * @memberof LoanSummaryGoodsPageData
     */
    price: string;
    /**
     * Quantity
     * @type {string}
     * @memberof LoanSummaryGoodsPageData
     */
    quantity: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryHolidayLoanInfoData
 */
export interface LoanSummaryHolidayLoanInfoData {
    /**
     * true if it is vacation credit
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    isVacationCredit: string;
    /**
     * Group Composition
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    destinationCountry: string;
    /**
     * Number Of People
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    numberOfPeople: string;
    /**
     * Departure Date
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    departureDate: string;
    /**
     * Group Composition
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    groupComposition: string;
    /**
     * Duration
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    duration: string;
    /**
     * Tour Source
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    tourSource: string;
    /**
     * Price
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    price: string;
    /**
     * Total Cost
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    totalCost: string;
    /**
     * Organization Name
     * @type {string}
     * @memberof LoanSummaryHolidayLoanInfoData
     */
    organizationName?: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryInfoResponse
 */
export interface LoanSummaryInfoResponse extends Response {
    /**
     * 
     * @type {LoanSummaryProductInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryProductInfoPage: LoanSummaryProductInfoPage;
    /**
     * 
     * @type {LoanSummaryCustomerInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryCustomerInfoPage: LoanSummaryCustomerInfoPage;
    /**
     * 
     * @type {LoanSummaryContactInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryContactInfoPage: LoanSummaryContactInfoPage;
    /**
     * 
     * @type {LoanSummaryJobScoringInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryJobScoringInfoPage: LoanSummaryJobScoringInfoPage;
    /**
     * 
     * @type {LoanSummaryCustomerDetailInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryCustomerDetailInfoPage: LoanSummaryCustomerDetailInfoPage;
    /**
     * 
     * @type {LoanSummaryBenefitsThirdPartyInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryBenefitsThirdPartyInfoPage: LoanSummaryBenefitsThirdPartyInfoPage;
    /**
     * 
     * @type {LoanSummaryLoanInfoPage}
     * @memberof LoanSummaryInfoResponse
     */
    loanSummaryLoanInfoPage: LoanSummaryLoanInfoPage;
}
/**
 * 
 * @export
 * @interface LoanSummaryJobInfoData
 */
export interface LoanSummaryJobInfoData {
    /**
     * Company Name
     * @type {string}
     * @memberof LoanSummaryJobInfoData
     */
    companyName: string;
    /**
     * Job Title
     * @type {string}
     * @memberof LoanSummaryJobInfoData
     */
    jobTitle: string;
    /**
     * Occupation
     * @type {string}
     * @memberof LoanSummaryJobInfoData
     */
    occupation: string;
    /**
     * Job Sector
     * @type {string}
     * @memberof LoanSummaryJobInfoData
     */
    jobSector: string;
    /**
     * Beginning time of current work
     * @type {string}
     * @memberof LoanSummaryJobInfoData
     */
    currentWorkBeginningTime: string;
    /**
     * Beginning time of work life
     * @type {string}
     * @memberof LoanSummaryJobInfoData
     */
    workLifeBeginningTime: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryJobScoringInfoPage
 */
export interface LoanSummaryJobScoringInfoPage {
    /**
     * 
     * @type {LoanSummaryJobInfoData}
     * @memberof LoanSummaryJobScoringInfoPage
     */
    loanSummaryJobInfoData: LoanSummaryJobInfoData;
}
/**
 * 
 * @export
 * @interface LoanSummaryLoanInfoPage
 */
export interface LoanSummaryLoanInfoPage {
    /**
     * 
     * @type {LoanSummaryGoodsInfoData}
     * @memberof LoanSummaryLoanInfoPage
     */
    loanSummaryGoodsInfoData?: LoanSummaryGoodsInfoData;
    /**
     * 
     * @type {LoanSummaryHolidayLoanInfoData}
     * @memberof LoanSummaryLoanInfoPage
     */
    loanSummaryHolidayLoanInfoData?: LoanSummaryHolidayLoanInfoData;
    /**
     * 
     * @type {LoanSummaryAdditionalServicesInfoData}
     * @memberof LoanSummaryLoanInfoPage
     */
    loanSummaryAdditionalServicesInfoData: LoanSummaryAdditionalServicesInfoData;
}
/**
 * 
 * @export
 * @interface LoanSummaryPrintButtonsResponse
 */
export interface LoanSummaryPrintButtonsResponse extends Response {
    /**
     * true if print application button is visible
     * @type {boolean}
     * @memberof LoanSummaryPrintButtonsResponse
     */
    isPrintApplicationButtonVisible: boolean;
    /**
     * true if print power of attorney button is visible
     * @type {boolean}
     * @memberof LoanSummaryPrintButtonsResponse
     */
    isPrintPowerOfAttorneyButtonVisible: boolean;
}
/**
 * 
 * @export
 * @interface LoanSummaryProductInfoPage
 */
export interface LoanSummaryProductInfoPage {
    /**
     * Loan Type
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    loanType: string;
    /**
     * Action Type
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    actionType: string;
    /**
     * Currency Type
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    currencyType: string;
    /**
     * Product Price
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    productPrice: string;
    /**
     * Loan Amount
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    loanAmount: string;
    /**
     * Down Payment Amount
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    downPaymentAmount: string;
    /**
     * Interest Rate
     * @type {string}
     * @memberof LoanSummaryProductInfoPage
     */
    interestRate: string;
}
/**
 * 
 * @export
 * @interface LoanSummaryTaxResidencyData
 */
export interface LoanSummaryTaxResidencyData {
    /**
     * Tax Residence Country
     * @type {string}
     * @memberof LoanSummaryTaxResidencyData
     */
    taxResidenceCountry: string;
    /**
     * Has Tax Number Provided
     * @type {string}
     * @memberof LoanSummaryTaxResidencyData
     */
    hasTaxNumberProvided?: string;
    /**
     * Foreign Tax Number
     * @type {string}
     * @memberof LoanSummaryTaxResidencyData
     */
    foreignTaxNumber?: string;
}
/**
 * 
 * @export
 * @interface LoanTaxInfoData
 */
export interface LoanTaxInfoData {
    /**
     * Foreign Tax Number Id
     * @type {string}
     * @memberof LoanTaxInfoData
     */
    foreignTaxNumberId?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanTaxInfoData
     */
    taxResidenceCountry: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanTaxInfoData
     */
    hasTaxNumberProvided: DictionaryLine;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof LoanTaxInfoData
     */
    differentNumber?: boolean;
    /**
     * Foreign Tax Number
     * @type {string}
     * @memberof LoanTaxInfoData
     */
    foreignTaxNumber?: string;
    /**
     * true if it is new
     * @type {boolean}
     * @memberof LoanTaxInfoData
     */
    isNew: boolean;
}
/**
 * 
 * @export
 * @interface LoanTaxInfoPageData
 */
export interface LoanTaxInfoPageData {
    /**
     * Tax Number
     * @type {string}
     * @memberof LoanTaxInfoPageData
     */
    taxNumber?: string;
    /**
     * 
     * @type {Array<LoanTaxInfoData>}
     * @memberof LoanTaxInfoPageData
     */
    taxResidencyList?: Array<LoanTaxInfoData>;
}
/**
 * 
 * @export
 * @interface LoanTaxInfoPageDataResponse
 */
export interface LoanTaxInfoPageDataResponse extends Response {
    /**
     * 
     * @type {LoanTaxInfoPageData}
     * @memberof LoanTaxInfoPageDataResponse
     */
    pageData?: LoanTaxInfoPageData;
}
/**
 * 
 * @export
 * @interface LoanThirdPartyPageValidationComponentsResponse
 */
export interface LoanThirdPartyPageValidationComponentsResponse extends LoanDocumentPageValidationComponentsResponse {
}
/**
 * 
 * @export
 * @interface LoanTotalCostCalculateCarRequest
 */
export interface LoanTotalCostCalculateCarRequest {
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostCalculateCarRequest
     */
    downPaymentRate: string;
    /**
     * Down Payment Amount
     * @type {number}
     * @memberof LoanTotalCostCalculateCarRequest
     */
    downPaymentAmount: number;
}
/**
 * 
 * @export
 * @interface LoanTotalCostCalculateCarResponse
 */
export interface LoanTotalCostCalculateCarResponse extends Response {
    /**
     * Interest Rate
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    interestRate: string;
    /**
     * Differentiated Interest Rate
     * @type {boolean}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    differentiatedInterestRate?: boolean;
    /**
     * Loan Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    loanAmount: string;
    /**
     * Currency Code
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    currency: string;
    /**
     * Down Payment Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    downPaymentAmount?: string;
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    downPaymentRate?: string;
    /**
     * Interest Rate in case of non-fulfillment of insurance obligations
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    alternativeActionRate?: string;
    /**
     * Commission for issuing a loan
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    commissionAmount?: string;
    /**
     * Interest Accrual Scheme
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    interestScheme?: string;
    /**
     * Account Maintenance Fee
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    periodicCommissionAmount?: string;
    /**
     * Initial Deposit Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    depositAmount: string;
    /**
     * Commission for consideration of the application
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    fixedCommissionAmount?: string;
    /**
     * Interest Payable
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    accruedInterest?: string;
    /**
     * Early Payment Fee
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    earlyPaymentCommisionAmount?: string;
    /**
     * Commission For Life Insurance
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    insuranceAmount?: string;
    /**
     * Opening Date
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    openingDate?: string;
    /**
     * Product Price
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    productPrice: string;
    /**
     * Additional Services Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    additionalServicesAmount: string;
    /**
     * Period Code
     * @type {string}
     * @memberof LoanTotalCostCalculateCarResponse
     */
    period: string;
}
/**
 * 
 * @export
 * @interface LoanTotalCostCalculateRequest
 */
export interface LoanTotalCostCalculateRequest {
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostCalculateRequest
     */
    downPaymentRate: string;
    /**
     * Down Payment Amount
     * @type {number}
     * @memberof LoanTotalCostCalculateRequest
     */
    downPaymentAmount: number;
}
/**
 * 
 * @export
 * @interface LoanTotalCostCalculateResponse
 */
export interface LoanTotalCostCalculateResponse extends Response {
    /**
     * Product Price
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    productPrice: string;
    /**
     * Additional Services Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    additionalServicesAmount: string;
    /**
     * Loan Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    loanAmount: string;
    /**
     * Currency Code
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    currency: string;
    /**
     * Period Code
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    period: string;
    /**
     * Deposit Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    depositAmount: string;
    /**
     * Interest Rate
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    interestRate: string;
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    downPaymentRate?: string;
    /**
     * Down Payment Amount
     * @type {string}
     * @memberof LoanTotalCostCalculateResponse
     */
    downPaymentAmount?: string;
}
/**
 * 
 * @export
 * @interface LoanTotalCostPageData
 */
export interface LoanTotalCostPageData {
    /**
     * Product Price
     * @type {number}
     * @memberof LoanTotalCostPageData
     */
    productPrice: number;
    /**
     * Additional Services Amount
     * @type {number}
     * @memberof LoanTotalCostPageData
     */
    additionalServicesAmount: number;
    /**
     * Loan Amount
     * @type {number}
     * @memberof LoanTotalCostPageData
     */
    loanAmount: number;
    /**
     * Currency Code
     * @type {string}
     * @memberof LoanTotalCostPageData
     */
    currency: string;
    /**
     * Period Code
     * @type {string}
     * @memberof LoanTotalCostPageData
     */
    period: string;
    /**
     * Deposit Amount
     * @type {number}
     * @memberof LoanTotalCostPageData
     */
    depositAmount: number;
    /**
     * Interest Rate
     * @type {string}
     * @memberof LoanTotalCostPageData
     */
    interestRate: string;
    /**
     * Comments
     * @type {string}
     * @memberof LoanTotalCostPageData
     */
    comments?: string;
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostPageData
     */
    downPaymentRate?: string;
    /**
     * Down Payment Amount
     * @type {number}
     * @memberof LoanTotalCostPageData
     */
    downPaymentAmount?: number;
}
/**
 * 
 * @export
 * @interface LoanTotalCostPageDataResponse
 */
export interface LoanTotalCostPageDataResponse extends Response {
    /**
     * 
     * @type {LoanTotalCostPageData}
     * @memberof LoanTotalCostPageDataResponse
     */
    pageData?: LoanTotalCostPageData;
}
/**
 * 
 * @export
 * @interface LoanTotalCostSummaryCarResponse
 */
export interface LoanTotalCostSummaryCarResponse extends Response {
    /**
     * Product Price
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    productPrice: string;
    /**
     * Additional Services Amount
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    additionalServicesAmount: string;
    /**
     * Currency Code
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    currency: string;
    /**
     * Additional Services Amount
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    creditAmountLimit?: string;
    /**
     * Credit Opening Date
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    openingDate?: string;
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    downPaymentRate?: string;
    /**
     * Down Payment Amount
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    downPaymentAmount?: string;
    /**
     * Period Code
     * @type {string}
     * @memberof LoanTotalCostSummaryCarResponse
     */
    period: string;
}
/**
 * 
 * @export
 * @interface LoanTotalCostSummaryResponse
 */
export interface LoanTotalCostSummaryResponse extends Response {
    /**
     * Product Price
     * @type {string}
     * @memberof LoanTotalCostSummaryResponse
     */
    productPrice: string;
    /**
     * Additional Services Amount
     * @type {string}
     * @memberof LoanTotalCostSummaryResponse
     */
    additionalServicesAmount: string;
    /**
     * Currency Code
     * @type {string}
     * @memberof LoanTotalCostSummaryResponse
     */
    currency: string;
    /**
     * Period Code
     * @type {string}
     * @memberof LoanTotalCostSummaryResponse
     */
    period: string;
    /**
     * Down Payment Rate
     * @type {string}
     * @memberof LoanTotalCostSummaryResponse
     */
    downPaymentRate?: string;
    /**
     * Down Payment Amount
     * @type {string}
     * @memberof LoanTotalCostSummaryResponse
     */
    downPaymentAmount?: string;
}
/**
 * 
 * @export
 * @interface LoanVehicleInformationPageData
 */
export interface LoanVehicleInformationPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    transportVehicle: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    serviceGroup: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    brand: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    modelCombo?: DictionaryLine;
    /**
     * Model
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    model?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    vehicleType: DictionaryLine;
    /**
     * Year Of Release
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    yearOfRelease?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    vehicleCategory?: DictionaryLine;
    /**
     * Bodywork
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    bodyWork?: string;
    /**
     * true if epts check
     * @type {boolean}
     * @memberof LoanVehicleInformationPageData
     */
    epts?: boolean;
    /**
     * Pts Series And Number
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    ptsSeriesAndNumber?: string;
    /**
     * Pts Issue Date
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    ptsIssueDate?: string;
    /**
     * true if VIN is missing
     * @type {boolean}
     * @memberof LoanVehicleInformationPageData
     */
    vinMissing?: boolean;
    /**
     * vin
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    vin?: string;
    /**
     * vinTwo
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    vinTwo?: string;
    /**
     * Modification
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    modification?: string;
    /**
     * Chassis
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    chassis?: string;
    /**
     * Engine Number
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    engineNumber?: string;
    /**
     * Engine Capacity
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    engineCapacity?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof LoanVehicleInformationPageData
     */
    color?: DictionaryLine;
    /**
     * Number of the purchase and sale agreement
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    numberOfThePurchase?: string;
    /**
     * Uweos
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    uweos?: string;
    /**
     * Permitted Maximum Mass
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    permittedMaximumMass?: string;
    /**
     * Number Of Passenger Seats
     * @type {string}
     * @memberof LoanVehicleInformationPageData
     */
    numberOfPassengerSeats?: string;
    /**
     * Car Price
     * @type {number}
     * @memberof LoanVehicleInformationPageData
     */
    carPrice: number;
}
/**
 * 
 * @export
 * @interface LoanVehicleInformationPageDataResponse
 */
export interface LoanVehicleInformationPageDataResponse extends Response {
    /**
     * 
     * @type {LoanVehicleInformationPageData}
     * @memberof LoanVehicleInformationPageDataResponse
     */
    pageData?: LoanVehicleInformationPageData;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    password: string;
}
/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse extends Response {
    /**
     * Unique session id for the user login
     * @type {string}
     * @memberof LoginResponse
     */
    loginSessionID: string;
    /**
     * Masked Customer Number
     * @type {string}
     * @memberof LoginResponse
     */
    userCode?: string;
    /**
     * Full Name of User
     * @type {string}
     * @memberof LoginResponse
     */
    userName?: string;
    /**
     * Short Name displayed in the Profile Image
     * @type {string}
     * @memberof LoginResponse
     */
    userProfileImageName?: string;
    /**
     * Process Date
     * @type {string}
     * @memberof LoginResponse
     */
    processDate?: string;
    /**
     * true If the password is expired
     * @type {boolean}
     * @memberof LoginResponse
     */
    isAuthenticationRestricted?: boolean;
    /**
     * 
     * @type {Array<Menu>}
     * @memberof LoginResponse
     */
    menuList?: Array<Menu>;
    /**
     * 
     * @type {Array<Menu>}
     * @memberof LoginResponse
     */
    profileMenuList?: Array<Menu>;
}
/**
 * 
 * @export
 * @interface Menu
 */
export interface Menu extends MenuItem {
    /**
     * 
     * @type {Array<Menu>}
     * @memberof Menu
     */
    subMenuList?: Array<Menu>;
}
/**
 * 
 * @export
 * @interface MenuItem
 */
export interface MenuItem {
    /**
     * Unique id of the menu item
     * @type {string}
     * @memberof MenuItem
     */
    menuID: string;
    /**
     * Localization key for the name of the menu item
     * @type {string}
     * @memberof MenuItem
     */
    name: string;
    /**
     * Localization key for the description of the menu item
     * @type {string}
     * @memberof MenuItem
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Unique ID of the error message
     * @type {number}
     * @memberof ModelError
     */
    errorID?: number;
    /**
     * Description of the error message
     * @type {string}
     * @memberof ModelError
     */
    errorMessage?: string;
    /**
     * 
     * @type {ErrorType}
     * @memberof ModelError
     */
    errorType?: ErrorType;
}
/**
 * 
 * @export
 * @interface NewObserveButtonActionRequest
 */
export interface NewObserveButtonActionRequest {
    /**
     * Button Name
     * @type {string}
     * @memberof NewObserveButtonActionRequest
     */
    buttonName: string;
}
/**
 * 
 * @export
 * @interface NewObserveButtonActionResponse
 */
export interface NewObserveButtonActionResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof NewObserveButtonActionResponse
     */
    documentId?: string;
}
/**
 * 
 * @export
 * @interface NewObserveButtonAdditionalServiceData
 */
export interface NewObserveButtonAdditionalServiceData {
    /**
     * Service Id
     * @type {string}
     * @memberof NewObserveButtonAdditionalServiceData
     */
    serviceId: string;
    /**
     * Service Name
     * @type {string}
     * @memberof NewObserveButtonAdditionalServiceData
     */
    serviceName: string;
}
/**
 * 
 * @export
 * @interface NewObserveButtonResponseData
 */
export interface NewObserveButtonResponseData {
    /**
     * Button Name
     * @type {string}
     * @memberof NewObserveButtonResponseData
     */
    buttonName: string;
    /**
     * Button Visible Status
     * @type {boolean}
     * @memberof NewObserveButtonResponseData
     */
    isVisible: boolean;
}
/**
 * 
 * @export
 * @interface NewObserveButtonVisibilityRequest
 */
export interface NewObserveButtonVisibilityRequest {
    /**
     * Loan Code
     * @type {string}
     * @memberof NewObserveButtonVisibilityRequest
     */
    loanId: string;
}
/**
 * 
 * @export
 * @interface NewObserveButtonVisibilityResponse
 */
export interface NewObserveButtonVisibilityResponse extends Response {
    /**
     * 
     * @type {Array<NewObserveButtonResponseData>}
     * @memberof NewObserveButtonVisibilityResponse
     */
    buttonList: Array<NewObserveButtonResponseData>;
    /**
     * 
     * @type {Array<NewObserveButtonAdditionalServiceData>}
     * @memberof NewObserveButtonVisibilityResponse
     */
    serviceList?: Array<NewObserveButtonAdditionalServiceData>;
}
/**
 * 
 * @export
 * @interface NewObserveSearchRequest
 */
export interface NewObserveSearchRequest extends PaginationRequest {
    /**
     * Begin Date
     * @type {string}
     * @memberof NewObserveSearchRequest
     */
    beginDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof NewObserveSearchRequest
     */
    endDate: string;
    /**
     * Shop Code
     * @type {string}
     * @memberof NewObserveSearchRequest
     */
    shopId?: string;
    /**
     * Surname
     * @type {string}
     * @memberof NewObserveSearchRequest
     */
    surname?: string;
    /**
     * Loan Status
     * @type {string}
     * @memberof NewObserveSearchRequest
     */
    loanStatus?: string;
    /**
     * Loan Type Code
     * @type {string}
     * @memberof NewObserveSearchRequest
     */
    loanType: string;
}
/**
 * 
 * @export
 * @interface NewObserveSearchResponse
 */
export interface NewObserveSearchResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<NewObserveSearchResponseData>}
     * @memberof NewObserveSearchResponse
     */
    loanList: Array<NewObserveSearchResponseData>;
}
/**
 * 
 * @export
 * @interface NewObserveSearchResponseData
 */
export interface NewObserveSearchResponseData {
    /**
     * Loan Code
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    loanId: string;
    /**
     * Loan Status
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    status: string;
    /**
     * Contact Number
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    contactNumber: string;
    /**
     * Client\'s Full Name
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    fullName: string;
    /**
     * Currency
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    currency: string;
    /**
     * Loan Amount
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    loanAmount: string;
    /**
     * Date
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    date: string;
    /**
     * Application Creation Date
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    applicationCreationDate: string;
    /**
     * Credit Amount Limit
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    creditAmountLimit?: string;
    /**
     * Minimum Down Payment
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    minimumDownPayment: string;
    /**
     * Rate or Promotion Name
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    rateOrPromotionName: string;
    /**
     * Comment
     * @type {string}
     * @memberof NewObserveSearchResponseData
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface NewSettlementComboRequest
 */
export interface NewSettlementComboRequest {
    /**
     * 
     * @type {NewSettlementComboType}
     * @memberof NewSettlementComboRequest
     */
    newSettlementComboType: NewSettlementComboType;
    /**
     * Loan Type Code
     * @type {string}
     * @memberof NewSettlementComboRequest
     */
    loanType?: string;
    /**
     * Settlement Type Code
     * @type {string}
     * @memberof NewSettlementComboRequest
     */
    settlementType?: string;
    /**
     * Organization Code
     * @type {string}
     * @memberof NewSettlementComboRequest
     */
    organization?: string;
    /**
     * Insurance Company Code
     * @type {string}
     * @memberof NewSettlementComboRequest
     */
    insuranceCompany?: string;
}
/**
 * 
 * @export
 * @interface NewSettlementComboResponse
 */
export interface NewSettlementComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof NewSettlementComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
    /**
     * if insurance combo is visible
     * @type {boolean}
     * @memberof NewSettlementComboResponse
     */
    isInsuranceComboVisible?: boolean;
    /**
     * if insurance combo is disable
     * @type {boolean}
     * @memberof NewSettlementComboResponse
     */
    isSettlementTypeComboDisable?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NewSettlementComboType {
    LOANTYPE = 'LOANTYPE',
    SETTLEMENTTYPE = 'SETTLEMENTTYPE',
    INSURANCECOMPANY = 'INSURANCECOMPANY',
    ORGANIZATION = 'ORGANIZATION'
}

/**
 * 
 * @export
 * @interface NewSettlementReportRequest
 */
export interface NewSettlementReportRequest {
    /**
     * Begin Date
     * @type {string}
     * @memberof NewSettlementReportRequest
     */
    beginDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof NewSettlementReportRequest
     */
    endDate: string;
    /**
     * Loan Type Code
     * @type {string}
     * @memberof NewSettlementReportRequest
     */
    loanType: string;
    /**
     * Settlement Type Code
     * @type {string}
     * @memberof NewSettlementReportRequest
     */
    settlementType: string;
    /**
     * Organization Code
     * @type {string}
     * @memberof NewSettlementReportRequest
     */
    organization: string;
    /**
     * Insurance Company Code
     * @type {string}
     * @memberof NewSettlementReportRequest
     */
    insuranceCompany?: string;
}
/**
 * 
 * @export
 * @interface NewSettlementReportResponse
 */
export interface NewSettlementReportResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof NewSettlementReportResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface ObservationButtonData
 */
export interface ObservationButtonData {
    /**
     * Button Label
     * @type {string}
     * @memberof ObservationButtonData
     */
    buttonLabel: string;
    /**
     * true if button will be visible
     * @type {boolean}
     * @memberof ObservationButtonData
     */
    visible: boolean;
    /**
     * 
     * @type {ObservationDocumentType}
     * @memberof ObservationButtonData
     */
    observationDocumentType: ObservationDocumentType;
    /**
     * true if button will be clickable
     * @type {boolean}
     * @memberof ObservationButtonData
     */
    clickable?: boolean;
}
/**
 * 
 * @export
 * @interface ObservationCardsRequest
 */
export interface ObservationCardsRequest extends PaginationRequest {
    /**
     * Pos Id
     * @type {string}
     * @memberof ObservationCardsRequest
     */
    posId: string;
    /**
     * Begin Date
     * @type {string}
     * @memberof ObservationCardsRequest
     */
    beginDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof ObservationCardsRequest
     */
    endDate: string;
}
/**
 * 
 * @export
 * @interface ObservationCardsResponse
 */
export interface ObservationCardsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<ObservationCardsResponseData>}
     * @memberof ObservationCardsResponse
     */
    cardList: Array<ObservationCardsResponseData>;
}
/**
 * 
 * @export
 * @interface ObservationCardsResponseData
 */
export interface ObservationCardsResponseData {
    /**
     * Customer Number
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    customerNumber: string;
    /**
     * Card Owner
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    cardOwner?: string;
    /**
     * Card Status
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    cardStatus: string;
    /**
     * Application Date
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    applicationDate?: string;
    /**
     * Entry Date
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    entryDate?: string;
    /**
     * Reference Number
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    referenceNumber: string;
    /**
     * Application Number
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    applicationNumber?: string;
    /**
     * limit amount
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    cardLimit: string;
    /**
     * Card Type
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    cardType?: string;
    /**
     * Card Type
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    customerType?: string;
    /**
     * Currency
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    currency?: string;
    /**
     * Card Id
     * @type {string}
     * @memberof ObservationCardsResponseData
     */
    cardId?: string;
}
/**
 * 
 * @export
 * @interface ObservationDocumentRequest
 */
export interface ObservationDocumentRequest {
    /**
     * 
     * @type {ObservationDocumentType}
     * @memberof ObservationDocumentRequest
     */
    observationDocumentType: ObservationDocumentType;
}
/**
 * 
 * @export
 * @interface ObservationDocumentResponse
 */
export interface ObservationDocumentResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof ObservationDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ObservationDocumentType {
    CARDACTIVATION = 'CARD_ACTIVATION',
    IKEAFAMILY = 'IKEA_FAMILY',
    INDIVIDUALCONDITION = 'INDIVIDUAL_CONDITION',
    INSURANCEPOLICY = 'INSURANCE_POLICY',
    INSURANCERECEIPT = 'INSURANCE_RECEIPT',
    LIFEINSURANCE = 'LIFE_INSURANCE',
    MEGA = 'MEGA',
    NONAMECARD = 'NO_NAME_CARD',
    OFFERSTATEMENT = 'OFFER_STATEMENT',
    STAKEHOLDERCARDAPPLICATION = 'STAKEHOLDER_CARD_APPLICATION',
    PRODUCTTRANSFER = 'PRODUCT_TRANSFER',
    DIGITALCARD = 'DIGITAL_CARD',
    SMSINFORMATION = 'SMS_INFORMATION'
}

/**
 * 
 * @export
 * @interface ObservationVisibilityRequest
 */
export interface ObservationVisibilityRequest {
    /**
     * Reference Number
     * @type {string}
     * @memberof ObservationVisibilityRequest
     */
    referenceNumber: string;
    /**
     * Page number starting with 1
     * @type {number}
     * @memberof ObservationVisibilityRequest
     */
    pageNumber: number;
}
/**
 * 
 * @export
 * @interface ObservationVisibilityResponse
 */
export interface ObservationVisibilityResponse extends Response {
    /**
     * Customer Number
     * @type {string}
     * @memberof ObservationVisibilityResponse
     */
    customerNumber: string;
    /**
     * Card Number
     * @type {string}
     * @memberof ObservationVisibilityResponse
     */
    cardNumber: string;
    /**
     * Card Status
     * @type {string}
     * @memberof ObservationVisibilityResponse
     */
    cardStatus: string;
    /**
     * 
     * @type {Array<ObservationButtonData>}
     * @memberof ObservationVisibilityResponse
     */
    buttonList: Array<ObservationButtonData>;
    /**
     * true if upload panel can be visible
     * @type {boolean}
     * @memberof ObservationVisibilityResponse
     */
    canUploadPanelVisible: boolean;
}
/**
 * 
 * @export
 * @interface OperationsCardApplicationGetRequest
 */
export interface OperationsCardApplicationGetRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof OperationsCardApplicationGetRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface OperationsCardApplicationGetResponse
 */
export interface OperationsCardApplicationGetResponse extends Response {
    /**
     * Customer Id
     * @type {string}
     * @memberof OperationsCardApplicationGetResponse
     */
    customerId: string;
    /**
     * true if it is product offer
     * @type {boolean}
     * @memberof OperationsCardApplicationGetResponse
     */
    isProductOffer?: boolean;
}
/**
 * 
 * @export
 * @interface OperationsCardApplicationSummaryResponse
 */
export interface OperationsCardApplicationSummaryResponse extends Response {
}
/**
 * 
 * @export
 * @interface OperationsCardApplyUpdateRequest
 */
export interface OperationsCardApplyUpdateRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof OperationsCardApplyUpdateRequest
     */
    documentList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface OperationsCardApplyUpdateResponse
 */
export interface OperationsCardApplyUpdateResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof OperationsCardApplyUpdateResponse
     */
    applicationResultMessage: string;
}
/**
 * 
 * @export
 * @interface OperationsClientInfoChangeGetRequest
 */
export interface OperationsClientInfoChangeGetRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof OperationsClientInfoChangeGetRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface OperationsClientInfoChangeGetResponse
 */
export interface OperationsClientInfoChangeGetResponse extends Response {
    /**
     * Customer Name
     * @type {string}
     * @memberof OperationsClientInfoChangeGetResponse
     */
    clientName?: string;
}
/**
 * 
 * @export
 * @interface OperationsClientInfoChangeUpdateRequest
 */
export interface OperationsClientInfoChangeUpdateRequest {
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof OperationsClientInfoChangeUpdateRequest
     */
    documentUploadDataList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface OperationsClientInfoChangeUpdateResponse
 */
export interface OperationsClientInfoChangeUpdateResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof OperationsClientInfoChangeUpdateResponse
     */
    clientInfoChangeResultMessage: string;
}
/**
 * 
 * @export
 * @interface OperationsContactInfoChangeGetRequest
 */
export interface OperationsContactInfoChangeGetRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof OperationsContactInfoChangeGetRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface OperationsContactInfoChangeGetResponse
 */
export interface OperationsContactInfoChangeGetResponse extends Response {
    /**
     * Customer Name
     * @type {string}
     * @memberof OperationsContactInfoChangeGetResponse
     */
    clientName?: string;
}
/**
 * 
 * @export
 * @interface OperationsContactInfoChangeUpdateRequest
 */
export interface OperationsContactInfoChangeUpdateRequest extends ContactInfoChangeUpdateRequest {
}
/**
 * 
 * @export
 * @interface OperationsContactInfoChangeUpdateResponse
 */
export interface OperationsContactInfoChangeUpdateResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof OperationsContactInfoChangeUpdateResponse
     */
    contactInfoChangeResultMessage: string;
}
/**
 * 
 * @export
 * @interface OperationsReissueGetRequest
 */
export interface OperationsReissueGetRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof OperationsReissueGetRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface OperationsReissueGetResponse
 */
export interface OperationsReissueGetResponse extends Response {
    /**
     * Card Number
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    cardNumber: string;
    /**
     * Card Id
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    cardId: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    expireDate: string;
    /**
     * Card Status
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    cardStatusCode: string;
    /**
     * Card Sub Status
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    cardSubStatusCode: string;
    /**
     * Embossed Name
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    embossedName: string;
    /**
     * Embossed Name Other
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    embossedNameOther: string;
    /**
     * Customer Type Code
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    customerTypeCode: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    customerNumber: string;
    /**
     * Card Account Number
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    cardAccountNumber: string;
    /**
     * No Name Card Id
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    noNameCardId: string;
    /**
     * Reissue Reason Code
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    reissueReasonCode: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    clientName: string;
    /**
     * Customer Id
     * @type {string}
     * @memberof OperationsReissueGetResponse
     */
    customerId: string;
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof OperationsReissueGetResponse
     */
    documentUploadDataList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface OperationsReissueUpdateRequest
 */
export interface OperationsReissueUpdateRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    referenceNumber: string;
    /**
     * Card Number
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    cardNumber: string;
    /**
     * Card Id
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    cardId: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    customerNumber: string;
    /**
     * Card Account Number
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    cardAccountNumber: string;
    /**
     * No Name Card Id
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    noNameCardId: string;
    /**
     * Last 4 Digits
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    lastFourDigits: string;
    /**
     * Card Status
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    cardStatusCode: string;
    /**
     * Card Sub Status
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    cardSubStatusCode: string;
    /**
     * Reissue Reason Code
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    reissueReasonCode: string;
    /**
     * Embossed Name
     * @type {string}
     * @memberof OperationsReissueUpdateRequest
     */
    embossedName: string;
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof OperationsReissueUpdateRequest
     */
    documentUploadDataList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface OperationsReissueUpdateResponse
 */
export interface OperationsReissueUpdateResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof OperationsReissueUpdateResponse
     */
    reissueResultMessage: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PageOperationType {
    NEW = 'NEW',
    EDIT = 'EDIT'
}

/**
 * 
 * @export
 * @interface PaginationRequest
 */
export interface PaginationRequest {
    /**
     * Number of rows per page
     * @type {number}
     * @memberof PaginationRequest
     */
    rowCountPerPage?: number;
    /**
     * Page number starting with 1
     * @type {number}
     * @memberof PaginationRequest
     */
    pageNumber?: number;
    /**
     * True if cache will not be used
     * @type {boolean}
     * @memberof PaginationRequest
     */
    refresh?: boolean;
}
/**
 * 
 * @export
 * @interface PaginationResponse
 */
export interface PaginationResponse extends Response {
    /**
     * True if previous data exists
     * @type {boolean}
     * @memberof PaginationResponse
     */
    hasPreviousPage: boolean;
    /**
     * True if next data exists
     * @type {boolean}
     * @memberof PaginationResponse
     */
    hasNextPage: boolean;
}
/**
 * 
 * @export
 * @interface ParameterRequest
 */
export interface ParameterRequest {
    /**
     * 
     * @type {ParameterType}
     * @memberof ParameterRequest
     */
    parameterType: ParameterType;
}
/**
 * 
 * @export
 * @interface ParameterResponse
 */
export interface ParameterResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof ParameterResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ParameterType {
    ACCOUNTCURRENCY = 'ACCOUNT_CURRENCY'
}

/**
 * 
 * @export
 * @interface PhoneDetailData
 */
export interface PhoneDetailData {
    /**
     * Field Code
     * @type {string}
     * @memberof PhoneDetailData
     */
    fieldCode?: string;
    /**
     * Telephone No
     * @type {string}
     * @memberof PhoneDetailData
     */
    telephoneNo?: string;
    /**
     * Id
     * @type {string}
     * @memberof PhoneDetailData
     */
    id?: string;
    /**
     * Country Code
     * @type {string}
     * @memberof PhoneDetailData
     */
    countryCode?: string;
}
/**
 * 
 * @export
 * @interface PhoneInfoPageData
 */
export interface PhoneInfoPageData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PhoneInfoPageData
     */
    countryCode: DictionaryLine;
    /**
     * Field code
     * @type {string}
     * @memberof PhoneInfoPageData
     */
    fieldCode: string;
    /**
     * Phone number
     * @type {string}
     * @memberof PhoneInfoPageData
     */
    telephoneNo: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PhoneType {
    MOBILEPHONE = 'MOBILE_PHONE',
    HOMEPHONE = 'HOME_PHONE',
    WORKPHONE = 'WORK_PHONE',
    CONTACTMOBILEPHONE = 'CONTACT_MOBILE_PHONE',
    REGISTRATIONADDRESSPHONE = 'REGISTRATION_ADDRESS_PHONE'
}

/**
 * 
 * @export
 * @interface PlasticCardAccountDocumentRequest
 */
export interface PlasticCardAccountDocumentRequest {
    /**
     * Document Number
     * @type {string}
     * @memberof PlasticCardAccountDocumentRequest
     */
    documentNumber: string;
    /**
     * Account Name
     * @type {string}
     * @memberof PlasticCardAccountDocumentRequest
     */
    accountName: string;
    /**
     * Start Date
     * @type {string}
     * @memberof PlasticCardAccountDocumentRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof PlasticCardAccountDocumentRequest
     */
    endDate: string;
}
/**
 * 
 * @export
 * @interface PlasticCardAccountDocumentResponse
 */
export interface PlasticCardAccountDocumentResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof PlasticCardAccountDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface PlasticCardAccountsSearchData
 */
export interface PlasticCardAccountsSearchData {
    /**
     * Document Number
     * @type {string}
     * @memberof PlasticCardAccountsSearchData
     */
    documentNumber: string;
    /**
     * Account Name
     * @type {string}
     * @memberof PlasticCardAccountsSearchData
     */
    accountName: string;
}
/**
 * 
 * @export
 * @interface PlasticCardAccountsSearchRequest
 */
export interface PlasticCardAccountsSearchRequest extends PaginationRequest {
    /**
     * Point of Sale Code
     * @type {string}
     * @memberof PlasticCardAccountsSearchRequest
     */
    pointOfSale: string;
}
/**
 * 
 * @export
 * @interface PlasticCardAccountsSearchResponse
 */
export interface PlasticCardAccountsSearchResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<PlasticCardAccountsSearchData>}
     * @memberof PlasticCardAccountsSearchResponse
     */
    accountList: Array<PlasticCardAccountsSearchData>;
}
/**
 * 
 * @export
 * @interface PlasticCardActNumberComboRequest
 */
export interface PlasticCardActNumberComboRequest {
    /**
     * Point of Sale Code
     * @type {string}
     * @memberof PlasticCardActNumberComboRequest
     */
    pointOfSale: string;
    /**
     * Account Type Code
     * @type {string}
     * @memberof PlasticCardActNumberComboRequest
     */
    accountType: string;
}
/**
 * 
 * @export
 * @interface PlasticCardActNumberComboResponse
 */
export interface PlasticCardActNumberComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof PlasticCardActNumberComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface PlasticCardAdditionalInfoComponentsData
 */
export interface PlasticCardAdditionalInfoComponentsData {
    /**
     * Component Type
     * @type {string}
     * @memberof PlasticCardAdditionalInfoComponentsData
     */
    componentType: string;
    /**
     * Component Value
     * @type {string}
     * @memberof PlasticCardAdditionalInfoComponentsData
     */
    componentValue: string;
    /**
     * Component Input Key
     * @type {string}
     * @memberof PlasticCardAdditionalInfoComponentsData
     */
    componentInputKey: string;
    /**
     * true if it is visible
     * @type {boolean}
     * @memberof PlasticCardAdditionalInfoComponentsData
     */
    isVisible: boolean;
}
/**
 * 
 * @export
 * @interface PlasticCardAdditionalInfoComponentsRequest
 */
export interface PlasticCardAdditionalInfoComponentsRequest {
    /**
     * Operations Code
     * @type {string}
     * @memberof PlasticCardAdditionalInfoComponentsRequest
     */
    operations: string;
}
/**
 * 
 * @export
 * @interface PlasticCardAdditionalInfoComponentsResponse
 */
export interface PlasticCardAdditionalInfoComponentsResponse extends Response {
    /**
     * 
     * @type {Array<PlasticCardAdditionalInfoComponentsData>}
     * @memberof PlasticCardAdditionalInfoComponentsResponse
     */
    componentsList: Array<PlasticCardAdditionalInfoComponentsData>;
}
/**
 * 
 * @export
 * @interface PlasticCardApplyRequest
 */
export interface PlasticCardApplyRequest {
    /**
     * Point of Sale Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    pointOfSale: string;
    /**
     * Operations Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    operations: string;
    /**
     * Account Type Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    accountType: string;
    /**
     * Quantity
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    quantity: string;
    /**
     * Document Create Date
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    documentCreateDate: string;
    /**
     * Act Number
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    actNumber?: string;
    /**
     * From The Account Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    fromAccount?: string;
    /**
     * Branch Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    branchCode?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PlasticCardApplyRequest
     */
    toPointOfSale?: DictionaryLine;
    /**
     * Act Number Combo Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    actNumberCombo?: string;
    /**
     * To Account Code
     * @type {string}
     * @memberof PlasticCardApplyRequest
     */
    toAccount?: string;
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof PlasticCardApplyRequest
     */
    documentList: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface PlasticCardApplyResponse
 */
export interface PlasticCardApplyResponse extends Response {
}
/**
 * 
 * @export
 * @interface PlasticCardOperationsSearchData
 */
export interface PlasticCardOperationsSearchData {
    /**
     * Operations
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    operations: string;
    /**
     * Act Number
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    actNumber: string;
    /**
     * Quantity
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    quantity: string;
    /**
     * Transaction Date
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    transactionDate: string;
    /**
     * User Code
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    userCode: string;
    /**
     * Comment
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    comment: string;
    /**
     * Direction
     * @type {string}
     * @memberof PlasticCardOperationsSearchData
     */
    direction: string;
}
/**
 * 
 * @export
 * @interface PlasticCardOperationsSearchRequest
 */
export interface PlasticCardOperationsSearchRequest extends PaginationRequest {
    /**
     * Point of Sale Code
     * @type {string}
     * @memberof PlasticCardOperationsSearchRequest
     */
    pointOfSale: string;
    /**
     * Account Type Code
     * @type {string}
     * @memberof PlasticCardOperationsSearchRequest
     */
    accountType?: string;
    /**
     * Start Date
     * @type {string}
     * @memberof PlasticCardOperationsSearchRequest
     */
    startDate?: string;
    /**
     * End Date
     * @type {string}
     * @memberof PlasticCardOperationsSearchRequest
     */
    endDate?: string;
}
/**
 * 
 * @export
 * @interface PlasticCardOperationsSearchResponse
 */
export interface PlasticCardOperationsSearchResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<PlasticCardOperationsSearchData>}
     * @memberof PlasticCardOperationsSearchResponse
     */
    operationList: Array<PlasticCardOperationsSearchData>;
}
/**
 * 
 * @export
 * @interface PosActivateRequest
 */
export interface PosActivateRequest {
    /**
     * Card Status
     * @type {string}
     * @memberof PosActivateRequest
     */
    cardStatus?: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof PosActivateRequest
     */
    customerNumber?: string;
    /**
     * Customer Id
     * @type {string}
     * @memberof PosActivateRequest
     */
    customerId?: string;
    /**
     * id
     * @type {string}
     * @memberof PosActivateRequest
     */
    documentId?: string;
    /**
     * Card Number
     * @type {string}
     * @memberof PosActivateRequest
     */
    cardNumber?: string;
    /**
     * Card Id
     * @type {string}
     * @memberof PosActivateRequest
     */
    cardId?: string;
    /**
     * 
     * @type {DocumentUploadData}
     * @memberof PosActivateRequest
     */
    documentUploadData: DocumentUploadData;
    /**
     * 
     * @type {CardActivationType}
     * @memberof PosActivateRequest
     */
    cardActivationType: CardActivationType;
}
/**
 * 
 * @export
 * @interface PosActivateResponse
 */
export interface PosActivateResponse extends Response {
}
/**
 * 
 * @export
 * @interface PosActivationDocumentRequest
 */
export interface PosActivationDocumentRequest {
    /**
     * Card Id
     * @type {string}
     * @memberof PosActivationDocumentRequest
     */
    cardId: string;
}
/**
 * 
 * @export
 * @interface PosActivationDocumentResponse
 */
export interface PosActivationDocumentResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof PosActivationDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface PosActivationRequest
 */
export interface PosActivationRequest {
    /**
     * Card Number
     * @type {string}
     * @memberof PosActivationRequest
     */
    cardNumber: string;
    /**
     * Card Id
     * @type {string}
     * @memberof PosActivationRequest
     */
    cardId: string;
    /**
     * Card Status
     * @type {string}
     * @memberof PosActivationRequest
     */
    cardStatus: string;
}
/**
 * 
 * @export
 * @interface PosActivationResponse
 */
export interface PosActivationResponse extends Response {
    /**
     * Result message of pos activation
     * @type {string}
     * @memberof PosActivationResponse
     */
    posResultMessage: string;
    /**
     * true if download button will be visible
     * @type {boolean}
     * @memberof PosActivationResponse
     */
    isDownloadButtonVisible?: boolean;
}
/**
 * 
 * @export
 * @interface PosCardsRequest
 */
export interface PosCardsRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof PosCardsRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface PosCardsResponse
 */
export interface PosCardsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<PosCardsResponseData>}
     * @memberof PosCardsResponse
     */
    posCardList: Array<PosCardsResponseData>;
}
/**
 * 
 * @export
 * @interface PosCardsResponseData
 */
export interface PosCardsResponseData {
    /**
     * Card Id
     * @type {string}
     * @memberof PosCardsResponseData
     */
    cardId?: string;
    /**
     * Card Number
     * @type {string}
     * @memberof PosCardsResponseData
     */
    cardNumber?: string;
    /**
     * Card Owner
     * @type {string}
     * @memberof PosCardsResponseData
     */
    cardOwner?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PosCardsResponseData
     */
    cardStatus?: DictionaryLine;
    /**
     * Card Sub Status
     * @type {string}
     * @memberof PosCardsResponseData
     */
    cardSubStatus?: string;
    /**
     * Currency
     * @type {string}
     * @memberof PosCardsResponseData
     */
    currency?: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof PosCardsResponseData
     */
    expireDate?: string;
}
/**
 * 
 * @export
 * @interface PosDataDetailResponse
 */
export interface PosDataDetailResponse extends Response {
    /**
     * Store Code
     * @type {string}
     * @memberof PosDataDetailResponse
     */
    storeCode: string;
    /**
     * 
     * @type {CardSelectionType}
     * @memberof PosDataDetailResponse
     */
    cardSelectionType: CardSelectionType;
}
/**
 * 
 * @export
 * @interface PosDataResponse
 */
export interface PosDataResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof PosDataResponse
     */
    posDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface PosSearchPageData
 */
export interface PosSearchPageData {
    /**
     * 
     * @type {CustomerSearchCriteria}
     * @memberof PosSearchPageData
     */
    customerSearchCriteria: CustomerSearchCriteria;
    /**
     * Selected Customer Id
     * @type {string}
     * @memberof PosSearchPageData
     */
    selectedCustomerId: string;
    /**
     * Page number starting with 1
     * @type {number}
     * @memberof PosSearchPageData
     */
    customerPageNumber: number;
    /**
     * Card Id
     * @type {string}
     * @memberof PosSearchPageData
     */
    selectedCardId: string;
    /**
     * Page number starting with 1
     * @type {number}
     * @memberof PosSearchPageData
     */
    cardPageNumber: number;
}
/**
 * 
 * @export
 * @interface PosSearchPageDataResponse
 */
export interface PosSearchPageDataResponse extends Response {
    /**
     * 
     * @type {PosSearchPageData}
     * @memberof PosSearchPageDataResponse
     */
    pageData?: PosSearchPageData;
}
/**
 * 
 * @export
 * @interface ProductComboRequest
 */
export interface ProductComboRequest {
    /**
     * 
     * @type {ProductComboType}
     * @memberof ProductComboRequest
     */
    productComboType: ProductComboType;
    /**
     * Fill Point Id
     * @type {string}
     * @memberof ProductComboRequest
     */
    fillPointId: string;
    /**
     * Card Type Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    cardTypeCode?: string;
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    customerTypeCode?: string;
    /**
     * Customer Sub Type Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    customerSubTypeCode?: string;
    /**
     * Debit Flag Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    debitFlagCode?: string;
    /**
     * Resident Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    residentCode?: string;
    /**
     * Account Type Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    accountTypeCode?: string;
    /**
     * Brand Owner Code
     * @type {string}
     * @memberof ProductComboRequest
     */
    brandOwnerCode?: string;
    /**
     * Card Type
     * @type {string}
     * @memberof ProductComboRequest
     */
    cardType?: string;
}
/**
 * 
 * @export
 * @interface ProductComboResponse
 */
export interface ProductComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof ProductComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
    /**
     * if salary is visible
     * @type {boolean}
     * @memberof ProductComboResponse
     */
    isSalaryVisible?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductComboType {
    CUSTOMER = 'CUSTOMER',
    CUSTOMERSUB = 'CUSTOMER_SUB',
    DEBITFLAG = 'DEBIT_FLAG',
    RESIDENT = 'RESIDENT',
    ACCOUNT = 'ACCOUNT',
    BRANDOWNER = 'BRAND_OWNER',
    CARD = 'CARD'
}

/**
 * 
 * @export
 * @interface ProductLineDetailRequest
 */
export interface ProductLineDetailRequest {
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    customerTypeCode: string;
    /**
     * Customer Sub Type Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    customerSubTypeCode: string;
    /**
     * Debit Flag Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    debitFlagCode: string;
    /**
     * Resident Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    residentCode: string;
    /**
     * Account Type Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    accountTypeCode: string;
    /**
     * Brand Owner Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    brandOwnerCode: string;
    /**
     * Card Type Code
     * @type {string}
     * @memberof ProductLineDetailRequest
     */
    cardTypeCode: string;
}
/**
 * 
 * @export
 * @interface ProductLineDetailResponse
 */
export interface ProductLineDetailResponse extends Response {
    /**
     * Product
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    product: string;
    /**
     * Pricing Group
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    pricingGroup: string;
    /**
     * Statement(Billing Group)
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    billingGroup: string;
    /**
     * Risk Group
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    riskGroup: string;
    /**
     * Customer Group
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    customerGroup: string;
    /**
     * Y if it has insurance
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    hasInsurance: string;
    /**
     * Line Code
     * @type {string}
     * @memberof ProductLineDetailResponse
     */
    lineCode: string;
}
/**
 * 
 * @export
 * @interface ProductOfferBaseData
 */
export interface ProductOfferBaseData {
    /**
     * Row ID starting with 0
     * @type {number}
     * @memberof ProductOfferBaseData
     */
    rowId: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    brandOwner: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    cardType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    customerType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    customerSubType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    debitFlag: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    residentFlag: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductOfferBaseData
     */
    accountType: DictionaryLine;
    /**
     * Customer Name
     * @type {string}
     * @memberof ProductOfferBaseData
     */
    customerName: string;
    /**
     * Card Status
     * @type {string}
     * @memberof ProductOfferBaseData
     */
    cardStatus: string;
    /**
     * Reference Number
     * @type {string}
     * @memberof ProductOfferBaseData
     */
    referenceNumber: string;
    /**
     * limit amount
     * @type {string}
     * @memberof ProductOfferBaseData
     */
    cardLimit: string;
    /**
     * Entry Date
     * @type {string}
     * @memberof ProductOfferBaseData
     */
    entryDate: string;
}
/**
 * 
 * @export
 * @interface ProductOfferData
 */
export interface ProductOfferData {
    /**
     * 
     * @type {Array<ProductOfferBaseData>}
     * @memberof ProductOfferData
     */
    productOfferDataList?: Array<ProductOfferBaseData>;
    /**
     * true if document printed
     * @type {boolean}
     * @memberof ProductOfferData
     */
    isItScoredForProductService: boolean;
    /**
     * Document Id
     * @type {string}
     * @memberof ProductOfferData
     */
    productOfferDocumentId?: string;
    /**
     * Physical File Name
     * @type {string}
     * @memberof ProductOfferData
     */
    physicalFileName?: string;
}
/**
 * 
 * @export
 * @interface ProductOfferDocumentResponse
 */
export interface ProductOfferDocumentResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof ProductOfferDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface ProductOfferPageData
 */
export interface ProductOfferPageData {
    /**
     * 
     * @type {ProductPageBaseData}
     * @memberof ProductOfferPageData
     */
    productData?: ProductPageBaseData;
    /**
     * 
     * @type {ProductOfferData}
     * @memberof ProductOfferPageData
     */
    productOfferData: ProductOfferData;
}
/**
 * 
 * @export
 * @interface ProductOfferPageDataResponse
 */
export interface ProductOfferPageDataResponse extends Response {
    /**
     * 
     * @type {ProductOfferPageData}
     * @memberof ProductOfferPageDataResponse
     */
    pageData?: ProductOfferPageData;
}
/**
 * 
 * @export
 * @interface ProductOfferScoringResponse
 */
export interface ProductOfferScoringResponse extends Response {
    /**
     * 
     * @type {Array<ProductOfferBaseData>}
     * @memberof ProductOfferScoringResponse
     */
    productOfferDataList: Array<ProductOfferBaseData>;
    /**
     * true if all product offers are rejected
     * @type {boolean}
     * @memberof ProductOfferScoringResponse
     */
    isProductOfferRejected?: boolean;
}
/**
 * 
 * @export
 * @interface ProductOfferVisibilityRequest
 */
export interface ProductOfferVisibilityRequest {
    /**
     * true if product offer checkbox is checked
     * @type {boolean}
     * @memberof ProductOfferVisibilityRequest
     */
    isProductOfferChecked: boolean;
}
/**
 * 
 * @export
 * @interface ProductOfferVisibilityResponse
 */
export interface ProductOfferVisibilityResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof ProductOfferVisibilityResponse
     */
    parameterDataList: Array<DictionaryLine>;
    /**
     * if card type is visible
     * @type {boolean}
     * @memberof ProductOfferVisibilityResponse
     */
    isCardTypeVisible: boolean;
    /**
     * if card usage type is enabled
     * @type {boolean}
     * @memberof ProductOfferVisibilityResponse
     */
    isCardUsageTypeEnabled: boolean;
}
/**
 * 
 * @export
 * @interface ProductOperationCriteriaData
 */
export interface ProductOperationCriteriaData {
    /**
     * 
     * @type {ProductOperationCriteriaId}
     * @memberof ProductOperationCriteriaData
     */
    id: ProductOperationCriteriaId;
    /**
     * Label
     * @type {string}
     * @memberof ProductOperationCriteriaData
     */
    label: string;
    /**
     * True if criteria will be visible
     * @type {boolean}
     * @memberof ProductOperationCriteriaData
     */
    visible: boolean;
    /**
     * 
     * @type {InputType}
     * @memberof ProductOperationCriteriaData
     */
    inputType: InputType;
    /**
     * Maximum Length
     * @type {number}
     * @memberof ProductOperationCriteriaData
     */
    maxLength?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductOperationCriteriaId {
    CRITERIA1A = 'CRITERIA1A',
    CRITERIA1B = 'CRITERIA1B',
    CRITERIA2A = 'CRITERIA2A',
    CRITERIA2B = 'CRITERIA2B',
    CRITERIA3 = 'CRITERIA3',
    CRITERIA4 = 'CRITERIA4',
    CRITERIA5 = 'CRITERIA5',
    CRITERIA6 = 'CRITERIA6'
}

/**
 * 
 * @export
 * @interface ProductOperationCriteriaRequest
 */
export interface ProductOperationCriteriaRequest {
    /**
     * Product Code
     * @type {string}
     * @memberof ProductOperationCriteriaRequest
     */
    productCode: string;
    /**
     * Product Operation Code
     * @type {string}
     * @memberof ProductOperationCriteriaRequest
     */
    productOperationCode: string;
}
/**
 * 
 * @export
 * @interface ProductOperationCriteriaResponse
 */
export interface ProductOperationCriteriaResponse extends Response {
    /**
     * 
     * @type {Array<ProductOperationCriteriaData>}
     * @memberof ProductOperationCriteriaResponse
     */
    criteriaList: Array<ProductOperationCriteriaData>;
}
/**
 * 
 * @export
 * @interface ProductOperationResponseData
 */
export interface ProductOperationResponseData {
    /**
     * Product Operation Status
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    productOperationStatus: string;
    /**
     * Process Date
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    processDate: string;
    /**
     * Product Name
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    productName: string;
    /**
     * Product Operation Name
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    productOperationName: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    customerNumber: string;
    /**
     * Client Name
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    clientName: string;
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    referenceNumber: string;
    /**
     * Criteria1
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    criteria1: string;
    /**
     * Criteria2
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    criteria2: string;
    /**
     * criteria3
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    criteria3: string;
    /**
     * criteria4
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    criteria4: string;
    /**
     * criteria5
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    criteria5: string;
    /**
     * criteria6
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    criteria6: string;
    /**
     * True if edit button will be visible
     * @type {boolean}
     * @memberof ProductOperationResponseData
     */
    isEditButtonVisible: boolean;
    /**
     * True if cancel button will be visible
     * @type {boolean}
     * @memberof ProductOperationResponseData
     */
    isCancelButtonVisible: boolean;
    /**
     * Unique id of the menu item
     * @type {string}
     * @memberof ProductOperationResponseData
     */
    menuID: string;
}
/**
 * 
 * @export
 * @interface ProductOperationStatusData
 */
export interface ProductOperationStatusData {
    /**
     * Process Date
     * @type {string}
     * @memberof ProductOperationStatusData
     */
    processDate: string;
    /**
     * Process Time
     * @type {string}
     * @memberof ProductOperationStatusData
     */
    processTime: string;
    /**
     * Product Operation Status
     * @type {string}
     * @memberof ProductOperationStatusData
     */
    productOperationStatus: string;
    /**
     * Explanation
     * @type {string}
     * @memberof ProductOperationStatusData
     */
    explanation: string;
}
/**
 * 
 * @export
 * @interface ProductOperationsRequest
 */
export interface ProductOperationsRequest extends PaginationRequest {
    /**
     * Product Code
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    productCode?: string;
    /**
     * Product Operation Code
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    productOperationCode?: string;
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    referenceNumber?: string;
    /**
     * Begin Date
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    beginDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    endDate: string;
    /**
     * Product Operation Status Code
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    productOperationStatusCode?: string;
    /**
     * lower bound amount
     * @type {number}
     * @memberof ProductOperationsRequest
     */
    amountLowerBound?: number;
    /**
     * upper bound amount
     * @type {number}
     * @memberof ProductOperationsRequest
     */
    amountUpperBound?: number;
    /**
     * Criteria1 A begin date
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    criteria1A?: string;
    /**
     * Criteria1 B end date
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    criteria1B?: string;
    /**
     * criteria2 A lower bound
     * @type {number}
     * @memberof ProductOperationsRequest
     */
    criteria2A?: number;
    /**
     * criteria2 B upper bound
     * @type {number}
     * @memberof ProductOperationsRequest
     */
    criteria2B?: number;
    /**
     * criteria3
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    criteria3?: string;
    /**
     * criteria4
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    criteria4?: string;
    /**
     * criteria5
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    criteria5?: string;
    /**
     * criteria6
     * @type {string}
     * @memberof ProductOperationsRequest
     */
    criteria6?: string;
}
/**
 * 
 * @export
 * @interface ProductOperationsResponse
 */
export interface ProductOperationsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<ProductOperationResponseData>}
     * @memberof ProductOperationsResponse
     */
    productOperationList: Array<ProductOperationResponseData>;
}
/**
 * 
 * @export
 * @interface ProductOperationsStatusRequest
 */
export interface ProductOperationsStatusRequest extends PaginationRequest {
    /**
     * Product Operation Ref No
     * @type {string}
     * @memberof ProductOperationsStatusRequest
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface ProductOperationsStatusResponse
 */
export interface ProductOperationsStatusResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<ProductOperationStatusData>}
     * @memberof ProductOperationsStatusResponse
     */
    productOperationStatusList: Array<ProductOperationStatusData>;
}
/**
 * 
 * @export
 * @interface ProductPageBaseData
 */
export interface ProductPageBaseData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    customerType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    customerSubType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    debitFlag: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    resident: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    accountType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    brandOwner: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageBaseData
     */
    productCardType: DictionaryLine;
}
/**
 * 
 * @export
 * @interface ProductPageData
 */
export interface ProductPageData extends ProductPageBaseData {
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageData
     */
    pos: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageData
     */
    subPos: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageData
     */
    cardType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ProductPageData
     */
    printType: DictionaryLine;
    /**
     * 
     * @type {CardSelectionType}
     * @memberof ProductPageData
     */
    cardSelectionType: CardSelectionType;
    /**
     * 
     * @type {CardUsageType}
     * @memberof ProductPageData
     */
    cardUsageType: CardUsageType;
    /**
     * 
     * @type {CardListData}
     * @memberof ProductPageData
     */
    mainCardInfo?: CardListData;
    /**
     * Card Image Id
     * @type {string}
     * @memberof ProductPageData
     */
    cardImageId?: string;
    /**
     * true if salary is visible
     * @type {boolean}
     * @memberof ProductPageData
     */
    isSalaryVisible: boolean;
    /**
     * true if salary checkbox is checked
     * @type {boolean}
     * @memberof ProductPageData
     */
    isSalaryChecked?: boolean;
    /**
     * true if it is transferable product checkbox is checked
     * @type {boolean}
     * @memberof ProductPageData
     */
    isProductTransfer?: boolean;
    /**
     * 
     * @type {TransferableCardData}
     * @memberof ProductPageData
     */
    transferableCardInfo?: TransferableCardData;
    /**
     * true if product offer is visible
     * @type {boolean}
     * @memberof ProductPageData
     */
    isProductOfferVisible: boolean;
    /**
     * true if product offer is checked
     * @type {boolean}
     * @memberof ProductPageData
     */
    isProductOfferChecked: boolean;
    /**
     * true if sing document is checked
     * @type {boolean}
     * @memberof ProductPageData
     */
    isSignDocuments?: boolean;
}
/**
 * 
 * @export
 * @interface ProductPageDataResponse
 */
export interface ProductPageDataResponse extends Response {
    /**
     * 
     * @type {ProductPageData}
     * @memberof ProductPageDataResponse
     */
    pageData?: ProductPageData;
}
/**
 * 
 * @export
 * @interface ProductSalaryLineRequest
 */
export interface ProductSalaryLineRequest {
    /**
     * Residence Country
     * @type {string}
     * @memberof ProductSalaryLineRequest
     */
    residenceCountry?: string;
}
/**
 * 
 * @export
 * @interface ProductSalaryLineResponse
 */
export interface ProductSalaryLineResponse extends Response {
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ProductSalaryLineResponse
     */
    customerTypeCode: string;
    /**
     * Customer Sub Type Code
     * @type {string}
     * @memberof ProductSalaryLineResponse
     */
    customerSubTypeCode: string;
    /**
     * Debit Flag Code
     * @type {string}
     * @memberof ProductSalaryLineResponse
     */
    debitFlagCode: string;
}
/**
 * 
 * @export
 * @interface PtsComponentsChangeableResponse
 */
export interface PtsComponentsChangeableResponse extends Response {
    /**
     * true if it is changeable
     * @type {boolean}
     * @memberof PtsComponentsChangeableResponse
     */
    isDeadlineChangeable: boolean;
    /**
     * true if it is changeable
     * @type {boolean}
     * @memberof PtsComponentsChangeableResponse
     */
    isClassificationCodeChangeable: boolean;
    /**
     * true if it is changeable
     * @type {boolean}
     * @memberof PtsComponentsChangeableResponse
     */
    isStatusChangeable: boolean;
}
/**
 * 
 * @export
 * @interface PtsComponentsValuesResponse
 */
export interface PtsComponentsValuesResponse extends Response {
    /**
     * Deadline
     * @type {string}
     * @memberof PtsComponentsValuesResponse
     */
    deadline: string;
}
/**
 * 
 * @export
 * @interface PtsCustomerChangeRequest
 */
export interface PtsCustomerChangeRequest {
    /**
     * Customer Id
     * @type {string}
     * @memberof PtsCustomerChangeRequest
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface PtsCustomerChangeResponse
 */
export interface PtsCustomerChangeResponse extends Response {
}
/**
 * 
 * @export
 * @interface PtsDocumentsRequest
 */
export interface PtsDocumentsRequest extends PaginationRequest {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsDocumentsRequest
     */
    problemId: string;
}
/**
 * 
 * @export
 * @interface PtsDocumentsResponse
 */
export interface PtsDocumentsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<PtsDocumentsSearchData>}
     * @memberof PtsDocumentsResponse
     */
    documentList: Array<PtsDocumentsSearchData>;
}
/**
 * 
 * @export
 * @interface PtsDocumentsSearchData
 */
export interface PtsDocumentsSearchData {
    /**
     * Document Number
     * @type {string}
     * @memberof PtsDocumentsSearchData
     */
    documentNumber: string;
    /**
     * Comment
     * @type {string}
     * @memberof PtsDocumentsSearchData
     */
    comment: string;
    /**
     * Name
     * @type {string}
     * @memberof PtsDocumentsSearchData
     */
    name: string;
    /**
     * true if the document is old
     * @type {boolean}
     * @memberof PtsDocumentsSearchData
     */
    isOldDocument: boolean;
}
/**
 * 
 * @export
 * @interface PtsLevelThreeComboRequest
 */
export interface PtsLevelThreeComboRequest {
    /**
     * Level One Code
     * @type {string}
     * @memberof PtsLevelThreeComboRequest
     */
    levelOne: string;
    /**
     * Level Two Code
     * @type {string}
     * @memberof PtsLevelThreeComboRequest
     */
    levelTwo: string;
}
/**
 * 
 * @export
 * @interface PtsLevelThreeComboResponse
 */
export interface PtsLevelThreeComboResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof PtsLevelThreeComboResponse
     */
    parameterDataList: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @interface PtsLockRecordRequest
 */
export interface PtsLockRecordRequest {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsLockRecordRequest
     */
    problemId: string;
}
/**
 * 
 * @export
 * @interface PtsLockRecordResponse
 */
export interface PtsLockRecordResponse extends Response {
}
/**
 * 
 * @export
 * @interface PtsRecordCheckLockStatusRequest
 */
export interface PtsRecordCheckLockStatusRequest {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsRecordCheckLockStatusRequest
     */
    problemId: string;
}
/**
 * 
 * @export
 * @interface PtsRecordCheckLockStatusResponse
 */
export interface PtsRecordCheckLockStatusResponse extends Response {
    /**
     * true if record is locked
     * @type {boolean}
     * @memberof PtsRecordCheckLockStatusResponse
     */
    isLocked: boolean;
    /**
     * User Code
     * @type {string}
     * @memberof PtsRecordCheckLockStatusResponse
     */
    userCode?: string;
}
/**
 * 
 * @export
 * @interface PtsRecordHistoryData
 */
export interface PtsRecordHistoryData {
    /**
     * Date Of Entry
     * @type {string}
     * @memberof PtsRecordHistoryData
     */
    dateOfEntry: string;
    /**
     * Input Time
     * @type {string}
     * @memberof PtsRecordHistoryData
     */
    inputTime: string;
    /**
     * User Code
     * @type {string}
     * @memberof PtsRecordHistoryData
     */
    userCode: string;
    /**
     * Department
     * @type {string}
     * @memberof PtsRecordHistoryData
     */
    department: string;
    /**
     * Type Of Action
     * @type {string}
     * @memberof PtsRecordHistoryData
     */
    typeOfAction: string;
    /**
     * New Value
     * @type {string}
     * @memberof PtsRecordHistoryData
     */
    newValue: string;
}
/**
 * 
 * @export
 * @interface PtsRecordHistoryRequest
 */
export interface PtsRecordHistoryRequest extends PaginationRequest {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsRecordHistoryRequest
     */
    problemId: string;
}
/**
 * 
 * @export
 * @interface PtsRecordHistoryResponse
 */
export interface PtsRecordHistoryResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<PtsRecordHistoryData>}
     * @memberof PtsRecordHistoryResponse
     */
    recordList: Array<PtsRecordHistoryData>;
}
/**
 * 
 * @export
 * @interface PtsSaveRequest
 */
export interface PtsSaveRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof PtsSaveRequest
     */
    customerNumber?: string;
    /**
     * Customer Oid
     * @type {string}
     * @memberof PtsSaveRequest
     */
    customerId?: string;
    /**
     * Level Zero Code
     * @type {string}
     * @memberof PtsSaveRequest
     */
    levelZero: string;
    /**
     * Level One Code
     * @type {string}
     * @memberof PtsSaveRequest
     */
    levelOne: string;
    /**
     * Level Two Code
     * @type {string}
     * @memberof PtsSaveRequest
     */
    levelTwo?: string;
    /**
     * Level Three Code
     * @type {string}
     * @memberof PtsSaveRequest
     */
    levelThree?: string;
    /**
     * Product Type
     * @type {string}
     * @memberof PtsSaveRequest
     */
    productType?: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof PtsSaveRequest
     */
    customerName?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof PtsSaveRequest
     */
    customerSurname?: string;
    /**
     * Customer Second Name
     * @type {string}
     * @memberof PtsSaveRequest
     */
    customerSecondName?: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof PtsSaveRequest
     */
    birthDate?: string;
    /**
     * Classification Code
     * @type {string}
     * @memberof PtsSaveRequest
     */
    classificationCode?: string;
    /**
     * Channel Code
     * @type {string}
     * @memberof PtsSaveRequest
     */
    channelCode?: string;
    /**
     * Send Type
     * @type {string}
     * @memberof PtsSaveRequest
     */
    sendType?: string;
    /**
     * Status Type
     * @type {string}
     * @memberof PtsSaveRequest
     */
    status?: string;
    /**
     * Closure Type
     * @type {string}
     * @memberof PtsSaveRequest
     */
    closureType?: string;
    /**
     * Detail About The Record
     * @type {string}
     * @memberof PtsSaveRequest
     */
    detailAboutRecord: string;
    /**
     * true if Sms is checked
     * @type {boolean}
     * @memberof PtsSaveRequest
     */
    isSmsChecked: boolean;
    /**
     * true if Vip is checked
     * @type {boolean}
     * @memberof PtsSaveRequest
     */
    isVipChecked: boolean;
    /**
     * Dead Line
     * @type {string}
     * @memberof PtsSaveRequest
     */
    deadline: string;
    /**
     * 
     * @type {Array<DocumentPageUploadData>}
     * @memberof PtsSaveRequest
     */
    documentList?: Array<DocumentPageUploadData>;
}
/**
 * 
 * @export
 * @interface PtsSaveResponse
 */
export interface PtsSaveResponse extends Response {
}
/**
 * 
 * @export
 * @interface PtsSearchRequest
 */
export interface PtsSearchRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof PtsSearchRequest
     */
    customerNumber?: string;
    /**
     * Customer Oid
     * @type {string}
     * @memberof PtsSearchRequest
     */
    customerId?: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof PtsSearchRequest
     */
    customerName?: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof PtsSearchRequest
     */
    customerSurname?: string;
    /**
     * Customer Second Name
     * @type {string}
     * @memberof PtsSearchRequest
     */
    customerSecondName?: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof PtsSearchRequest
     */
    birthDate?: string;
    /**
     * Start Date
     * @type {string}
     * @memberof PtsSearchRequest
     */
    startDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof PtsSearchRequest
     */
    endDate: string;
    /**
     * Status Type
     * @type {string}
     * @memberof PtsSearchRequest
     */
    status?: string;
    /**
     * Product Type
     * @type {string}
     * @memberof PtsSearchRequest
     */
    productType?: string;
    /**
     * Channel Code
     * @type {string}
     * @memberof PtsSearchRequest
     */
    channelCode?: string;
    /**
     * Pool
     * @type {string}
     * @memberof PtsSearchRequest
     */
    pool?: string;
    /**
     * Classification Code
     * @type {string}
     * @memberof PtsSearchRequest
     */
    classificationCode?: string;
    /**
     * Application Id
     * @type {string}
     * @memberof PtsSearchRequest
     */
    applicationId?: string;
    /**
     * Level Zero Code
     * @type {string}
     * @memberof PtsSearchRequest
     */
    levelZero?: string;
    /**
     * Level One Code
     * @type {string}
     * @memberof PtsSearchRequest
     */
    levelOne?: string;
    /**
     * Level Two Code
     * @type {string}
     * @memberof PtsSearchRequest
     */
    levelTwo?: string;
    /**
     * Level Three Code
     * @type {string}
     * @memberof PtsSearchRequest
     */
    levelThree?: string;
}
/**
 * 
 * @export
 * @interface PtsSearchResponse
 */
export interface PtsSearchResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<PtsSearchResponseData>}
     * @memberof PtsSearchResponse
     */
    recordList: Array<PtsSearchResponseData>;
}
/**
 * 
 * @export
 * @interface PtsSearchResponseData
 */
export interface PtsSearchResponseData {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    problemId: string;
    /**
     * Application Id
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    applicationId: string;
    /**
     * Date
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    date: string;
    /**
     * Time
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    time: string;
    /**
     * User Code
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    userCode: string;
    /**
     * Branch
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    branch: string;
    /**
     * true if it is vip
     * @type {boolean}
     * @memberof PtsSearchResponseData
     */
    vip: boolean;
    /**
     * Client\'s Full Name
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    fullName: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    levelZero: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    levelOne: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    levelTwo: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    levelThree: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    productType: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    status: DictionaryLine;
    /**
     * Classification Code
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    classificationCode: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    channel: DictionaryLine;
    /**
     * Deadline
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    deadline: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    pool: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof PtsSearchResponseData
     */
    typeOfClosure: DictionaryLine;
    /**
     * true if sms will be send
     * @type {boolean}
     * @memberof PtsSearchResponseData
     */
    sendSms: boolean;
    /**
     * Problem Text
     * @type {string}
     * @memberof PtsSearchResponseData
     */
    problemText: string;
}
/**
 * 
 * @export
 * @interface PtsSmsCheckBoxVisibilityRequest
 */
export interface PtsSmsCheckBoxVisibilityRequest {
    /**
     * Level One Code
     * @type {string}
     * @memberof PtsSmsCheckBoxVisibilityRequest
     */
    levelOne: string;
    /**
     * Level Two Code
     * @type {string}
     * @memberof PtsSmsCheckBoxVisibilityRequest
     */
    levelTwo?: string;
    /**
     * Level Three Code
     * @type {string}
     * @memberof PtsSmsCheckBoxVisibilityRequest
     */
    levelThree?: string;
    /**
     * Channel Code
     * @type {string}
     * @memberof PtsSmsCheckBoxVisibilityRequest
     */
    channelCode?: string;
}
/**
 * 
 * @export
 * @interface PtsSmsCheckBoxVisibilityResponse
 */
export interface PtsSmsCheckBoxVisibilityResponse extends Response {
    /**
     * true if it is enable and select
     * @type {boolean}
     * @memberof PtsSmsCheckBoxVisibilityResponse
     */
    isSmsCheckBoxWillBeEnableAndSelect: boolean;
}
/**
 * 
 * @export
 * @interface PtsUnlockRecordRequest
 */
export interface PtsUnlockRecordRequest {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsUnlockRecordRequest
     */
    problemId: string;
}
/**
 * 
 * @export
 * @interface PtsUnlockRecordResponse
 */
export interface PtsUnlockRecordResponse extends Response {
}
/**
 * 
 * @export
 * @interface PtsUpdateRequest
 */
export interface PtsUpdateRequest extends PtsSaveRequest {
    /**
     * Problem Id
     * @type {string}
     * @memberof PtsUpdateRequest
     */
    problemId: string;
    /**
     * Comments
     * @type {string}
     * @memberof PtsUpdateRequest
     */
    comments?: string;
}
/**
 * 
 * @export
 * @interface PtsUpdateResponse
 */
export interface PtsUpdateResponse extends Response {
}
/**
 * 
 * @export
 * @interface Rate
 */
export interface Rate {
    /**
     * Exchange Rate
     * @type {string}
     * @memberof Rate
     */
    rate: string;
    /**
     * 
     * @type {ExchangeRateDirection}
     * @memberof Rate
     */
    rateDirection: ExchangeRateDirection;
}
/**
 * 
 * @export
 * @interface ReferenceDataRequest
 */
export interface ReferenceDataRequest {
    /**
     * 
     * @type {ReferenceDataType}
     * @memberof ReferenceDataRequest
     */
    referenceDataType: ReferenceDataType;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDataRequest
     */
    additionalCode?: string;
}
/**
 * 
 * @export
 * @interface ReferenceDataResponse
 */
export interface ReferenceDataResponse extends Response {
    /**
     * 
     * @type {Array<DictionaryLine>}
     * @memberof ReferenceDataResponse
     */
    parameterDataList?: Array<DictionaryLine>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReferenceDataType {
    COUNTRIES = 'COUNTRIES',
    GENDER = 'GENDER',
    REGION = 'REGION',
    REGIONNOOTHER = 'REGION_NOOTHER',
    IDENTITYTYPE = 'IDENTITY_TYPE',
    ADDRESSTYPE = 'ADDRESS_TYPE',
    DISTRICTTYPE = 'DISTRICT_TYPE',
    STREETTYPE = 'STREET_TYPE',
    HOMEOWNERTYPE = 'HOME_OWNER_TYPE',
    CARDCARDTYPE = 'CARD_CARDTYPE',
    CARDFILLPOINT = 'CARD_FILLPOINT',
    CARDCARDTYPEBYPOSID = 'CARD_CARDTYPE_BYPOSID',
    YESNOTYPE = 'YES_NO_TYPE',
    CARDSELECTIONTYPE = 'CARD_SELECTION_TYPE',
    CARDPRINTTYPE = 'CARD_PRINT_TYPE',
    COUNTRYCODETELEPHONE = 'COUNTRY_CODE_TELEPHONE',
    MARITALSTATUS = 'MARITAL_STATUS',
    EDUCATIONSTATUS = 'EDUCATION_STATUS',
    CARDACTIONTYPE = 'CARD_ACTION_TYPE',
    COUNTRYCODETELEPHONECODE = 'COUNTRY_CODE_TELEPHONE_CODE',
    CARDSTATEMENTGROUP = 'CARD_STATEMENT_GROUP',
    CARDSENDINGADDRESS = 'CARD_SENDING_ADDRESS',
    ISPROVIDED = 'IS_PROVIDED',
    JOBTITLE = 'JOB_TITLE',
    LOANJOBTITLE = 'LOAN_JOB_TITLE',
    OCCUPATION = 'OCCUPATION',
    JOBSECTOR = 'JOB_SECTOR',
    BUSSINESSLINE = 'BUSSINESS_LINE',
    EMPLOYEENUMBER = 'EMPLOYEE_NUMBER',
    OTHERBANKS = 'OTHER_BANKS',
    ESTATEACQUISITION = 'ESTATE_ACQUISITION',
    CARDAPPUPLOADDOCUMENTTYPE = 'CARD_APP_UPLOAD_DOCUMENT_TYPE',
    CREDITCARDDOCUMENTTYPE = 'CREDIT_CARD_DOCUMENT_TYPE',
    PASTYEARS = 'PAST_YEARS',
    MONTHS = 'MONTHS',
    APPLICATIONBRANCH = 'APPLICATION_BRANCH',
    UPLOADDOCUMENTPAGETYPE = 'UPLOAD_DOCUMENT_PAGE_TYPE',
    POSSTORETYPE = 'POS_STORETYPE',
    REISSUETYPE = 'REISSUE_TYPE',
    CARDSTATUS = 'CARD_STATUS',
    CARDSUBSTATUS = 'CARD_SUB_STATUS',
    REISSUEREASONS = 'REISSUE_REASONS',
    PRODUCTS = 'PRODUCTS',
    PRODUCTOPERATIONS = 'PRODUCT_OPERATIONS',
    PRODUCTOPERATIONSTATUS = 'PRODUCT_OPERATION_STATUS',
    REISSUEDOCUMENTTYPE = 'REISSUE_DOCUMENT_TYPE',
    REISSUECARDSTATUS = 'REISSUE_CARD_STATUS',
    REISSUECARDSUBSTATUS = 'REISSUE_CARD_SUB_STATUS',
    CUSTOMERDOCUMENTS = 'CUSTOMER_DOCUMENTS',
    LOANTYPE = 'LOAN_TYPE',
    CREDITSTATUS = 'CREDIT_STATUS',
    CREDITSHOPS = 'CREDIT_SHOPS',
    ACCOUNTTYPE = 'ACCOUNT_TYPE',
    GLOBALBONUSCONNECTIONTYPE = 'GLOBAL_BONUS_CONNECTION_TYPE',
    LOANAPPUPLOADDOCUMENTTYPE = 'LOAN_APP_UPLOAD_DOCUMENT_TYPE',
    PTSLEVELZERO = 'PTS_LEVEL_ZERO',
    PTSLEVELONE = 'PTS_LEVEL_ONE',
    PTSLEVELTWO = 'PTS_LEVEL_TWO',
    PTSPRODUCTTYPE = 'PTS_PRODUCT_TYPE',
    PTSCHANNELCODE = 'PTS_CHANNEL_CODE',
    PTSSENDTYPE = 'PTS_SEND_TYPE',
    PTSSTATUS = 'PTS_STATUS',
    PTSCLOSURETYPE = 'PTS_CLOSURE_TYPE',
    PTSPOOL = 'PTS_POOL',
    CCOPERATIONTYPE = 'CC_OPERATION_TYPE',
    CCOPERATIONSTATUSTYPE = 'CC_OPERATION_STATUS_TYPE',
    CCSESSIONSTATUSTYPE = 'CC_SESSION_STATUS_TYPE',
    CCOPERATIONHISTORYOPERATIONTYPE = 'CC_OPERATION_HISTORY_OPERATION_TYPE',
    CCIBBLOCKAGEREASONS = 'CC_IB_BLOCKAGE_REASONS',
    WORKEXPERIENCE = 'WORK_EXPERIENCE',
    LOANMARITALSTATUS = 'LOAN_MARITAL_STATUS',
    PLASTICCARDPOINTOFSALETYPE = 'PLASTIC_CARD_POINT_OF_SALE_TYPE',
    PLASTICCARDOPERATIONSTYPE = 'PLASTIC_CARD_OPERATIONS_TYPE',
    PLASTICCARDACCOUNTTYPE = 'PLASTIC_CARD_ACCOUNT_TYPE',
    PLASTICCARDOPERATIONSACCOUNTTYPE = 'PLASTIC_CARD_OPERATIONS_ACCOUNT_TYPE',
    PLASTICCARDADDITIONALACCOUNTTYPE = 'PLASTIC_CARD_ADDITIONAL_ACCOUNT_TYPE',
    PLASTICCARDADDITIONALTOPOINTOFSALETYPE = 'PLASTIC_CARD_ADDITIONAL_TO_POINT_OF_SALE_TYPE',
    LOANPURCHASERETURNGETDOCUMENTS = 'LOAN_PURCHASE_RETURN_GET_DOCUMENTS',
    LOANPURCHASERETURNGETDOCUMENTSMODAL = 'LOAN_PURCHASE_RETURN_GET_DOCUMENTS_MODAL',
    USERBRANCH = 'USER_BRANCH',
    LOANCURRENCYTYPE = 'LOAN_CURRENCY_TYPE',
    LOANCREDITPERIOD = 'LOAN_CREDIT_PERIOD',
    GOODSPRODUCTGROUP = 'GOODS_PRODUCT_GROUP',
    GOODSPRODUCT = 'GOODS_PRODUCT',
    ONETOTEN = 'ONE_TO_TEN',
    LOANGROUPCOMPOSITION = 'LOAN_GROUP_COMPOSITION',
    LOANTOURSOURCE = 'LOAN_TOUR_SOURCE',
    LOANHOLIDAYORGANIZATIONTOUR = 'LOAN_HOLIDAY_ORGANIZATION_TOUR',
    LOANADDITIONALSERVICESSERVICE = 'LOAN_ADDITIONAL_SERVICES_SERVICE',
    LOANADDITIONALSERVICESORGANIZATION = 'LOAN_ADDITIONAL_SERVICES_ORGANIZATION',
    LOANADDITIONALSERVICESPRODUCT = 'LOAN_ADDITIONAL_SERVICES_PRODUCT',
    LOANINITPAYMENTMETHOD = 'LOAN_INIT_PAYMENT_METHOD',
    FELOANDOCUMENTTYPE = 'FE_LOAN_DOCUMENT_TYPE',
    RECEIPTCHANNEL = 'RECEIPT_CHANNEL',
    CARLOANTRANSPORTVEHICLE = 'CAR_LOAN_TRANSPORT_VEHICLE',
    CARLOANBROKER = 'CAR_LOAN_BROKER',
    CARLOANSERVICEGROUP = 'CAR_LOAN_SERVICE_GROUP',
    CARLOANCOLOR = 'CAR_LOAN_COLOR',
    CARLOANMODEL = 'CAR_LOAN_MODEL',
    CARLOANVEHICLECATEGORY = 'CAR_LOAN_VEHICLE_CATEGORY',
    CARLOANVEHICLETYPE = 'CAR_LOAN_VEHICLE_TYPE',
    LOANINSURANCESHOP = 'LOAN_INSURANCE_SHOP',
    LOANINSURANCETYPE = 'LOAN_INSURANCE_TYPE',
    LOANINSURANCEPERIOD = 'LOAN_INSURANCE_PERIOD',
    LOANINSURANCEPAYMENTMETHOD = 'LOAN_INSURANCE_PAYMENT_METHOD',
    LOANACTIONTYPE = 'LOAN_ACTION_TYPE',
    PAYMENTPLANSIMLOANTYPE = 'PAYMENT_PLAN_SIM_LOAN_TYPE',
    PAYMENTPLANSIMLOANACTIONTYPE = 'PAYMENT_PLAN_SIM_LOAN_ACTION_TYPE',
    ACCOUNTOBSERVATIONTYPE = 'ACCOUNT_OBSERVATION_TYPE',
    BRANCH = 'BRANCH',
    CURRENCY = 'CURRENCY',
    ACCOUNTMASK = 'ACCOUNT_MASK'
}

/**
 * 
 * @export
 * @interface ReissueCardsApplyRequest
 */
export interface ReissueCardsApplyRequest extends DocumentPageUploadDataRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    customerNumber: string;
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    customerTypeCode: string;
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    cardId: string;
    /**
     * Card Number
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    cardNumber?: string;
    /**
     * Card Status
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    cardStatusCode: string;
    /**
     * Card Sub Status
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    cardSubStatusCode: string;
    /**
     * Reissue Reason Code
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    reissueReasonCode: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    clientName: string;
    /**
     * Embossed Name
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    embossedName: string;
    /**
     * Embossed Name Other
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    embossedNameOther: string;
    /**
     * No Name Card Id
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    noNameCardId?: string;
    /**
     * Last 4 Digits
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    lastFourDigits?: string;
    /**
     * Pos Id
     * @type {string}
     * @memberof ReissueCardsApplyRequest
     */
    posId: string;
    /**
     * Main Monthly Income
     * @type {number}
     * @memberof ReissueCardsApplyRequest
     */
    mainMonthlyIncome?: number;
    /**
     * Flag for Proof of Income Provided
     * @type {boolean}
     * @memberof ReissueCardsApplyRequest
     */
    proofOfIncomeProvided?: boolean;
    /**
     * true if campaign checkbox is checked
     * @type {boolean}
     * @memberof ReissueCardsApplyRequest
     */
    isCampaignFlag?: boolean;
}
/**
 * 
 * @export
 * @interface ReissueCardsApplyResponse
 */
export interface ReissueCardsApplyResponse extends Response {
    /**
     * Result Message
     * @type {string}
     * @memberof ReissueCardsApplyResponse
     */
    reissueResultMessage: string;
}
/**
 * 
 * @export
 * @interface ReissueCardsDocumentRequest
 */
export interface ReissueCardsDocumentRequest {
    /**
     * Card Number
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    cardNumber: string;
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    cardId: string;
    /**
     * Card Account Number
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    cardAccountNumber: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    clientName: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    customerNumber: string;
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    customerTypeCode?: string;
    /**
     * Reissue Reason Code
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    reissueReasonCode: string;
    /**
     * Reissue Reason value
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    reissueReasonValue: string;
    /**
     * Currency
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    currency: string;
    /**
     * Card Status Value
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    cardStatusValue: string;
    /**
     * No Name Card Id
     * @type {string}
     * @memberof ReissueCardsDocumentRequest
     */
    noNameCardId?: string;
    /**
     * true if salary campaign is checked
     * @type {boolean}
     * @memberof ReissueCardsDocumentRequest
     */
    isCampaignFlag?: boolean;
}
/**
 * 
 * @export
 * @interface ReissueCardsDocumentResponse
 */
export interface ReissueCardsDocumentResponse extends Response {
    /**
     * id
     * @type {string}
     * @memberof ReissueCardsDocumentResponse
     */
    documentId: string;
}
/**
 * 
 * @export
 * @interface ReissueCardsRequest
 */
export interface ReissueCardsRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueCardsRequest
     */
    customerNumber?: string;
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ReissueCardsRequest
     */
    customerTypeCode: string;
}
/**
 * 
 * @export
 * @interface ReissueCardsResponse
 */
export interface ReissueCardsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<ReissueCardsResponseData>}
     * @memberof ReissueCardsResponse
     */
    cardList: Array<ReissueCardsResponseData>;
}
/**
 * 
 * @export
 * @interface ReissueCardsResponseData
 */
export interface ReissueCardsResponseData {
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    cardId: string;
    /**
     * Card Number
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    cardNumber: string;
    /**
     * Card Status Value
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    cardStatusValue: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    expireDate: string;
    /**
     * Embossed Name
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    embossedName: string;
    /**
     * limit amount
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    cardLimit: string;
    /**
     * Embossed Name Other
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    embossedNameOther: string;
    /**
     * Card Account Number
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    cardAccountNumber: string;
    /**
     * Currency
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    currency: string;
    /**
     * No Name Card Id
     * @type {string}
     * @memberof ReissueCardsResponseData
     */
    noNameCardId?: string;
    /**
     * Shows Personal Income Fields
     * @type {boolean}
     * @memberof ReissueCardsResponseData
     */
    showPersonalIncome: boolean;
    /**
     * Card may by reissued
     * @type {boolean}
     * @memberof ReissueCardsResponseData
     */
    canReissued: boolean;
}
/**
 * 
 * @export
 * @interface ReissueCardsSentDocumentRequest
 */
export interface ReissueCardsSentDocumentRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueCardsSentDocumentRequest
     */
    customerNumber: string;
    /**
     * Pos Id
     * @type {string}
     * @memberof ReissueCardsSentDocumentRequest
     */
    posId: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof ReissueCardsSentDocumentRequest
     */
    clientName: string;
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueCardsSentDocumentRequest
     */
    cardId: string;
    /**
     * Card Number
     * @type {string}
     * @memberof ReissueCardsSentDocumentRequest
     */
    cardNumber: string;
}
/**
 * 
 * @export
 * @interface ReissueCardsSentDocumentResponse
 */
export interface ReissueCardsSentDocumentResponse extends ReissueCardsDocumentResponse {
}
/**
 * 
 * @export
 * @interface ReissueCardsSentRequest
 */
export interface ReissueCardsSentRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueCardsSentRequest
     */
    customerNumber?: string;
    /**
     * Pos Id
     * @type {string}
     * @memberof ReissueCardsSentRequest
     */
    posId: string;
}
/**
 * 
 * @export
 * @interface ReissueCardsSentResponse
 */
export interface ReissueCardsSentResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<ReissueCardsSentResponseData>}
     * @memberof ReissueCardsSentResponse
     */
    cardList: Array<ReissueCardsSentResponseData>;
}
/**
 * 
 * @export
 * @interface ReissueCardsSentResponseData
 */
export interface ReissueCardsSentResponseData {
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    cardId: string;
    /**
     * Entry Date
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    entryDate: string;
    /**
     * Approval Date
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    approvalDate: string;
    /**
     * Application Status
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    applicationStatus: string;
    /**
     * Old Card Number
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    oldCardNumber: string;
    /**
     * New Card Number
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    newCardNumber: string;
    /**
     * Embossed Name
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    embossedName: string;
    /**
     * Explanation
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    explanation?: string;
    /**
     * true if card activation button will be visible
     * @type {boolean}
     * @memberof ReissueCardsSentResponseData
     */
    isCardActivationButtonVisible: boolean;
    /**
     * previous limit amount
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    previousLimit?: string;
    /**
     * new limit amount
     * @type {string}
     * @memberof ReissueCardsSentResponseData
     */
    newLimit?: string;
}
/**
 * 
 * @export
 * @interface ReissueDigitalCardsApplyRequest
 */
export interface ReissueDigitalCardsApplyRequest extends DocumentPageUploadDataRequest {
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueDigitalCardsApplyRequest
     */
    cardId: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof ReissueDigitalCardsApplyRequest
     */
    clientName: string;
    /**
     * Pos Id
     * @type {string}
     * @memberof ReissueDigitalCardsApplyRequest
     */
    posId: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueDigitalCardsApplyRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface ReissueDigitalCardsApplyResponse
 */
export interface ReissueDigitalCardsApplyResponse extends Response {
}
/**
 * 
 * @export
 * @interface ReissueDigitalCardsRequest
 */
export interface ReissueDigitalCardsRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueDigitalCardsRequest
     */
    customerNumber: string;
    /**
     * Customer Type Code
     * @type {string}
     * @memberof ReissueDigitalCardsRequest
     */
    customerTypeCode: string;
}
/**
 * 
 * @export
 * @interface ReissueDigitalCardsResponse
 */
export interface ReissueDigitalCardsResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<ReissueDigitalCardsResponseData>}
     * @memberof ReissueDigitalCardsResponse
     */
    digitalCardList: Array<ReissueDigitalCardsResponseData>;
}
/**
 * 
 * @export
 * @interface ReissueDigitalCardsResponseData
 */
export interface ReissueDigitalCardsResponseData {
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardId: string;
    /**
     * limit amount
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardLimit: string;
    /**
     * Expiration Date
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    expireDate: string;
    /**
     * Card Number
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardNumber: string;
    /**
     * Card Status Code
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardStatusCode: string;
    /**
     * Card Status Value
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardStatusValue: string;
    /**
     * Embossed Name
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    embossedName: string;
    /**
     * Embossed Name Other
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    embossedNameOther: string;
    /**
     * Card Account Number
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardAccountNumber: string;
    /**
     * Currency
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    currency: string;
    /**
     * No Name Card Id
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    noNameCardId: string;
    /**
     * true if no name checked
     * @type {boolean}
     * @memberof ReissueDigitalCardsResponseData
     */
    isNoNameChecked: boolean;
    /**
     * Card Sub Status Code
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    cardSubStatusCode: string;
    /**
     * Reissue Reason Code
     * @type {string}
     * @memberof ReissueDigitalCardsResponseData
     */
    reissueReasonCode: string;
}
/**
 * 
 * @export
 * @interface ReissueFundamentalInfoRequest
 */
export interface ReissueFundamentalInfoRequest {
    /**
     * Card Id
     * @type {string}
     * @memberof ReissueFundamentalInfoRequest
     */
    cardId: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof ReissueFundamentalInfoRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface ReissueFundamentalInfoResponse
 */
export interface ReissueFundamentalInfoResponse extends Response {
    /**
     * Max length of embossed name
     * @type {number}
     * @memberof ReissueFundamentalInfoResponse
     */
    cardEmbossedNameMaxLength: number;
    /**
     * true if salary campaign is checked
     * @type {boolean}
     * @memberof ReissueFundamentalInfoResponse
     */
    isCardNSPKConcentVisible?: boolean;
}
/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {Result}
     * @memberof Response
     */
    result: Result;
    /**
     * Result message
     * @type {string}
     * @memberof Response
     */
    message?: string;
    /**
     * Unique id for the user session
     * @type {string}
     * @memberof Response
     */
    sessionID?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Result {
    OK = 'OK',
    ERROR = 'ERROR',
    VALIDATIONREQUIRED = 'VALIDATION_REQUIRED',
    PASSWORDCHANGINGREQUIRED = 'PASSWORD_CHANGING_REQUIRED',
    PASSWORDEXPIRED = 'PASSWORD_EXPIRED',
    IMAGESELECTIONREQUIRED = 'IMAGE_SELECTION_REQUIRED',
    UNDEFINED = 'UNDEFINED'
}

/**
 * 
 * @export
 * @interface ScoringJobPageData
 */
export interface ScoringJobPageData {
    /**
     * company name
     * @type {string}
     * @memberof ScoringJobPageData
     */
    companyName: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    jobTitle: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    occupation: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    jobSector: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    businessLine: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    employeeNumber: DictionaryLine;
    /**
     * number of work places for last 3 years
     * @type {string}
     * @memberof ScoringJobPageData
     */
    jobNumberForLast3Years: string;
    /**
     * true if state is checked
     * @type {boolean}
     * @memberof ScoringJobPageData
     */
    isGovernmentOrganisation?: boolean;
    /**
     * limit amount
     * @type {number}
     * @memberof ScoringJobPageData
     */
    requestedLimit?: number;
    /**
     * employee number code
     * @type {number}
     * @memberof ScoringJobPageData
     */
    income: number;
    /**
     * other income
     * @type {number}
     * @memberof ScoringJobPageData
     */
    otherIncome?: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    is2NdflCertificateProvided: DictionaryLine;
    /**
     * What percentage of the card limit can be used
     * @type {number}
     * @memberof ScoringJobPageData
     */
    cardLimitPercentage?: number;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    currentWorkBeginningMonth: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    currentWorkBeginningYear: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    workLifeBeginningMonth: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof ScoringJobPageData
     */
    workLifeBeginningYear: DictionaryLine;
    /**
     * Work INN
     * @type {string}
     * @memberof ScoringJobPageData
     */
    workInn?: string;
}
/**
 * 
 * @export
 * @interface ScoringJobPageDataResponse
 */
export interface ScoringJobPageDataResponse extends Response {
    /**
     * 
     * @type {ScoringJobPageData}
     * @memberof ScoringJobPageDataResponse
     */
    pageData?: ScoringJobPageData;
    /**
     * 
     * @type {ScoringJobPageVisibility}
     * @memberof ScoringJobPageDataResponse
     */
    displayRules?: ScoringJobPageVisibility;
}
/**
 * 
 * @export
 * @interface ScoringJobPageVisibility
 */
export interface ScoringJobPageVisibility {
    /**
     * true if Limit Multiplier is visible
     * @type {boolean}
     * @memberof ScoringJobPageVisibility
     */
    isCardLimitPercentageVisible?: boolean;
    /**
     * true if Requested Limit is visible
     * @type {boolean}
     * @memberof ScoringJobPageVisibility
     */
    isRequestedLimitVisible?: boolean;
    /**
     * true if Requested Limit can be zero
     * @type {boolean}
     * @memberof ScoringJobPageVisibility
     */
    canRequestedLimitBeZero?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ScoringResultType {
    AUTOREJECT = 'AUTOREJECT',
    AUTOAPPROVE = 'AUTOAPPROVE'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ScreenProcessType {
    NEW = 'NEW',
    EDIT = 'EDIT'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchBankruptInterfaceType {
    CARDENTRY = 'CARD_ENTRY',
    LOANAPPLICATION = 'LOAN_APPLICATION'
}

/**
 * 
 * @export
 * @interface SearchBankruptRequest
 */
export interface SearchBankruptRequest {
    /**
     * 
     * @type {SearchBankruptInterfaceType}
     * @memberof SearchBankruptRequest
     */
    interfaceType: SearchBankruptInterfaceType;
}
/**
 * 
 * @export
 * @interface SearchBankruptResponse
 */
export interface SearchBankruptResponse extends Response {
    /**
     * Result search in bankrupt list
     * @type {boolean}
     * @memberof SearchBankruptResponse
     */
    isBankrupt?: boolean;
}
/**
 * 
 * @export
 * @interface SearchCreditRequest
 */
export interface SearchCreditRequest extends PaginationRequest {
    /**
     * Begin Date
     * @type {string}
     * @memberof SearchCreditRequest
     */
    beginDate: string;
    /**
     * End Date
     * @type {string}
     * @memberof SearchCreditRequest
     */
    endDate: string;
    /**
     * Credit Status
     * @type {string}
     * @memberof SearchCreditRequest
     */
    creditStatus?: string;
    /**
     * Credit Type Code
     * @type {string}
     * @memberof SearchCreditRequest
     */
    creditType?: string;
}
/**
 * 
 * @export
 * @interface SearchCreditResponse
 */
export interface SearchCreditResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<SearchCreditResponseData>}
     * @memberof SearchCreditResponse
     */
    creditList: Array<SearchCreditResponseData>;
}
/**
 * 
 * @export
 * @interface SearchCreditResponseData
 */
export interface SearchCreditResponseData {
    /**
     * Credit Code
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    creditId: string;
    /**
     * Credit Status
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    status: string;
    /**
     * Date
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    date: string;
    /**
     * Contract Number
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    contractNumber: string;
    /**
     * Currency
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    currency: string;
    /**
     * Credit Amount
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    amount: string;
    /**
     * Client\'s Full Name
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    fullName: string;
    /**
     * Comment
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    comment: string;
    /**
     * promotion Name
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    promotionName: string;
    /**
     * Credit Type Code
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    creditType: string;
    /**
     * Reference Number
     * @type {string}
     * @memberof SearchCreditResponseData
     */
    referenceNumber: string;
}
/**
 * 
 * @export
 * @interface SearchCustomerRequest
 */
export interface SearchCustomerRequest extends SearchCustomerRequestData {
}
/**
 * 
 * @export
 * @interface SearchCustomerRequestData
 */
export interface SearchCustomerRequestData extends PaginationRequest {
    /**
     * Customer Name
     * @type {string}
     * @memberof SearchCustomerRequestData
     */
    customerName: string;
    /**
     * Customer Surname
     * @type {string}
     * @memberof SearchCustomerRequestData
     */
    customerSurname: string;
    /**
     * Date Of Birth
     * @type {string}
     * @memberof SearchCustomerRequestData
     */
    birthDate: string;
    /**
     * Second Name
     * @type {string}
     * @memberof SearchCustomerRequestData
     */
    customerSecondName?: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof SearchCustomerRequestData
     */
    identityDocumentSerialCode?: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof SearchCustomerRequestData
     */
    identityDocumentSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface SearchCustomerResponse
 */
export interface SearchCustomerResponse extends PaginationResponse {
    /**
     * warning message
     * @type {string}
     * @memberof SearchCustomerResponse
     */
    warning?: string;
    /**
     * 
     * @type {Array<SearchCustomerResponseData>}
     * @memberof SearchCustomerResponse
     */
    customerList: Array<SearchCustomerResponseData>;
}
/**
 * 
 * @export
 * @interface SearchCustomerResponseData
 */
export interface SearchCustomerResponseData extends CustomerResponseData {
    /**
     * Customer Id
     * @type {string}
     * @memberof SearchCustomerResponseData
     */
    customerId?: string;
    /**
     * Customer Number
     * @type {string}
     * @memberof SearchCustomerResponseData
     */
    customerNumber: string;
    /**
     * Place of Birth
     * @type {string}
     * @memberof SearchCustomerResponseData
     */
    birthPlace?: string;
    /**
     * Gender
     * @type {string}
     * @memberof SearchCustomerResponseData
     */
    gender?: string;
}
/**
 * 
 * @export
 * @interface SearchDocumentRequest
 */
export interface SearchDocumentRequest extends PaginationRequest {
    /**
     * Customer Oid
     * @type {string}
     * @memberof SearchDocumentRequest
     */
    customerId?: string;
    /**
     * Document Type
     * @type {string}
     * @memberof SearchDocumentRequest
     */
    documentType: string;
    /**
     * 
     * @type {UploadType}
     * @memberof SearchDocumentRequest
     */
    uploadType?: UploadType;
}
/**
 * 
 * @export
 * @interface SearchDocumentResponse
 */
export interface SearchDocumentResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<DocumentData>}
     * @memberof SearchDocumentResponse
     */
    documentList: Array<DocumentData>;
}
/**
 * 
 * @export
 * @interface SessionCardApplicationResponse
 */
export interface SessionCardApplicationResponse extends Response {
}
/**
 * 
 * @export
 * @interface SessionClearRequest
 */
export interface SessionClearRequest {
    /**
     * Unique id of the menu item
     * @type {string}
     * @memberof SessionClearRequest
     */
    menuID?: string;
}
/**
 * 
 * @export
 * @interface SessionClearResponse
 */
export interface SessionClearResponse extends Response {
}
/**
 * 
 * @export
 * @interface SignCardDocumentResponse
 */
export interface SignCardDocumentResponse extends Response {
}
/**
 * 
 * @export
 * @interface SignDigitalCardDocumentResponse
 */
export interface SignDigitalCardDocumentResponse extends Response {
}
/**
 * 
 * @export
 * @interface SignProductTransferDocumentResponse
 */
export interface SignProductTransferDocumentResponse extends Response {
}
/**
 * 
 * @export
 * @interface SummaryAddressData
 */
export interface SummaryAddressData {
    /**
     * Address Type
     * @type {string}
     * @memberof SummaryAddressData
     */
    addressType: string;
    /**
     * Address Info
     * @type {string}
     * @memberof SummaryAddressData
     */
    addressInfo: string;
    /**
     * Zip Code
     * @type {string}
     * @memberof SummaryAddressData
     */
    zipCode: string;
    /**
     * text exists if address is the correspondence one
     * @type {string}
     * @memberof SummaryAddressData
     */
    hasCorrespondenceFlag?: string;
    /**
     * Resident Type
     * @type {string}
     * @memberof SummaryAddressData
     */
    addressHomeOwnerType?: string;
    /**
     * Registration Date
     * @type {string}
     * @memberof SummaryAddressData
     */
    registrationDate?: string;
}
/**
 * 
 * @export
 * @interface SummaryAddressInfoData
 */
export interface SummaryAddressInfoData {
    /**
     * 
     * @type {Array<SummaryAddressData>}
     * @memberof SummaryAddressInfoData
     */
    addressList: Array<SummaryAddressData>;
}
/**
 * 
 * @export
 * @interface SummaryApplicationInfoData
 */
export interface SummaryApplicationInfoData {
    /**
     * Name on the Card
     * @type {string}
     * @memberof SummaryApplicationInfoData
     */
    cardEmbossedName: string;
    /**
     * Application Date
     * @type {string}
     * @memberof SummaryApplicationInfoData
     */
    applicationDate: string;
    /**
     * branch name
     * @type {string}
     * @memberof SummaryApplicationInfoData
     */
    branchName?: string;
}
/**
 * 
 * @export
 * @interface SummaryBenefitsThirdPartyInfoPage
 */
export interface SummaryBenefitsThirdPartyInfoPage {
    /**
     * Has Benefits Third Party
     * @type {string}
     * @memberof SummaryBenefitsThirdPartyInfoPage
     */
    hasBenefitsThirdParty: string;
    /**
     * 
     * @type {SummaryBenefitsThirdPersonInfoData}
     * @memberof SummaryBenefitsThirdPartyInfoPage
     */
    summaryBenefitsThirdPartyInfoData?: SummaryBenefitsThirdPersonInfoData;
    /**
     * Has Control Person
     * @type {string}
     * @memberof SummaryBenefitsThirdPartyInfoPage
     */
    hasControlPerson: string;
    /**
     * 
     * @type {SummaryBenefitsThirdPersonInfoData}
     * @memberof SummaryBenefitsThirdPartyInfoPage
     */
    summaryControlPersonInfoData?: SummaryBenefitsThirdPersonInfoData;
}
/**
 * 
 * @export
 * @interface SummaryBenefitsThirdPersonInfoData
 */
export interface SummaryBenefitsThirdPersonInfoData {
    /**
     * Beneficiary Name
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    beneficiaryName: string;
    /**
     * Birth Place
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    birthPlace: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    birthDate: string;
    /**
     * Identity Type
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    identityType: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    identityDocumentSerialCode: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    identityDocumentSerialNumber: string;
    /**
     * Issued By
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    issuedBy: string;
    /**
     * Issue Date
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    issueDate: string;
    /**
     * Unit Code
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    unitCode: string;
    /**
     * Inn
     * @type {string}
     * @memberof SummaryBenefitsThirdPersonInfoData
     */
    inn: string;
}
/**
 * 
 * @export
 * @interface SummaryCardInfoPage
 */
export interface SummaryCardInfoPage {
    /**
     * 
     * @type {SummaryApplicationInfoData}
     * @memberof SummaryCardInfoPage
     */
    summaryApplicationInfoData: SummaryApplicationInfoData;
    /**
     * 
     * @type {SummarySendingInfoData}
     * @memberof SummaryCardInfoPage
     */
    summarySendingInfoData: SummarySendingInfoData;
}
/**
 * 
 * @export
 * @interface SummaryContactDetailInfoData
 */
export interface SummaryContactDetailInfoData {
    /**
     * Mobile Phone Number
     * @type {string}
     * @memberof SummaryContactDetailInfoData
     */
    mobilePhoneNumber: string;
    /**
     * Home Phone Number
     * @type {string}
     * @memberof SummaryContactDetailInfoData
     */
    homePhoneNumber: string;
    /**
     * Work Phone Number
     * @type {string}
     * @memberof SummaryContactDetailInfoData
     */
    workPhoneNumber: string;
    /**
     * Contact Phone 1 Number
     * @type {string}
     * @memberof SummaryContactDetailInfoData
     */
    contactPhone1Number: string;
    /**
     * Contact Phone 2 Number
     * @type {string}
     * @memberof SummaryContactDetailInfoData
     */
    contactPhone2Number: string;
    /**
     * Email Address
     * @type {string}
     * @memberof SummaryContactDetailInfoData
     */
    emailAddress?: string;
}
/**
 * 
 * @export
 * @interface SummaryContactInfoPage
 */
export interface SummaryContactInfoPage {
    /**
     * 
     * @type {SummaryAddressInfoData}
     * @memberof SummaryContactInfoPage
     */
    summaryAddressInfoData: SummaryAddressInfoData;
    /**
     * 
     * @type {SummaryContactDetailInfoData}
     * @memberof SummaryContactInfoPage
     */
    summaryContactDetailInfoData: SummaryContactDetailInfoData;
}
/**
 * 
 * @export
 * @interface SummaryCustomerDetailInfoData
 */
export interface SummaryCustomerDetailInfoData {
    /**
     * Marital Status
     * @type {string}
     * @memberof SummaryCustomerDetailInfoData
     */
    maritalStatus: string;
    /**
     * Education Status
     * @type {string}
     * @memberof SummaryCustomerDetailInfoData
     */
    educationStatus?: string;
    /**
     * Number of Children
     * @type {number}
     * @memberof SummaryCustomerDetailInfoData
     */
    numberOfChildren?: number;
    /**
     * YES if customer is a government officer
     * @type {string}
     * @memberof SummaryCustomerDetailInfoData
     */
    isGovernmentOfficer?: string;
}
/**
 * 
 * @export
 * @interface SummaryCustomerDetailInfoPage
 */
export interface SummaryCustomerDetailInfoPage extends Response {
    /**
     * 
     * @type {SummaryCustomerTaxInfoData}
     * @memberof SummaryCustomerDetailInfoPage
     */
    summaryCustomerTaxInfoData: SummaryCustomerTaxInfoData;
    /**
     * 
     * @type {SummaryCustomerDetailInfoData}
     * @memberof SummaryCustomerDetailInfoPage
     */
    summaryCustomerDetailInfoData: SummaryCustomerDetailInfoData;
}
/**
 * 
 * @export
 * @interface SummaryCustomerDocumentInfo
 */
export interface SummaryCustomerDocumentInfo {
    /**
     * 
     * @type {Array<SummaryCustomerDocumentInfoData>}
     * @memberof SummaryCustomerDocumentInfo
     */
    documentInfoDataList: Array<SummaryCustomerDocumentInfoData>;
}
/**
 * 
 * @export
 * @interface SummaryCustomerDocumentInfoData
 */
export interface SummaryCustomerDocumentInfoData {
    /**
     * Document Type
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    documentType: string;
    /**
     * Identity Document Serial Code
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    identityDocumentSerialCode: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    identityDocumentSerialNumber: string;
    /**
     * Issued By
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    issuedBy: string;
    /**
     * Issue Date
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    issueDate: string;
    /**
     * Expire Date
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    expireDate: string;
    /**
     * Issue Country
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    issueCountry: string;
    /**
     * Unit Code
     * @type {string}
     * @memberof SummaryCustomerDocumentInfoData
     */
    unitCode: string;
}
/**
 * 
 * @export
 * @interface SummaryCustomerIndividualInfoData
 */
export interface SummaryCustomerIndividualInfoData {
    /**
     * Customer Surname
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    customerSurname: string;
    /**
     * Customer Name
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    customerName: string;
    /**
     * Customer Second Name
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    customerSecondName: string;
    /**
     * Birth Date
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    birthDate: string;
    /**
     * Customer Gender
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    customerGender: string;
    /**
     * Citizenship
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    citizenship: string;
    /**
     * Residence Country
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    residenceCountry: string;
    /**
     * Place Of Birth
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    birthPlaceCity: string;
    /**
     * Previous Surname
     * @type {string}
     * @memberof SummaryCustomerIndividualInfoData
     */
    previousSurname: string;
}
/**
 * 
 * @export
 * @interface SummaryCustomerInfoPage
 */
export interface SummaryCustomerInfoPage {
    /**
     * 
     * @type {SummaryCustomerIndividualInfoData}
     * @memberof SummaryCustomerInfoPage
     */
    summaryCustomerIndividualInfoData: SummaryCustomerIndividualInfoData;
    /**
     * 
     * @type {SummaryCustomerDocumentInfo}
     * @memberof SummaryCustomerInfoPage
     */
    summaryCustomerDocumentInfo: SummaryCustomerDocumentInfo;
}
/**
 * 
 * @export
 * @interface SummaryCustomerTaxInfoData
 */
export interface SummaryCustomerTaxInfoData {
    /**
     * Tax Number
     * @type {string}
     * @memberof SummaryCustomerTaxInfoData
     */
    taxNumber: string;
    /**
     * 
     * @type {Array<SummaryTaxResidencyData>}
     * @memberof SummaryCustomerTaxInfoData
     */
    taxResidencyList: Array<SummaryTaxResidencyData>;
}
/**
 * 
 * @export
 * @interface SummaryInfoResponse
 */
export interface SummaryInfoResponse extends Response {
    /**
     * 
     * @type {SummaryProductInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryProductInfoPage: SummaryProductInfoPage;
    /**
     * 
     * @type {SummaryCustomerInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryCustomerInfoPage: SummaryCustomerInfoPage;
    /**
     * 
     * @type {SummaryCustomerDetailInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryCustomerDetailInfoPage: SummaryCustomerDetailInfoPage;
    /**
     * 
     * @type {SummaryBenefitsThirdPartyInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryBenefitsThirdPartyInfoPage: SummaryBenefitsThirdPartyInfoPage;
    /**
     * 
     * @type {SummaryContactInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryContactInfoPage: SummaryContactInfoPage;
    /**
     * 
     * @type {SummaryCardInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryCardInfoPage: SummaryCardInfoPage;
    /**
     * 
     * @type {SummaryJobScoringInfoPage}
     * @memberof SummaryInfoResponse
     */
    summaryJobScoringInfoPage: SummaryJobScoringInfoPage;
    /**
     * true if print button is visible
     * @type {boolean}
     * @memberof SummaryInfoResponse
     */
    isPrintButtonVisible: boolean;
}
/**
 * 
 * @export
 * @interface SummaryJobInfoData
 */
export interface SummaryJobInfoData {
    /**
     * Company Name
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    companyName: string;
    /**
     * Job Title
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    jobTitle: string;
    /**
     * Occupation
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    occupation: string;
    /**
     * Job Sector
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    jobSector: string;
    /**
     * Business Line
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    businessLine: string;
    /**
     * Employee number
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    employeeNumber: string;
    /**
     * The number of jobs in the last 3 years
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    jobNumberForLast3Years: string;
    /**
     * Certificate 2 - NDFL provided
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    is2NdflCertificateProvided: string;
    /**
     * Beginning time of current work
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    currentWorkBeginningTime: string;
    /**
     * Beginning time of work life
     * @type {string}
     * @memberof SummaryJobInfoData
     */
    workLifeBeginningTime: string;
}
/**
 * 
 * @export
 * @interface SummaryJobScoringInfoPage
 */
export interface SummaryJobScoringInfoPage {
    /**
     * 
     * @type {SummaryJobInfoData}
     * @memberof SummaryJobScoringInfoPage
     */
    summaryJobInfoData: SummaryJobInfoData;
    /**
     * 
     * @type {SummaryScoringInfoData}
     * @memberof SummaryJobScoringInfoPage
     */
    summaryScoringInfoData: SummaryScoringInfoData;
}
/**
 * 
 * @export
 * @interface SummaryProductInfoPage
 */
export interface SummaryProductInfoPage {
    /**
     * Card Print Type
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    printType: string;
    /**
     * Card Usage Type
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    cardUsageType: string;
    /**
     * Main Card Number
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    mainCardNumber: string;
    /**
     * Customer Type
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    customerType: string;
    /**
     * Customer Sub Type
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    customerSubType: string;
    /**
     * Debit Flag
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    debitFlag: string;
    /**
     * Resident
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    resident: string;
    /**
     * Account Type
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    accountType: string;
    /**
     * Brand Owner
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    brandOwner: string;
    /**
     * Card Type
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    cardType: string;
    /**
     * Another card transfer flag
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    transferAnotherCardflag?: string;
    /**
     * Valid Card Info
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    validCardInfo?: string;
    /**
     * Product Offer flag
     * @type {string}
     * @memberof SummaryProductInfoPage
     */
    productOfferFlag?: string;
}
/**
 * 
 * @export
 * @interface SummaryScoringInfoData
 */
export interface SummaryScoringInfoData {
    /**
     * limit amount
     * @type {string}
     * @memberof SummaryScoringInfoData
     */
    requestedLimit?: string;
    /**
     * income
     * @type {string}
     * @memberof SummaryScoringInfoData
     */
    income: string;
    /**
     * other income
     * @type {string}
     * @memberof SummaryScoringInfoData
     */
    otherIncome: string;
    /**
     * What percentage of the card limit can be used
     * @type {string}
     * @memberof SummaryScoringInfoData
     */
    cardLimitPercentage?: string;
}
/**
 * 
 * @export
 * @interface SummarySendingInfoData
 */
export interface SummarySendingInfoData {
    /**
     * Delivery Address
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    cardDeliveryAddress: string;
    /**
     * Branch Name
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    cardDeliveryBranch?: string;
    /**
     * Sms Transaction Alert
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    smsAlert?: string;
    /**
     * Pin Code Delivery Address
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    pinCodeDeliveryAddress?: string;
    /**
     * Branch Name
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    pinCodeDeliveryBranch?: string;
    /**
     * Statement Period
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    statementPeriod?: string;
    /**
     * Send Via Email Flag
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    sendViaEmail?: string;
    /**
     * If life insurance flag has been checked
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    lifeInsurance?: string;
    /**
     * If salary campaign is checked
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    campaignFlag?: string;
    /**
     * If scoring consent is checked
     * @type {string}
     * @memberof SummarySendingInfoData
     */
    consentScoring?: string;
}
/**
 * 
 * @export
 * @interface SummaryTaxResidencyData
 */
export interface SummaryTaxResidencyData {
    /**
     * Tax Residence Country
     * @type {string}
     * @memberof SummaryTaxResidencyData
     */
    taxResidenceCountry: string;
    /**
     * Has Tax Number Provided
     * @type {string}
     * @memberof SummaryTaxResidencyData
     */
    hasTaxNumberProvided?: string;
    /**
     * Foreign Tax Number
     * @type {string}
     * @memberof SummaryTaxResidencyData
     */
    foreignTaxNumber?: string;
}
/**
 * 
 * @export
 * @interface TaxInfoData
 */
export interface TaxInfoData {
    /**
     * Foreign Tax Number Id
     * @type {string}
     * @memberof TaxInfoData
     */
    foreignTaxNumberId?: string;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof TaxInfoData
     */
    taxResidenceCountry: DictionaryLine;
    /**
     * 
     * @type {DictionaryLine}
     * @memberof TaxInfoData
     */
    hasTaxNumberProvided: DictionaryLine;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof TaxInfoData
     */
    differentNumber?: boolean;
    /**
     * Foreign Tax Number
     * @type {string}
     * @memberof TaxInfoData
     */
    foreignTaxNumber?: string;
    /**
     * true if it is new
     * @type {boolean}
     * @memberof TaxInfoData
     */
    isNew: boolean;
}
/**
 * 
 * @export
 * @interface TaxInfoPageData
 */
export interface TaxInfoPageData {
    /**
     * Tax Number
     * @type {string}
     * @memberof TaxInfoPageData
     */
    taxNumber?: string;
    /**
     * 
     * @type {Array<TaxInfoData>}
     * @memberof TaxInfoPageData
     */
    taxResidencyList?: Array<TaxInfoData>;
}
/**
 * 
 * @export
 * @interface TaxInfoPageDataResponse
 */
export interface TaxInfoPageDataResponse extends Response {
    /**
     * 
     * @type {TaxInfoPageData}
     * @memberof TaxInfoPageDataResponse
     */
    pageData?: TaxInfoPageData;
}
/**
 * 
 * @export
 * @interface TaxPageData
 */
export interface TaxPageData {
    /**
     * 
     * @type {TaxInfoPageData}
     * @memberof TaxPageData
     */
    taxData?: TaxInfoPageData;
    /**
     * 
     * @type {Array<DocumentPageIdentityData>}
     * @memberof TaxPageData
     */
    documentIdentityDataList?: Array<DocumentPageIdentityData>;
}
/**
 * 
 * @export
 * @interface TaxResidencyData
 */
export interface TaxResidencyData {
    /**
     * Foreign Tax Number Id
     * @type {string}
     * @memberof TaxResidencyData
     */
    foreignTaxNumberId?: string;
    /**
     * Tax Residence Country Code
     * @type {string}
     * @memberof TaxResidencyData
     */
    taxResidenceCountryCode: string;
    /**
     * True if tax is provided
     * @type {boolean}
     * @memberof TaxResidencyData
     */
    hasTaxNumberProvided: boolean;
    /**
     * Foreign Tax Number
     * @type {string}
     * @memberof TaxResidencyData
     */
    foreignTaxNumber?: string;
    /**
     * true if it is new
     * @type {boolean}
     * @memberof TaxResidencyData
     */
    isNew?: boolean;
    /**
     * true if different number checkbox is clicked
     * @type {boolean}
     * @memberof TaxResidencyData
     */
    differentNumber?: boolean;
}
/**
 * 
 * @export
 * @interface ThirdPartyPageValidationComponentsResponse
 */
export interface ThirdPartyPageValidationComponentsResponse extends DocumentPageValidationComponentsResponse {
}
/**
 * 
 * @export
 * @interface TransferableCardData
 */
export interface TransferableCardData {
    /**
     * Transferable Card Id
     * @type {string}
     * @memberof TransferableCardData
     */
    transferableCardId: string;
    /**
     * Transferable Product Name
     * @type {string}
     * @memberof TransferableCardData
     */
    transferableProductName: string;
    /**
     * Transferable Card Number
     * @type {string}
     * @memberof TransferableCardData
     */
    transferableCardNumber: string;
    /**
     * Transferable Card Account Number
     * @type {string}
     * @memberof TransferableCardData
     */
    transferableCardAccountNumber: string;
}
/**
 * 
 * @export
 * @interface TransferableCardListRequest
 */
export interface TransferableCardListRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof TransferableCardListRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface TransferableCardListResponse
 */
export interface TransferableCardListResponse extends PaginationResponse {
    /**
     * 
     * @type {Array<TransferableCardData>}
     * @memberof TransferableCardListResponse
     */
    transferableCardList: Array<TransferableCardData>;
}
/**
 * 
 * @export
 * @interface UpdateDocumentRequest
 */
export interface UpdateDocumentRequest {
    /**
     * Document Id
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    documentId: string;
    /**
     * User free explanation text
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    explanation?: string;
    /**
     * Document Type
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    documentType: string;
    /**
     * document name which is created by core service
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    documentName: string;
    /**
     * Customer Oid
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    customerId?: string;
    /**
     * 
     * @type {UploadType}
     * @memberof UpdateDocumentRequest
     */
    uploadType?: UploadType;
}
/**
 * 
 * @export
 * @interface UpdateDocumentResponse
 */
export interface UpdateDocumentResponse extends DocumentResponse {
}
/**
 * 
 * @export
 * @interface UploadCardApplicationDocumentRequest
 */
export interface UploadCardApplicationDocumentRequest {
    /**
     * Uploaded file
     * @type {any}
     * @memberof UploadCardApplicationDocumentRequest
     */
    file: any;
    /**
     * Customer Oid
     * @type {string}
     * @memberof UploadCardApplicationDocumentRequest
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface UploadCardApplicationDocumentResponse
 */
export interface UploadCardApplicationDocumentResponse extends DocumentResponse {
}
/**
 * 
 * @export
 * @interface UploadDocumentRequest
 */
export interface UploadDocumentRequest {
    /**
     * Uploaded file
     * @type {any}
     * @memberof UploadDocumentRequest
     */
    file: any;
    /**
     * Document Type
     * @type {string}
     * @memberof UploadDocumentRequest
     */
    documentType: string;
    /**
     * User free explanation text
     * @type {string}
     * @memberof UploadDocumentRequest
     */
    explanation?: string;
    /**
     * Customer Oid
     * @type {string}
     * @memberof UploadDocumentRequest
     */
    customerId?: string;
    /**
     * Upload Type
     * @type {string}
     * @memberof UploadDocumentRequest
     */
    uploadType: string;
}
/**
 * 
 * @export
 * @interface UploadDocumentResponse
 */
export interface UploadDocumentResponse extends DocumentResponse {
    /**
     * Physical File Name
     * @type {string}
     * @memberof UploadDocumentResponse
     */
    physicalFileName?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum UploadType {
    IDENTITY = 'IDENTITY',
    APPLICATION = 'APPLICATION',
    POS = 'POS',
    OBSERVATION = 'OBSERVATION',
    CLIENTINFO = 'CLIENT_INFO',
    DOCUMENTUPLOAD = 'DOCUMENT_UPLOAD',
    REISSUESENT = 'REISSUE_SENT',
    REISSUE = 'REISSUE',
    CONTACTINFO = 'CONTACT_INFO',
    LOANAPPLICATIONIDENTITY = 'LOAN_APPLICATION_IDENTITY',
    PLASTICCARD = 'PLASTIC_CARD',
    PTSDOCUMENT = 'PTS_DOCUMENT',
    PURCHASERETURN = 'PURCHASE_RETURN',
    PAYMENTPLANSIMULATION = 'PAYMENT_PLAN_SIMULATION'
}

/**
 * 
 * @export
 * @interface ValidateAddIdentityRequest
 */
export interface ValidateAddIdentityRequest {
    /**
     * Document Type
     * @type {string}
     * @memberof ValidateAddIdentityRequest
     */
    documentType?: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof ValidateAddIdentityRequest
     */
    identityDocumentSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface ValidateAddIdentityResponse
 */
export interface ValidateAddIdentityResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateAddressPageDataRequest
 */
export interface ValidateAddressPageDataRequest extends AddressPageData {
}
/**
 * 
 * @export
 * @interface ValidateAddressPageDataResponse
 */
export interface ValidateAddressPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateApplicationDocumentPageDataRequest
 */
export interface ValidateApplicationDocumentPageDataRequest extends ApplicationDocumentPageData {
}
/**
 * 
 * @export
 * @interface ValidateApplicationDocumentPageDataResponse
 */
export interface ValidateApplicationDocumentPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateApplicationInfoPageDataRequest
 */
export interface ValidateApplicationInfoPageDataRequest extends ApplicationInfoPageData {
}
/**
 * 
 * @export
 * @interface ValidateApplicationInfoPageDataResponse
 */
export interface ValidateApplicationInfoPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateBenefitsThirdPartyPageDataRequest
 */
export interface ValidateBenefitsThirdPartyPageDataRequest extends BenefitsThirdPartyPageData {
}
/**
 * 
 * @export
 * @interface ValidateBenefitsThirdPartyPageDataResponse
 */
export interface ValidateBenefitsThirdPartyPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateCaptchaRequest
 */
export interface ValidateCaptchaRequest {
    /**
     * Captcha text
     * @type {string}
     * @memberof ValidateCaptchaRequest
     */
    captcha: string;
}
/**
 * 
 * @export
 * @interface ValidateCardSendingPageDataRequest
 */
export interface ValidateCardSendingPageDataRequest extends CardSendingPageData {
}
/**
 * 
 * @export
 * @interface ValidateCardSendingPageDataResponse
 */
export interface ValidateCardSendingPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateClientInfoDocumentPageDataRequest
 */
export interface ValidateClientInfoDocumentPageDataRequest extends ClientInfoDocumentPageData {
}
/**
 * 
 * @export
 * @interface ValidateClientInfoDocumentPageDataResponse
 */
export interface ValidateClientInfoDocumentPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateClientInfoIndividualPageDataRequest
 */
export interface ValidateClientInfoIndividualPageDataRequest extends IndividualPageData {
}
/**
 * 
 * @export
 * @interface ValidateClientInfoIndividualPageDataResponse
 */
export interface ValidateClientInfoIndividualPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateClientInfoTaxPageDataRequest
 */
export interface ValidateClientInfoTaxPageDataRequest extends TaxPageData {
    /**
     * 
     * @type {ScreenProcessType}
     * @memberof ValidateClientInfoTaxPageDataRequest
     */
    screenProcessType?: ScreenProcessType;
}
/**
 * 
 * @export
 * @interface ValidateClientInfoTaxPageDataResponse
 */
export interface ValidateClientInfoTaxPageDataResponse extends Response {
    /**
     * true if client info data changed
     * @type {boolean}
     * @memberof ValidateClientInfoTaxPageDataResponse
     */
    isClientDataChanged?: boolean;
}
/**
 * 
 * @export
 * @interface ValidateContactInfoChangePageDataRequest
 */
export interface ValidateContactInfoChangePageDataRequest extends ContactInfoChangeData {
    /**
     * 
     * @type {ScreenProcessType}
     * @memberof ValidateContactInfoChangePageDataRequest
     */
    screenProcessType?: ScreenProcessType;
}
/**
 * 
 * @export
 * @interface ValidateContactInfoChangePageDataResponse
 */
export interface ValidateContactInfoChangePageDataResponse extends Response {
    /**
     * true if mobile data changed
     * @type {boolean}
     * @memberof ValidateContactInfoChangePageDataResponse
     */
    isMobileDataChanged?: boolean;
}
/**
 * 
 * @export
 * @interface ValidateContactInfoIndividualPageDataRequest
 */
export interface ValidateContactInfoIndividualPageDataRequest extends ContactIndividualPageData {
}
/**
 * 
 * @export
 * @interface ValidateContactInfoIndividualPageDataResponse
 */
export interface ValidateContactInfoIndividualPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateContactInfoPageDataRequest
 */
export interface ValidateContactInfoPageDataRequest extends ContactInfoPageData {
}
/**
 * 
 * @export
 * @interface ValidateContactInfoPageDataResponse
 */
export interface ValidateContactInfoPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateCustomerDetailPageDataRequest
 */
export interface ValidateCustomerDetailPageDataRequest extends CustomerDetailPageData {
}
/**
 * 
 * @export
 * @interface ValidateCustomerDetailPageDataResponse
 */
export interface ValidateCustomerDetailPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateCustomerTaxInfoFormatRequest
 */
export interface ValidateCustomerTaxInfoFormatRequest {
    /**
     * Tax Residence Country
     * @type {string}
     * @memberof ValidateCustomerTaxInfoFormatRequest
     */
    taxResidenceCountry: string;
    /**
     * true if it has checked
     * @type {boolean}
     * @memberof ValidateCustomerTaxInfoFormatRequest
     */
    differentNumber: boolean;
    /**
     * Foreign Tax Number
     * @type {string}
     * @memberof ValidateCustomerTaxInfoFormatRequest
     */
    foreignTaxNumber: string;
}
/**
 * 
 * @export
 * @interface ValidateCustomerTaxInfoFormatResponse
 */
export interface ValidateCustomerTaxInfoFormatResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateDocumentPageDataRequest
 */
export interface ValidateDocumentPageDataRequest extends DocumentPageData {
}
/**
 * 
 * @export
 * @interface ValidateDocumentPageDataResponse
 */
export interface ValidateDocumentPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateIndividualPageCustomerChangeRequest
 */
export interface ValidateIndividualPageCustomerChangeRequest {
    /**
     * Customer Id
     * @type {string}
     * @memberof ValidateIndividualPageCustomerChangeRequest
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface ValidateIndividualPageCustomerChangeResponse
 */
export interface ValidateIndividualPageCustomerChangeResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateIndividualPageDataRequest
 */
export interface ValidateIndividualPageDataRequest extends IndividualPageData {
}
/**
 * 
 * @export
 * @interface ValidateIndividualPageDataResponse
 */
export interface ValidateIndividualPageDataResponse extends Response {
    /**
     * warning message
     * @type {string}
     * @memberof ValidateIndividualPageDataResponse
     */
    warning?: string;
}
/**
 * 
 * @export
 * @interface ValidateLoanAddIdentityRequest
 */
export interface ValidateLoanAddIdentityRequest {
    /**
     * Document Type
     * @type {string}
     * @memberof ValidateLoanAddIdentityRequest
     */
    documentType?: string;
    /**
     * Identity Document Serial Number
     * @type {string}
     * @memberof ValidateLoanAddIdentityRequest
     */
    identityDocumentSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface ValidateLoanAddIdentityResponse
 */
export interface ValidateLoanAddIdentityResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanAdditionalEquipmentPageDataRequest
 */
export interface ValidateLoanAdditionalEquipmentPageDataRequest extends LoanAdditionalEquipmentPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanAdditionalEquipmentPageDataResponse
 */
export interface ValidateLoanAdditionalEquipmentPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanAdditionalServicesGlobalBonusPageDataRequest
 */
export interface ValidateLoanAdditionalServicesGlobalBonusPageDataRequest extends LoanAdditionalServicesGlobalBonusPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanAdditionalServicesGlobalBonusPageDataResponse
 */
export interface ValidateLoanAdditionalServicesGlobalBonusPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanAdditionalServicesPageDataRequest
 */
export interface ValidateLoanAdditionalServicesPageDataRequest extends LoanAdditionalServicesPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanAdditionalServicesPageDataResponse
 */
export interface ValidateLoanAdditionalServicesPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanAddressPageDataRequest
 */
export interface ValidateLoanAddressPageDataRequest extends LoanAddressPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanAddressPageDataResponse
 */
export interface ValidateLoanAddressPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanApplicationDocumentPageDataRequest
 */
export interface ValidateLoanApplicationDocumentPageDataRequest extends LoanApplicationDocumentPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanApplicationDocumentPageDataResponse
 */
export interface ValidateLoanApplicationDocumentPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanBenefitsThirdPartyPageDataRequest
 */
export interface ValidateLoanBenefitsThirdPartyPageDataRequest extends LoanBenefitsThirdPartyPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanBenefitsThirdPartyPageDataResponse
 */
export interface ValidateLoanBenefitsThirdPartyPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanCarDocumentsPageDataRequest
 */
export interface ValidateLoanCarDocumentsPageDataRequest extends LoanCarDocumentsPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanCarDocumentsPageDataResponse
 */
export interface ValidateLoanCarDocumentsPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanCarTotalCostPageDataRequest
 */
export interface ValidateLoanCarTotalCostPageDataRequest extends LoanCarTotalCostPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanCarTotalCostPageDataResponse
 */
export interface ValidateLoanCarTotalCostPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanContactInfoPageDataRequest
 */
export interface ValidateLoanContactInfoPageDataRequest extends LoanContactInfoPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanContactInfoPageDataResponse
 */
export interface ValidateLoanContactInfoPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanCustomerDetailPageDataRequest
 */
export interface ValidateLoanCustomerDetailPageDataRequest extends LoanCustomerDetailPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanCustomerDetailPageDataResponse
 */
export interface ValidateLoanCustomerDetailPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanDetailsPageDataRequest
 */
export interface ValidateLoanDetailsPageDataRequest extends LoanDetailsPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanDetailsPageDataResponse
 */
export interface ValidateLoanDetailsPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanDocumentPageDataRequest
 */
export interface ValidateLoanDocumentPageDataRequest extends LoanDocumentPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanDocumentPageDataResponse
 */
export interface ValidateLoanDocumentPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanGoodsPageDataRequest
 */
export interface ValidateLoanGoodsPageDataRequest extends LoanGoodsPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanGoodsPageDataResponse
 */
export interface ValidateLoanGoodsPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanGuarantorPageDataRequest
 */
export interface ValidateLoanGuarantorPageDataRequest extends LoanGuarantorPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanGuarantorPageDataResponse
 */
export interface ValidateLoanGuarantorPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanHolidayPageDataRequest
 */
export interface ValidateLoanHolidayPageDataRequest extends LoanHolidayPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanHolidayPageDataResponse
 */
export interface ValidateLoanHolidayPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanIndividualPageCustomerChangeRequest
 */
export interface ValidateLoanIndividualPageCustomerChangeRequest {
    /**
     * Customer Id
     * @type {string}
     * @memberof ValidateLoanIndividualPageCustomerChangeRequest
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface ValidateLoanIndividualPageCustomerChangeResponse
 */
export interface ValidateLoanIndividualPageCustomerChangeResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanIndividualPageDataRequest
 */
export interface ValidateLoanIndividualPageDataRequest extends LoanIndividualPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanIndividualPageDataResponse
 */
export interface ValidateLoanIndividualPageDataResponse extends Response {
    /**
     * warning message
     * @type {string}
     * @memberof ValidateLoanIndividualPageDataResponse
     */
    warning?: string;
}
/**
 * 
 * @export
 * @interface ValidateLoanInsurancePageDataRequest
 */
export interface ValidateLoanInsurancePageDataRequest extends LoanInsurancePageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanInsurancePageDataResponse
 */
export interface ValidateLoanInsurancePageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanProductGlobalBonusPageDataRequest
 */
export interface ValidateLoanProductGlobalBonusPageDataRequest extends LoanProductGlobalBonusPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanProductGlobalBonusPageDataResponse
 */
export interface ValidateLoanProductGlobalBonusPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanProductPageDataRequest
 */
export interface ValidateLoanProductPageDataRequest extends LoanProductPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanProductPageDataResponse
 */
export interface ValidateLoanProductPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanScoringJobPageDataRequest
 */
export interface ValidateLoanScoringJobPageDataRequest extends LoanScoringJobPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanScoringJobPageDataResponse
 */
export interface ValidateLoanScoringJobPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanSummaryConfirmationPageResponse
 */
export interface ValidateLoanSummaryConfirmationPageResponse extends Response {
    /**
     * true if card application document is printed
     * @type {boolean}
     * @memberof ValidateLoanSummaryConfirmationPageResponse
     */
    isLoanApplicationPrinted?: boolean;
    /**
     * true if card power of attorney document is printed
     * @type {boolean}
     * @memberof ValidateLoanSummaryConfirmationPageResponse
     */
    isLoanPowerOfAttorneyPrinted?: boolean;
}
/**
 * 
 * @export
 * @interface ValidateLoanTaxInfoPageDataRequest
 */
export interface ValidateLoanTaxInfoPageDataRequest extends LoanTaxInfoPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanTaxInfoPageDataResponse
 */
export interface ValidateLoanTaxInfoPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanTotalCostPageDataRequest
 */
export interface ValidateLoanTotalCostPageDataRequest extends LoanTotalCostPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanTotalCostPageDataResponse
 */
export interface ValidateLoanTotalCostPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateLoanVehicleInformationPageDataRequest
 */
export interface ValidateLoanVehicleInformationPageDataRequest extends LoanVehicleInformationPageData {
}
/**
 * 
 * @export
 * @interface ValidateLoanVehicleInformationPageDataResponse
 */
export interface ValidateLoanVehicleInformationPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidatePosSearchPageDataRequest
 */
export interface ValidatePosSearchPageDataRequest extends PosSearchPageData {
}
/**
 * 
 * @export
 * @interface ValidatePosSearchPageDataResponse
 */
export interface ValidatePosSearchPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateProductOfferPageDataRequest
 */
export interface ValidateProductOfferPageDataRequest extends ProductOfferPageData {
}
/**
 * 
 * @export
 * @interface ValidateProductOfferPageDataResponse
 */
export interface ValidateProductOfferPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateProductPageDataRequest
 */
export interface ValidateProductPageDataRequest extends ProductPageData {
    /**
     * 
     * @type {PageOperationType}
     * @memberof ValidateProductPageDataRequest
     */
    pageOperationType?: PageOperationType;
}
/**
 * 
 * @export
 * @interface ValidateProductPageDataResponse
 */
export interface ValidateProductPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateScoringJobPageDataRequest
 */
export interface ValidateScoringJobPageDataRequest extends ScoringJobPageData {
}
/**
 * 
 * @export
 * @interface ValidateScoringJobPageDataResponse
 */
export interface ValidateScoringJobPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @interface ValidateSummaryPageDataResponse
 */
export interface ValidateSummaryPageDataResponse extends Response {
    /**
     * true if card application document is printed
     * @type {boolean}
     * @memberof ValidateSummaryPageDataResponse
     */
    isCardApplicationPrinted?: boolean;
}
/**
 * 
 * @export
 * @interface ValidateTaxInfoPageDataRequest
 */
export interface ValidateTaxInfoPageDataRequest extends TaxInfoPageData {
}
/**
 * 
 * @export
 * @interface ValidateTaxInfoPageDataResponse
 */
export interface ValidateTaxInfoPageDataResponse extends Response {
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ValidatorType {
    DEFAULT = 'DEFAULT',
    POSACTIVATIONSEARCHPAGE = 'POS_ACTIVATION_SEARCH_PAGE',
    INDIVIDUALPAGE = 'INDIVIDUAL_PAGE',
    DOCUMENTPAGE = 'DOCUMENT_PAGE',
    PRODUCTPAGE = 'PRODUCT_PAGE',
    CUSTOMERIDENTITYMODAL = 'CUSTOMER_IDENTITY_MODAL',
    TAXINFOPAGE = 'TAX_INFO_PAGE',
    CUSTOMERDETAILPAGE = 'CUSTOMER_DETAIL_PAGE',
    ADDRESSPAGE = 'ADDRESS_PAGE',
    CONTACTINFOPAGE = 'CONTACT_INFO_PAGE',
    BENEFITSTHIRDPARTYPAGE = 'BENEFITS_THIRD_PARTY_PAGE',
    APPLICATIONPAGE = 'APPLICATION_PAGE',
    CARDSENDINGPAGE = 'CARD_SENDING_PAGE',
    SCORINGJOBPAGE = 'SCORING_JOB_PAGE',
    APPLICATIONDOCUMENTPAGE = 'APPLICATION_DOCUMENT_PAGE',
    PRODUCTOFFERPAGE = 'PRODUCT_OFFER_PAGE',
    LOANPRODUCTPAGE = 'LOAN_PRODUCT_PAGE',
    LOANPRODUCTGLOBALBONUSPAGE = 'LOAN_PRODUCT_GLOBAL_BONUS_PAGE',
    LOANINDIVIDUALPAGE = 'LOAN_INDIVIDUAL_PAGE',
    LOANDOCUMENTPAGE = 'LOAN_DOCUMENT_PAGE',
    LOANADDRESSPAGE = 'LOAN_ADDRESS_PAGE',
    LOANCONTACTINFOPAGE = 'LOAN_CONTACT_INFO_PAGE',
    LOANTAXINFOPAGE = 'LOAN_TAX_INFO_PAGE',
    LOANSCORINGJOBPAGE = 'LOAN_SCORING_JOB_PAGE',
    LOANCUSTOMERDETAILPAGE = 'LOAN_CUSTOMER_DETAIL_PAGE',
    LOANBENEFITSTHIRDPARTYPAGE = 'LOAN_BENEFITS_THIRD_PARTY_PAGE',
    LOANDETAILSPAGE = 'LOAN_DETAILS_PAGE',
    LOANGOODSPAGE = 'LOAN_GOODS_PAGE',
    LOANHOLIDAYPAGE = 'LOAN_HOLIDAY_PAGE',
    LOANADDITIONALSERVICESPAGE = 'LOAN_ADDITIONAL_SERVICES_PAGE',
    LOANTOTALCOSTPAGE = 'LOAN_TOTAL_COST_PAGE',
    LOANAPPLICATIONDOCUMENTPAGE = 'LOAN_APPLICATION_DOCUMENT_PAGE',
    LOANVEHICLEINFORMATIONPAGE = 'LOAN_VEHICLE_INFORMATION_PAGE',
    LOANADDITIONALEQUIPMENTPAGE = 'LOAN_ADDITIONAL_EQUIPMENT_PAGE',
    LOANINSURANCEPAGE = 'LOAN_INSURANCE_PAGE',
    LOANGUARANTORPAGE = 'LOAN_GUARANTOR_PAGE',
    LOANCARDOCUMENTSPAGE = 'LOAN_CAR_DOCUMENTS_PAGE',
    LOANCARTOTALCOSTPAGE = 'LOAN_CAR_TOTAL_COST_PAGE'
}

/**
 * 
 * @export
 * @interface ViewCreditsDetailsRequest
 */
export interface ViewCreditsDetailsRequest extends PaginationRequest {
    /**
     * Customer Number
     * @type {string}
     * @memberof ViewCreditsDetailsRequest
     */
    customerNumber: string;
}
/**
 * 
 * @export
 * @interface ViewCreditsDetailsResponse
 */
export interface ViewCreditsDetailsResponse extends PaginationResponse {
    /**
     * Client Name
     * @type {string}
     * @memberof ViewCreditsDetailsResponse
     */
    nameSurname?: string;
    /**
     * 
     * @type {Array<ViewCreditsDetailsResponseData>}
     * @memberof ViewCreditsDetailsResponse
     */
    creditList: Array<ViewCreditsDetailsResponseData>;
}
/**
 * 
 * @export
 * @interface ViewCreditsDetailsResponseData
 */
export interface ViewCreditsDetailsResponseData {
    /**
     * Status
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    status: string;
    /**
     * Full Name
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    fullName: string;
    /**
     * Contract Number
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    contractNumber: string;
    /**
     * Currency
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    currency: string;
    /**
     * Loan Amount
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    loanAmount: string;
    /**
     * Date
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    date: string;
    /**
     * Maximum Number Of Delay Days
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    maximumNumberOfDelayDays: string;
    /**
     * Loan Type
     * @type {string}
     * @memberof ViewCreditsDetailsResponseData
     */
    loanType: string;
}

/**
 * AddressPageValidationApi - axios parameter creator
 * @export
 */
export const AddressPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get address page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-address-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate address page data
         * @param {ValidateAddressPageDataRequest} validateAddressPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddressPageData(validateAddressPageDataRequest: ValidateAddressPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateAddressPageDataRequest' is not null or undefined
            if (validateAddressPageDataRequest === null || validateAddressPageDataRequest === undefined) {
                throw new RequiredError('validateAddressPageDataRequest','Required parameter validateAddressPageDataRequest was null or undefined when calling validateAddressPageData.');
            }
            const localVarPath = `/validate-address-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateAddressPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateAddressPageDataRequest !== undefined ? validateAddressPageDataRequest : {}) : (validateAddressPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressPageValidationApi - functional programming interface
 * @export
 */
export const AddressPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get address page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressPageDataResponse> {
            const localVarAxiosArgs = AddressPageValidationApiAxiosParamCreator(configuration).getAddressPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate address page data
         * @param {ValidateAddressPageDataRequest} validateAddressPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddressPageData(validateAddressPageDataRequest: ValidateAddressPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateAddressPageDataResponse> {
            const localVarAxiosArgs = AddressPageValidationApiAxiosParamCreator(configuration).validateAddressPageData(validateAddressPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AddressPageValidationApi - factory interface
 * @export
 */
export const AddressPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get address page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressPageData(options?: any): AxiosPromise<AddressPageDataResponse> {
            return AddressPageValidationApiFp(configuration).getAddressPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate address page data
         * @param {ValidateAddressPageDataRequest} validateAddressPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddressPageData(validateAddressPageDataRequest: ValidateAddressPageDataRequest, options?: any): AxiosPromise<ValidateAddressPageDataResponse> {
            return AddressPageValidationApiFp(configuration).validateAddressPageData(validateAddressPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * AddressPageValidationApi - object-oriented interface
 * @export
 * @class AddressPageValidationApi
 * @extends {BaseAPI}
 */
export class AddressPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get address page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressPageValidationApi
     */
    public getAddressPageData(options?: any) {
        return AddressPageValidationApiFp(this.configuration).getAddressPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate address page data
     * @param {ValidateAddressPageDataRequest} validateAddressPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressPageValidationApi
     */
    public validateAddressPageData(validateAddressPageDataRequest: ValidateAddressPageDataRequest, options?: any) {
        return AddressPageValidationApiFp(this.configuration).validateAddressPageData(validateAddressPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ApplicationDocumentPageValidationApi - axios parameter creator
 * @export
 */
export const ApplicationDocumentPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get application document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationDocumentPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-application-document-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate application document page data
         * @param {ValidateApplicationDocumentPageDataRequest} validateApplicationDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest: ValidateApplicationDocumentPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateApplicationDocumentPageDataRequest' is not null or undefined
            if (validateApplicationDocumentPageDataRequest === null || validateApplicationDocumentPageDataRequest === undefined) {
                throw new RequiredError('validateApplicationDocumentPageDataRequest','Required parameter validateApplicationDocumentPageDataRequest was null or undefined when calling validateApplicationDocumentPageData.');
            }
            const localVarPath = `/validate-application-document-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateApplicationDocumentPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateApplicationDocumentPageDataRequest !== undefined ? validateApplicationDocumentPageDataRequest : {}) : (validateApplicationDocumentPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationDocumentPageValidationApi - functional programming interface
 * @export
 */
export const ApplicationDocumentPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get application document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationDocumentPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationDocumentPageDataResponse> {
            const localVarAxiosArgs = ApplicationDocumentPageValidationApiAxiosParamCreator(configuration).getApplicationDocumentPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate application document page data
         * @param {ValidateApplicationDocumentPageDataRequest} validateApplicationDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest: ValidateApplicationDocumentPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateApplicationDocumentPageDataResponse> {
            const localVarAxiosArgs = ApplicationDocumentPageValidationApiAxiosParamCreator(configuration).validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ApplicationDocumentPageValidationApi - factory interface
 * @export
 */
export const ApplicationDocumentPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get application document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationDocumentPageData(options?: any): AxiosPromise<ApplicationDocumentPageDataResponse> {
            return ApplicationDocumentPageValidationApiFp(configuration).getApplicationDocumentPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate application document page data
         * @param {ValidateApplicationDocumentPageDataRequest} validateApplicationDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest: ValidateApplicationDocumentPageDataRequest, options?: any): AxiosPromise<ValidateApplicationDocumentPageDataResponse> {
            return ApplicationDocumentPageValidationApiFp(configuration).validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ApplicationDocumentPageValidationApi - object-oriented interface
 * @export
 * @class ApplicationDocumentPageValidationApi
 * @extends {BaseAPI}
 */
export class ApplicationDocumentPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get application document page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDocumentPageValidationApi
     */
    public getApplicationDocumentPageData(options?: any) {
        return ApplicationDocumentPageValidationApiFp(this.configuration).getApplicationDocumentPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate application document page data
     * @param {ValidateApplicationDocumentPageDataRequest} validateApplicationDocumentPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDocumentPageValidationApi
     */
    public validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest: ValidateApplicationDocumentPageDataRequest, options?: any) {
        return ApplicationDocumentPageValidationApiFp(this.configuration).validateApplicationDocumentPageData(validateApplicationDocumentPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ApplicationInfoPageValidationApi - axios parameter creator
 * @export
 */
export const ApplicationInfoPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get application info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationInfoPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-application-info-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate application info page data
         * @param {ValidateApplicationInfoPageDataRequest} validateApplicationInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApplicationInfoPageData(validateApplicationInfoPageDataRequest: ValidateApplicationInfoPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateApplicationInfoPageDataRequest' is not null or undefined
            if (validateApplicationInfoPageDataRequest === null || validateApplicationInfoPageDataRequest === undefined) {
                throw new RequiredError('validateApplicationInfoPageDataRequest','Required parameter validateApplicationInfoPageDataRequest was null or undefined when calling validateApplicationInfoPageData.');
            }
            const localVarPath = `/validate-application-info-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateApplicationInfoPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateApplicationInfoPageDataRequest !== undefined ? validateApplicationInfoPageDataRequest : {}) : (validateApplicationInfoPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationInfoPageValidationApi - functional programming interface
 * @export
 */
export const ApplicationInfoPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get application info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationInfoPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationInfoPageDataResponse> {
            const localVarAxiosArgs = ApplicationInfoPageValidationApiAxiosParamCreator(configuration).getApplicationInfoPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate application info page data
         * @param {ValidateApplicationInfoPageDataRequest} validateApplicationInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApplicationInfoPageData(validateApplicationInfoPageDataRequest: ValidateApplicationInfoPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateApplicationInfoPageDataResponse> {
            const localVarAxiosArgs = ApplicationInfoPageValidationApiAxiosParamCreator(configuration).validateApplicationInfoPageData(validateApplicationInfoPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ApplicationInfoPageValidationApi - factory interface
 * @export
 */
export const ApplicationInfoPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get application info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationInfoPageData(options?: any): AxiosPromise<ApplicationInfoPageDataResponse> {
            return ApplicationInfoPageValidationApiFp(configuration).getApplicationInfoPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate application info page data
         * @param {ValidateApplicationInfoPageDataRequest} validateApplicationInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApplicationInfoPageData(validateApplicationInfoPageDataRequest: ValidateApplicationInfoPageDataRequest, options?: any): AxiosPromise<ValidateApplicationInfoPageDataResponse> {
            return ApplicationInfoPageValidationApiFp(configuration).validateApplicationInfoPageData(validateApplicationInfoPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ApplicationInfoPageValidationApi - object-oriented interface
 * @export
 * @class ApplicationInfoPageValidationApi
 * @extends {BaseAPI}
 */
export class ApplicationInfoPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get application info page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationInfoPageValidationApi
     */
    public getApplicationInfoPageData(options?: any) {
        return ApplicationInfoPageValidationApiFp(this.configuration).getApplicationInfoPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate application info page data
     * @param {ValidateApplicationInfoPageDataRequest} validateApplicationInfoPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationInfoPageValidationApi
     */
    public validateApplicationInfoPageData(validateApplicationInfoPageDataRequest: ValidateApplicationInfoPageDataRequest, options?: any) {
        return ApplicationInfoPageValidationApiFp(this.configuration).validateApplicationInfoPageData(validateApplicationInfoPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * BankruptApi - axios parameter creator
 * @export
 */
export const BankruptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search for bankrupt list matching
         * @param {SearchBankruptRequest} searchBankruptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankrupt(searchBankruptRequest: SearchBankruptRequest, options: any = {}): RequestArgs {
            // verify required parameter 'searchBankruptRequest' is not null or undefined
            if (searchBankruptRequest === null || searchBankruptRequest === undefined) {
                throw new RequiredError('searchBankruptRequest','Required parameter searchBankruptRequest was null or undefined when calling searchBankrupt.');
            }
            const localVarPath = `/bankrupt/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof searchBankruptRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(searchBankruptRequest !== undefined ? searchBankruptRequest : {}) : (searchBankruptRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankruptApi - functional programming interface
 * @export
 */
export const BankruptApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search for bankrupt list matching
         * @param {SearchBankruptRequest} searchBankruptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankrupt(searchBankruptRequest: SearchBankruptRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchBankruptResponse> {
            const localVarAxiosArgs = BankruptApiAxiosParamCreator(configuration).searchBankrupt(searchBankruptRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BankruptApi - factory interface
 * @export
 */
export const BankruptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Search for bankrupt list matching
         * @param {SearchBankruptRequest} searchBankruptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankrupt(searchBankruptRequest: SearchBankruptRequest, options?: any): AxiosPromise<SearchBankruptResponse> {
            return BankruptApiFp(configuration).searchBankrupt(searchBankruptRequest, options)(axios, basePath);
        },
    };
};

/**
 * BankruptApi - object-oriented interface
 * @export
 * @class BankruptApi
 * @extends {BaseAPI}
 */
export class BankruptApi extends BaseAPI {
    /**
     * 
     * @summary Search for bankrupt list matching
     * @param {SearchBankruptRequest} searchBankruptRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankruptApi
     */
    public searchBankrupt(searchBankruptRequest: SearchBankruptRequest, options?: any) {
        return BankruptApiFp(this.configuration).searchBankrupt(searchBankruptRequest, options)(this.axios, this.basePath);
    }

}


/**
 * BenefitsThirdPartyPageValidationApi - axios parameter creator
 * @export
 */
export const BenefitsThirdPartyPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get benefits third party page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenefitsThirdPartyPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-benefits-third-party-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate benefits third party page data
         * @param {ValidateBenefitsThirdPartyPageDataRequest} validateBenefitsThirdPartyPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest: ValidateBenefitsThirdPartyPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateBenefitsThirdPartyPageDataRequest' is not null or undefined
            if (validateBenefitsThirdPartyPageDataRequest === null || validateBenefitsThirdPartyPageDataRequest === undefined) {
                throw new RequiredError('validateBenefitsThirdPartyPageDataRequest','Required parameter validateBenefitsThirdPartyPageDataRequest was null or undefined when calling validateBenefitsThirdPartyPageData.');
            }
            const localVarPath = `/validate-benefits-third-party-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateBenefitsThirdPartyPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateBenefitsThirdPartyPageDataRequest !== undefined ? validateBenefitsThirdPartyPageDataRequest : {}) : (validateBenefitsThirdPartyPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BenefitsThirdPartyPageValidationApi - functional programming interface
 * @export
 */
export const BenefitsThirdPartyPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get benefits third party page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenefitsThirdPartyPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BenefitsThirdPartyPageDataResponse> {
            const localVarAxiosArgs = BenefitsThirdPartyPageValidationApiAxiosParamCreator(configuration).getBenefitsThirdPartyPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate benefits third party page data
         * @param {ValidateBenefitsThirdPartyPageDataRequest} validateBenefitsThirdPartyPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest: ValidateBenefitsThirdPartyPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateBenefitsThirdPartyPageDataResponse> {
            const localVarAxiosArgs = BenefitsThirdPartyPageValidationApiAxiosParamCreator(configuration).validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BenefitsThirdPartyPageValidationApi - factory interface
 * @export
 */
export const BenefitsThirdPartyPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get benefits third party page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenefitsThirdPartyPageData(options?: any): AxiosPromise<BenefitsThirdPartyPageDataResponse> {
            return BenefitsThirdPartyPageValidationApiFp(configuration).getBenefitsThirdPartyPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate benefits third party page data
         * @param {ValidateBenefitsThirdPartyPageDataRequest} validateBenefitsThirdPartyPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest: ValidateBenefitsThirdPartyPageDataRequest, options?: any): AxiosPromise<ValidateBenefitsThirdPartyPageDataResponse> {
            return BenefitsThirdPartyPageValidationApiFp(configuration).validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * BenefitsThirdPartyPageValidationApi - object-oriented interface
 * @export
 * @class BenefitsThirdPartyPageValidationApi
 * @extends {BaseAPI}
 */
export class BenefitsThirdPartyPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get benefits third party page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsThirdPartyPageValidationApi
     */
    public getBenefitsThirdPartyPageData(options?: any) {
        return BenefitsThirdPartyPageValidationApiFp(this.configuration).getBenefitsThirdPartyPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate benefits third party page data
     * @param {ValidateBenefitsThirdPartyPageDataRequest} validateBenefitsThirdPartyPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsThirdPartyPageValidationApi
     */
    public validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest: ValidateBenefitsThirdPartyPageDataRequest, options?: any) {
        return BenefitsThirdPartyPageValidationApiFp(this.configuration).validateBenefitsThirdPartyPageData(validateBenefitsThirdPartyPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CallCenterApi - axios parameter creator
 * @export
 */
export const CallCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Log Screen for Call Center
         * @param {CallCenterLogScreenRequest} callCenterLogScreenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logScreen(callCenterLogScreenRequest: CallCenterLogScreenRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterLogScreenRequest' is not null or undefined
            if (callCenterLogScreenRequest === null || callCenterLogScreenRequest === undefined) {
                throw new RequiredError('callCenterLogScreenRequest','Required parameter callCenterLogScreenRequest was null or undefined when calling logScreen.');
            }
            const localVarPath = `/call-center/log-screen`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterLogScreenRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterLogScreenRequest !== undefined ? callCenterLogScreenRequest : {}) : (callCenterLogScreenRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterApi - functional programming interface
 * @export
 */
export const CallCenterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Log Screen for Call Center
         * @param {CallCenterLogScreenRequest} callCenterLogScreenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logScreen(callCenterLogScreenRequest: CallCenterLogScreenRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterLogScreenResponse> {
            const localVarAxiosArgs = CallCenterApiAxiosParamCreator(configuration).logScreen(callCenterLogScreenRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CallCenterApi - factory interface
 * @export
 */
export const CallCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Log Screen for Call Center
         * @param {CallCenterLogScreenRequest} callCenterLogScreenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logScreen(callCenterLogScreenRequest: CallCenterLogScreenRequest, options?: any): AxiosPromise<CallCenterLogScreenResponse> {
            return CallCenterApiFp(configuration).logScreen(callCenterLogScreenRequest, options)(axios, basePath);
        },
    };
};

/**
 * CallCenterApi - object-oriented interface
 * @export
 * @class CallCenterApi
 * @extends {BaseAPI}
 */
export class CallCenterApi extends BaseAPI {
    /**
     * 
     * @summary Log Screen for Call Center
     * @param {CallCenterLogScreenRequest} callCenterLogScreenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public logScreen(callCenterLogScreenRequest: CallCenterLogScreenRequest, options?: any) {
        return CallCenterApiFp(this.configuration).logScreen(callCenterLogScreenRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CallCenterInfoRBSAgreementApi - axios parameter creator
 * @export
 */
export const CallCenterInfoRBSAgreementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {CallCenterInfoRBSAgreementBlockUserRequest} callCenterInfoRBSAgreementBlockUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(callCenterInfoRBSAgreementBlockUserRequest: CallCenterInfoRBSAgreementBlockUserRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterInfoRBSAgreementBlockUserRequest' is not null or undefined
            if (callCenterInfoRBSAgreementBlockUserRequest === null || callCenterInfoRBSAgreementBlockUserRequest === undefined) {
                throw new RequiredError('callCenterInfoRBSAgreementBlockUserRequest','Required parameter callCenterInfoRBSAgreementBlockUserRequest was null or undefined when calling blockUser.');
            }
            const localVarPath = `/call-center-info-rbs-agreement/block-user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterInfoRBSAgreementBlockUserRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterInfoRBSAgreementBlockUserRequest !== undefined ? callCenterInfoRBSAgreementBlockUserRequest : {}) : (callCenterInfoRBSAgreementBlockUserRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRBSUserAgreementInfo(options: any = {}): RequestArgs {
            const localVarPath = `/call-center-info-rbs-agreement/get-user-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {CallCenterInfoRBSAgreementSearchAccessInfoRequest} callCenterInfoRBSAgreementSearchAccessInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest: CallCenterInfoRBSAgreementSearchAccessInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterInfoRBSAgreementSearchAccessInfoRequest' is not null or undefined
            if (callCenterInfoRBSAgreementSearchAccessInfoRequest === null || callCenterInfoRBSAgreementSearchAccessInfoRequest === undefined) {
                throw new RequiredError('callCenterInfoRBSAgreementSearchAccessInfoRequest','Required parameter callCenterInfoRBSAgreementSearchAccessInfoRequest was null or undefined when calling searchAccessInfo.');
            }
            const localVarPath = `/call-center-info-rbs-agreement/search-access-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterInfoRBSAgreementSearchAccessInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterInfoRBSAgreementSearchAccessInfoRequest !== undefined ? callCenterInfoRBSAgreementSearchAccessInfoRequest : {}) : (callCenterInfoRBSAgreementSearchAccessInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterInfoRBSAgreementApi - functional programming interface
 * @export
 */
export const CallCenterInfoRBSAgreementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {CallCenterInfoRBSAgreementBlockUserRequest} callCenterInfoRBSAgreementBlockUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(callCenterInfoRBSAgreementBlockUserRequest: CallCenterInfoRBSAgreementBlockUserRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterInfoRBSAgreementBlockUserResponse> {
            const localVarAxiosArgs = CallCenterInfoRBSAgreementApiAxiosParamCreator(configuration).blockUser(callCenterInfoRBSAgreementBlockUserRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRBSUserAgreementInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterInfoRBSAgreementUserInfoResponse> {
            const localVarAxiosArgs = CallCenterInfoRBSAgreementApiAxiosParamCreator(configuration).getRBSUserAgreementInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {CallCenterInfoRBSAgreementSearchAccessInfoRequest} callCenterInfoRBSAgreementSearchAccessInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest: CallCenterInfoRBSAgreementSearchAccessInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterInfoRBSAgreementSearchAccessInfoResponse> {
            const localVarAxiosArgs = CallCenterInfoRBSAgreementApiAxiosParamCreator(configuration).searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CallCenterInfoRBSAgreementApi - factory interface
 * @export
 */
export const CallCenterInfoRBSAgreementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {CallCenterInfoRBSAgreementBlockUserRequest} callCenterInfoRBSAgreementBlockUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(callCenterInfoRBSAgreementBlockUserRequest: CallCenterInfoRBSAgreementBlockUserRequest, options?: any): AxiosPromise<CallCenterInfoRBSAgreementBlockUserResponse> {
            return CallCenterInfoRBSAgreementApiFp(configuration).blockUser(callCenterInfoRBSAgreementBlockUserRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRBSUserAgreementInfo(options?: any): AxiosPromise<CallCenterInfoRBSAgreementUserInfoResponse> {
            return CallCenterInfoRBSAgreementApiFp(configuration).getRBSUserAgreementInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get RBS User Agreement Info
         * @param {CallCenterInfoRBSAgreementSearchAccessInfoRequest} callCenterInfoRBSAgreementSearchAccessInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest: CallCenterInfoRBSAgreementSearchAccessInfoRequest, options?: any): AxiosPromise<CallCenterInfoRBSAgreementSearchAccessInfoResponse> {
            return CallCenterInfoRBSAgreementApiFp(configuration).searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest, options)(axios, basePath);
        },
    };
};

/**
 * CallCenterInfoRBSAgreementApi - object-oriented interface
 * @export
 * @class CallCenterInfoRBSAgreementApi
 * @extends {BaseAPI}
 */
export class CallCenterInfoRBSAgreementApi extends BaseAPI {
    /**
     * 
     * @summary Get RBS User Agreement Info
     * @param {CallCenterInfoRBSAgreementBlockUserRequest} callCenterInfoRBSAgreementBlockUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterInfoRBSAgreementApi
     */
    public blockUser(callCenterInfoRBSAgreementBlockUserRequest: CallCenterInfoRBSAgreementBlockUserRequest, options?: any) {
        return CallCenterInfoRBSAgreementApiFp(this.configuration).blockUser(callCenterInfoRBSAgreementBlockUserRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get RBS User Agreement Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterInfoRBSAgreementApi
     */
    public getRBSUserAgreementInfo(options?: any) {
        return CallCenterInfoRBSAgreementApiFp(this.configuration).getRBSUserAgreementInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get RBS User Agreement Info
     * @param {CallCenterInfoRBSAgreementSearchAccessInfoRequest} callCenterInfoRBSAgreementSearchAccessInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterInfoRBSAgreementApi
     */
    public searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest: CallCenterInfoRBSAgreementSearchAccessInfoRequest, options?: any) {
        return CallCenterInfoRBSAgreementApiFp(this.configuration).searchAccessInfo(callCenterInfoRBSAgreementSearchAccessInfoRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CallCenterInterbankApi - axios parameter creator
 * @export
 */
export const CallCenterInterbankApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Current Accounts for Call Center Interbank
         * @param {CallCenterInterbankCurrentAccountsRequest} callCenterInterbankCurrentAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccounts(callCenterInterbankCurrentAccountsRequest: CallCenterInterbankCurrentAccountsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterInterbankCurrentAccountsRequest' is not null or undefined
            if (callCenterInterbankCurrentAccountsRequest === null || callCenterInterbankCurrentAccountsRequest === undefined) {
                throw new RequiredError('callCenterInterbankCurrentAccountsRequest','Required parameter callCenterInterbankCurrentAccountsRequest was null or undefined when calling getCurrentAccounts.');
            }
            const localVarPath = `/call-center-interbank/current-accounts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterInterbankCurrentAccountsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterInterbankCurrentAccountsRequest !== undefined ? callCenterInterbankCurrentAccountsRequest : {}) : (callCenterInterbankCurrentAccountsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Money Transfer History for Call Center Interbank
         * @param {CallCenterInterbankMoneyTransferHistoryRequest} callCenterInterbankMoneyTransferHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest: CallCenterInterbankMoneyTransferHistoryRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterInterbankMoneyTransferHistoryRequest' is not null or undefined
            if (callCenterInterbankMoneyTransferHistoryRequest === null || callCenterInterbankMoneyTransferHistoryRequest === undefined) {
                throw new RequiredError('callCenterInterbankMoneyTransferHistoryRequest','Required parameter callCenterInterbankMoneyTransferHistoryRequest was null or undefined when calling getMoneyTransferHistory.');
            }
            const localVarPath = `/call-center-interbank/money-transfer-history`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterInterbankMoneyTransferHistoryRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterInterbankMoneyTransferHistoryRequest !== undefined ? callCenterInterbankMoneyTransferHistoryRequest : {}) : (callCenterInterbankMoneyTransferHistoryRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterInterbankApi - functional programming interface
 * @export
 */
export const CallCenterInterbankApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Current Accounts for Call Center Interbank
         * @param {CallCenterInterbankCurrentAccountsRequest} callCenterInterbankCurrentAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccounts(callCenterInterbankCurrentAccountsRequest: CallCenterInterbankCurrentAccountsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterInterbankCurrentAccountsResponse> {
            const localVarAxiosArgs = CallCenterInterbankApiAxiosParamCreator(configuration).getCurrentAccounts(callCenterInterbankCurrentAccountsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Money Transfer History for Call Center Interbank
         * @param {CallCenterInterbankMoneyTransferHistoryRequest} callCenterInterbankMoneyTransferHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest: CallCenterInterbankMoneyTransferHistoryRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterInterbankMoneyTransferHistoryResponse> {
            const localVarAxiosArgs = CallCenterInterbankApiAxiosParamCreator(configuration).getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CallCenterInterbankApi - factory interface
 * @export
 */
export const CallCenterInterbankApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Current Accounts for Call Center Interbank
         * @param {CallCenterInterbankCurrentAccountsRequest} callCenterInterbankCurrentAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccounts(callCenterInterbankCurrentAccountsRequest: CallCenterInterbankCurrentAccountsRequest, options?: any): AxiosPromise<CallCenterInterbankCurrentAccountsResponse> {
            return CallCenterInterbankApiFp(configuration).getCurrentAccounts(callCenterInterbankCurrentAccountsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Money Transfer History for Call Center Interbank
         * @param {CallCenterInterbankMoneyTransferHistoryRequest} callCenterInterbankMoneyTransferHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest: CallCenterInterbankMoneyTransferHistoryRequest, options?: any): AxiosPromise<CallCenterInterbankMoneyTransferHistoryResponse> {
            return CallCenterInterbankApiFp(configuration).getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest, options)(axios, basePath);
        },
    };
};

/**
 * CallCenterInterbankApi - object-oriented interface
 * @export
 * @class CallCenterInterbankApi
 * @extends {BaseAPI}
 */
export class CallCenterInterbankApi extends BaseAPI {
    /**
     * 
     * @summary Get Current Accounts for Call Center Interbank
     * @param {CallCenterInterbankCurrentAccountsRequest} callCenterInterbankCurrentAccountsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterInterbankApi
     */
    public getCurrentAccounts(callCenterInterbankCurrentAccountsRequest: CallCenterInterbankCurrentAccountsRequest, options?: any) {
        return CallCenterInterbankApiFp(this.configuration).getCurrentAccounts(callCenterInterbankCurrentAccountsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Money Transfer History for Call Center Interbank
     * @param {CallCenterInterbankMoneyTransferHistoryRequest} callCenterInterbankMoneyTransferHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterInterbankApi
     */
    public getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest: CallCenterInterbankMoneyTransferHistoryRequest, options?: any) {
        return CallCenterInterbankApiFp(this.configuration).getMoneyTransferHistory(callCenterInterbankMoneyTransferHistoryRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CallCenterIntrabankApi - axios parameter creator
 * @export
 */
export const CallCenterIntrabankApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Current Accounts for Call Center Intrabank
         * @param {CallCenterIntrabankCurrentAccountsRequest} callCenterIntrabankCurrentAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest: CallCenterIntrabankCurrentAccountsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterIntrabankCurrentAccountsRequest' is not null or undefined
            if (callCenterIntrabankCurrentAccountsRequest === null || callCenterIntrabankCurrentAccountsRequest === undefined) {
                throw new RequiredError('callCenterIntrabankCurrentAccountsRequest','Required parameter callCenterIntrabankCurrentAccountsRequest was null or undefined when calling getCurrentAccountsIntrabank.');
            }
            const localVarPath = `/call-center-intrabank/current-accounts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterIntrabankCurrentAccountsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterIntrabankCurrentAccountsRequest !== undefined ? callCenterIntrabankCurrentAccountsRequest : {}) : (callCenterIntrabankCurrentAccountsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Money Transfer Details for Call Center Intrabank
         * @param {CallCenterIntrabankMoneyTransferDetailsRequest} callCenterIntrabankMoneyTransferDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest: CallCenterIntrabankMoneyTransferDetailsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterIntrabankMoneyTransferDetailsRequest' is not null or undefined
            if (callCenterIntrabankMoneyTransferDetailsRequest === null || callCenterIntrabankMoneyTransferDetailsRequest === undefined) {
                throw new RequiredError('callCenterIntrabankMoneyTransferDetailsRequest','Required parameter callCenterIntrabankMoneyTransferDetailsRequest was null or undefined when calling getMoneyTransferDetailsIntrabank.');
            }
            const localVarPath = `/call-center-intrabank/money-transfer-details`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterIntrabankMoneyTransferDetailsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterIntrabankMoneyTransferDetailsRequest !== undefined ? callCenterIntrabankMoneyTransferDetailsRequest : {}) : (callCenterIntrabankMoneyTransferDetailsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Money Transfer History for Call Center Intrabank
         * @param {CallCenterIntrabankMoneyTransferHistoryRequest} callCenterIntrabankMoneyTransferHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest: CallCenterIntrabankMoneyTransferHistoryRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterIntrabankMoneyTransferHistoryRequest' is not null or undefined
            if (callCenterIntrabankMoneyTransferHistoryRequest === null || callCenterIntrabankMoneyTransferHistoryRequest === undefined) {
                throw new RequiredError('callCenterIntrabankMoneyTransferHistoryRequest','Required parameter callCenterIntrabankMoneyTransferHistoryRequest was null or undefined when calling getMoneyTransferHistoryIntrabank.');
            }
            const localVarPath = `/call-center-intrabank/money-transfer-history`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterIntrabankMoneyTransferHistoryRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterIntrabankMoneyTransferHistoryRequest !== undefined ? callCenterIntrabankMoneyTransferHistoryRequest : {}) : (callCenterIntrabankMoneyTransferHistoryRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product Combo for Call Center Intrabank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductComboIntrabank(options: any = {}): RequestArgs {
            const localVarPath = `/call-center-intrabank/product-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterIntrabankApi - functional programming interface
 * @export
 */
export const CallCenterIntrabankApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Current Accounts for Call Center Intrabank
         * @param {CallCenterIntrabankCurrentAccountsRequest} callCenterIntrabankCurrentAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest: CallCenterIntrabankCurrentAccountsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterIntrabankCurrentAccountsResponse> {
            const localVarAxiosArgs = CallCenterIntrabankApiAxiosParamCreator(configuration).getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Money Transfer Details for Call Center Intrabank
         * @param {CallCenterIntrabankMoneyTransferDetailsRequest} callCenterIntrabankMoneyTransferDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest: CallCenterIntrabankMoneyTransferDetailsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterIntrabankMoneyTransferDetailsResponse> {
            const localVarAxiosArgs = CallCenterIntrabankApiAxiosParamCreator(configuration).getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Money Transfer History for Call Center Intrabank
         * @param {CallCenterIntrabankMoneyTransferHistoryRequest} callCenterIntrabankMoneyTransferHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest: CallCenterIntrabankMoneyTransferHistoryRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterIntrabankMoneyTransferHistoryResponse> {
            const localVarAxiosArgs = CallCenterIntrabankApiAxiosParamCreator(configuration).getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Product Combo for Call Center Intrabank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductComboIntrabank(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterIntrabankProductComboResponse> {
            const localVarAxiosArgs = CallCenterIntrabankApiAxiosParamCreator(configuration).getProductComboIntrabank(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CallCenterIntrabankApi - factory interface
 * @export
 */
export const CallCenterIntrabankApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Current Accounts for Call Center Intrabank
         * @param {CallCenterIntrabankCurrentAccountsRequest} callCenterIntrabankCurrentAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest: CallCenterIntrabankCurrentAccountsRequest, options?: any): AxiosPromise<CallCenterIntrabankCurrentAccountsResponse> {
            return CallCenterIntrabankApiFp(configuration).getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Money Transfer Details for Call Center Intrabank
         * @param {CallCenterIntrabankMoneyTransferDetailsRequest} callCenterIntrabankMoneyTransferDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest: CallCenterIntrabankMoneyTransferDetailsRequest, options?: any): AxiosPromise<CallCenterIntrabankMoneyTransferDetailsResponse> {
            return CallCenterIntrabankApiFp(configuration).getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Money Transfer History for Call Center Intrabank
         * @param {CallCenterIntrabankMoneyTransferHistoryRequest} callCenterIntrabankMoneyTransferHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest: CallCenterIntrabankMoneyTransferHistoryRequest, options?: any): AxiosPromise<CallCenterIntrabankMoneyTransferHistoryResponse> {
            return CallCenterIntrabankApiFp(configuration).getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Product Combo for Call Center Intrabank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductComboIntrabank(options?: any): AxiosPromise<CallCenterIntrabankProductComboResponse> {
            return CallCenterIntrabankApiFp(configuration).getProductComboIntrabank(options)(axios, basePath);
        },
    };
};

/**
 * CallCenterIntrabankApi - object-oriented interface
 * @export
 * @class CallCenterIntrabankApi
 * @extends {BaseAPI}
 */
export class CallCenterIntrabankApi extends BaseAPI {
    /**
     * 
     * @summary Get Current Accounts for Call Center Intrabank
     * @param {CallCenterIntrabankCurrentAccountsRequest} callCenterIntrabankCurrentAccountsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterIntrabankApi
     */
    public getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest: CallCenterIntrabankCurrentAccountsRequest, options?: any) {
        return CallCenterIntrabankApiFp(this.configuration).getCurrentAccountsIntrabank(callCenterIntrabankCurrentAccountsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Money Transfer Details for Call Center Intrabank
     * @param {CallCenterIntrabankMoneyTransferDetailsRequest} callCenterIntrabankMoneyTransferDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterIntrabankApi
     */
    public getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest: CallCenterIntrabankMoneyTransferDetailsRequest, options?: any) {
        return CallCenterIntrabankApiFp(this.configuration).getMoneyTransferDetailsIntrabank(callCenterIntrabankMoneyTransferDetailsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Money Transfer History for Call Center Intrabank
     * @param {CallCenterIntrabankMoneyTransferHistoryRequest} callCenterIntrabankMoneyTransferHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterIntrabankApi
     */
    public getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest: CallCenterIntrabankMoneyTransferHistoryRequest, options?: any) {
        return CallCenterIntrabankApiFp(this.configuration).getMoneyTransferHistoryIntrabank(callCenterIntrabankMoneyTransferHistoryRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Product Combo for Call Center Intrabank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterIntrabankApi
     */
    public getProductComboIntrabank(options?: any) {
        return CallCenterIntrabankApiFp(this.configuration).getProductComboIntrabank(options)(this.axios, this.basePath);
    }

}


/**
 * CallCenterMobileBankingLogsApi - axios parameter creator
 * @export
 */
export const CallCenterMobileBankingLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Operation Logs for Mobile Banking
         * @param {CallCenterMobileOperationLogsRequest} callCenterMobileOperationLogsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileOperationLogs(callCenterMobileOperationLogsRequest: CallCenterMobileOperationLogsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterMobileOperationLogsRequest' is not null or undefined
            if (callCenterMobileOperationLogsRequest === null || callCenterMobileOperationLogsRequest === undefined) {
                throw new RequiredError('callCenterMobileOperationLogsRequest','Required parameter callCenterMobileOperationLogsRequest was null or undefined when calling getMobileOperationLogs.');
            }
            const localVarPath = `/call-center-mobile-banking-logs/operations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterMobileOperationLogsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterMobileOperationLogsRequest !== undefined ? callCenterMobileOperationLogsRequest : {}) : (callCenterMobileOperationLogsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Logs for Mobile Banking
         * @param {CallCenterMobileSessionLogsRequest} callCenterMobileSessionLogsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileSessionLogs(callCenterMobileSessionLogsRequest: CallCenterMobileSessionLogsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterMobileSessionLogsRequest' is not null or undefined
            if (callCenterMobileSessionLogsRequest === null || callCenterMobileSessionLogsRequest === undefined) {
                throw new RequiredError('callCenterMobileSessionLogsRequest','Required parameter callCenterMobileSessionLogsRequest was null or undefined when calling getMobileSessionLogs.');
            }
            const localVarPath = `/call-center-mobile-banking-logs/sessions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterMobileSessionLogsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterMobileSessionLogsRequest !== undefined ? callCenterMobileSessionLogsRequest : {}) : (callCenterMobileSessionLogsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterMobileBankingLogsApi - functional programming interface
 * @export
 */
export const CallCenterMobileBankingLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Operation Logs for Mobile Banking
         * @param {CallCenterMobileOperationLogsRequest} callCenterMobileOperationLogsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileOperationLogs(callCenterMobileOperationLogsRequest: CallCenterMobileOperationLogsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterMobileOperationLogsResponse> {
            const localVarAxiosArgs = CallCenterMobileBankingLogsApiAxiosParamCreator(configuration).getMobileOperationLogs(callCenterMobileOperationLogsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Session Logs for Mobile Banking
         * @param {CallCenterMobileSessionLogsRequest} callCenterMobileSessionLogsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileSessionLogs(callCenterMobileSessionLogsRequest: CallCenterMobileSessionLogsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterMobileSessionLogsResponse> {
            const localVarAxiosArgs = CallCenterMobileBankingLogsApiAxiosParamCreator(configuration).getMobileSessionLogs(callCenterMobileSessionLogsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CallCenterMobileBankingLogsApi - factory interface
 * @export
 */
export const CallCenterMobileBankingLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Operation Logs for Mobile Banking
         * @param {CallCenterMobileOperationLogsRequest} callCenterMobileOperationLogsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileOperationLogs(callCenterMobileOperationLogsRequest: CallCenterMobileOperationLogsRequest, options?: any): AxiosPromise<CallCenterMobileOperationLogsResponse> {
            return CallCenterMobileBankingLogsApiFp(configuration).getMobileOperationLogs(callCenterMobileOperationLogsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Session Logs for Mobile Banking
         * @param {CallCenterMobileSessionLogsRequest} callCenterMobileSessionLogsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileSessionLogs(callCenterMobileSessionLogsRequest: CallCenterMobileSessionLogsRequest, options?: any): AxiosPromise<CallCenterMobileSessionLogsResponse> {
            return CallCenterMobileBankingLogsApiFp(configuration).getMobileSessionLogs(callCenterMobileSessionLogsRequest, options)(axios, basePath);
        },
    };
};

/**
 * CallCenterMobileBankingLogsApi - object-oriented interface
 * @export
 * @class CallCenterMobileBankingLogsApi
 * @extends {BaseAPI}
 */
export class CallCenterMobileBankingLogsApi extends BaseAPI {
    /**
     * 
     * @summary Get Operation Logs for Mobile Banking
     * @param {CallCenterMobileOperationLogsRequest} callCenterMobileOperationLogsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterMobileBankingLogsApi
     */
    public getMobileOperationLogs(callCenterMobileOperationLogsRequest: CallCenterMobileOperationLogsRequest, options?: any) {
        return CallCenterMobileBankingLogsApiFp(this.configuration).getMobileOperationLogs(callCenterMobileOperationLogsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Session Logs for Mobile Banking
     * @param {CallCenterMobileSessionLogsRequest} callCenterMobileSessionLogsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterMobileBankingLogsApi
     */
    public getMobileSessionLogs(callCenterMobileSessionLogsRequest: CallCenterMobileSessionLogsRequest, options?: any) {
        return CallCenterMobileBankingLogsApiFp(this.configuration).getMobileSessionLogs(callCenterMobileSessionLogsRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CallCenterOperationHistoryApi - axios parameter creator
 * @export
 */
export const CallCenterOperationHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Internet Transactions
         * @param {CallCenterInternetOperationsRequest} callCenterInternetOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternetOperations(callCenterInternetOperationsRequest: CallCenterInternetOperationsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'callCenterInternetOperationsRequest' is not null or undefined
            if (callCenterInternetOperationsRequest === null || callCenterInternetOperationsRequest === undefined) {
                throw new RequiredError('callCenterInternetOperationsRequest','Required parameter callCenterInternetOperationsRequest was null or undefined when calling getInternetOperations.');
            }
            const localVarPath = `/call-center-operation-history/operations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof callCenterInternetOperationsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(callCenterInternetOperationsRequest !== undefined ? callCenterInternetOperationsRequest : {}) : (callCenterInternetOperationsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterOperationHistoryApi - functional programming interface
 * @export
 */
export const CallCenterOperationHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Internet Transactions
         * @param {CallCenterInternetOperationsRequest} callCenterInternetOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternetOperations(callCenterInternetOperationsRequest: CallCenterInternetOperationsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterInternetOperationsResponse> {
            const localVarAxiosArgs = CallCenterOperationHistoryApiAxiosParamCreator(configuration).getInternetOperations(callCenterInternetOperationsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CallCenterOperationHistoryApi - factory interface
 * @export
 */
export const CallCenterOperationHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Internet Transactions
         * @param {CallCenterInternetOperationsRequest} callCenterInternetOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternetOperations(callCenterInternetOperationsRequest: CallCenterInternetOperationsRequest, options?: any): AxiosPromise<CallCenterInternetOperationsResponse> {
            return CallCenterOperationHistoryApiFp(configuration).getInternetOperations(callCenterInternetOperationsRequest, options)(axios, basePath);
        },
    };
};

/**
 * CallCenterOperationHistoryApi - object-oriented interface
 * @export
 * @class CallCenterOperationHistoryApi
 * @extends {BaseAPI}
 */
export class CallCenterOperationHistoryApi extends BaseAPI {
    /**
     * 
     * @summary Get Internet Transactions
     * @param {CallCenterInternetOperationsRequest} callCenterInternetOperationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterOperationHistoryApi
     */
    public getInternetOperations(callCenterInternetOperationsRequest: CallCenterInternetOperationsRequest, options?: any) {
        return CallCenterOperationHistoryApiFp(this.configuration).getInternetOperations(callCenterInternetOperationsRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CaptchaApi - axios parameter creator
 * @export
 */
export const CaptchaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get captcha image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptcha(options: any = {}): RequestArgs {
            const localVarPath = `/captcha`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate captcha
         * @param {ValidateCaptchaRequest} validateCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCaptcha(validateCaptchaRequest: ValidateCaptchaRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateCaptchaRequest' is not null or undefined
            if (validateCaptchaRequest === null || validateCaptchaRequest === undefined) {
                throw new RequiredError('validateCaptchaRequest','Required parameter validateCaptchaRequest was null or undefined when calling validateCaptcha.');
            }
            const localVarPath = `/captcha/validate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateCaptchaRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateCaptchaRequest !== undefined ? validateCaptchaRequest : {}) : (validateCaptchaRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaptchaApi - functional programming interface
 * @export
 */
export const CaptchaApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get captcha image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptcha(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaptchaResponse> {
            const localVarAxiosArgs = CaptchaApiAxiosParamCreator(configuration).getCaptcha(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate captcha
         * @param {ValidateCaptchaRequest} validateCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCaptcha(validateCaptchaRequest: ValidateCaptchaRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = CaptchaApiAxiosParamCreator(configuration).validateCaptcha(validateCaptchaRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CaptchaApi - factory interface
 * @export
 */
export const CaptchaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get captcha image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptcha(options?: any): AxiosPromise<CaptchaResponse> {
            return CaptchaApiFp(configuration).getCaptcha(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate captcha
         * @param {ValidateCaptchaRequest} validateCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCaptcha(validateCaptchaRequest: ValidateCaptchaRequest, options?: any): AxiosPromise<Response> {
            return CaptchaApiFp(configuration).validateCaptcha(validateCaptchaRequest, options)(axios, basePath);
        },
    };
};

/**
 * CaptchaApi - object-oriented interface
 * @export
 * @class CaptchaApi
 * @extends {BaseAPI}
 */
export class CaptchaApi extends BaseAPI {
    /**
     * 
     * @summary Get captcha image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptchaApi
     */
    public getCaptcha(options?: any) {
        return CaptchaApiFp(this.configuration).getCaptcha(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate captcha
     * @param {ValidateCaptchaRequest} validateCaptchaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptchaApi
     */
    public validateCaptcha(validateCaptchaRequest: ValidateCaptchaRequest, options?: any) {
        return CaptchaApiFp(this.configuration).validateCaptcha(validateCaptchaRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CardApi - axios parameter creator
 * @export
 */
export const CardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Card Customer Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCustomerInfo(options: any = {}): RequestArgs {
            const localVarPath = `/card/customer-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card List
         * @param {CardListRequest} cardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardList(cardListRequest: CardListRequest, options: any = {}): RequestArgs {
            // verify required parameter 'cardListRequest' is not null or undefined
            if (cardListRequest === null || cardListRequest === undefined) {
                throw new RequiredError('cardListRequest','Required parameter cardListRequest was null or undefined when calling getCardList.');
            }
            const localVarPath = `/card/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cardListRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cardListRequest !== undefined ? cardListRequest : {}) : (cardListRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Card current account list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccountsForCardApplication(options: any = {}): RequestArgs {
            const localVarPath = `/card/current-accounts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Embossed Card Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbossedCardInfo(options: any = {}): RequestArgs {
            const localVarPath = `/card/embossed-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Embossed Card Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNSPKConcentInfo(options: any = {}): RequestArgs {
            const localVarPath = `/card/nspk-concent-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Transferable Card Data
         * @param {TransferableCardListRequest} transferableCardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferableCardData(transferableCardListRequest: TransferableCardListRequest, options: any = {}): RequestArgs {
            // verify required parameter 'transferableCardListRequest' is not null or undefined
            if (transferableCardListRequest === null || transferableCardListRequest === undefined) {
                throw new RequiredError('transferableCardListRequest','Required parameter transferableCardListRequest was null or undefined when calling getTransferableCardData.');
            }
            const localVarPath = `/card/transferable/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transferableCardListRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transferableCardListRequest !== undefined ? transferableCardListRequest : {}) : (transferableCardListRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Card Application Info
         * @param {CardApplicationInfoValidationRequest} cardApplicationInfoValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCardApplicationInfo(cardApplicationInfoValidationRequest: CardApplicationInfoValidationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'cardApplicationInfoValidationRequest' is not null or undefined
            if (cardApplicationInfoValidationRequest === null || cardApplicationInfoValidationRequest === undefined) {
                throw new RequiredError('cardApplicationInfoValidationRequest','Required parameter cardApplicationInfoValidationRequest was null or undefined when calling validateCardApplicationInfo.');
            }
            const localVarPath = `/card/application-info-validation`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cardApplicationInfoValidationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cardApplicationInfoValidationRequest !== undefined ? cardApplicationInfoValidationRequest : {}) : (cardApplicationInfoValidationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardApi - functional programming interface
 * @export
 */
export const CardApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Card Customer Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCustomerInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardCustomerInfoResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).getCardCustomerInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Card List
         * @param {CardListRequest} cardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardList(cardListRequest: CardListRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardListResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).getCardList(cardListRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Card current account list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccountsForCardApplication(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardCurrentAccountsResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).getCurrentAccountsForCardApplication(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Embossed Card Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbossedCardInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardEmbossedInfoResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).getEmbossedCardInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Embossed Card Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNSPKConcentInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardNSPKConcentInfoResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).getNSPKConcentInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Transferable Card Data
         * @param {TransferableCardListRequest} transferableCardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferableCardData(transferableCardListRequest: TransferableCardListRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferableCardListResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).getTransferableCardData(transferableCardListRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate Card Application Info
         * @param {CardApplicationInfoValidationRequest} cardApplicationInfoValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCardApplicationInfo(cardApplicationInfoValidationRequest: CardApplicationInfoValidationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardApplicationInfoValidationResponse> {
            const localVarAxiosArgs = CardApiAxiosParamCreator(configuration).validateCardApplicationInfo(cardApplicationInfoValidationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CardApi - factory interface
 * @export
 */
export const CardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Card Customer Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCustomerInfo(options?: any): AxiosPromise<CardCustomerInfoResponse> {
            return CardApiFp(configuration).getCardCustomerInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Card List
         * @param {CardListRequest} cardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardList(cardListRequest: CardListRequest, options?: any): AxiosPromise<CardListResponse> {
            return CardApiFp(configuration).getCardList(cardListRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Card current account list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccountsForCardApplication(options?: any): AxiosPromise<CardCurrentAccountsResponse> {
            return CardApiFp(configuration).getCurrentAccountsForCardApplication(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Embossed Card Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbossedCardInfo(options?: any): AxiosPromise<CardEmbossedInfoResponse> {
            return CardApiFp(configuration).getEmbossedCardInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Embossed Card Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNSPKConcentInfo(options?: any): AxiosPromise<CardNSPKConcentInfoResponse> {
            return CardApiFp(configuration).getNSPKConcentInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Transferable Card Data
         * @param {TransferableCardListRequest} transferableCardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferableCardData(transferableCardListRequest: TransferableCardListRequest, options?: any): AxiosPromise<TransferableCardListResponse> {
            return CardApiFp(configuration).getTransferableCardData(transferableCardListRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate Card Application Info
         * @param {CardApplicationInfoValidationRequest} cardApplicationInfoValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCardApplicationInfo(cardApplicationInfoValidationRequest: CardApplicationInfoValidationRequest, options?: any): AxiosPromise<CardApplicationInfoValidationResponse> {
            return CardApiFp(configuration).validateCardApplicationInfo(cardApplicationInfoValidationRequest, options)(axios, basePath);
        },
    };
};

/**
 * CardApi - object-oriented interface
 * @export
 * @class CardApi
 * @extends {BaseAPI}
 */
export class CardApi extends BaseAPI {
    /**
     * 
     * @summary Get Card Customer Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getCardCustomerInfo(options?: any) {
        return CardApiFp(this.configuration).getCardCustomerInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Card List
     * @param {CardListRequest} cardListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getCardList(cardListRequest: CardListRequest, options?: any) {
        return CardApiFp(this.configuration).getCardList(cardListRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Card current account list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getCurrentAccountsForCardApplication(options?: any) {
        return CardApiFp(this.configuration).getCurrentAccountsForCardApplication(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Embossed Card Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getEmbossedCardInfo(options?: any) {
        return CardApiFp(this.configuration).getEmbossedCardInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Embossed Card Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getNSPKConcentInfo(options?: any) {
        return CardApiFp(this.configuration).getNSPKConcentInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Transferable Card Data
     * @param {TransferableCardListRequest} transferableCardListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getTransferableCardData(transferableCardListRequest: TransferableCardListRequest, options?: any) {
        return CardApiFp(this.configuration).getTransferableCardData(transferableCardListRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate Card Application Info
     * @param {CardApplicationInfoValidationRequest} cardApplicationInfoValidationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public validateCardApplicationInfo(cardApplicationInfoValidationRequest: CardApplicationInfoValidationRequest, options?: any) {
        return CardApiFp(this.configuration).validateCardApplicationInfo(cardApplicationInfoValidationRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CardApplicationApi - axios parameter creator
 * @export
 */
export const CardApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Card Application
         * @param {CardApplicationRequest} cardApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardApplication(cardApplicationRequest: CardApplicationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'cardApplicationRequest' is not null or undefined
            if (cardApplicationRequest === null || cardApplicationRequest === undefined) {
                throw new RequiredError('cardApplicationRequest','Required parameter cardApplicationRequest was null or undefined when calling generateCardApplication.');
            }
            const localVarPath = `/card-application/apply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cardApplicationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cardApplicationRequest !== undefined ? cardApplicationRequest : {}) : (cardApplicationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Card Application Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardApplicationDocument(options: any = {}): RequestArgs {
            const localVarPath = `/card-application/pre-apply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardApplicationApi - functional programming interface
 * @export
 */
export const CardApplicationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Card Application
         * @param {CardApplicationRequest} cardApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardApplication(cardApplicationRequest: CardApplicationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardApplicationResponse> {
            const localVarAxiosArgs = CardApplicationApiAxiosParamCreator(configuration).generateCardApplication(cardApplicationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generate Card Application Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardApplicationDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardPreApplicationResponse> {
            const localVarAxiosArgs = CardApplicationApiAxiosParamCreator(configuration).generateCardApplicationDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CardApplicationApi - factory interface
 * @export
 */
export const CardApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Generate Card Application
         * @param {CardApplicationRequest} cardApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardApplication(cardApplicationRequest: CardApplicationRequest, options?: any): AxiosPromise<CardApplicationResponse> {
            return CardApplicationApiFp(configuration).generateCardApplication(cardApplicationRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Generate Card Application Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardApplicationDocument(options?: any): AxiosPromise<CardPreApplicationResponse> {
            return CardApplicationApiFp(configuration).generateCardApplicationDocument(options)(axios, basePath);
        },
    };
};

/**
 * CardApplicationApi - object-oriented interface
 * @export
 * @class CardApplicationApi
 * @extends {BaseAPI}
 */
export class CardApplicationApi extends BaseAPI {
    /**
     * 
     * @summary Generate Card Application
     * @param {CardApplicationRequest} cardApplicationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApplicationApi
     */
    public generateCardApplication(cardApplicationRequest: CardApplicationRequest, options?: any) {
        return CardApplicationApiFp(this.configuration).generateCardApplication(cardApplicationRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Generate Card Application Document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApplicationApi
     */
    public generateCardApplicationDocument(options?: any) {
        return CardApplicationApiFp(this.configuration).generateCardApplicationDocument(options)(this.axios, this.basePath);
    }

}


/**
 * CardObservationApi - axios parameter creator
 * @export
 */
export const CardObservationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary set button visibility
         * @param {ObservationVisibilityRequest} observationVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationButtonVisibility(observationVisibilityRequest: ObservationVisibilityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'observationVisibilityRequest' is not null or undefined
            if (observationVisibilityRequest === null || observationVisibilityRequest === undefined) {
                throw new RequiredError('observationVisibilityRequest','Required parameter observationVisibilityRequest was null or undefined when calling getCardObservationButtonVisibility.');
            }
            const localVarPath = `/card-observation/visibility`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof observationVisibilityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(observationVisibilityRequest !== undefined ? observationVisibilityRequest : {}) : (observationVisibilityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary lists cards
         * @param {ObservationCardsRequest} observationCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationCards(observationCardsRequest: ObservationCardsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'observationCardsRequest' is not null or undefined
            if (observationCardsRequest === null || observationCardsRequest === undefined) {
                throw new RequiredError('observationCardsRequest','Required parameter observationCardsRequest was null or undefined when calling getCardObservationCards.');
            }
            const localVarPath = `/card-observation/cards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof observationCardsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(observationCardsRequest !== undefined ? observationCardsRequest : {}) : (observationCardsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get document id
         * @param {ObservationDocumentRequest} observationDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationDocumentId(observationDocumentRequest: ObservationDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'observationDocumentRequest' is not null or undefined
            if (observationDocumentRequest === null || observationDocumentRequest === undefined) {
                throw new RequiredError('observationDocumentRequest','Required parameter observationDocumentRequest was null or undefined when calling getCardObservationDocumentId.');
            }
            const localVarPath = `/card-observation/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof observationDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(observationDocumentRequest !== undefined ? observationDocumentRequest : {}) : (observationDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sign card document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationCardDocument(options: any = {}): RequestArgs {
            const localVarPath = `/card-observation/sign-card-document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sign digital card document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationDigitalCardDocument(options: any = {}): RequestArgs {
            const localVarPath = `/card-observation/sign-digital-card-document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sign product transfer document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationProductTransferDocument(options: any = {}): RequestArgs {
            const localVarPath = `/card-observation/sign-product-transfer-document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardObservationApi - functional programming interface
 * @export
 */
export const CardObservationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary set button visibility
         * @param {ObservationVisibilityRequest} observationVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationButtonVisibility(observationVisibilityRequest: ObservationVisibilityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationVisibilityResponse> {
            const localVarAxiosArgs = CardObservationApiAxiosParamCreator(configuration).getCardObservationButtonVisibility(observationVisibilityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary lists cards
         * @param {ObservationCardsRequest} observationCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationCards(observationCardsRequest: ObservationCardsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationCardsResponse> {
            const localVarAxiosArgs = CardObservationApiAxiosParamCreator(configuration).getCardObservationCards(observationCardsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get document id
         * @param {ObservationDocumentRequest} observationDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationDocumentId(observationDocumentRequest: ObservationDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationDocumentResponse> {
            const localVarAxiosArgs = CardObservationApiAxiosParamCreator(configuration).getCardObservationDocumentId(observationDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary sign card document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationCardDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignCardDocumentResponse> {
            const localVarAxiosArgs = CardObservationApiAxiosParamCreator(configuration).signCardObservationCardDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary sign digital card document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationDigitalCardDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignDigitalCardDocumentResponse> {
            const localVarAxiosArgs = CardObservationApiAxiosParamCreator(configuration).signCardObservationDigitalCardDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary sign product transfer document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationProductTransferDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignProductTransferDocumentResponse> {
            const localVarAxiosArgs = CardObservationApiAxiosParamCreator(configuration).signCardObservationProductTransferDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CardObservationApi - factory interface
 * @export
 */
export const CardObservationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary set button visibility
         * @param {ObservationVisibilityRequest} observationVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationButtonVisibility(observationVisibilityRequest: ObservationVisibilityRequest, options?: any): AxiosPromise<ObservationVisibilityResponse> {
            return CardObservationApiFp(configuration).getCardObservationButtonVisibility(observationVisibilityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary lists cards
         * @param {ObservationCardsRequest} observationCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationCards(observationCardsRequest: ObservationCardsRequest, options?: any): AxiosPromise<ObservationCardsResponse> {
            return CardObservationApiFp(configuration).getCardObservationCards(observationCardsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary get document id
         * @param {ObservationDocumentRequest} observationDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardObservationDocumentId(observationDocumentRequest: ObservationDocumentRequest, options?: any): AxiosPromise<ObservationDocumentResponse> {
            return CardObservationApiFp(configuration).getCardObservationDocumentId(observationDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary sign card document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationCardDocument(options?: any): AxiosPromise<SignCardDocumentResponse> {
            return CardObservationApiFp(configuration).signCardObservationCardDocument(options)(axios, basePath);
        },
        /**
         * 
         * @summary sign digital card document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationDigitalCardDocument(options?: any): AxiosPromise<SignDigitalCardDocumentResponse> {
            return CardObservationApiFp(configuration).signCardObservationDigitalCardDocument(options)(axios, basePath);
        },
        /**
         * 
         * @summary sign product transfer document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signCardObservationProductTransferDocument(options?: any): AxiosPromise<SignProductTransferDocumentResponse> {
            return CardObservationApiFp(configuration).signCardObservationProductTransferDocument(options)(axios, basePath);
        },
    };
};

/**
 * CardObservationApi - object-oriented interface
 * @export
 * @class CardObservationApi
 * @extends {BaseAPI}
 */
export class CardObservationApi extends BaseAPI {
    /**
     * 
     * @summary set button visibility
     * @param {ObservationVisibilityRequest} observationVisibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardObservationApi
     */
    public getCardObservationButtonVisibility(observationVisibilityRequest: ObservationVisibilityRequest, options?: any) {
        return CardObservationApiFp(this.configuration).getCardObservationButtonVisibility(observationVisibilityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary lists cards
     * @param {ObservationCardsRequest} observationCardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardObservationApi
     */
    public getCardObservationCards(observationCardsRequest: ObservationCardsRequest, options?: any) {
        return CardObservationApiFp(this.configuration).getCardObservationCards(observationCardsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get document id
     * @param {ObservationDocumentRequest} observationDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardObservationApi
     */
    public getCardObservationDocumentId(observationDocumentRequest: ObservationDocumentRequest, options?: any) {
        return CardObservationApiFp(this.configuration).getCardObservationDocumentId(observationDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary sign card document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardObservationApi
     */
    public signCardObservationCardDocument(options?: any) {
        return CardObservationApiFp(this.configuration).signCardObservationCardDocument(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary sign digital card document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardObservationApi
     */
    public signCardObservationDigitalCardDocument(options?: any) {
        return CardObservationApiFp(this.configuration).signCardObservationDigitalCardDocument(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary sign product transfer document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardObservationApi
     */
    public signCardObservationProductTransferDocument(options?: any) {
        return CardObservationApiFp(this.configuration).signCardObservationProductTransferDocument(options)(this.axios, this.basePath);
    }

}


/**
 * CardReissueApi - axios parameter creator
 * @export
 */
export const CardReissueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Apply card reissue
         * @param {ReissueCardsApplyRequest} reissueCardsApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCardReissue(reissueCardsApplyRequest: ReissueCardsApplyRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueCardsApplyRequest' is not null or undefined
            if (reissueCardsApplyRequest === null || reissueCardsApplyRequest === undefined) {
                throw new RequiredError('reissueCardsApplyRequest','Required parameter reissueCardsApplyRequest was null or undefined when calling applyCardReissue.');
            }
            const localVarPath = `/card-reissue/apply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueCardsApplyRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueCardsApplyRequest !== undefined ? reissueCardsApplyRequest : {}) : (reissueCardsApplyRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply digital card reissue
         * @param {ReissueDigitalCardsApplyRequest} reissueDigitalCardsApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDigitalCardReissue(reissueDigitalCardsApplyRequest: ReissueDigitalCardsApplyRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueDigitalCardsApplyRequest' is not null or undefined
            if (reissueDigitalCardsApplyRequest === null || reissueDigitalCardsApplyRequest === undefined) {
                throw new RequiredError('reissueDigitalCardsApplyRequest','Required parameter reissueDigitalCardsApplyRequest was null or undefined when calling applyDigitalCardReissue.');
            }
            const localVarPath = `/card-reissue/digital-cards-apply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueDigitalCardsApplyRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueDigitalCardsApplyRequest !== undefined ? reissueDigitalCardsApplyRequest : {}) : (reissueDigitalCardsApplyRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate card reissue form
         * @param {ReissueCardsDocumentRequest} reissueCardsDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardReissueForm(reissueCardsDocumentRequest: ReissueCardsDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueCardsDocumentRequest' is not null or undefined
            if (reissueCardsDocumentRequest === null || reissueCardsDocumentRequest === undefined) {
                throw new RequiredError('reissueCardsDocumentRequest','Required parameter reissueCardsDocumentRequest was null or undefined when calling generateCardReissueForm.');
            }
            const localVarPath = `/card-reissue/reissue-form`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueCardsDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueCardsDocumentRequest !== undefined ? reissueCardsDocumentRequest : {}) : (reissueCardsDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate card reissue sent form
         * @param {ReissueCardsSentDocumentRequest} reissueCardsSentDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardReissueSentForm(reissueCardsSentDocumentRequest: ReissueCardsSentDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueCardsSentDocumentRequest' is not null or undefined
            if (reissueCardsSentDocumentRequest === null || reissueCardsSentDocumentRequest === undefined) {
                throw new RequiredError('reissueCardsSentDocumentRequest','Required parameter reissueCardsSentDocumentRequest was null or undefined when calling generateCardReissueSentForm.');
            }
            const localVarPath = `/card-reissue/reissue-sent-form`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueCardsSentDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueCardsSentDocumentRequest !== undefined ? reissueCardsSentDocumentRequest : {}) : (reissueCardsSentDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cards
         * @param {ReissueCardsRequest} reissueCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsForReissue(reissueCardsRequest: ReissueCardsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueCardsRequest' is not null or undefined
            if (reissueCardsRequest === null || reissueCardsRequest === undefined) {
                throw new RequiredError('reissueCardsRequest','Required parameter reissueCardsRequest was null or undefined when calling getCardsForReissue.');
            }
            const localVarPath = `/card-reissue/cards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueCardsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueCardsRequest !== undefined ? reissueCardsRequest : {}) : (reissueCardsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cards sent
         * @param {ReissueCardsSentRequest} reissueCardsSentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsSentForReissue(reissueCardsSentRequest: ReissueCardsSentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueCardsSentRequest' is not null or undefined
            if (reissueCardsSentRequest === null || reissueCardsSentRequest === undefined) {
                throw new RequiredError('reissueCardsSentRequest','Required parameter reissueCardsSentRequest was null or undefined when calling getCardsSentForReissue.');
            }
            const localVarPath = `/card-reissue/cards-sent`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueCardsSentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueCardsSentRequest !== undefined ? reissueCardsSentRequest : {}) : (reissueCardsSentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get digital cards
         * @param {ReissueDigitalCardsRequest} reissueDigitalCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigitalCardsForReissue(reissueDigitalCardsRequest: ReissueDigitalCardsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueDigitalCardsRequest' is not null or undefined
            if (reissueDigitalCardsRequest === null || reissueDigitalCardsRequest === undefined) {
                throw new RequiredError('reissueDigitalCardsRequest','Required parameter reissueDigitalCardsRequest was null or undefined when calling getDigitalCardsForReissue.');
            }
            const localVarPath = `/card-reissue/digital-cards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueDigitalCardsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueDigitalCardsRequest !== undefined ? reissueDigitalCardsRequest : {}) : (reissueDigitalCardsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Fundamental Data
         * @param {ReissueFundamentalInfoRequest} reissueFundamentalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFundamentalInfoForReissue(reissueFundamentalInfoRequest: ReissueFundamentalInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'reissueFundamentalInfoRequest' is not null or undefined
            if (reissueFundamentalInfoRequest === null || reissueFundamentalInfoRequest === undefined) {
                throw new RequiredError('reissueFundamentalInfoRequest','Required parameter reissueFundamentalInfoRequest was null or undefined when calling getFundamentalInfoForReissue.');
            }
            const localVarPath = `/card-reissue/prepare-fundamental-data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reissueFundamentalInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reissueFundamentalInfoRequest !== undefined ? reissueFundamentalInfoRequest : {}) : (reissueFundamentalInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardReissueApi - functional programming interface
 * @export
 */
export const CardReissueApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Apply card reissue
         * @param {ReissueCardsApplyRequest} reissueCardsApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCardReissue(reissueCardsApplyRequest: ReissueCardsApplyRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueCardsApplyResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).applyCardReissue(reissueCardsApplyRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Apply digital card reissue
         * @param {ReissueDigitalCardsApplyRequest} reissueDigitalCardsApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDigitalCardReissue(reissueDigitalCardsApplyRequest: ReissueDigitalCardsApplyRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueDigitalCardsApplyResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).applyDigitalCardReissue(reissueDigitalCardsApplyRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generate card reissue form
         * @param {ReissueCardsDocumentRequest} reissueCardsDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardReissueForm(reissueCardsDocumentRequest: ReissueCardsDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueCardsDocumentResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).generateCardReissueForm(reissueCardsDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generate card reissue sent form
         * @param {ReissueCardsSentDocumentRequest} reissueCardsSentDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardReissueSentForm(reissueCardsSentDocumentRequest: ReissueCardsSentDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueCardsSentDocumentResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).generateCardReissueSentForm(reissueCardsSentDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get cards
         * @param {ReissueCardsRequest} reissueCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsForReissue(reissueCardsRequest: ReissueCardsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueCardsResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).getCardsForReissue(reissueCardsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get cards sent
         * @param {ReissueCardsSentRequest} reissueCardsSentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsSentForReissue(reissueCardsSentRequest: ReissueCardsSentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueCardsSentResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).getCardsSentForReissue(reissueCardsSentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get digital cards
         * @param {ReissueDigitalCardsRequest} reissueDigitalCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigitalCardsForReissue(reissueDigitalCardsRequest: ReissueDigitalCardsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueDigitalCardsResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).getDigitalCardsForReissue(reissueDigitalCardsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Card Fundamental Data
         * @param {ReissueFundamentalInfoRequest} reissueFundamentalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFundamentalInfoForReissue(reissueFundamentalInfoRequest: ReissueFundamentalInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueFundamentalInfoResponse> {
            const localVarAxiosArgs = CardReissueApiAxiosParamCreator(configuration).getFundamentalInfoForReissue(reissueFundamentalInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CardReissueApi - factory interface
 * @export
 */
export const CardReissueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Apply card reissue
         * @param {ReissueCardsApplyRequest} reissueCardsApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCardReissue(reissueCardsApplyRequest: ReissueCardsApplyRequest, options?: any): AxiosPromise<ReissueCardsApplyResponse> {
            return CardReissueApiFp(configuration).applyCardReissue(reissueCardsApplyRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Apply digital card reissue
         * @param {ReissueDigitalCardsApplyRequest} reissueDigitalCardsApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDigitalCardReissue(reissueDigitalCardsApplyRequest: ReissueDigitalCardsApplyRequest, options?: any): AxiosPromise<ReissueDigitalCardsApplyResponse> {
            return CardReissueApiFp(configuration).applyDigitalCardReissue(reissueDigitalCardsApplyRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Generate card reissue form
         * @param {ReissueCardsDocumentRequest} reissueCardsDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardReissueForm(reissueCardsDocumentRequest: ReissueCardsDocumentRequest, options?: any): AxiosPromise<ReissueCardsDocumentResponse> {
            return CardReissueApiFp(configuration).generateCardReissueForm(reissueCardsDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Generate card reissue sent form
         * @param {ReissueCardsSentDocumentRequest} reissueCardsSentDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardReissueSentForm(reissueCardsSentDocumentRequest: ReissueCardsSentDocumentRequest, options?: any): AxiosPromise<ReissueCardsSentDocumentResponse> {
            return CardReissueApiFp(configuration).generateCardReissueSentForm(reissueCardsSentDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get cards
         * @param {ReissueCardsRequest} reissueCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsForReissue(reissueCardsRequest: ReissueCardsRequest, options?: any): AxiosPromise<ReissueCardsResponse> {
            return CardReissueApiFp(configuration).getCardsForReissue(reissueCardsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get cards sent
         * @param {ReissueCardsSentRequest} reissueCardsSentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsSentForReissue(reissueCardsSentRequest: ReissueCardsSentRequest, options?: any): AxiosPromise<ReissueCardsSentResponse> {
            return CardReissueApiFp(configuration).getCardsSentForReissue(reissueCardsSentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get digital cards
         * @param {ReissueDigitalCardsRequest} reissueDigitalCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigitalCardsForReissue(reissueDigitalCardsRequest: ReissueDigitalCardsRequest, options?: any): AxiosPromise<ReissueDigitalCardsResponse> {
            return CardReissueApiFp(configuration).getDigitalCardsForReissue(reissueDigitalCardsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Card Fundamental Data
         * @param {ReissueFundamentalInfoRequest} reissueFundamentalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFundamentalInfoForReissue(reissueFundamentalInfoRequest: ReissueFundamentalInfoRequest, options?: any): AxiosPromise<ReissueFundamentalInfoResponse> {
            return CardReissueApiFp(configuration).getFundamentalInfoForReissue(reissueFundamentalInfoRequest, options)(axios, basePath);
        },
    };
};

/**
 * CardReissueApi - object-oriented interface
 * @export
 * @class CardReissueApi
 * @extends {BaseAPI}
 */
export class CardReissueApi extends BaseAPI {
    /**
     * 
     * @summary Apply card reissue
     * @param {ReissueCardsApplyRequest} reissueCardsApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public applyCardReissue(reissueCardsApplyRequest: ReissueCardsApplyRequest, options?: any) {
        return CardReissueApiFp(this.configuration).applyCardReissue(reissueCardsApplyRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Apply digital card reissue
     * @param {ReissueDigitalCardsApplyRequest} reissueDigitalCardsApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public applyDigitalCardReissue(reissueDigitalCardsApplyRequest: ReissueDigitalCardsApplyRequest, options?: any) {
        return CardReissueApiFp(this.configuration).applyDigitalCardReissue(reissueDigitalCardsApplyRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Generate card reissue form
     * @param {ReissueCardsDocumentRequest} reissueCardsDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public generateCardReissueForm(reissueCardsDocumentRequest: ReissueCardsDocumentRequest, options?: any) {
        return CardReissueApiFp(this.configuration).generateCardReissueForm(reissueCardsDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Generate card reissue sent form
     * @param {ReissueCardsSentDocumentRequest} reissueCardsSentDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public generateCardReissueSentForm(reissueCardsSentDocumentRequest: ReissueCardsSentDocumentRequest, options?: any) {
        return CardReissueApiFp(this.configuration).generateCardReissueSentForm(reissueCardsSentDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get cards
     * @param {ReissueCardsRequest} reissueCardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public getCardsForReissue(reissueCardsRequest: ReissueCardsRequest, options?: any) {
        return CardReissueApiFp(this.configuration).getCardsForReissue(reissueCardsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get cards sent
     * @param {ReissueCardsSentRequest} reissueCardsSentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public getCardsSentForReissue(reissueCardsSentRequest: ReissueCardsSentRequest, options?: any) {
        return CardReissueApiFp(this.configuration).getCardsSentForReissue(reissueCardsSentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get digital cards
     * @param {ReissueDigitalCardsRequest} reissueDigitalCardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public getDigitalCardsForReissue(reissueDigitalCardsRequest: ReissueDigitalCardsRequest, options?: any) {
        return CardReissueApiFp(this.configuration).getDigitalCardsForReissue(reissueDigitalCardsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Card Fundamental Data
     * @param {ReissueFundamentalInfoRequest} reissueFundamentalInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardReissueApi
     */
    public getFundamentalInfoForReissue(reissueFundamentalInfoRequest: ReissueFundamentalInfoRequest, options?: any) {
        return CardReissueApiFp(this.configuration).getFundamentalInfoForReissue(reissueFundamentalInfoRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CardSendingApi - axios parameter creator
 * @export
 */
export const CardSendingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary gives decision of which combo will be showed
         * @param {CardDeliveryComboRequest} cardDeliveryComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDeliveryCombo(cardDeliveryComboRequest: CardDeliveryComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'cardDeliveryComboRequest' is not null or undefined
            if (cardDeliveryComboRequest === null || cardDeliveryComboRequest === undefined) {
                throw new RequiredError('cardDeliveryComboRequest','Required parameter cardDeliveryComboRequest was null or undefined when calling getCardDeliveryCombo.');
            }
            const localVarPath = `/card-sending/delivery-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cardDeliveryComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cardDeliveryComboRequest !== undefined ? cardDeliveryComboRequest : {}) : (cardDeliveryComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get card sending page info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardSendingInfo(options: any = {}): RequestArgs {
            const localVarPath = `/card-sending/info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary after instant embossed flag is checked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantEmbossedParameters(options: any = {}): RequestArgs {
            const localVarPath = `/card-sending/instant-emboss`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary pos is for backoffice or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isBackOfficePos(options: any = {}): RequestArgs {
            const localVarPath = `/card-sending/is-backoffice-pos`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardSendingApi - functional programming interface
 * @export
 */
export const CardSendingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary gives decision of which combo will be showed
         * @param {CardDeliveryComboRequest} cardDeliveryComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDeliveryCombo(cardDeliveryComboRequest: CardDeliveryComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardDeliveryComboResponse> {
            const localVarAxiosArgs = CardSendingApiAxiosParamCreator(configuration).getCardDeliveryCombo(cardDeliveryComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get card sending page info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardSendingInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardSendingInfoResponse> {
            const localVarAxiosArgs = CardSendingApiAxiosParamCreator(configuration).getCardSendingInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary after instant embossed flag is checked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantEmbossedParameters(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstantEmbossResponse> {
            const localVarAxiosArgs = CardSendingApiAxiosParamCreator(configuration).getInstantEmbossedParameters(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary pos is for backoffice or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isBackOfficePos(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficePosResponse> {
            const localVarAxiosArgs = CardSendingApiAxiosParamCreator(configuration).isBackOfficePos(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CardSendingApi - factory interface
 * @export
 */
export const CardSendingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary gives decision of which combo will be showed
         * @param {CardDeliveryComboRequest} cardDeliveryComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDeliveryCombo(cardDeliveryComboRequest: CardDeliveryComboRequest, options?: any): AxiosPromise<CardDeliveryComboResponse> {
            return CardSendingApiFp(configuration).getCardDeliveryCombo(cardDeliveryComboRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary get card sending page info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardSendingInfo(options?: any): AxiosPromise<CardSendingInfoResponse> {
            return CardSendingApiFp(configuration).getCardSendingInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary after instant embossed flag is checked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantEmbossedParameters(options?: any): AxiosPromise<InstantEmbossResponse> {
            return CardSendingApiFp(configuration).getInstantEmbossedParameters(options)(axios, basePath);
        },
        /**
         * 
         * @summary pos is for backoffice or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isBackOfficePos(options?: any): AxiosPromise<BackOfficePosResponse> {
            return CardSendingApiFp(configuration).isBackOfficePos(options)(axios, basePath);
        },
    };
};

/**
 * CardSendingApi - object-oriented interface
 * @export
 * @class CardSendingApi
 * @extends {BaseAPI}
 */
export class CardSendingApi extends BaseAPI {
    /**
     * 
     * @summary gives decision of which combo will be showed
     * @param {CardDeliveryComboRequest} cardDeliveryComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSendingApi
     */
    public getCardDeliveryCombo(cardDeliveryComboRequest: CardDeliveryComboRequest, options?: any) {
        return CardSendingApiFp(this.configuration).getCardDeliveryCombo(cardDeliveryComboRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get card sending page info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSendingApi
     */
    public getCardSendingInfo(options?: any) {
        return CardSendingApiFp(this.configuration).getCardSendingInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary after instant embossed flag is checked
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSendingApi
     */
    public getInstantEmbossedParameters(options?: any) {
        return CardSendingApiFp(this.configuration).getInstantEmbossedParameters(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary pos is for backoffice or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSendingApi
     */
    public isBackOfficePos(options?: any) {
        return CardSendingApiFp(this.configuration).isBackOfficePos(options)(this.axios, this.basePath);
    }

}


/**
 * CardSendingPageValidationApi - axios parameter creator
 * @export
 */
export const CardSendingPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get card sending page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardSendingPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-card-sending-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate card sending page data
         * @param {ValidateCardSendingPageDataRequest} validateCardSendingPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCardSendingPageData(validateCardSendingPageDataRequest: ValidateCardSendingPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateCardSendingPageDataRequest' is not null or undefined
            if (validateCardSendingPageDataRequest === null || validateCardSendingPageDataRequest === undefined) {
                throw new RequiredError('validateCardSendingPageDataRequest','Required parameter validateCardSendingPageDataRequest was null or undefined when calling validateCardSendingPageData.');
            }
            const localVarPath = `/validate-card-sending-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateCardSendingPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateCardSendingPageDataRequest !== undefined ? validateCardSendingPageDataRequest : {}) : (validateCardSendingPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardSendingPageValidationApi - functional programming interface
 * @export
 */
export const CardSendingPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get card sending page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardSendingPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardSendingPageDataResponse> {
            const localVarAxiosArgs = CardSendingPageValidationApiAxiosParamCreator(configuration).getCardSendingPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate card sending page data
         * @param {ValidateCardSendingPageDataRequest} validateCardSendingPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCardSendingPageData(validateCardSendingPageDataRequest: ValidateCardSendingPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCardSendingPageDataResponse> {
            const localVarAxiosArgs = CardSendingPageValidationApiAxiosParamCreator(configuration).validateCardSendingPageData(validateCardSendingPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CardSendingPageValidationApi - factory interface
 * @export
 */
export const CardSendingPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get card sending page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardSendingPageData(options?: any): AxiosPromise<CardSendingPageDataResponse> {
            return CardSendingPageValidationApiFp(configuration).getCardSendingPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate card sending page data
         * @param {ValidateCardSendingPageDataRequest} validateCardSendingPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCardSendingPageData(validateCardSendingPageDataRequest: ValidateCardSendingPageDataRequest, options?: any): AxiosPromise<ValidateCardSendingPageDataResponse> {
            return CardSendingPageValidationApiFp(configuration).validateCardSendingPageData(validateCardSendingPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * CardSendingPageValidationApi - object-oriented interface
 * @export
 * @class CardSendingPageValidationApi
 * @extends {BaseAPI}
 */
export class CardSendingPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get card sending page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSendingPageValidationApi
     */
    public getCardSendingPageData(options?: any) {
        return CardSendingPageValidationApiFp(this.configuration).getCardSendingPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate card sending page data
     * @param {ValidateCardSendingPageDataRequest} validateCardSendingPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSendingPageValidationApi
     */
    public validateCardSendingPageData(validateCardSendingPageDataRequest: ValidateCardSendingPageDataRequest, options?: any) {
        return CardSendingPageValidationApiFp(this.configuration).validateCardSendingPageData(validateCardSendingPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ClientInfoChangeApi - axios parameter creator
 * @export
 */
export const ClientInfoChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer info change document
         * @param {ClientInfoDocumentRequest} clientInfoDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest: ClientInfoDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'clientInfoDocumentRequest' is not null or undefined
            if (clientInfoDocumentRequest === null || clientInfoDocumentRequest === undefined) {
                throw new RequiredError('clientInfoDocumentRequest','Required parameter clientInfoDocumentRequest was null or undefined when calling generateCustomerInfoChangeDocumentId.');
            }
            const localVarPath = `/client-info-change/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof clientInfoDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(clientInfoDocumentRequest !== undefined ? clientInfoDocumentRequest : {}) : (clientInfoDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Merge Client Name
         * @param {ClientInfoNameRequest} clientInfoNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientName(clientInfoNameRequest: ClientInfoNameRequest, options: any = {}): RequestArgs {
            // verify required parameter 'clientInfoNameRequest' is not null or undefined
            if (clientInfoNameRequest === null || clientInfoNameRequest === undefined) {
                throw new RequiredError('clientInfoNameRequest','Required parameter clientInfoNameRequest was null or undefined when calling getClientName.');
            }
            const localVarPath = `/client-info-change/client-name`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof clientInfoNameRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(clientInfoNameRequest !== undefined ? clientInfoNameRequest : {}) : (clientInfoNameRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update customer info
         * @param {ClientInfoUpdateRequest} clientInfoUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerInfo(clientInfoUpdateRequest: ClientInfoUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'clientInfoUpdateRequest' is not null or undefined
            if (clientInfoUpdateRequest === null || clientInfoUpdateRequest === undefined) {
                throw new RequiredError('clientInfoUpdateRequest','Required parameter clientInfoUpdateRequest was null or undefined when calling updateCustomerInfo.');
            }
            const localVarPath = `/client-info-change/customer-update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof clientInfoUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(clientInfoUpdateRequest !== undefined ? clientInfoUpdateRequest : {}) : (clientInfoUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientInfoChangeApi - functional programming interface
 * @export
 */
export const ClientInfoChangeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer info change document
         * @param {ClientInfoDocumentRequest} clientInfoDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest: ClientInfoDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoDocumentResponse> {
            const localVarAxiosArgs = ClientInfoChangeApiAxiosParamCreator(configuration).generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Merge Client Name
         * @param {ClientInfoNameRequest} clientInfoNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientName(clientInfoNameRequest: ClientInfoNameRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoNameResponse> {
            const localVarAxiosArgs = ClientInfoChangeApiAxiosParamCreator(configuration).getClientName(clientInfoNameRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update customer info
         * @param {ClientInfoUpdateRequest} clientInfoUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerInfo(clientInfoUpdateRequest: ClientInfoUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoUpdateResponse> {
            const localVarAxiosArgs = ClientInfoChangeApiAxiosParamCreator(configuration).updateCustomerInfo(clientInfoUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientInfoChangeApi - factory interface
 * @export
 */
export const ClientInfoChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get customer info change document
         * @param {ClientInfoDocumentRequest} clientInfoDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest: ClientInfoDocumentRequest, options?: any): AxiosPromise<ClientInfoDocumentResponse> {
            return ClientInfoChangeApiFp(configuration).generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Merge Client Name
         * @param {ClientInfoNameRequest} clientInfoNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientName(clientInfoNameRequest: ClientInfoNameRequest, options?: any): AxiosPromise<ClientInfoNameResponse> {
            return ClientInfoChangeApiFp(configuration).getClientName(clientInfoNameRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update customer info
         * @param {ClientInfoUpdateRequest} clientInfoUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerInfo(clientInfoUpdateRequest: ClientInfoUpdateRequest, options?: any): AxiosPromise<ClientInfoUpdateResponse> {
            return ClientInfoChangeApiFp(configuration).updateCustomerInfo(clientInfoUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * ClientInfoChangeApi - object-oriented interface
 * @export
 * @class ClientInfoChangeApi
 * @extends {BaseAPI}
 */
export class ClientInfoChangeApi extends BaseAPI {
    /**
     * 
     * @summary Get customer info change document
     * @param {ClientInfoDocumentRequest} clientInfoDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoChangeApi
     */
    public generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest: ClientInfoDocumentRequest, options?: any) {
        return ClientInfoChangeApiFp(this.configuration).generateCustomerInfoChangeDocumentId(clientInfoDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Merge Client Name
     * @param {ClientInfoNameRequest} clientInfoNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoChangeApi
     */
    public getClientName(clientInfoNameRequest: ClientInfoNameRequest, options?: any) {
        return ClientInfoChangeApiFp(this.configuration).getClientName(clientInfoNameRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update customer info
     * @param {ClientInfoUpdateRequest} clientInfoUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoChangeApi
     */
    public updateCustomerInfo(clientInfoUpdateRequest: ClientInfoUpdateRequest, options?: any) {
        return ClientInfoChangeApiFp(this.configuration).updateCustomerInfo(clientInfoUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ClientInfoDocumentPageValidationApi - axios parameter creator
 * @export
 */
export const ClientInfoDocumentPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get client info document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoDocumentPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-client-info-document-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate client info document page data
         * @param {ValidateClientInfoDocumentPageDataRequest} validateClientInfoDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest: ValidateClientInfoDocumentPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateClientInfoDocumentPageDataRequest' is not null or undefined
            if (validateClientInfoDocumentPageDataRequest === null || validateClientInfoDocumentPageDataRequest === undefined) {
                throw new RequiredError('validateClientInfoDocumentPageDataRequest','Required parameter validateClientInfoDocumentPageDataRequest was null or undefined when calling validateClientInfoDocumentPageData.');
            }
            const localVarPath = `/validate-client-info-document-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateClientInfoDocumentPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateClientInfoDocumentPageDataRequest !== undefined ? validateClientInfoDocumentPageDataRequest : {}) : (validateClientInfoDocumentPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientInfoDocumentPageValidationApi - functional programming interface
 * @export
 */
export const ClientInfoDocumentPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get client info document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoDocumentPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoDocumentPageDataResponse> {
            const localVarAxiosArgs = ClientInfoDocumentPageValidationApiAxiosParamCreator(configuration).getClientInfoDocumentPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate client info document page data
         * @param {ValidateClientInfoDocumentPageDataRequest} validateClientInfoDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest: ValidateClientInfoDocumentPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateClientInfoDocumentPageDataResponse> {
            const localVarAxiosArgs = ClientInfoDocumentPageValidationApiAxiosParamCreator(configuration).validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientInfoDocumentPageValidationApi - factory interface
 * @export
 */
export const ClientInfoDocumentPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get client info document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoDocumentPageData(options?: any): AxiosPromise<ClientInfoDocumentPageDataResponse> {
            return ClientInfoDocumentPageValidationApiFp(configuration).getClientInfoDocumentPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate client info document page data
         * @param {ValidateClientInfoDocumentPageDataRequest} validateClientInfoDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest: ValidateClientInfoDocumentPageDataRequest, options?: any): AxiosPromise<ValidateClientInfoDocumentPageDataResponse> {
            return ClientInfoDocumentPageValidationApiFp(configuration).validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ClientInfoDocumentPageValidationApi - object-oriented interface
 * @export
 * @class ClientInfoDocumentPageValidationApi
 * @extends {BaseAPI}
 */
export class ClientInfoDocumentPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get client info document page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoDocumentPageValidationApi
     */
    public getClientInfoDocumentPageData(options?: any) {
        return ClientInfoDocumentPageValidationApiFp(this.configuration).getClientInfoDocumentPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate client info document page data
     * @param {ValidateClientInfoDocumentPageDataRequest} validateClientInfoDocumentPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoDocumentPageValidationApi
     */
    public validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest: ValidateClientInfoDocumentPageDataRequest, options?: any) {
        return ClientInfoDocumentPageValidationApiFp(this.configuration).validateClientInfoDocumentPageData(validateClientInfoDocumentPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ClientInfoIndividualPageValidationApi - axios parameter creator
 * @export
 */
export const ClientInfoIndividualPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if client info can be updated
         * @param {CheckClientInfoIndividualRequest} checkClientInfoIndividualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkClientInfo(checkClientInfoIndividualRequest: CheckClientInfoIndividualRequest, options: any = {}): RequestArgs {
            // verify required parameter 'checkClientInfoIndividualRequest' is not null or undefined
            if (checkClientInfoIndividualRequest === null || checkClientInfoIndividualRequest === undefined) {
                throw new RequiredError('checkClientInfoIndividualRequest','Required parameter checkClientInfoIndividualRequest was null or undefined when calling checkClientInfo.');
            }
            const localVarPath = `/validate-client-info-individual-page/check`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof checkClientInfoIndividualRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(checkClientInfoIndividualRequest !== undefined ? checkClientInfoIndividualRequest : {}) : (checkClientInfoIndividualRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get client info individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoIndividualPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-client-info-individual-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate client info individual page data
         * @param {ValidateClientInfoIndividualPageDataRequest} validateClientInfoIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest: ValidateClientInfoIndividualPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateClientInfoIndividualPageDataRequest' is not null or undefined
            if (validateClientInfoIndividualPageDataRequest === null || validateClientInfoIndividualPageDataRequest === undefined) {
                throw new RequiredError('validateClientInfoIndividualPageDataRequest','Required parameter validateClientInfoIndividualPageDataRequest was null or undefined when calling validateClientInfoIndividualPageData.');
            }
            const localVarPath = `/validate-client-info-individual-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateClientInfoIndividualPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateClientInfoIndividualPageDataRequest !== undefined ? validateClientInfoIndividualPageDataRequest : {}) : (validateClientInfoIndividualPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientInfoIndividualPageValidationApi - functional programming interface
 * @export
 */
export const ClientInfoIndividualPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if client info can be updated
         * @param {CheckClientInfoIndividualRequest} checkClientInfoIndividualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkClientInfo(checkClientInfoIndividualRequest: CheckClientInfoIndividualRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckClientInfoIndividualResponse> {
            const localVarAxiosArgs = ClientInfoIndividualPageValidationApiAxiosParamCreator(configuration).checkClientInfo(checkClientInfoIndividualRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get client info individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoIndividualPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoIndividualPageDataResponse> {
            const localVarAxiosArgs = ClientInfoIndividualPageValidationApiAxiosParamCreator(configuration).getClientInfoIndividualPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate client info individual page data
         * @param {ValidateClientInfoIndividualPageDataRequest} validateClientInfoIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest: ValidateClientInfoIndividualPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateClientInfoIndividualPageDataResponse> {
            const localVarAxiosArgs = ClientInfoIndividualPageValidationApiAxiosParamCreator(configuration).validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientInfoIndividualPageValidationApi - factory interface
 * @export
 */
export const ClientInfoIndividualPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Check if client info can be updated
         * @param {CheckClientInfoIndividualRequest} checkClientInfoIndividualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkClientInfo(checkClientInfoIndividualRequest: CheckClientInfoIndividualRequest, options?: any): AxiosPromise<CheckClientInfoIndividualResponse> {
            return ClientInfoIndividualPageValidationApiFp(configuration).checkClientInfo(checkClientInfoIndividualRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get client info individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoIndividualPageData(options?: any): AxiosPromise<ClientInfoIndividualPageDataResponse> {
            return ClientInfoIndividualPageValidationApiFp(configuration).getClientInfoIndividualPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate client info individual page data
         * @param {ValidateClientInfoIndividualPageDataRequest} validateClientInfoIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest: ValidateClientInfoIndividualPageDataRequest, options?: any): AxiosPromise<ValidateClientInfoIndividualPageDataResponse> {
            return ClientInfoIndividualPageValidationApiFp(configuration).validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ClientInfoIndividualPageValidationApi - object-oriented interface
 * @export
 * @class ClientInfoIndividualPageValidationApi
 * @extends {BaseAPI}
 */
export class ClientInfoIndividualPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Check if client info can be updated
     * @param {CheckClientInfoIndividualRequest} checkClientInfoIndividualRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoIndividualPageValidationApi
     */
    public checkClientInfo(checkClientInfoIndividualRequest: CheckClientInfoIndividualRequest, options?: any) {
        return ClientInfoIndividualPageValidationApiFp(this.configuration).checkClientInfo(checkClientInfoIndividualRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get client info individual page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoIndividualPageValidationApi
     */
    public getClientInfoIndividualPageData(options?: any) {
        return ClientInfoIndividualPageValidationApiFp(this.configuration).getClientInfoIndividualPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate client info individual page data
     * @param {ValidateClientInfoIndividualPageDataRequest} validateClientInfoIndividualPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoIndividualPageValidationApi
     */
    public validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest: ValidateClientInfoIndividualPageDataRequest, options?: any) {
        return ClientInfoIndividualPageValidationApiFp(this.configuration).validateClientInfoIndividualPageData(validateClientInfoIndividualPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ClientInfoTaxPageValidationApi - axios parameter creator
 * @export
 */
export const ClientInfoTaxPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get client info tax page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoTaxPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-client-info-tax-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate client info tax page data
         * @param {ValidateClientInfoTaxPageDataRequest} validateClientInfoTaxPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest: ValidateClientInfoTaxPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateClientInfoTaxPageDataRequest' is not null or undefined
            if (validateClientInfoTaxPageDataRequest === null || validateClientInfoTaxPageDataRequest === undefined) {
                throw new RequiredError('validateClientInfoTaxPageDataRequest','Required parameter validateClientInfoTaxPageDataRequest was null or undefined when calling validateClientInfoTaxPageData.');
            }
            const localVarPath = `/validate-client-info-tax-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateClientInfoTaxPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateClientInfoTaxPageDataRequest !== undefined ? validateClientInfoTaxPageDataRequest : {}) : (validateClientInfoTaxPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientInfoTaxPageValidationApi - functional programming interface
 * @export
 */
export const ClientInfoTaxPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get client info tax page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoTaxPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoTaxPageDataResponse> {
            const localVarAxiosArgs = ClientInfoTaxPageValidationApiAxiosParamCreator(configuration).getClientInfoTaxPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate client info tax page data
         * @param {ValidateClientInfoTaxPageDataRequest} validateClientInfoTaxPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest: ValidateClientInfoTaxPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateClientInfoTaxPageDataResponse> {
            const localVarAxiosArgs = ClientInfoTaxPageValidationApiAxiosParamCreator(configuration).validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientInfoTaxPageValidationApi - factory interface
 * @export
 */
export const ClientInfoTaxPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get client info tax page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoTaxPageData(options?: any): AxiosPromise<ClientInfoTaxPageDataResponse> {
            return ClientInfoTaxPageValidationApiFp(configuration).getClientInfoTaxPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate client info tax page data
         * @param {ValidateClientInfoTaxPageDataRequest} validateClientInfoTaxPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest: ValidateClientInfoTaxPageDataRequest, options?: any): AxiosPromise<ValidateClientInfoTaxPageDataResponse> {
            return ClientInfoTaxPageValidationApiFp(configuration).validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ClientInfoTaxPageValidationApi - object-oriented interface
 * @export
 * @class ClientInfoTaxPageValidationApi
 * @extends {BaseAPI}
 */
export class ClientInfoTaxPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get client info tax page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoTaxPageValidationApi
     */
    public getClientInfoTaxPageData(options?: any) {
        return ClientInfoTaxPageValidationApiFp(this.configuration).getClientInfoTaxPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate client info tax page data
     * @param {ValidateClientInfoTaxPageDataRequest} validateClientInfoTaxPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientInfoTaxPageValidationApi
     */
    public validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest: ValidateClientInfoTaxPageDataRequest, options?: any) {
        return ClientInfoTaxPageValidationApiFp(this.configuration).validateClientInfoTaxPageData(validateClientInfoTaxPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ContactInfoChangeApi - axios parameter creator
 * @export
 */
export const ContactInfoChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate contact info change document
         * @param {ContactInfoChangeDocumentRequest} contactInfoChangeDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest: ContactInfoChangeDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'contactInfoChangeDocumentRequest' is not null or undefined
            if (contactInfoChangeDocumentRequest === null || contactInfoChangeDocumentRequest === undefined) {
                throw new RequiredError('contactInfoChangeDocumentRequest','Required parameter contactInfoChangeDocumentRequest was null or undefined when calling generateContactInfoChangeDocumentId.');
            }
            const localVarPath = `/contact-info-change/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contactInfoChangeDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contactInfoChangeDocumentRequest !== undefined ? contactInfoChangeDocumentRequest : {}) : (contactInfoChangeDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get phone number
         * @param {ContactInfoChangeRequest} contactInfoChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberForContactInfoChange(contactInfoChangeRequest: ContactInfoChangeRequest, options: any = {}): RequestArgs {
            // verify required parameter 'contactInfoChangeRequest' is not null or undefined
            if (contactInfoChangeRequest === null || contactInfoChangeRequest === undefined) {
                throw new RequiredError('contactInfoChangeRequest','Required parameter contactInfoChangeRequest was null or undefined when calling getPhoneNumberForContactInfoChange.');
            }
            const localVarPath = `/contact-info-change/phone-number`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contactInfoChangeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contactInfoChangeRequest !== undefined ? contactInfoChangeRequest : {}) : (contactInfoChangeRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update contact info change
         * @param {ContactInfoChangeUpdateRequest} contactInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfo(contactInfoChangeUpdateRequest: ContactInfoChangeUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'contactInfoChangeUpdateRequest' is not null or undefined
            if (contactInfoChangeUpdateRequest === null || contactInfoChangeUpdateRequest === undefined) {
                throw new RequiredError('contactInfoChangeUpdateRequest','Required parameter contactInfoChangeUpdateRequest was null or undefined when calling updateContactInfo.');
            }
            const localVarPath = `/contact-info-change/contact-update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contactInfoChangeUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contactInfoChangeUpdateRequest !== undefined ? contactInfoChangeUpdateRequest : {}) : (contactInfoChangeUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactInfoChangeApi - functional programming interface
 * @export
 */
export const ContactInfoChangeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate contact info change document
         * @param {ContactInfoChangeDocumentRequest} contactInfoChangeDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest: ContactInfoChangeDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoChangeDocumentResponse> {
            const localVarAxiosArgs = ContactInfoChangeApiAxiosParamCreator(configuration).generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get phone number
         * @param {ContactInfoChangeRequest} contactInfoChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberForContactInfoChange(contactInfoChangeRequest: ContactInfoChangeRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoChangeResponse> {
            const localVarAxiosArgs = ContactInfoChangeApiAxiosParamCreator(configuration).getPhoneNumberForContactInfoChange(contactInfoChangeRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update contact info change
         * @param {ContactInfoChangeUpdateRequest} contactInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfo(contactInfoChangeUpdateRequest: ContactInfoChangeUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoChangeUpdateResponse> {
            const localVarAxiosArgs = ContactInfoChangeApiAxiosParamCreator(configuration).updateContactInfo(contactInfoChangeUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContactInfoChangeApi - factory interface
 * @export
 */
export const ContactInfoChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Generate contact info change document
         * @param {ContactInfoChangeDocumentRequest} contactInfoChangeDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest: ContactInfoChangeDocumentRequest, options?: any): AxiosPromise<ContactInfoChangeDocumentResponse> {
            return ContactInfoChangeApiFp(configuration).generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get phone number
         * @param {ContactInfoChangeRequest} contactInfoChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberForContactInfoChange(contactInfoChangeRequest: ContactInfoChangeRequest, options?: any): AxiosPromise<ContactInfoChangeResponse> {
            return ContactInfoChangeApiFp(configuration).getPhoneNumberForContactInfoChange(contactInfoChangeRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update contact info change
         * @param {ContactInfoChangeUpdateRequest} contactInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfo(contactInfoChangeUpdateRequest: ContactInfoChangeUpdateRequest, options?: any): AxiosPromise<ContactInfoChangeUpdateResponse> {
            return ContactInfoChangeApiFp(configuration).updateContactInfo(contactInfoChangeUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * ContactInfoChangeApi - object-oriented interface
 * @export
 * @class ContactInfoChangeApi
 * @extends {BaseAPI}
 */
export class ContactInfoChangeApi extends BaseAPI {
    /**
     * 
     * @summary Generate contact info change document
     * @param {ContactInfoChangeDocumentRequest} contactInfoChangeDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoChangeApi
     */
    public generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest: ContactInfoChangeDocumentRequest, options?: any) {
        return ContactInfoChangeApiFp(this.configuration).generateContactInfoChangeDocumentId(contactInfoChangeDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get phone number
     * @param {ContactInfoChangeRequest} contactInfoChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoChangeApi
     */
    public getPhoneNumberForContactInfoChange(contactInfoChangeRequest: ContactInfoChangeRequest, options?: any) {
        return ContactInfoChangeApiFp(this.configuration).getPhoneNumberForContactInfoChange(contactInfoChangeRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update contact info change
     * @param {ContactInfoChangeUpdateRequest} contactInfoChangeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoChangeApi
     */
    public updateContactInfo(contactInfoChangeUpdateRequest: ContactInfoChangeUpdateRequest, options?: any) {
        return ContactInfoChangeApiFp(this.configuration).updateContactInfo(contactInfoChangeUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ContactInfoChangePageValidationApi - axios parameter creator
 * @export
 */
export const ContactInfoChangePageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact info change page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoChangePageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-contact-info-change-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate contact info change page data
         * @param {ValidateContactInfoChangePageDataRequest} validateContactInfoChangePageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoChangePageData(validateContactInfoChangePageDataRequest: ValidateContactInfoChangePageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateContactInfoChangePageDataRequest' is not null or undefined
            if (validateContactInfoChangePageDataRequest === null || validateContactInfoChangePageDataRequest === undefined) {
                throw new RequiredError('validateContactInfoChangePageDataRequest','Required parameter validateContactInfoChangePageDataRequest was null or undefined when calling validateContactInfoChangePageData.');
            }
            const localVarPath = `/validate-contact-info-change-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateContactInfoChangePageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateContactInfoChangePageDataRequest !== undefined ? validateContactInfoChangePageDataRequest : {}) : (validateContactInfoChangePageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactInfoChangePageValidationApi - functional programming interface
 * @export
 */
export const ContactInfoChangePageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact info change page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoChangePageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoChangePageDataResponse> {
            const localVarAxiosArgs = ContactInfoChangePageValidationApiAxiosParamCreator(configuration).getContactInfoChangePageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate contact info change page data
         * @param {ValidateContactInfoChangePageDataRequest} validateContactInfoChangePageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoChangePageData(validateContactInfoChangePageDataRequest: ValidateContactInfoChangePageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateContactInfoChangePageDataResponse> {
            const localVarAxiosArgs = ContactInfoChangePageValidationApiAxiosParamCreator(configuration).validateContactInfoChangePageData(validateContactInfoChangePageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContactInfoChangePageValidationApi - factory interface
 * @export
 */
export const ContactInfoChangePageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get contact info change page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoChangePageData(options?: any): AxiosPromise<ContactInfoChangePageDataResponse> {
            return ContactInfoChangePageValidationApiFp(configuration).getContactInfoChangePageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate contact info change page data
         * @param {ValidateContactInfoChangePageDataRequest} validateContactInfoChangePageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoChangePageData(validateContactInfoChangePageDataRequest: ValidateContactInfoChangePageDataRequest, options?: any): AxiosPromise<ValidateContactInfoChangePageDataResponse> {
            return ContactInfoChangePageValidationApiFp(configuration).validateContactInfoChangePageData(validateContactInfoChangePageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ContactInfoChangePageValidationApi - object-oriented interface
 * @export
 * @class ContactInfoChangePageValidationApi
 * @extends {BaseAPI}
 */
export class ContactInfoChangePageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get contact info change page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoChangePageValidationApi
     */
    public getContactInfoChangePageData(options?: any) {
        return ContactInfoChangePageValidationApiFp(this.configuration).getContactInfoChangePageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate contact info change page data
     * @param {ValidateContactInfoChangePageDataRequest} validateContactInfoChangePageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoChangePageValidationApi
     */
    public validateContactInfoChangePageData(validateContactInfoChangePageDataRequest: ValidateContactInfoChangePageDataRequest, options?: any) {
        return ContactInfoChangePageValidationApiFp(this.configuration).validateContactInfoChangePageData(validateContactInfoChangePageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ContactInfoIndividualPageValidationApi - axios parameter creator
 * @export
 */
export const ContactInfoIndividualPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if contact info can be updated
         * @param {CheckContactInfoIndividualRequest} checkContactInfoIndividualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContactInfo(checkContactInfoIndividualRequest: CheckContactInfoIndividualRequest, options: any = {}): RequestArgs {
            // verify required parameter 'checkContactInfoIndividualRequest' is not null or undefined
            if (checkContactInfoIndividualRequest === null || checkContactInfoIndividualRequest === undefined) {
                throw new RequiredError('checkContactInfoIndividualRequest','Required parameter checkContactInfoIndividualRequest was null or undefined when calling checkContactInfo.');
            }
            const localVarPath = `/validate-contact-info-individual-page/check`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof checkContactInfoIndividualRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(checkContactInfoIndividualRequest !== undefined ? checkContactInfoIndividualRequest : {}) : (checkContactInfoIndividualRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contact info individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoIndividualPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-contact-info-individual-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate contact info individual page data
         * @param {ValidateContactInfoIndividualPageDataRequest} validateContactInfoIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest: ValidateContactInfoIndividualPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateContactInfoIndividualPageDataRequest' is not null or undefined
            if (validateContactInfoIndividualPageDataRequest === null || validateContactInfoIndividualPageDataRequest === undefined) {
                throw new RequiredError('validateContactInfoIndividualPageDataRequest','Required parameter validateContactInfoIndividualPageDataRequest was null or undefined when calling validateContactInfoIndividualPageData.');
            }
            const localVarPath = `/validate-contact-info-individual-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateContactInfoIndividualPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateContactInfoIndividualPageDataRequest !== undefined ? validateContactInfoIndividualPageDataRequest : {}) : (validateContactInfoIndividualPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactInfoIndividualPageValidationApi - functional programming interface
 * @export
 */
export const ContactInfoIndividualPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if contact info can be updated
         * @param {CheckContactInfoIndividualRequest} checkContactInfoIndividualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContactInfo(checkContactInfoIndividualRequest: CheckContactInfoIndividualRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckContactInfoIndividualResponse> {
            const localVarAxiosArgs = ContactInfoIndividualPageValidationApiAxiosParamCreator(configuration).checkContactInfo(checkContactInfoIndividualRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get contact info individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoIndividualPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoIndividualPageDataResponse> {
            const localVarAxiosArgs = ContactInfoIndividualPageValidationApiAxiosParamCreator(configuration).getContactInfoIndividualPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate contact info individual page data
         * @param {ValidateContactInfoIndividualPageDataRequest} validateContactInfoIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest: ValidateContactInfoIndividualPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateContactInfoIndividualPageDataResponse> {
            const localVarAxiosArgs = ContactInfoIndividualPageValidationApiAxiosParamCreator(configuration).validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContactInfoIndividualPageValidationApi - factory interface
 * @export
 */
export const ContactInfoIndividualPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Check if contact info can be updated
         * @param {CheckContactInfoIndividualRequest} checkContactInfoIndividualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContactInfo(checkContactInfoIndividualRequest: CheckContactInfoIndividualRequest, options?: any): AxiosPromise<CheckContactInfoIndividualResponse> {
            return ContactInfoIndividualPageValidationApiFp(configuration).checkContactInfo(checkContactInfoIndividualRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get contact info individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoIndividualPageData(options?: any): AxiosPromise<ContactInfoIndividualPageDataResponse> {
            return ContactInfoIndividualPageValidationApiFp(configuration).getContactInfoIndividualPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate contact info individual page data
         * @param {ValidateContactInfoIndividualPageDataRequest} validateContactInfoIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest: ValidateContactInfoIndividualPageDataRequest, options?: any): AxiosPromise<ValidateContactInfoIndividualPageDataResponse> {
            return ContactInfoIndividualPageValidationApiFp(configuration).validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ContactInfoIndividualPageValidationApi - object-oriented interface
 * @export
 * @class ContactInfoIndividualPageValidationApi
 * @extends {BaseAPI}
 */
export class ContactInfoIndividualPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Check if contact info can be updated
     * @param {CheckContactInfoIndividualRequest} checkContactInfoIndividualRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoIndividualPageValidationApi
     */
    public checkContactInfo(checkContactInfoIndividualRequest: CheckContactInfoIndividualRequest, options?: any) {
        return ContactInfoIndividualPageValidationApiFp(this.configuration).checkContactInfo(checkContactInfoIndividualRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get contact info individual page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoIndividualPageValidationApi
     */
    public getContactInfoIndividualPageData(options?: any) {
        return ContactInfoIndividualPageValidationApiFp(this.configuration).getContactInfoIndividualPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate contact info individual page data
     * @param {ValidateContactInfoIndividualPageDataRequest} validateContactInfoIndividualPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoIndividualPageValidationApi
     */
    public validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest: ValidateContactInfoIndividualPageDataRequest, options?: any) {
        return ContactInfoIndividualPageValidationApiFp(this.configuration).validateContactInfoIndividualPageData(validateContactInfoIndividualPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ContactInfoPageValidationApi - axios parameter creator
 * @export
 */
export const ContactInfoPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-contact-info-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate contact info page data
         * @param {ValidateContactInfoPageDataRequest} validateContactInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoPageData(validateContactInfoPageDataRequest: ValidateContactInfoPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateContactInfoPageDataRequest' is not null or undefined
            if (validateContactInfoPageDataRequest === null || validateContactInfoPageDataRequest === undefined) {
                throw new RequiredError('validateContactInfoPageDataRequest','Required parameter validateContactInfoPageDataRequest was null or undefined when calling validateContactInfoPageData.');
            }
            const localVarPath = `/validate-contact-info-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateContactInfoPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateContactInfoPageDataRequest !== undefined ? validateContactInfoPageDataRequest : {}) : (validateContactInfoPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactInfoPageValidationApi - functional programming interface
 * @export
 */
export const ContactInfoPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoPageDataResponse> {
            const localVarAxiosArgs = ContactInfoPageValidationApiAxiosParamCreator(configuration).getContactInfoPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate contact info page data
         * @param {ValidateContactInfoPageDataRequest} validateContactInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoPageData(validateContactInfoPageDataRequest: ValidateContactInfoPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateContactInfoPageDataResponse> {
            const localVarAxiosArgs = ContactInfoPageValidationApiAxiosParamCreator(configuration).validateContactInfoPageData(validateContactInfoPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContactInfoPageValidationApi - factory interface
 * @export
 */
export const ContactInfoPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get contact info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoPageData(options?: any): AxiosPromise<ContactInfoPageDataResponse> {
            return ContactInfoPageValidationApiFp(configuration).getContactInfoPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate contact info page data
         * @param {ValidateContactInfoPageDataRequest} validateContactInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactInfoPageData(validateContactInfoPageDataRequest: ValidateContactInfoPageDataRequest, options?: any): AxiosPromise<ValidateContactInfoPageDataResponse> {
            return ContactInfoPageValidationApiFp(configuration).validateContactInfoPageData(validateContactInfoPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ContactInfoPageValidationApi - object-oriented interface
 * @export
 * @class ContactInfoPageValidationApi
 * @extends {BaseAPI}
 */
export class ContactInfoPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get contact info page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoPageValidationApi
     */
    public getContactInfoPageData(options?: any) {
        return ContactInfoPageValidationApiFp(this.configuration).getContactInfoPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate contact info page data
     * @param {ValidateContactInfoPageDataRequest} validateContactInfoPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactInfoPageValidationApi
     */
    public validateContactInfoPageData(validateContactInfoPageDataRequest: ValidateContactInfoPageDataRequest, options?: any) {
        return ContactInfoPageValidationApiFp(this.configuration).validateContactInfoPageData(validateContactInfoPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CreditApi - axios parameter creator
 * @export
 */
export const CreditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search Credit
         * @param {SearchCreditRequest} searchCreditRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits(searchCreditRequest: SearchCreditRequest, options: any = {}): RequestArgs {
            // verify required parameter 'searchCreditRequest' is not null or undefined
            if (searchCreditRequest === null || searchCreditRequest === undefined) {
                throw new RequiredError('searchCreditRequest','Required parameter searchCreditRequest was null or undefined when calling getCredits.');
            }
            const localVarPath = `/credit/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof searchCreditRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(searchCreditRequest !== undefined ? searchCreditRequest : {}) : (searchCreditRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditApi - functional programming interface
 * @export
 */
export const CreditApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search Credit
         * @param {SearchCreditRequest} searchCreditRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits(searchCreditRequest: SearchCreditRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchCreditResponse> {
            const localVarAxiosArgs = CreditApiAxiosParamCreator(configuration).getCredits(searchCreditRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CreditApi - factory interface
 * @export
 */
export const CreditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Search Credit
         * @param {SearchCreditRequest} searchCreditRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits(searchCreditRequest: SearchCreditRequest, options?: any): AxiosPromise<SearchCreditResponse> {
            return CreditApiFp(configuration).getCredits(searchCreditRequest, options)(axios, basePath);
        },
    };
};

/**
 * CreditApi - object-oriented interface
 * @export
 * @class CreditApi
 * @extends {BaseAPI}
 */
export class CreditApi extends BaseAPI {
    /**
     * 
     * @summary Search Credit
     * @param {SearchCreditRequest} searchCreditRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditApi
     */
    public getCredits(searchCreditRequest: SearchCreditRequest, options?: any) {
        return CreditApiFp(this.configuration).getCredits(searchCreditRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary View All Account Observation
         * @param {AllAccountObservationRequest} allAccountObservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAccountObservation(allAccountObservationRequest: AllAccountObservationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'allAccountObservationRequest' is not null or undefined
            if (allAccountObservationRequest === null || allAccountObservationRequest === undefined) {
                throw new RequiredError('allAccountObservationRequest','Required parameter allAccountObservationRequest was null or undefined when calling getAllAccountObservation.');
            }
            const localVarPath = `/customer-all-account-observation`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof allAccountObservationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(allAccountObservationRequest !== undefined ? allAccountObservationRequest : {}) : (allAccountObservationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Customer Address
         * @param {CustomerAddressRequest} customerAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAddress(customerAddressRequest: CustomerAddressRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerAddressRequest' is not null or undefined
            if (customerAddressRequest === null || customerAddressRequest === undefined) {
                throw new RequiredError('customerAddressRequest','Required parameter customerAddressRequest was null or undefined when calling getCustomerAddress.');
            }
            const localVarPath = `/customer/address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerAddressRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerAddressRequest !== undefined ? customerAddressRequest : {}) : (customerAddressRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Customer Address region by rfCode
         * @param {string} rfCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAddressRegionCodeByRfCode(rfCode: string, options: any = {}): RequestArgs {
            // verify required parameter 'rfCode' is not null or undefined
            if (rfCode === null || rfCode === undefined) {
                throw new RequiredError('rfCode','Required parameter rfCode was null or undefined when calling getCustomerAddressRegionCodeByRfCode.');
            }
            const localVarPath = `/customer/address/region/{rfCode}`
                .replace(`{${"rfCode"}}`, encodeURIComponent(String(rfCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Customer Contact Info
         * @param {CustomerContactInfoRequest} customerContactInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContactInfo(customerContactInfoRequest: CustomerContactInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerContactInfoRequest' is not null or undefined
            if (customerContactInfoRequest === null || customerContactInfoRequest === undefined) {
                throw new RequiredError('customerContactInfoRequest','Required parameter customerContactInfoRequest was null or undefined when calling getCustomerContactInfo.');
            }
            const localVarPath = `/customer/contact-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerContactInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerContactInfoRequest !== undefined ? customerContactInfoRequest : {}) : (customerContactInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Customer Details For Card Application
         * @param {CustomerDetailForCardApplicationRequest} customerDetailForCardApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest: CustomerDetailForCardApplicationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerDetailForCardApplicationRequest' is not null or undefined
            if (customerDetailForCardApplicationRequest === null || customerDetailForCardApplicationRequest === undefined) {
                throw new RequiredError('customerDetailForCardApplicationRequest','Required parameter customerDetailForCardApplicationRequest was null or undefined when calling getCustomerDetailForCardApplication.');
            }
            const localVarPath = `/customer/card-application-details`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerDetailForCardApplicationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerDetailForCardApplicationRequest !== undefined ? customerDetailForCardApplicationRequest : {}) : (customerDetailForCardApplicationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Customer Details For Loan Application
         * @param {CustomerDetailForLoanApplicationRequest} customerDetailForLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest: CustomerDetailForLoanApplicationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerDetailForLoanApplicationRequest' is not null or undefined
            if (customerDetailForLoanApplicationRequest === null || customerDetailForLoanApplicationRequest === undefined) {
                throw new RequiredError('customerDetailForLoanApplicationRequest','Required parameter customerDetailForLoanApplicationRequest was null or undefined when calling getCustomerDetailForLoanApplication.');
            }
            const localVarPath = `/customer/loan-application-details`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerDetailForLoanApplicationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerDetailForLoanApplicationRequest !== undefined ? customerDetailForLoanApplicationRequest : {}) : (customerDetailForLoanApplicationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Customer Detail Info Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailInfo(options: any = {}): RequestArgs {
            const localVarPath = `/customer/detail-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer Identity Info
         * @param {CustomerIdentityRequest} customerIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerIdentities(customerIdentityRequest: CustomerIdentityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerIdentityRequest' is not null or undefined
            if (customerIdentityRequest === null || customerIdentityRequest === undefined) {
                throw new RequiredError('customerIdentityRequest','Required parameter customerIdentityRequest was null or undefined when calling getCustomerIdentities.');
            }
            const localVarPath = `/customer/identity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerIdentityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerIdentityRequest !== undefined ? customerIdentityRequest : {}) : (customerIdentityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loan Customer Contact Info
         * @param {LoanCustomerContactInfoRequest} loanCustomerContactInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoanContactInfo(loanCustomerContactInfoRequest: LoanCustomerContactInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanCustomerContactInfoRequest' is not null or undefined
            if (loanCustomerContactInfoRequest === null || loanCustomerContactInfoRequest === undefined) {
                throw new RequiredError('loanCustomerContactInfoRequest','Required parameter loanCustomerContactInfoRequest was null or undefined when calling getCustomerLoanContactInfo.');
            }
            const localVarPath = `/customer/loan-contact-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanCustomerContactInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanCustomerContactInfoRequest !== undefined ? loanCustomerContactInfoRequest : {}) : (loanCustomerContactInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Customer
         * @param {SearchCustomerRequest} searchCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(searchCustomerRequest: SearchCustomerRequest, options: any = {}): RequestArgs {
            // verify required parameter 'searchCustomerRequest' is not null or undefined
            if (searchCustomerRequest === null || searchCustomerRequest === undefined) {
                throw new RequiredError('searchCustomerRequest','Required parameter searchCustomerRequest was null or undefined when calling getCustomers.');
            }
            const localVarPath = `/customer/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof searchCustomerRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(searchCustomerRequest !== undefined ? searchCustomerRequest : {}) : (searchCustomerRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loan Customer Detail Info Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerDetailInfo(options: any = {}): RequestArgs {
            const localVarPath = `/customer/loan-detail-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary View All Account Observation
         * @param {AllAccountObservationRequest} allAccountObservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAccountObservation(allAccountObservationRequest: AllAccountObservationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllAccountObservationResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getAllAccountObservation(allAccountObservationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Customer Address
         * @param {CustomerAddressRequest} customerAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAddress(customerAddressRequest: CustomerAddressRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAddressResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerAddress(customerAddressRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Customer Address region by rfCode
         * @param {string} rfCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAddressRegionCodeByRfCode(rfCode: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAddressRegionResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerAddressRegionCodeByRfCode(rfCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Customer Contact Info
         * @param {CustomerContactInfoRequest} customerContactInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContactInfo(customerContactInfoRequest: CustomerContactInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerContactInfoResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerContactInfo(customerContactInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Customer Details For Card Application
         * @param {CustomerDetailForCardApplicationRequest} customerDetailForCardApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest: CustomerDetailForCardApplicationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailForCardApplicationResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Customer Details For Loan Application
         * @param {CustomerDetailForLoanApplicationRequest} customerDetailForLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest: CustomerDetailForLoanApplicationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailForLoanApplicationResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Customer Detail Info Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailInfoResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerDetailInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Customer Identity Info
         * @param {CustomerIdentityRequest} customerIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerIdentities(customerIdentityRequest: CustomerIdentityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerIdentityResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerIdentities(customerIdentityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Loan Customer Contact Info
         * @param {LoanCustomerContactInfoRequest} loanCustomerContactInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoanContactInfo(loanCustomerContactInfoRequest: LoanCustomerContactInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCustomerContactInfoResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomerLoanContactInfo(loanCustomerContactInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Search Customer
         * @param {SearchCustomerRequest} searchCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(searchCustomerRequest: SearchCustomerRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchCustomerResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getCustomers(searchCustomerRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Loan Customer Detail Info Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerDetailInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerLoanDetailInfoResponse> {
            const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).getLoanCustomerDetailInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary View All Account Observation
         * @param {AllAccountObservationRequest} allAccountObservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAccountObservation(allAccountObservationRequest: AllAccountObservationRequest, options?: any): AxiosPromise<AllAccountObservationResponse> {
            return CustomerApiFp(configuration).getAllAccountObservation(allAccountObservationRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Customer Address
         * @param {CustomerAddressRequest} customerAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAddress(customerAddressRequest: CustomerAddressRequest, options?: any): AxiosPromise<CustomerAddressResponse> {
            return CustomerApiFp(configuration).getCustomerAddress(customerAddressRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Customer Address region by rfCode
         * @param {string} rfCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAddressRegionCodeByRfCode(rfCode: string, options?: any): AxiosPromise<CustomerAddressRegionResponse> {
            return CustomerApiFp(configuration).getCustomerAddressRegionCodeByRfCode(rfCode, options)(axios, basePath);
        },
        /**
         * 
         * @summary Customer Contact Info
         * @param {CustomerContactInfoRequest} customerContactInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContactInfo(customerContactInfoRequest: CustomerContactInfoRequest, options?: any): AxiosPromise<CustomerContactInfoResponse> {
            return CustomerApiFp(configuration).getCustomerContactInfo(customerContactInfoRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Customer Details For Card Application
         * @param {CustomerDetailForCardApplicationRequest} customerDetailForCardApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest: CustomerDetailForCardApplicationRequest, options?: any): AxiosPromise<CustomerDetailForCardApplicationResponse> {
            return CustomerApiFp(configuration).getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Customer Details For Loan Application
         * @param {CustomerDetailForLoanApplicationRequest} customerDetailForLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest: CustomerDetailForLoanApplicationRequest, options?: any): AxiosPromise<CustomerDetailForLoanApplicationResponse> {
            return CustomerApiFp(configuration).getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Customer Detail Info Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailInfo(options?: any): AxiosPromise<CustomerDetailInfoResponse> {
            return CustomerApiFp(configuration).getCustomerDetailInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Customer Identity Info
         * @param {CustomerIdentityRequest} customerIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerIdentities(customerIdentityRequest: CustomerIdentityRequest, options?: any): AxiosPromise<CustomerIdentityResponse> {
            return CustomerApiFp(configuration).getCustomerIdentities(customerIdentityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Loan Customer Contact Info
         * @param {LoanCustomerContactInfoRequest} loanCustomerContactInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoanContactInfo(loanCustomerContactInfoRequest: LoanCustomerContactInfoRequest, options?: any): AxiosPromise<LoanCustomerContactInfoResponse> {
            return CustomerApiFp(configuration).getCustomerLoanContactInfo(loanCustomerContactInfoRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Search Customer
         * @param {SearchCustomerRequest} searchCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(searchCustomerRequest: SearchCustomerRequest, options?: any): AxiosPromise<SearchCustomerResponse> {
            return CustomerApiFp(configuration).getCustomers(searchCustomerRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Loan Customer Detail Info Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerDetailInfo(options?: any): AxiosPromise<CustomerLoanDetailInfoResponse> {
            return CustomerApiFp(configuration).getLoanCustomerDetailInfo(options)(axios, basePath);
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @summary View All Account Observation
     * @param {AllAccountObservationRequest} allAccountObservationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getAllAccountObservation(allAccountObservationRequest: AllAccountObservationRequest, options?: any) {
        return CustomerApiFp(this.configuration).getAllAccountObservation(allAccountObservationRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Customer Address
     * @param {CustomerAddressRequest} customerAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerAddress(customerAddressRequest: CustomerAddressRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerAddress(customerAddressRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Customer Address region by rfCode
     * @param {string} rfCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerAddressRegionCodeByRfCode(rfCode: string, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerAddressRegionCodeByRfCode(rfCode, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Customer Contact Info
     * @param {CustomerContactInfoRequest} customerContactInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerContactInfo(customerContactInfoRequest: CustomerContactInfoRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerContactInfo(customerContactInfoRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Customer Details For Card Application
     * @param {CustomerDetailForCardApplicationRequest} customerDetailForCardApplicationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest: CustomerDetailForCardApplicationRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerDetailForCardApplication(customerDetailForCardApplicationRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Customer Details For Loan Application
     * @param {CustomerDetailForLoanApplicationRequest} customerDetailForLoanApplicationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest: CustomerDetailForLoanApplicationRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerDetailForLoanApplication(customerDetailForLoanApplicationRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Customer Detail Info Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerDetailInfo(options?: any) {
        return CustomerApiFp(this.configuration).getCustomerDetailInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Customer Identity Info
     * @param {CustomerIdentityRequest} customerIdentityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerIdentities(customerIdentityRequest: CustomerIdentityRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerIdentities(customerIdentityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Loan Customer Contact Info
     * @param {LoanCustomerContactInfoRequest} loanCustomerContactInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerLoanContactInfo(loanCustomerContactInfoRequest: LoanCustomerContactInfoRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomerLoanContactInfo(loanCustomerContactInfoRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Search Customer
     * @param {SearchCustomerRequest} searchCustomerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomers(searchCustomerRequest: SearchCustomerRequest, options?: any) {
        return CustomerApiFp(this.configuration).getCustomers(searchCustomerRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Loan Customer Detail Info Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getLoanCustomerDetailInfo(options?: any) {
        return CustomerApiFp(this.configuration).getLoanCustomerDetailInfo(options)(this.axios, this.basePath);
    }

}


/**
 * CustomerContactInfoApi - axios parameter creator
 * @export
 */
export const CustomerContactInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get customer contact info format
         * @param {CustomerContactInfoFormatRequest} customerContactInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContactInfoFormat(customerContactInfoFormatRequest: CustomerContactInfoFormatRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerContactInfoFormatRequest' is not null or undefined
            if (customerContactInfoFormatRequest === null || customerContactInfoFormatRequest === undefined) {
                throw new RequiredError('customerContactInfoFormatRequest','Required parameter customerContactInfoFormatRequest was null or undefined when calling getCustomerContactInfoFormat.');
            }
            const localVarPath = `/customer-contact-info/format`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerContactInfoFormatRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerContactInfoFormatRequest !== undefined ? customerContactInfoFormatRequest : {}) : (customerContactInfoFormatRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerContactInfoApi - functional programming interface
 * @export
 */
export const CustomerContactInfoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get customer contact info format
         * @param {CustomerContactInfoFormatRequest} customerContactInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContactInfoFormat(customerContactInfoFormatRequest: CustomerContactInfoFormatRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerContactInfoFormatResponse> {
            const localVarAxiosArgs = CustomerContactInfoApiAxiosParamCreator(configuration).getCustomerContactInfoFormat(customerContactInfoFormatRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerContactInfoApi - factory interface
 * @export
 */
export const CustomerContactInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary get customer contact info format
         * @param {CustomerContactInfoFormatRequest} customerContactInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContactInfoFormat(customerContactInfoFormatRequest: CustomerContactInfoFormatRequest, options?: any): AxiosPromise<CustomerContactInfoFormatResponse> {
            return CustomerContactInfoApiFp(configuration).getCustomerContactInfoFormat(customerContactInfoFormatRequest, options)(axios, basePath);
        },
    };
};

/**
 * CustomerContactInfoApi - object-oriented interface
 * @export
 * @class CustomerContactInfoApi
 * @extends {BaseAPI}
 */
export class CustomerContactInfoApi extends BaseAPI {
    /**
     * 
     * @summary get customer contact info format
     * @param {CustomerContactInfoFormatRequest} customerContactInfoFormatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerContactInfoApi
     */
    public getCustomerContactInfoFormat(customerContactInfoFormatRequest: CustomerContactInfoFormatRequest, options?: any) {
        return CustomerContactInfoApiFp(this.configuration).getCustomerContactInfoFormat(customerContactInfoFormatRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CustomerDetailPageValidationApi - axios parameter creator
 * @export
 */
export const CustomerDetailPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer detail page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-customer-detail-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate customer detail page data
         * @param {ValidateCustomerDetailPageDataRequest} validateCustomerDetailPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerDetailPageData(validateCustomerDetailPageDataRequest: ValidateCustomerDetailPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateCustomerDetailPageDataRequest' is not null or undefined
            if (validateCustomerDetailPageDataRequest === null || validateCustomerDetailPageDataRequest === undefined) {
                throw new RequiredError('validateCustomerDetailPageDataRequest','Required parameter validateCustomerDetailPageDataRequest was null or undefined when calling validateCustomerDetailPageData.');
            }
            const localVarPath = `/validate-customer-detail-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateCustomerDetailPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateCustomerDetailPageDataRequest !== undefined ? validateCustomerDetailPageDataRequest : {}) : (validateCustomerDetailPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerDetailPageValidationApi - functional programming interface
 * @export
 */
export const CustomerDetailPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer detail page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailPageDataResponse> {
            const localVarAxiosArgs = CustomerDetailPageValidationApiAxiosParamCreator(configuration).getCustomerDetailPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate customer detail page data
         * @param {ValidateCustomerDetailPageDataRequest} validateCustomerDetailPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerDetailPageData(validateCustomerDetailPageDataRequest: ValidateCustomerDetailPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCustomerDetailPageDataResponse> {
            const localVarAxiosArgs = CustomerDetailPageValidationApiAxiosParamCreator(configuration).validateCustomerDetailPageData(validateCustomerDetailPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerDetailPageValidationApi - factory interface
 * @export
 */
export const CustomerDetailPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get customer detail page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetailPageData(options?: any): AxiosPromise<CustomerDetailPageDataResponse> {
            return CustomerDetailPageValidationApiFp(configuration).getCustomerDetailPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate customer detail page data
         * @param {ValidateCustomerDetailPageDataRequest} validateCustomerDetailPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerDetailPageData(validateCustomerDetailPageDataRequest: ValidateCustomerDetailPageDataRequest, options?: any): AxiosPromise<ValidateCustomerDetailPageDataResponse> {
            return CustomerDetailPageValidationApiFp(configuration).validateCustomerDetailPageData(validateCustomerDetailPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * CustomerDetailPageValidationApi - object-oriented interface
 * @export
 * @class CustomerDetailPageValidationApi
 * @extends {BaseAPI}
 */
export class CustomerDetailPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get customer detail page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDetailPageValidationApi
     */
    public getCustomerDetailPageData(options?: any) {
        return CustomerDetailPageValidationApiFp(this.configuration).getCustomerDetailPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate customer detail page data
     * @param {ValidateCustomerDetailPageDataRequest} validateCustomerDetailPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDetailPageValidationApi
     */
    public validateCustomerDetailPageData(validateCustomerDetailPageDataRequest: ValidateCustomerDetailPageDataRequest, options?: any) {
        return CustomerDetailPageValidationApiFp(this.configuration).validateCustomerDetailPageData(validateCustomerDetailPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CustomerLoanTaxInfoApi - axios parameter creator
 * @export
 */
export const CustomerLoanTaxInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Customer Loan Tax Information
         * @param {CustomerLoanTaxInformationRequest} customerLoanTaxInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoanTaxInfo(customerLoanTaxInformationRequest: CustomerLoanTaxInformationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerLoanTaxInformationRequest' is not null or undefined
            if (customerLoanTaxInformationRequest === null || customerLoanTaxInformationRequest === undefined) {
                throw new RequiredError('customerLoanTaxInformationRequest','Required parameter customerLoanTaxInformationRequest was null or undefined when calling getCustomerLoanTaxInfo.');
            }
            const localVarPath = `/customer-loan-tax-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerLoanTaxInformationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerLoanTaxInformationRequest !== undefined ? customerLoanTaxInformationRequest : {}) : (customerLoanTaxInformationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerLoanTaxInfoApi - functional programming interface
 * @export
 */
export const CustomerLoanTaxInfoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Customer Loan Tax Information
         * @param {CustomerLoanTaxInformationRequest} customerLoanTaxInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoanTaxInfo(customerLoanTaxInformationRequest: CustomerLoanTaxInformationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerLoanTaxInformationResponse> {
            const localVarAxiosArgs = CustomerLoanTaxInfoApiAxiosParamCreator(configuration).getCustomerLoanTaxInfo(customerLoanTaxInformationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerLoanTaxInfoApi - factory interface
 * @export
 */
export const CustomerLoanTaxInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Customer Loan Tax Information
         * @param {CustomerLoanTaxInformationRequest} customerLoanTaxInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoanTaxInfo(customerLoanTaxInformationRequest: CustomerLoanTaxInformationRequest, options?: any): AxiosPromise<CustomerLoanTaxInformationResponse> {
            return CustomerLoanTaxInfoApiFp(configuration).getCustomerLoanTaxInfo(customerLoanTaxInformationRequest, options)(axios, basePath);
        },
    };
};

/**
 * CustomerLoanTaxInfoApi - object-oriented interface
 * @export
 * @class CustomerLoanTaxInfoApi
 * @extends {BaseAPI}
 */
export class CustomerLoanTaxInfoApi extends BaseAPI {
    /**
     * 
     * @summary Customer Loan Tax Information
     * @param {CustomerLoanTaxInformationRequest} customerLoanTaxInformationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerLoanTaxInfoApi
     */
    public getCustomerLoanTaxInfo(customerLoanTaxInformationRequest: CustomerLoanTaxInformationRequest, options?: any) {
        return CustomerLoanTaxInfoApiFp(this.configuration).getCustomerLoanTaxInfo(customerLoanTaxInformationRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CustomerOperationsApi - axios parameter creator
 * @export
 */
export const CustomerOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(options: any = {}): RequestArgs {
            const localVarPath = `/customer-operations/create`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(options: any = {}): RequestArgs {
            const localVarPath = `/customer-operations/update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerOperationsApi - functional programming interface
 * @export
 */
export const CustomerOperationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreateResponse> {
            const localVarAxiosArgs = CustomerOperationsApiAxiosParamCreator(configuration).createCustomer(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerUpdateResponse> {
            const localVarAxiosArgs = CustomerOperationsApiAxiosParamCreator(configuration).updateCustomer(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerOperationsApi - factory interface
 * @export
 */
export const CustomerOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(options?: any): AxiosPromise<CustomerCreateResponse> {
            return CustomerOperationsApiFp(configuration).createCustomer(options)(axios, basePath);
        },
        /**
         * 
         * @summary Update Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(options?: any): AxiosPromise<CustomerUpdateResponse> {
            return CustomerOperationsApiFp(configuration).updateCustomer(options)(axios, basePath);
        },
    };
};

/**
 * CustomerOperationsApi - object-oriented interface
 * @export
 * @class CustomerOperationsApi
 * @extends {BaseAPI}
 */
export class CustomerOperationsApi extends BaseAPI {
    /**
     * 
     * @summary Create Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerOperationsApi
     */
    public createCustomer(options?: any) {
        return CustomerOperationsApiFp(this.configuration).createCustomer(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerOperationsApi
     */
    public updateCustomer(options?: any) {
        return CustomerOperationsApiFp(this.configuration).updateCustomer(options)(this.axios, this.basePath);
    }

}


/**
 * CustomerTaxInfoApi - axios parameter creator
 * @export
 */
export const CustomerTaxInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Customer Tax Information
         * @param {CustomerTaxInformationRequest} customerTaxInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTaxInfo(customerTaxInformationRequest: CustomerTaxInformationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerTaxInformationRequest' is not null or undefined
            if (customerTaxInformationRequest === null || customerTaxInformationRequest === undefined) {
                throw new RequiredError('customerTaxInformationRequest','Required parameter customerTaxInformationRequest was null or undefined when calling getCustomerTaxInfo.');
            }
            const localVarPath = `/customer-tax-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerTaxInformationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerTaxInformationRequest !== undefined ? customerTaxInformationRequest : {}) : (customerTaxInformationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get customer tax info format
         * @param {CustomerTaxInfoFormatRequest} customerTaxInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTaxInfoFormat(customerTaxInfoFormatRequest: CustomerTaxInfoFormatRequest, options: any = {}): RequestArgs {
            // verify required parameter 'customerTaxInfoFormatRequest' is not null or undefined
            if (customerTaxInfoFormatRequest === null || customerTaxInfoFormatRequest === undefined) {
                throw new RequiredError('customerTaxInfoFormatRequest','Required parameter customerTaxInfoFormatRequest was null or undefined when calling getCustomerTaxInfoFormat.');
            }
            const localVarPath = `/customer-tax-info/format`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customerTaxInfoFormatRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customerTaxInfoFormatRequest !== undefined ? customerTaxInfoFormatRequest : {}) : (customerTaxInfoFormatRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validate customer tax info format
         * @param {ValidateCustomerTaxInfoFormatRequest} validateCustomerTaxInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest: ValidateCustomerTaxInfoFormatRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateCustomerTaxInfoFormatRequest' is not null or undefined
            if (validateCustomerTaxInfoFormatRequest === null || validateCustomerTaxInfoFormatRequest === undefined) {
                throw new RequiredError('validateCustomerTaxInfoFormatRequest','Required parameter validateCustomerTaxInfoFormatRequest was null or undefined when calling validateCustomerTaxInfoFormat.');
            }
            const localVarPath = `/customer-tax-info/validate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateCustomerTaxInfoFormatRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateCustomerTaxInfoFormatRequest !== undefined ? validateCustomerTaxInfoFormatRequest : {}) : (validateCustomerTaxInfoFormatRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerTaxInfoApi - functional programming interface
 * @export
 */
export const CustomerTaxInfoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Customer Tax Information
         * @param {CustomerTaxInformationRequest} customerTaxInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTaxInfo(customerTaxInformationRequest: CustomerTaxInformationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerTaxInformationResponse> {
            const localVarAxiosArgs = CustomerTaxInfoApiAxiosParamCreator(configuration).getCustomerTaxInfo(customerTaxInformationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get customer tax info format
         * @param {CustomerTaxInfoFormatRequest} customerTaxInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTaxInfoFormat(customerTaxInfoFormatRequest: CustomerTaxInfoFormatRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerTaxInfoFormatResponse> {
            const localVarAxiosArgs = CustomerTaxInfoApiAxiosParamCreator(configuration).getCustomerTaxInfoFormat(customerTaxInfoFormatRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary validate customer tax info format
         * @param {ValidateCustomerTaxInfoFormatRequest} validateCustomerTaxInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest: ValidateCustomerTaxInfoFormatRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCustomerTaxInfoFormatResponse> {
            const localVarAxiosArgs = CustomerTaxInfoApiAxiosParamCreator(configuration).validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerTaxInfoApi - factory interface
 * @export
 */
export const CustomerTaxInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Customer Tax Information
         * @param {CustomerTaxInformationRequest} customerTaxInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTaxInfo(customerTaxInformationRequest: CustomerTaxInformationRequest, options?: any): AxiosPromise<CustomerTaxInformationResponse> {
            return CustomerTaxInfoApiFp(configuration).getCustomerTaxInfo(customerTaxInformationRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary get customer tax info format
         * @param {CustomerTaxInfoFormatRequest} customerTaxInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTaxInfoFormat(customerTaxInfoFormatRequest: CustomerTaxInfoFormatRequest, options?: any): AxiosPromise<CustomerTaxInfoFormatResponse> {
            return CustomerTaxInfoApiFp(configuration).getCustomerTaxInfoFormat(customerTaxInfoFormatRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary validate customer tax info format
         * @param {ValidateCustomerTaxInfoFormatRequest} validateCustomerTaxInfoFormatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest: ValidateCustomerTaxInfoFormatRequest, options?: any): AxiosPromise<ValidateCustomerTaxInfoFormatResponse> {
            return CustomerTaxInfoApiFp(configuration).validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest, options)(axios, basePath);
        },
    };
};

/**
 * CustomerTaxInfoApi - object-oriented interface
 * @export
 * @class CustomerTaxInfoApi
 * @extends {BaseAPI}
 */
export class CustomerTaxInfoApi extends BaseAPI {
    /**
     * 
     * @summary Customer Tax Information
     * @param {CustomerTaxInformationRequest} customerTaxInformationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerTaxInfoApi
     */
    public getCustomerTaxInfo(customerTaxInformationRequest: CustomerTaxInformationRequest, options?: any) {
        return CustomerTaxInfoApiFp(this.configuration).getCustomerTaxInfo(customerTaxInformationRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get customer tax info format
     * @param {CustomerTaxInfoFormatRequest} customerTaxInfoFormatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerTaxInfoApi
     */
    public getCustomerTaxInfoFormat(customerTaxInfoFormatRequest: CustomerTaxInfoFormatRequest, options?: any) {
        return CustomerTaxInfoApiFp(this.configuration).getCustomerTaxInfoFormat(customerTaxInfoFormatRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary validate customer tax info format
     * @param {ValidateCustomerTaxInfoFormatRequest} validateCustomerTaxInfoFormatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerTaxInfoApi
     */
    public validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest: ValidateCustomerTaxInfoFormatRequest, options?: any) {
        return CustomerTaxInfoApiFp(this.configuration).validateCustomerTaxInfoFormat(validateCustomerTaxInfoFormatRequest, options)(this.axios, this.basePath);
    }

}


/**
 * CustomerThirdPartyApi - axios parameter creator
 * @export
 */
export const CustomerThirdPartyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Third Party Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThirdPartyPageValidationParameters(documentType: string, options: any = {}): RequestArgs {
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling getThirdPartyPageValidationParameters.');
            }
            const localVarPath = `/customer-third-party/validation-components/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerThirdPartyApi - functional programming interface
 * @export
 */
export const CustomerThirdPartyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Third Party Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThirdPartyPageValidationParameters(documentType: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThirdPartyPageValidationComponentsResponse> {
            const localVarAxiosArgs = CustomerThirdPartyApiAxiosParamCreator(configuration).getThirdPartyPageValidationParameters(documentType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerThirdPartyApi - factory interface
 * @export
 */
export const CustomerThirdPartyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Third Party Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThirdPartyPageValidationParameters(documentType: string, options?: any): AxiosPromise<ThirdPartyPageValidationComponentsResponse> {
            return CustomerThirdPartyApiFp(configuration).getThirdPartyPageValidationParameters(documentType, options)(axios, basePath);
        },
    };
};

/**
 * CustomerThirdPartyApi - object-oriented interface
 * @export
 * @class CustomerThirdPartyApi
 * @extends {BaseAPI}
 */
export class CustomerThirdPartyApi extends BaseAPI {
    /**
     * 
     * @summary Third Party Page Validation Components
     * @param {string} documentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerThirdPartyApi
     */
    public getThirdPartyPageValidationParameters(documentType: string, options?: any) {
        return CustomerThirdPartyApiFp(this.configuration).getThirdPartyPageValidationParameters(documentType, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Document
         * @param {DeleteDocumentRequest} deleteDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(deleteDocumentRequest: DeleteDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'deleteDocumentRequest' is not null or undefined
            if (deleteDocumentRequest === null || deleteDocumentRequest === undefined) {
                throw new RequiredError('deleteDocumentRequest','Required parameter deleteDocumentRequest was null or undefined when calling deleteDocument.');
            }
            const localVarPath = `/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deleteDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deleteDocumentRequest !== undefined ? deleteDocumentRequest : {}) : (deleteDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Document
         * @param {GetDocumentRequest} getDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentData(getDocumentRequest: GetDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'getDocumentRequest' is not null or undefined
            if (getDocumentRequest === null || getDocumentRequest === undefined) {
                throw new RequiredError('getDocumentRequest','Required parameter getDocumentRequest was null or undefined when calling getDocumentData.');
            }
            const localVarPath = `/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof getDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(getDocumentRequest !== undefined ? getDocumentRequest : {}) : (getDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Document Page Validation Components
         * @param {string} documentType 
         * @param {DocumentPageValidationComponentsRequest} documentPageValidationComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPageComponentsValidation(documentType: string, documentPageValidationComponentsRequest: DocumentPageValidationComponentsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling getDocumentPageComponentsValidation.');
            }
            // verify required parameter 'documentPageValidationComponentsRequest' is not null or undefined
            if (documentPageValidationComponentsRequest === null || documentPageValidationComponentsRequest === undefined) {
                throw new RequiredError('documentPageValidationComponentsRequest','Required parameter documentPageValidationComponentsRequest was null or undefined when calling getDocumentPageComponentsValidation.');
            }
            const localVarPath = `/document/components-validation/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentPageValidationComponentsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentPageValidationComponentsRequest !== undefined ? documentPageValidationComponentsRequest : {}) : (documentPageValidationComponentsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Document Type
         * @param {DocumentTypeRequest} documentTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTypeByScreenType(documentTypeRequest: DocumentTypeRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentTypeRequest' is not null or undefined
            if (documentTypeRequest === null || documentTypeRequest === undefined) {
                throw new RequiredError('documentTypeRequest','Required parameter documentTypeRequest was null or undefined when calling getDocumentTypeByScreenType.');
            }
            const localVarPath = `/document/type-get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentTypeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentTypeRequest !== undefined ? documentTypeRequest : {}) : (documentTypeRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Document
         * @param {SearchDocumentRequest} searchDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(searchDocumentRequest: SearchDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'searchDocumentRequest' is not null or undefined
            if (searchDocumentRequest === null || searchDocumentRequest === undefined) {
                throw new RequiredError('searchDocumentRequest','Required parameter searchDocumentRequest was null or undefined when calling getDocuments.');
            }
            const localVarPath = `/document/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof searchDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(searchDocumentRequest !== undefined ? searchDocumentRequest : {}) : (searchDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Document
         * @param {UpdateDocumentRequest} updateDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(updateDocumentRequest: UpdateDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'updateDocumentRequest' is not null or undefined
            if (updateDocumentRequest === null || updateDocumentRequest === undefined) {
                throw new RequiredError('updateDocumentRequest','Required parameter updateDocumentRequest was null or undefined when calling updateDocument.');
            }
            const localVarPath = `/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateDocumentRequest !== undefined ? updateDocumentRequest : {}) : (updateDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Card Application Form
         * @param {any} file Uploaded file
         * @param {string} [customerId] Customer Oid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardApplicationDocument(file: any, customerId?: string, options: any = {}): RequestArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadCardApplicationDocument.');
            }
            const localVarPath = `/document/upload/card-application`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (customerId !== undefined) { 
                localVarFormParams.append('customerId', customerId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Document
         * @param {any} file Uploaded file
         * @param {string} documentType Document Type
         * @param {string} uploadType Upload Type
         * @param {string} [explanation] User free explanation text
         * @param {string} [customerId] Customer Oid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocuments(file: any, documentType: string, uploadType: string, explanation?: string, customerId?: string, options: any = {}): RequestArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadDocuments.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling uploadDocuments.');
            }
            // verify required parameter 'uploadType' is not null or undefined
            if (uploadType === null || uploadType === undefined) {
                throw new RequiredError('uploadType','Required parameter uploadType was null or undefined when calling uploadDocuments.');
            }
            const localVarPath = `/document/upload`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (documentType !== undefined) { 
                localVarFormParams.append('documentType', documentType as any);
            }
    
            if (explanation !== undefined) { 
                localVarFormParams.append('explanation', explanation as any);
            }
    
            if (customerId !== undefined) { 
                localVarFormParams.append('customerId', customerId as any);
            }
    
            if (uploadType !== undefined) { 
                localVarFormParams.append('uploadType', uploadType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Document
         * @param {DeleteDocumentRequest} deleteDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(deleteDocumentRequest: DeleteDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).deleteDocument(deleteDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Document
         * @param {GetDocumentRequest} getDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentData(getDocumentRequest: GetDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDocumentResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).getDocumentData(getDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Document Page Validation Components
         * @param {string} documentType 
         * @param {DocumentPageValidationComponentsRequest} documentPageValidationComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPageComponentsValidation(documentType: string, documentPageValidationComponentsRequest: DocumentPageValidationComponentsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPageValidationComponentsResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).getDocumentPageComponentsValidation(documentType, documentPageValidationComponentsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Document Type
         * @param {DocumentTypeRequest} documentTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTypeByScreenType(documentTypeRequest: DocumentTypeRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).getDocumentTypeByScreenType(documentTypeRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Search Document
         * @param {SearchDocumentRequest} searchDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(searchDocumentRequest: SearchDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDocumentResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).getDocuments(searchDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update Document
         * @param {UpdateDocumentRequest} updateDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(updateDocumentRequest: UpdateDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDocumentResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).updateDocument(updateDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload Card Application Form
         * @param {any} file Uploaded file
         * @param {string} [customerId] Customer Oid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardApplicationDocument(file: any, customerId?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadCardApplicationDocumentResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).uploadCardApplicationDocument(file, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload Document
         * @param {any} file Uploaded file
         * @param {string} documentType Document Type
         * @param {string} uploadType Upload Type
         * @param {string} [explanation] User free explanation text
         * @param {string} [customerId] Customer Oid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocuments(file: any, documentType: string, uploadType: string, explanation?: string, customerId?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDocumentResponse> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).uploadDocuments(file, documentType, uploadType, explanation, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete Document
         * @param {DeleteDocumentRequest} deleteDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(deleteDocumentRequest: DeleteDocumentRequest, options?: any): AxiosPromise<Response> {
            return DocumentApiFp(configuration).deleteDocument(deleteDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Document
         * @param {GetDocumentRequest} getDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentData(getDocumentRequest: GetDocumentRequest, options?: any): AxiosPromise<GetDocumentResponse> {
            return DocumentApiFp(configuration).getDocumentData(getDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Document Page Validation Components
         * @param {string} documentType 
         * @param {DocumentPageValidationComponentsRequest} documentPageValidationComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPageComponentsValidation(documentType: string, documentPageValidationComponentsRequest: DocumentPageValidationComponentsRequest, options?: any): AxiosPromise<DocumentPageValidationComponentsResponse> {
            return DocumentApiFp(configuration).getDocumentPageComponentsValidation(documentType, documentPageValidationComponentsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Document Type
         * @param {DocumentTypeRequest} documentTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTypeByScreenType(documentTypeRequest: DocumentTypeRequest, options?: any): AxiosPromise<DocumentTypeResponse> {
            return DocumentApiFp(configuration).getDocumentTypeByScreenType(documentTypeRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Search Document
         * @param {SearchDocumentRequest} searchDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(searchDocumentRequest: SearchDocumentRequest, options?: any): AxiosPromise<SearchDocumentResponse> {
            return DocumentApiFp(configuration).getDocuments(searchDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update Document
         * @param {UpdateDocumentRequest} updateDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(updateDocumentRequest: UpdateDocumentRequest, options?: any): AxiosPromise<UpdateDocumentResponse> {
            return DocumentApiFp(configuration).updateDocument(updateDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Upload Card Application Form
         * @param {any} file Uploaded file
         * @param {string} [customerId] Customer Oid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardApplicationDocument(file: any, customerId?: string, options?: any): AxiosPromise<UploadCardApplicationDocumentResponse> {
            return DocumentApiFp(configuration).uploadCardApplicationDocument(file, customerId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Upload Document
         * @param {any} file Uploaded file
         * @param {string} documentType Document Type
         * @param {string} uploadType Upload Type
         * @param {string} [explanation] User free explanation text
         * @param {string} [customerId] Customer Oid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocuments(file: any, documentType: string, uploadType: string, explanation?: string, customerId?: string, options?: any): AxiosPromise<UploadDocumentResponse> {
            return DocumentApiFp(configuration).uploadDocuments(file, documentType, uploadType, explanation, customerId, options)(axios, basePath);
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @summary Delete Document
     * @param {DeleteDocumentRequest} deleteDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public deleteDocument(deleteDocumentRequest: DeleteDocumentRequest, options?: any) {
        return DocumentApiFp(this.configuration).deleteDocument(deleteDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Document
     * @param {GetDocumentRequest} getDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentData(getDocumentRequest: GetDocumentRequest, options?: any) {
        return DocumentApiFp(this.configuration).getDocumentData(getDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Document Page Validation Components
     * @param {string} documentType 
     * @param {DocumentPageValidationComponentsRequest} documentPageValidationComponentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentPageComponentsValidation(documentType: string, documentPageValidationComponentsRequest: DocumentPageValidationComponentsRequest, options?: any) {
        return DocumentApiFp(this.configuration).getDocumentPageComponentsValidation(documentType, documentPageValidationComponentsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Document Type
     * @param {DocumentTypeRequest} documentTypeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentTypeByScreenType(documentTypeRequest: DocumentTypeRequest, options?: any) {
        return DocumentApiFp(this.configuration).getDocumentTypeByScreenType(documentTypeRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Search Document
     * @param {SearchDocumentRequest} searchDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocuments(searchDocumentRequest: SearchDocumentRequest, options?: any) {
        return DocumentApiFp(this.configuration).getDocuments(searchDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update Document
     * @param {UpdateDocumentRequest} updateDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public updateDocument(updateDocumentRequest: UpdateDocumentRequest, options?: any) {
        return DocumentApiFp(this.configuration).updateDocument(updateDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Upload Card Application Form
     * @param {any} file Uploaded file
     * @param {string} [customerId] Customer Oid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public uploadCardApplicationDocument(file: any, customerId?: string, options?: any) {
        return DocumentApiFp(this.configuration).uploadCardApplicationDocument(file, customerId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Upload Document
     * @param {any} file Uploaded file
     * @param {string} documentType Document Type
     * @param {string} uploadType Upload Type
     * @param {string} [explanation] User free explanation text
     * @param {string} [customerId] Customer Oid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public uploadDocuments(file: any, documentType: string, uploadType: string, explanation?: string, customerId?: string, options?: any) {
        return DocumentApiFp(this.configuration).uploadDocuments(file, documentType, uploadType, explanation, customerId, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentLinkParameterApi - axios parameter creator
 * @export
 */
export const DocumentLinkParameterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Document Links by Parameter Name
         * @param {DocumentLinkParameterRequest} documentLinkParameterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentLinkByParameter(documentLinkParameterRequest: DocumentLinkParameterRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentLinkParameterRequest' is not null or undefined
            if (documentLinkParameterRequest === null || documentLinkParameterRequest === undefined) {
                throw new RequiredError('documentLinkParameterRequest','Required parameter documentLinkParameterRequest was null or undefined when calling getDocumentLinkByParameter.');
            }
            const localVarPath = `/document-link-by-parameter`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentLinkParameterRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentLinkParameterRequest !== undefined ? documentLinkParameterRequest : {}) : (documentLinkParameterRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentLinkParameterApi - functional programming interface
 * @export
 */
export const DocumentLinkParameterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Document Links by Parameter Name
         * @param {DocumentLinkParameterRequest} documentLinkParameterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentLinkByParameter(documentLinkParameterRequest: DocumentLinkParameterRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentLinkParameterResponse> {
            const localVarAxiosArgs = DocumentLinkParameterApiAxiosParamCreator(configuration).getDocumentLinkByParameter(documentLinkParameterRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentLinkParameterApi - factory interface
 * @export
 */
export const DocumentLinkParameterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Document Links by Parameter Name
         * @param {DocumentLinkParameterRequest} documentLinkParameterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentLinkByParameter(documentLinkParameterRequest: DocumentLinkParameterRequest, options?: any): AxiosPromise<DocumentLinkParameterResponse> {
            return DocumentLinkParameterApiFp(configuration).getDocumentLinkByParameter(documentLinkParameterRequest, options)(axios, basePath);
        },
    };
};

/**
 * DocumentLinkParameterApi - object-oriented interface
 * @export
 * @class DocumentLinkParameterApi
 * @extends {BaseAPI}
 */
export class DocumentLinkParameterApi extends BaseAPI {
    /**
     * 
     * @summary Get Document Links by Parameter Name
     * @param {DocumentLinkParameterRequest} documentLinkParameterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentLinkParameterApi
     */
    public getDocumentLinkByParameter(documentLinkParameterRequest: DocumentLinkParameterRequest, options?: any) {
        return DocumentLinkParameterApiFp(this.configuration).getDocumentLinkByParameter(documentLinkParameterRequest, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentPageValidationApi - axios parameter creator
 * @export
 */
export const DocumentPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-document-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate adding identity data
         * @param {ValidateAddIdentityRequest} validateAddIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddIdentityData(validateAddIdentityRequest: ValidateAddIdentityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateAddIdentityRequest' is not null or undefined
            if (validateAddIdentityRequest === null || validateAddIdentityRequest === undefined) {
                throw new RequiredError('validateAddIdentityRequest','Required parameter validateAddIdentityRequest was null or undefined when calling validateAddIdentityData.');
            }
            const localVarPath = `/validate-document-page/add-identity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateAddIdentityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateAddIdentityRequest !== undefined ? validateAddIdentityRequest : {}) : (validateAddIdentityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate document page data
         * @param {ValidateDocumentPageDataRequest} validateDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDocumentPageData(validateDocumentPageDataRequest: ValidateDocumentPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateDocumentPageDataRequest' is not null or undefined
            if (validateDocumentPageDataRequest === null || validateDocumentPageDataRequest === undefined) {
                throw new RequiredError('validateDocumentPageDataRequest','Required parameter validateDocumentPageDataRequest was null or undefined when calling validateDocumentPageData.');
            }
            const localVarPath = `/validate-document-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateDocumentPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateDocumentPageDataRequest !== undefined ? validateDocumentPageDataRequest : {}) : (validateDocumentPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentPageValidationApi - functional programming interface
 * @export
 */
export const DocumentPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPageDataResponse> {
            const localVarAxiosArgs = DocumentPageValidationApiAxiosParamCreator(configuration).getDocumentPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate adding identity data
         * @param {ValidateAddIdentityRequest} validateAddIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddIdentityData(validateAddIdentityRequest: ValidateAddIdentityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateAddIdentityResponse> {
            const localVarAxiosArgs = DocumentPageValidationApiAxiosParamCreator(configuration).validateAddIdentityData(validateAddIdentityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate document page data
         * @param {ValidateDocumentPageDataRequest} validateDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDocumentPageData(validateDocumentPageDataRequest: ValidateDocumentPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateDocumentPageDataResponse> {
            const localVarAxiosArgs = DocumentPageValidationApiAxiosParamCreator(configuration).validateDocumentPageData(validateDocumentPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentPageValidationApi - factory interface
 * @export
 */
export const DocumentPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPageData(options?: any): AxiosPromise<DocumentPageDataResponse> {
            return DocumentPageValidationApiFp(configuration).getDocumentPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate adding identity data
         * @param {ValidateAddIdentityRequest} validateAddIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddIdentityData(validateAddIdentityRequest: ValidateAddIdentityRequest, options?: any): AxiosPromise<ValidateAddIdentityResponse> {
            return DocumentPageValidationApiFp(configuration).validateAddIdentityData(validateAddIdentityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate document page data
         * @param {ValidateDocumentPageDataRequest} validateDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDocumentPageData(validateDocumentPageDataRequest: ValidateDocumentPageDataRequest, options?: any): AxiosPromise<ValidateDocumentPageDataResponse> {
            return DocumentPageValidationApiFp(configuration).validateDocumentPageData(validateDocumentPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * DocumentPageValidationApi - object-oriented interface
 * @export
 * @class DocumentPageValidationApi
 * @extends {BaseAPI}
 */
export class DocumentPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get document page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentPageValidationApi
     */
    public getDocumentPageData(options?: any) {
        return DocumentPageValidationApiFp(this.configuration).getDocumentPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate adding identity data
     * @param {ValidateAddIdentityRequest} validateAddIdentityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentPageValidationApi
     */
    public validateAddIdentityData(validateAddIdentityRequest: ValidateAddIdentityRequest, options?: any) {
        return DocumentPageValidationApiFp(this.configuration).validateAddIdentityData(validateAddIdentityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate document page data
     * @param {ValidateDocumentPageDataRequest} validateDocumentPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentPageValidationApi
     */
    public validateDocumentPageData(validateDocumentPageDataRequest: ValidateDocumentPageDataRequest, options?: any) {
        return DocumentPageValidationApiFp(this.configuration).validateDocumentPageData(validateDocumentPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentStorageApi - axios parameter creator
 * @export
 */
export const DocumentStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Document
         * @param {DocumentStorageRequest} documentStorageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(documentStorageRequest: DocumentStorageRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentStorageRequest' is not null or undefined
            if (documentStorageRequest === null || documentStorageRequest === undefined) {
                throw new RequiredError('documentStorageRequest','Required parameter documentStorageRequest was null or undefined when calling getDocument.');
            }
            const localVarPath = `/document-storage`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentStorageRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentStorageRequest !== undefined ? documentStorageRequest : {}) : (documentStorageRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentStorageApi - functional programming interface
 * @export
 */
export const DocumentStorageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Document
         * @param {DocumentStorageRequest} documentStorageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(documentStorageRequest: DocumentStorageRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStorageResponse> {
            const localVarAxiosArgs = DocumentStorageApiAxiosParamCreator(configuration).getDocument(documentStorageRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentStorageApi - factory interface
 * @export
 */
export const DocumentStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Document
         * @param {DocumentStorageRequest} documentStorageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(documentStorageRequest: DocumentStorageRequest, options?: any): AxiosPromise<DocumentStorageResponse> {
            return DocumentStorageApiFp(configuration).getDocument(documentStorageRequest, options)(axios, basePath);
        },
    };
};

/**
 * DocumentStorageApi - object-oriented interface
 * @export
 * @class DocumentStorageApi
 * @extends {BaseAPI}
 */
export class DocumentStorageApi extends BaseAPI {
    /**
     * 
     * @summary Get Document
     * @param {DocumentStorageRequest} documentStorageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentStorageApi
     */
    public getDocument(documentStorageRequest: DocumentStorageRequest, options?: any) {
        return DocumentStorageApiFp(this.configuration).getDocument(documentStorageRequest, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentUploadApi - axios parameter creator
 * @export
 */
export const DocumentUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get cards
         * @param {DocumentUploadCardRequest} documentUploadCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsByCustomerNumber(documentUploadCardRequest: DocumentUploadCardRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentUploadCardRequest' is not null or undefined
            if (documentUploadCardRequest === null || documentUploadCardRequest === undefined) {
                throw new RequiredError('documentUploadCardRequest','Required parameter documentUploadCardRequest was null or undefined when calling getCardsByCustomerNumber.');
            }
            const localVarPath = `/document-upload/cards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentUploadCardRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentUploadCardRequest !== undefined ? documentUploadCardRequest : {}) : (documentUploadCardRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upload document page document types
         * @param {DocumentUploadDocTypeRequest} documentUploadDocTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTypes(documentUploadDocTypeRequest: DocumentUploadDocTypeRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentUploadDocTypeRequest' is not null or undefined
            if (documentUploadDocTypeRequest === null || documentUploadDocTypeRequest === undefined) {
                throw new RequiredError('documentUploadDocTypeRequest','Required parameter documentUploadDocTypeRequest was null or undefined when calling getDocumentTypes.');
            }
            const localVarPath = `/document-upload/document-type`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentUploadDocTypeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentUploadDocTypeRequest !== undefined ? documentUploadDocTypeRequest : {}) : (documentUploadDocTypeRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prepare client info
         * @param {DocumentUploadClientInfoRequest} documentUploadClientInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareClientInfo(documentUploadClientInfoRequest: DocumentUploadClientInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'documentUploadClientInfoRequest' is not null or undefined
            if (documentUploadClientInfoRequest === null || documentUploadClientInfoRequest === undefined) {
                throw new RequiredError('documentUploadClientInfoRequest','Required parameter documentUploadClientInfoRequest was null or undefined when calling prepareClientInfo.');
            }
            const localVarPath = `/document-upload/client-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof documentUploadClientInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(documentUploadClientInfoRequest !== undefined ? documentUploadClientInfoRequest : {}) : (documentUploadClientInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentUploadApi - functional programming interface
 * @export
 */
export const DocumentUploadApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get cards
         * @param {DocumentUploadCardRequest} documentUploadCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsByCustomerNumber(documentUploadCardRequest: DocumentUploadCardRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadCardResponse> {
            const localVarAxiosArgs = DocumentUploadApiAxiosParamCreator(configuration).getCardsByCustomerNumber(documentUploadCardRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get upload document page document types
         * @param {DocumentUploadDocTypeRequest} documentUploadDocTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTypes(documentUploadDocTypeRequest: DocumentUploadDocTypeRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadDocTypeResponse> {
            const localVarAxiosArgs = DocumentUploadApiAxiosParamCreator(configuration).getDocumentTypes(documentUploadDocTypeRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Prepare client info
         * @param {DocumentUploadClientInfoRequest} documentUploadClientInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareClientInfo(documentUploadClientInfoRequest: DocumentUploadClientInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadClientInfoResponse> {
            const localVarAxiosArgs = DocumentUploadApiAxiosParamCreator(configuration).prepareClientInfo(documentUploadClientInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentUploadApi - factory interface
 * @export
 */
export const DocumentUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get cards
         * @param {DocumentUploadCardRequest} documentUploadCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsByCustomerNumber(documentUploadCardRequest: DocumentUploadCardRequest, options?: any): AxiosPromise<DocumentUploadCardResponse> {
            return DocumentUploadApiFp(configuration).getCardsByCustomerNumber(documentUploadCardRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get upload document page document types
         * @param {DocumentUploadDocTypeRequest} documentUploadDocTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTypes(documentUploadDocTypeRequest: DocumentUploadDocTypeRequest, options?: any): AxiosPromise<DocumentUploadDocTypeResponse> {
            return DocumentUploadApiFp(configuration).getDocumentTypes(documentUploadDocTypeRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Prepare client info
         * @param {DocumentUploadClientInfoRequest} documentUploadClientInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareClientInfo(documentUploadClientInfoRequest: DocumentUploadClientInfoRequest, options?: any): AxiosPromise<DocumentUploadClientInfoResponse> {
            return DocumentUploadApiFp(configuration).prepareClientInfo(documentUploadClientInfoRequest, options)(axios, basePath);
        },
    };
};

/**
 * DocumentUploadApi - object-oriented interface
 * @export
 * @class DocumentUploadApi
 * @extends {BaseAPI}
 */
export class DocumentUploadApi extends BaseAPI {
    /**
     * 
     * @summary Get cards
     * @param {DocumentUploadCardRequest} documentUploadCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentUploadApi
     */
    public getCardsByCustomerNumber(documentUploadCardRequest: DocumentUploadCardRequest, options?: any) {
        return DocumentUploadApiFp(this.configuration).getCardsByCustomerNumber(documentUploadCardRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get upload document page document types
     * @param {DocumentUploadDocTypeRequest} documentUploadDocTypeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentUploadApi
     */
    public getDocumentTypes(documentUploadDocTypeRequest: DocumentUploadDocTypeRequest, options?: any) {
        return DocumentUploadApiFp(this.configuration).getDocumentTypes(documentUploadDocTypeRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Prepare client info
     * @param {DocumentUploadClientInfoRequest} documentUploadClientInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentUploadApi
     */
    public prepareClientInfo(documentUploadClientInfoRequest: DocumentUploadClientInfoRequest, options?: any) {
        return DocumentUploadApiFp(this.configuration).prepareClientInfo(documentUploadClientInfoRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ExchangeRateApi - axios parameter creator
 * @export
 */
export const ExchangeRateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get exchange rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRate(options: any = {}): RequestArgs {
            const localVarPath = `/exchange-rate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExchangeRateApi - functional programming interface
 * @export
 */
export const ExchangeRateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get exchange rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRate(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRateResponse> {
            const localVarAxiosArgs = ExchangeRateApiAxiosParamCreator(configuration).getExchangeRate(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExchangeRateApi - factory interface
 * @export
 */
export const ExchangeRateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get exchange rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRate(options?: any): AxiosPromise<ExchangeRateResponse> {
            return ExchangeRateApiFp(configuration).getExchangeRate(options)(axios, basePath);
        },
    };
};

/**
 * ExchangeRateApi - object-oriented interface
 * @export
 * @class ExchangeRateApi
 * @extends {BaseAPI}
 */
export class ExchangeRateApi extends BaseAPI {
    /**
     * 
     * @summary Get exchange rates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeRateApi
     */
    public getExchangeRate(options?: any) {
        return ExchangeRateApiFp(this.configuration).getExchangeRate(options)(this.axios, this.basePath);
    }

}


/**
 * FiasApi - axios parameter creator
 * @export
 */
export const FiasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search address from DaData
         * @param {FiasAddressRequest} fiasAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddress(fiasAddressRequest: FiasAddressRequest, options: any = {}): RequestArgs {
            // verify required parameter 'fiasAddressRequest' is not null or undefined
            if (fiasAddressRequest === null || fiasAddressRequest === undefined) {
                throw new RequiredError('fiasAddressRequest','Required parameter fiasAddressRequest was null or undefined when calling searchAddress.');
            }
            const localVarPath = `/fias/address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fiasAddressRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fiasAddressRequest !== undefined ? fiasAddressRequest : {}) : (fiasAddressRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiasApi - functional programming interface
 * @export
 */
export const FiasApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search address from DaData
         * @param {FiasAddressRequest} fiasAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddress(fiasAddressRequest: FiasAddressRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiasAddressResponse> {
            const localVarAxiosArgs = FiasApiAxiosParamCreator(configuration).searchAddress(fiasAddressRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FiasApi - factory interface
 * @export
 */
export const FiasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Search address from DaData
         * @param {FiasAddressRequest} fiasAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddress(fiasAddressRequest: FiasAddressRequest, options?: any): AxiosPromise<FiasAddressResponse> {
            return FiasApiFp(configuration).searchAddress(fiasAddressRequest, options)(axios, basePath);
        },
    };
};

/**
 * FiasApi - object-oriented interface
 * @export
 * @class FiasApi
 * @extends {BaseAPI}
 */
export class FiasApi extends BaseAPI {
    /**
     * 
     * @summary Search address from DaData
     * @param {FiasAddressRequest} fiasAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiasApi
     */
    public searchAddress(fiasAddressRequest: FiasAddressRequest, options?: any) {
        return FiasApiFp(this.configuration).searchAddress(fiasAddressRequest, options)(this.axios, this.basePath);
    }

}


/**
 * FnsApi - axios parameter creator
 * @export
 */
export const FnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Поиск юридических лиц через FNS API
         * @param {FnsSearchRequest} fnsSearchRequest Параметры поиска
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(fnsSearchRequest: FnsSearchRequest, options: any = {}): RequestArgs {
            // verify required parameter 'fnsSearchRequest' is not null or undefined
            if (fnsSearchRequest === null || fnsSearchRequest === undefined) {
                throw new RequiredError('fnsSearchRequest','Required parameter fnsSearchRequest was null or undefined when calling search.');
            }
            const localVarPath = `/fns/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fnsSearchRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fnsSearchRequest !== undefined ? fnsSearchRequest : {}) : (fnsSearchRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FnsApi - functional programming interface
 * @export
 */
export const FnsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Поиск юридических лиц через FNS API
         * @param {FnsSearchRequest} fnsSearchRequest Параметры поиска
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(fnsSearchRequest: FnsSearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FnsSearchResponse> {
            const localVarAxiosArgs = FnsApiAxiosParamCreator(configuration).search(fnsSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FnsApi - factory interface
 * @export
 */
export const FnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Поиск юридических лиц через FNS API
         * @param {FnsSearchRequest} fnsSearchRequest Параметры поиска
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(fnsSearchRequest: FnsSearchRequest, options?: any): AxiosPromise<FnsSearchResponse> {
            return FnsApiFp(configuration).search(fnsSearchRequest, options)(axios, basePath);
        },
    };
};

/**
 * FnsApi - object-oriented interface
 * @export
 * @class FnsApi
 * @extends {BaseAPI}
 */
export class FnsApi extends BaseAPI {
    /**
     * 
     * @summary Поиск юридических лиц через FNS API
     * @param {FnsSearchRequest} fnsSearchRequest Параметры поиска
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FnsApi
     */
    public search(fnsSearchRequest: FnsSearchRequest, options?: any) {
        return FnsApiFp(this.configuration).search(fnsSearchRequest, options)(this.axios, this.basePath);
    }

}


/**
 * GlobalBonusApi - axios parameter creator
 * @export
 */
export const GlobalBonusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Global Bonus User Info
         * @param {GlobalBonusUserInfoRequest} globalBonusUserInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalBonusUserInfo(globalBonusUserInfoRequest: GlobalBonusUserInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'globalBonusUserInfoRequest' is not null or undefined
            if (globalBonusUserInfoRequest === null || globalBonusUserInfoRequest === undefined) {
                throw new RequiredError('globalBonusUserInfoRequest','Required parameter globalBonusUserInfoRequest was null or undefined when calling getGlobalBonusUserInfo.');
            }
            const localVarPath = `/global-bonus/user-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof globalBonusUserInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(globalBonusUserInfoRequest !== undefined ? globalBonusUserInfoRequest : {}) : (globalBonusUserInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Global Bonus Visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalBonusVisibility(options: any = {}): RequestArgs {
            const localVarPath = `/global-bonus/visibility`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalBonusApi - functional programming interface
 * @export
 */
export const GlobalBonusApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Global Bonus User Info
         * @param {GlobalBonusUserInfoRequest} globalBonusUserInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalBonusUserInfo(globalBonusUserInfoRequest: GlobalBonusUserInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalBonusUserInfoResponse> {
            const localVarAxiosArgs = GlobalBonusApiAxiosParamCreator(configuration).getGlobalBonusUserInfo(globalBonusUserInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Global Bonus Visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalBonusVisibility(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalBonusVisibilityResponse> {
            const localVarAxiosArgs = GlobalBonusApiAxiosParamCreator(configuration).getGlobalBonusVisibility(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GlobalBonusApi - factory interface
 * @export
 */
export const GlobalBonusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Global Bonus User Info
         * @param {GlobalBonusUserInfoRequest} globalBonusUserInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalBonusUserInfo(globalBonusUserInfoRequest: GlobalBonusUserInfoRequest, options?: any): AxiosPromise<GlobalBonusUserInfoResponse> {
            return GlobalBonusApiFp(configuration).getGlobalBonusUserInfo(globalBonusUserInfoRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Global Bonus Visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalBonusVisibility(options?: any): AxiosPromise<GlobalBonusVisibilityResponse> {
            return GlobalBonusApiFp(configuration).getGlobalBonusVisibility(options)(axios, basePath);
        },
    };
};

/**
 * GlobalBonusApi - object-oriented interface
 * @export
 * @class GlobalBonusApi
 * @extends {BaseAPI}
 */
export class GlobalBonusApi extends BaseAPI {
    /**
     * 
     * @summary Get Global Bonus User Info
     * @param {GlobalBonusUserInfoRequest} globalBonusUserInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalBonusApi
     */
    public getGlobalBonusUserInfo(globalBonusUserInfoRequest: GlobalBonusUserInfoRequest, options?: any) {
        return GlobalBonusApiFp(this.configuration).getGlobalBonusUserInfo(globalBonusUserInfoRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Global Bonus Visibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalBonusApi
     */
    public getGlobalBonusVisibility(options?: any) {
        return GlobalBonusApiFp(this.configuration).getGlobalBonusVisibility(options)(this.axios, this.basePath);
    }

}


/**
 * IndividualPageValidationApi - axios parameter creator
 * @export
 */
export const IndividualPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-individual-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate individual page data
         * @param {ValidateIndividualPageDataRequest} validateIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIndividualPageData(validateIndividualPageDataRequest: ValidateIndividualPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateIndividualPageDataRequest' is not null or undefined
            if (validateIndividualPageDataRequest === null || validateIndividualPageDataRequest === undefined) {
                throw new RequiredError('validateIndividualPageDataRequest','Required parameter validateIndividualPageDataRequest was null or undefined when calling validateIndividualPageData.');
            }
            const localVarPath = `/validate-individual-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateIndividualPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateIndividualPageDataRequest !== undefined ? validateIndividualPageDataRequest : {}) : (validateIndividualPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate individual page data for customer change
         * @param {ValidateIndividualPageCustomerChangeRequest} validateIndividualPageCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest: ValidateIndividualPageCustomerChangeRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateIndividualPageCustomerChangeRequest' is not null or undefined
            if (validateIndividualPageCustomerChangeRequest === null || validateIndividualPageCustomerChangeRequest === undefined) {
                throw new RequiredError('validateIndividualPageCustomerChangeRequest','Required parameter validateIndividualPageCustomerChangeRequest was null or undefined when calling validateIndividualPageDataForCustomerChange.');
            }
            const localVarPath = `/validate-individual-page/is-customer-changed`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateIndividualPageCustomerChangeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateIndividualPageCustomerChangeRequest !== undefined ? validateIndividualPageCustomerChangeRequest : {}) : (validateIndividualPageCustomerChangeRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndividualPageValidationApi - functional programming interface
 * @export
 */
export const IndividualPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualPageDataResponse> {
            const localVarAxiosArgs = IndividualPageValidationApiAxiosParamCreator(configuration).getIndividualPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate individual page data
         * @param {ValidateIndividualPageDataRequest} validateIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIndividualPageData(validateIndividualPageDataRequest: ValidateIndividualPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateIndividualPageDataResponse> {
            const localVarAxiosArgs = IndividualPageValidationApiAxiosParamCreator(configuration).validateIndividualPageData(validateIndividualPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate individual page data for customer change
         * @param {ValidateIndividualPageCustomerChangeRequest} validateIndividualPageCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest: ValidateIndividualPageCustomerChangeRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateIndividualPageCustomerChangeResponse> {
            const localVarAxiosArgs = IndividualPageValidationApiAxiosParamCreator(configuration).validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IndividualPageValidationApi - factory interface
 * @export
 */
export const IndividualPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualPageData(options?: any): AxiosPromise<IndividualPageDataResponse> {
            return IndividualPageValidationApiFp(configuration).getIndividualPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate individual page data
         * @param {ValidateIndividualPageDataRequest} validateIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIndividualPageData(validateIndividualPageDataRequest: ValidateIndividualPageDataRequest, options?: any): AxiosPromise<ValidateIndividualPageDataResponse> {
            return IndividualPageValidationApiFp(configuration).validateIndividualPageData(validateIndividualPageDataRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate individual page data for customer change
         * @param {ValidateIndividualPageCustomerChangeRequest} validateIndividualPageCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest: ValidateIndividualPageCustomerChangeRequest, options?: any): AxiosPromise<ValidateIndividualPageCustomerChangeResponse> {
            return IndividualPageValidationApiFp(configuration).validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest, options)(axios, basePath);
        },
    };
};

/**
 * IndividualPageValidationApi - object-oriented interface
 * @export
 * @class IndividualPageValidationApi
 * @extends {BaseAPI}
 */
export class IndividualPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get individual page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualPageValidationApi
     */
    public getIndividualPageData(options?: any) {
        return IndividualPageValidationApiFp(this.configuration).getIndividualPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate individual page data
     * @param {ValidateIndividualPageDataRequest} validateIndividualPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualPageValidationApi
     */
    public validateIndividualPageData(validateIndividualPageDataRequest: ValidateIndividualPageDataRequest, options?: any) {
        return IndividualPageValidationApiFp(this.configuration).validateIndividualPageData(validateIndividualPageDataRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate individual page data for customer change
     * @param {ValidateIndividualPageCustomerChangeRequest} validateIndividualPageCustomerChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualPageValidationApi
     */
    public validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest: ValidateIndividualPageCustomerChangeRequest, options?: any) {
        return IndividualPageValidationApiFp(this.configuration).validateIndividualPageDataForCustomerChange(validateIndividualPageCustomerChangeRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LoanApi - axios parameter creator
 * @export
 */
export const LoanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Action Type Combo Values
         * @param {LoanActionComboRequest} loanActionComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionCombo(loanActionComboRequest: LoanActionComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanActionComboRequest' is not null or undefined
            if (loanActionComboRequest === null || loanActionComboRequest === undefined) {
                throw new RequiredError('loanActionComboRequest','Required parameter loanActionComboRequest was null or undefined when calling getActionCombo.');
            }
            const localVarPath = `/loan/action-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanActionComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanActionComboRequest !== undefined ? loanActionComboRequest : {}) : (loanActionComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Brand Combo Values
         * @param {LoanCarBrandComboRequest} loanCarBrandComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarBrandCombo(loanCarBrandComboRequest: LoanCarBrandComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanCarBrandComboRequest' is not null or undefined
            if (loanCarBrandComboRequest === null || loanCarBrandComboRequest === undefined) {
                throw new RequiredError('loanCarBrandComboRequest','Required parameter loanCarBrandComboRequest was null or undefined when calling getCarBrandCombo.');
            }
            const localVarPath = `/loan/car-brand-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanCarBrandComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanCarBrandComboRequest !== undefined ? loanCarBrandComboRequest : {}) : (loanCarBrandComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApi - functional programming interface
 * @export
 */
export const LoanApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Action Type Combo Values
         * @param {LoanActionComboRequest} loanActionComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionCombo(loanActionComboRequest: LoanActionComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanActionComboResponse> {
            const localVarAxiosArgs = LoanApiAxiosParamCreator(configuration).getActionCombo(loanActionComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Brand Combo Values
         * @param {LoanCarBrandComboRequest} loanCarBrandComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarBrandCombo(loanCarBrandComboRequest: LoanCarBrandComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCarBrandComboResponse> {
            const localVarAxiosArgs = LoanApiAxiosParamCreator(configuration).getCarBrandCombo(loanCarBrandComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanApi - factory interface
 * @export
 */
export const LoanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Action Type Combo Values
         * @param {LoanActionComboRequest} loanActionComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionCombo(loanActionComboRequest: LoanActionComboRequest, options?: any): AxiosPromise<LoanActionComboResponse> {
            return LoanApiFp(configuration).getActionCombo(loanActionComboRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Brand Combo Values
         * @param {LoanCarBrandComboRequest} loanCarBrandComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarBrandCombo(loanCarBrandComboRequest: LoanCarBrandComboRequest, options?: any): AxiosPromise<LoanCarBrandComboResponse> {
            return LoanApiFp(configuration).getCarBrandCombo(loanCarBrandComboRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoanApi - object-oriented interface
 * @export
 * @class LoanApi
 * @extends {BaseAPI}
 */
export class LoanApi extends BaseAPI {
    /**
     * 
     * @summary Get Action Type Combo Values
     * @param {LoanActionComboRequest} loanActionComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public getActionCombo(loanActionComboRequest: LoanActionComboRequest, options?: any) {
        return LoanApiFp(this.configuration).getActionCombo(loanActionComboRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Brand Combo Values
     * @param {LoanCarBrandComboRequest} loanCarBrandComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public getCarBrandCombo(loanCarBrandComboRequest: LoanCarBrandComboRequest, options?: any) {
        return LoanApiFp(this.configuration).getCarBrandCombo(loanCarBrandComboRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LoanAdditionalServicesApi - axios parameter creator
 * @export
 */
export const LoanAdditionalServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Loan Additional Service Product Price
         * @param {LoanAdditionalServicesProductPriceRequest} loanAdditionalServicesProductPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrice(loanAdditionalServicesProductPriceRequest: LoanAdditionalServicesProductPriceRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanAdditionalServicesProductPriceRequest' is not null or undefined
            if (loanAdditionalServicesProductPriceRequest === null || loanAdditionalServicesProductPriceRequest === undefined) {
                throw new RequiredError('loanAdditionalServicesProductPriceRequest','Required parameter loanAdditionalServicesProductPriceRequest was null or undefined when calling getProductPrice.');
            }
            const localVarPath = `/loan-additional-services/product-price`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanAdditionalServicesProductPriceRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanAdditionalServicesProductPriceRequest !== undefined ? loanAdditionalServicesProductPriceRequest : {}) : (loanAdditionalServicesProductPriceRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanAdditionalServicesApi - functional programming interface
 * @export
 */
export const LoanAdditionalServicesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Loan Additional Service Product Price
         * @param {LoanAdditionalServicesProductPriceRequest} loanAdditionalServicesProductPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrice(loanAdditionalServicesProductPriceRequest: LoanAdditionalServicesProductPriceRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanAdditionalServicesProductPriceResponse> {
            const localVarAxiosArgs = LoanAdditionalServicesApiAxiosParamCreator(configuration).getProductPrice(loanAdditionalServicesProductPriceRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanAdditionalServicesApi - factory interface
 * @export
 */
export const LoanAdditionalServicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Loan Additional Service Product Price
         * @param {LoanAdditionalServicesProductPriceRequest} loanAdditionalServicesProductPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrice(loanAdditionalServicesProductPriceRequest: LoanAdditionalServicesProductPriceRequest, options?: any): AxiosPromise<LoanAdditionalServicesProductPriceResponse> {
            return LoanAdditionalServicesApiFp(configuration).getProductPrice(loanAdditionalServicesProductPriceRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoanAdditionalServicesApi - object-oriented interface
 * @export
 * @class LoanAdditionalServicesApi
 * @extends {BaseAPI}
 */
export class LoanAdditionalServicesApi extends BaseAPI {
    /**
     * 
     * @summary Get Loan Additional Service Product Price
     * @param {LoanAdditionalServicesProductPriceRequest} loanAdditionalServicesProductPriceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanAdditionalServicesApi
     */
    public getProductPrice(loanAdditionalServicesProductPriceRequest: LoanAdditionalServicesProductPriceRequest, options?: any) {
        return LoanAdditionalServicesApiFp(this.configuration).getProductPrice(loanAdditionalServicesProductPriceRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LoanApplicationApi - axios parameter creator
 * @export
 */
export const LoanApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Loan Application
         * @param {LoanApplicationApplyRequest} loanApplicationApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLoanApplication(loanApplicationApplyRequest: LoanApplicationApplyRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanApplicationApplyRequest' is not null or undefined
            if (loanApplicationApplyRequest === null || loanApplicationApplyRequest === undefined) {
                throw new RequiredError('loanApplicationApplyRequest','Required parameter loanApplicationApplyRequest was null or undefined when calling generateLoanApplication.');
            }
            const localVarPath = `/loan-application/apply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanApplicationApplyRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanApplicationApplyRequest !== undefined ? loanApplicationApplyRequest : {}) : (loanApplicationApplyRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Print Application Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printApplicationDocument(options: any = {}): RequestArgs {
            const localVarPath = `/loan-application/print-application-document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Print Power Of Attorney Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPowerOfAttorneyDocument(options: any = {}): RequestArgs {
            const localVarPath = `/loan-application/print-power-of-attorney-document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApplicationApi - functional programming interface
 * @export
 */
export const LoanApplicationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Loan Application
         * @param {LoanApplicationApplyRequest} loanApplicationApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLoanApplication(loanApplicationApplyRequest: LoanApplicationApplyRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationApplyResponse> {
            const localVarAxiosArgs = LoanApplicationApiAxiosParamCreator(configuration).generateLoanApplication(loanApplicationApplyRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Print Application Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printApplicationDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationPrintApplicationDocumentResponse> {
            const localVarAxiosArgs = LoanApplicationApiAxiosParamCreator(configuration).printApplicationDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Print Power Of Attorney Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPowerOfAttorneyDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationPrintPowerOfAttorneyDocumentResponse> {
            const localVarAxiosArgs = LoanApplicationApiAxiosParamCreator(configuration).printPowerOfAttorneyDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanApplicationApi - factory interface
 * @export
 */
export const LoanApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Generate Loan Application
         * @param {LoanApplicationApplyRequest} loanApplicationApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLoanApplication(loanApplicationApplyRequest: LoanApplicationApplyRequest, options?: any): AxiosPromise<LoanApplicationApplyResponse> {
            return LoanApplicationApiFp(configuration).generateLoanApplication(loanApplicationApplyRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Print Application Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printApplicationDocument(options?: any): AxiosPromise<LoanApplicationPrintApplicationDocumentResponse> {
            return LoanApplicationApiFp(configuration).printApplicationDocument(options)(axios, basePath);
        },
        /**
         * 
         * @summary Print Power Of Attorney Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPowerOfAttorneyDocument(options?: any): AxiosPromise<LoanApplicationPrintPowerOfAttorneyDocumentResponse> {
            return LoanApplicationApiFp(configuration).printPowerOfAttorneyDocument(options)(axios, basePath);
        },
    };
};

/**
 * LoanApplicationApi - object-oriented interface
 * @export
 * @class LoanApplicationApi
 * @extends {BaseAPI}
 */
export class LoanApplicationApi extends BaseAPI {
    /**
     * 
     * @summary Generate Loan Application
     * @param {LoanApplicationApplyRequest} loanApplicationApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public generateLoanApplication(loanApplicationApplyRequest: LoanApplicationApplyRequest, options?: any) {
        return LoanApplicationApiFp(this.configuration).generateLoanApplication(loanApplicationApplyRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Print Application Document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public printApplicationDocument(options?: any) {
        return LoanApplicationApiFp(this.configuration).printApplicationDocument(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Print Power Of Attorney Document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public printPowerOfAttorneyDocument(options?: any) {
        return LoanApplicationApiFp(this.configuration).printPowerOfAttorneyDocument(options)(this.axios, this.basePath);
    }

}


/**
 * LoanCustomerOperationsApi - axios parameter creator
 * @export
 */
export const LoanCustomerOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loan Create Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanCreateCustomer(options: any = {}): RequestArgs {
            const localVarPath = `/loan-customer-operations/create`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loan Update Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanUpdateCustomer(options: any = {}): RequestArgs {
            const localVarPath = `/loan-customer-operations/update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanCustomerOperationsApi - functional programming interface
 * @export
 */
export const LoanCustomerOperationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loan Create Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanCreateCustomer(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCustomerCreateResponse> {
            const localVarAxiosArgs = LoanCustomerOperationsApiAxiosParamCreator(configuration).loanCreateCustomer(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Loan Update Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanUpdateCustomer(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCustomerUpdateResponse> {
            const localVarAxiosArgs = LoanCustomerOperationsApiAxiosParamCreator(configuration).loanUpdateCustomer(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanCustomerOperationsApi - factory interface
 * @export
 */
export const LoanCustomerOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Loan Create Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanCreateCustomer(options?: any): AxiosPromise<LoanCustomerCreateResponse> {
            return LoanCustomerOperationsApiFp(configuration).loanCreateCustomer(options)(axios, basePath);
        },
        /**
         * 
         * @summary Loan Update Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanUpdateCustomer(options?: any): AxiosPromise<LoanCustomerUpdateResponse> {
            return LoanCustomerOperationsApiFp(configuration).loanUpdateCustomer(options)(axios, basePath);
        },
    };
};

/**
 * LoanCustomerOperationsApi - object-oriented interface
 * @export
 * @class LoanCustomerOperationsApi
 * @extends {BaseAPI}
 */
export class LoanCustomerOperationsApi extends BaseAPI {
    /**
     * 
     * @summary Loan Create Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanCustomerOperationsApi
     */
    public loanCreateCustomer(options?: any) {
        return LoanCustomerOperationsApiFp(this.configuration).loanCreateCustomer(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Loan Update Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanCustomerOperationsApi
     */
    public loanUpdateCustomer(options?: any) {
        return LoanCustomerOperationsApiFp(this.configuration).loanUpdateCustomer(options)(this.axios, this.basePath);
    }

}


/**
 * LoanCustomerThirdPartyApi - axios parameter creator
 * @export
 */
export const LoanCustomerThirdPartyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loan Third Party Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanThirdPartyPageValidationParameters(documentType: string, options: any = {}): RequestArgs {
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling getLoanThirdPartyPageValidationParameters.');
            }
            const localVarPath = `/loan-customer-third-party/validation-components/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanCustomerThirdPartyApi - functional programming interface
 * @export
 */
export const LoanCustomerThirdPartyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loan Third Party Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanThirdPartyPageValidationParameters(documentType: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanThirdPartyPageValidationComponentsResponse> {
            const localVarAxiosArgs = LoanCustomerThirdPartyApiAxiosParamCreator(configuration).getLoanThirdPartyPageValidationParameters(documentType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanCustomerThirdPartyApi - factory interface
 * @export
 */
export const LoanCustomerThirdPartyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Loan Third Party Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanThirdPartyPageValidationParameters(documentType: string, options?: any): AxiosPromise<LoanThirdPartyPageValidationComponentsResponse> {
            return LoanCustomerThirdPartyApiFp(configuration).getLoanThirdPartyPageValidationParameters(documentType, options)(axios, basePath);
        },
    };
};

/**
 * LoanCustomerThirdPartyApi - object-oriented interface
 * @export
 * @class LoanCustomerThirdPartyApi
 * @extends {BaseAPI}
 */
export class LoanCustomerThirdPartyApi extends BaseAPI {
    /**
     * 
     * @summary Loan Third Party Page Validation Components
     * @param {string} documentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanCustomerThirdPartyApi
     */
    public getLoanThirdPartyPageValidationParameters(documentType: string, options?: any) {
        return LoanCustomerThirdPartyApiFp(this.configuration).getLoanThirdPartyPageValidationParameters(documentType, options)(this.axios, this.basePath);
    }

}


/**
 * LoanDetailsPageConfigApi - axios parameter creator
 * @export
 */
export const LoanDetailsPageConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan details page config data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDetailsPageConfigData(options: any = {}): RequestArgs {
            const localVarPath = `/loan-details-page-config`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanDetailsPageConfigApi - functional programming interface
 * @export
 */
export const LoanDetailsPageConfigApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan details page config data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDetailsPageConfigData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDetailsPageConfigDataResponse> {
            const localVarAxiosArgs = LoanDetailsPageConfigApiAxiosParamCreator(configuration).getLoanDetailsPageConfigData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanDetailsPageConfigApi - factory interface
 * @export
 */
export const LoanDetailsPageConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan details page config data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDetailsPageConfigData(options?: any): AxiosPromise<LoanDetailsPageConfigDataResponse> {
            return LoanDetailsPageConfigApiFp(configuration).getLoanDetailsPageConfigData(options)(axios, basePath);
        },
    };
};

/**
 * LoanDetailsPageConfigApi - object-oriented interface
 * @export
 * @class LoanDetailsPageConfigApi
 * @extends {BaseAPI}
 */
export class LoanDetailsPageConfigApi extends BaseAPI {
    /**
     * 
     * @summary Get loan details page config data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanDetailsPageConfigApi
     */
    public getLoanDetailsPageConfigData(options?: any) {
        return LoanDetailsPageConfigApiFp(this.configuration).getLoanDetailsPageConfigData(options)(this.axios, this.basePath);
    }

}


/**
 * LoanDocumentApi - axios parameter creator
 * @export
 */
export const LoanDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loan Document Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentPageComponentsValidation(documentType: string, options: any = {}): RequestArgs {
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling getLoanDocumentPageComponentsValidation.');
            }
            const localVarPath = `/loan-document/components-validation/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Loan Document Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentType(options: any = {}): RequestArgs {
            const localVarPath = `/loan-document/type`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanDocumentApi - functional programming interface
 * @export
 */
export const LoanDocumentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loan Document Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentPageComponentsValidation(documentType: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDocumentPageValidationComponentsResponse> {
            const localVarAxiosArgs = LoanDocumentApiAxiosParamCreator(configuration).getLoanDocumentPageComponentsValidation(documentType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Loan Document Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentType(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDocumentTypeResponse> {
            const localVarAxiosArgs = LoanDocumentApiAxiosParamCreator(configuration).getLoanDocumentType(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanDocumentApi - factory interface
 * @export
 */
export const LoanDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Loan Document Page Validation Components
         * @param {string} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentPageComponentsValidation(documentType: string, options?: any): AxiosPromise<LoanDocumentPageValidationComponentsResponse> {
            return LoanDocumentApiFp(configuration).getLoanDocumentPageComponentsValidation(documentType, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Loan Document Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentType(options?: any): AxiosPromise<LoanDocumentTypeResponse> {
            return LoanDocumentApiFp(configuration).getLoanDocumentType(options)(axios, basePath);
        },
    };
};

/**
 * LoanDocumentApi - object-oriented interface
 * @export
 * @class LoanDocumentApi
 * @extends {BaseAPI}
 */
export class LoanDocumentApi extends BaseAPI {
    /**
     * 
     * @summary Loan Document Page Validation Components
     * @param {string} documentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanDocumentApi
     */
    public getLoanDocumentPageComponentsValidation(documentType: string, options?: any) {
        return LoanDocumentApiFp(this.configuration).getLoanDocumentPageComponentsValidation(documentType, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Loan Document Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanDocumentApi
     */
    public getLoanDocumentType(options?: any) {
        return LoanDocumentApiFp(this.configuration).getLoanDocumentType(options)(this.axios, this.basePath);
    }

}


/**
 * LoanPaymentPlanSimApi - axios parameter creator
 * @export
 */
export const LoanPaymentPlanSimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate Auchan Loan Payment Plan
         * @param {LoanPaymentPlanSimAuchanCalculateRequest} loanPaymentPlanSimAuchanCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest: LoanPaymentPlanSimAuchanCalculateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPaymentPlanSimAuchanCalculateRequest' is not null or undefined
            if (loanPaymentPlanSimAuchanCalculateRequest === null || loanPaymentPlanSimAuchanCalculateRequest === undefined) {
                throw new RequiredError('loanPaymentPlanSimAuchanCalculateRequest','Required parameter loanPaymentPlanSimAuchanCalculateRequest was null or undefined when calling calculateAuchanLoanPaymentPlan.');
            }
            const localVarPath = `/loan-payment-plan-sim/auchan-calculate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPaymentPlanSimAuchanCalculateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPaymentPlanSimAuchanCalculateRequest !== undefined ? loanPaymentPlanSimAuchanCalculateRequest : {}) : (loanPaymentPlanSimAuchanCalculateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate Car Loan Payment Plan
         * @param {LoanPaymentPlanSimCarCalculateRequest} loanPaymentPlanSimCarCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest: LoanPaymentPlanSimCarCalculateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPaymentPlanSimCarCalculateRequest' is not null or undefined
            if (loanPaymentPlanSimCarCalculateRequest === null || loanPaymentPlanSimCarCalculateRequest === undefined) {
                throw new RequiredError('loanPaymentPlanSimCarCalculateRequest','Required parameter loanPaymentPlanSimCarCalculateRequest was null or undefined when calling calculateCarLoanPaymentPlan.');
            }
            const localVarPath = `/loan-payment-plan-sim/car-calculate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPaymentPlanSimCarCalculateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPaymentPlanSimCarCalculateRequest !== undefined ? loanPaymentPlanSimCarCalculateRequest : {}) : (loanPaymentPlanSimCarCalculateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate Holiday Loan Payment Plan
         * @param {LoanPaymentPlanSimHolidayCalculateRequest} loanPaymentPlanSimHolidayCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest: LoanPaymentPlanSimHolidayCalculateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPaymentPlanSimHolidayCalculateRequest' is not null or undefined
            if (loanPaymentPlanSimHolidayCalculateRequest === null || loanPaymentPlanSimHolidayCalculateRequest === undefined) {
                throw new RequiredError('loanPaymentPlanSimHolidayCalculateRequest','Required parameter loanPaymentPlanSimHolidayCalculateRequest was null or undefined when calling calculateHolidayLoanPaymentPlan.');
            }
            const localVarPath = `/loan-payment-plan-sim/holiday-calculate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPaymentPlanSimHolidayCalculateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPaymentPlanSimHolidayCalculateRequest !== undefined ? loanPaymentPlanSimHolidayCalculateRequest : {}) : (loanPaymentPlanSimHolidayCalculateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate Instant Loan Payment Plan
         * @param {LoanPaymentPlanSimInstantCalculateRequest} loanPaymentPlanSimInstantCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest: LoanPaymentPlanSimInstantCalculateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPaymentPlanSimInstantCalculateRequest' is not null or undefined
            if (loanPaymentPlanSimInstantCalculateRequest === null || loanPaymentPlanSimInstantCalculateRequest === undefined) {
                throw new RequiredError('loanPaymentPlanSimInstantCalculateRequest','Required parameter loanPaymentPlanSimInstantCalculateRequest was null or undefined when calling calculateInstantLoanPaymentPlan.');
            }
            const localVarPath = `/loan-payment-plan-sim/instant-calculate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPaymentPlanSimInstantCalculateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPaymentPlanSimInstantCalculateRequest !== undefined ? loanPaymentPlanSimInstantCalculateRequest : {}) : (loanPaymentPlanSimInstantCalculateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Initial Payment Rate
         * @param {LoanPaymentPlanSimInitialPaymentRateRequest} loanPaymentPlanSimInitialPaymentRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest: LoanPaymentPlanSimInitialPaymentRateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPaymentPlanSimInitialPaymentRateRequest' is not null or undefined
            if (loanPaymentPlanSimInitialPaymentRateRequest === null || loanPaymentPlanSimInitialPaymentRateRequest === undefined) {
                throw new RequiredError('loanPaymentPlanSimInitialPaymentRateRequest','Required parameter loanPaymentPlanSimInitialPaymentRateRequest was null or undefined when calling getInitialPaymentRate.');
            }
            const localVarPath = `/loan-payment-plan-sim/initial-payment-rate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPaymentPlanSimInitialPaymentRateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPaymentPlanSimInitialPaymentRateRequest !== undefined ? loanPaymentPlanSimInitialPaymentRateRequest : {}) : (loanPaymentPlanSimInitialPaymentRateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Action Type Combo Values
         * @param {LoanPaymentPlanSimActionComboRequest} loanPaymentPlanSimActionComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimActionCombo(loanPaymentPlanSimActionComboRequest: LoanPaymentPlanSimActionComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPaymentPlanSimActionComboRequest' is not null or undefined
            if (loanPaymentPlanSimActionComboRequest === null || loanPaymentPlanSimActionComboRequest === undefined) {
                throw new RequiredError('loanPaymentPlanSimActionComboRequest','Required parameter loanPaymentPlanSimActionComboRequest was null or undefined when calling getSimActionCombo.');
            }
            const localVarPath = `/loan-payment-plan-sim/action-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPaymentPlanSimActionComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPaymentPlanSimActionComboRequest !== undefined ? loanPaymentPlanSimActionComboRequest : {}) : (loanPaymentPlanSimActionComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Print Payment Plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPaymentPlan(options: any = {}): RequestArgs {
            const localVarPath = `/loan-payment-plan-sim/print-payment-plan`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanPaymentPlanSimApi - functional programming interface
 * @export
 */
export const LoanPaymentPlanSimApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate Auchan Loan Payment Plan
         * @param {LoanPaymentPlanSimAuchanCalculateRequest} loanPaymentPlanSimAuchanCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest: LoanPaymentPlanSimAuchanCalculateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimAuchanCalculateResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Calculate Car Loan Payment Plan
         * @param {LoanPaymentPlanSimCarCalculateRequest} loanPaymentPlanSimCarCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest: LoanPaymentPlanSimCarCalculateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimCarCalculateResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Calculate Holiday Loan Payment Plan
         * @param {LoanPaymentPlanSimHolidayCalculateRequest} loanPaymentPlanSimHolidayCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest: LoanPaymentPlanSimHolidayCalculateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimHolidayCalculateResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Calculate Instant Loan Payment Plan
         * @param {LoanPaymentPlanSimInstantCalculateRequest} loanPaymentPlanSimInstantCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest: LoanPaymentPlanSimInstantCalculateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimInstantCalculateResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Initial Payment Rate
         * @param {LoanPaymentPlanSimInitialPaymentRateRequest} loanPaymentPlanSimInitialPaymentRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest: LoanPaymentPlanSimInitialPaymentRateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimInitialPaymentRateResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Action Type Combo Values
         * @param {LoanPaymentPlanSimActionComboRequest} loanPaymentPlanSimActionComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimActionCombo(loanPaymentPlanSimActionComboRequest: LoanPaymentPlanSimActionComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimActionComboResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).getSimActionCombo(loanPaymentPlanSimActionComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Print Payment Plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPaymentPlan(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPaymentPlanSimPrintResponse> {
            const localVarAxiosArgs = LoanPaymentPlanSimApiAxiosParamCreator(configuration).printPaymentPlan(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanPaymentPlanSimApi - factory interface
 * @export
 */
export const LoanPaymentPlanSimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Calculate Auchan Loan Payment Plan
         * @param {LoanPaymentPlanSimAuchanCalculateRequest} loanPaymentPlanSimAuchanCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest: LoanPaymentPlanSimAuchanCalculateRequest, options?: any): AxiosPromise<LoanPaymentPlanSimAuchanCalculateResponse> {
            return LoanPaymentPlanSimApiFp(configuration).calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Calculate Car Loan Payment Plan
         * @param {LoanPaymentPlanSimCarCalculateRequest} loanPaymentPlanSimCarCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest: LoanPaymentPlanSimCarCalculateRequest, options?: any): AxiosPromise<LoanPaymentPlanSimCarCalculateResponse> {
            return LoanPaymentPlanSimApiFp(configuration).calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Calculate Holiday Loan Payment Plan
         * @param {LoanPaymentPlanSimHolidayCalculateRequest} loanPaymentPlanSimHolidayCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest: LoanPaymentPlanSimHolidayCalculateRequest, options?: any): AxiosPromise<LoanPaymentPlanSimHolidayCalculateResponse> {
            return LoanPaymentPlanSimApiFp(configuration).calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Calculate Instant Loan Payment Plan
         * @param {LoanPaymentPlanSimInstantCalculateRequest} loanPaymentPlanSimInstantCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest: LoanPaymentPlanSimInstantCalculateRequest, options?: any): AxiosPromise<LoanPaymentPlanSimInstantCalculateResponse> {
            return LoanPaymentPlanSimApiFp(configuration).calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Initial Payment Rate
         * @param {LoanPaymentPlanSimInitialPaymentRateRequest} loanPaymentPlanSimInitialPaymentRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest: LoanPaymentPlanSimInitialPaymentRateRequest, options?: any): AxiosPromise<LoanPaymentPlanSimInitialPaymentRateResponse> {
            return LoanPaymentPlanSimApiFp(configuration).getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Action Type Combo Values
         * @param {LoanPaymentPlanSimActionComboRequest} loanPaymentPlanSimActionComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimActionCombo(loanPaymentPlanSimActionComboRequest: LoanPaymentPlanSimActionComboRequest, options?: any): AxiosPromise<LoanPaymentPlanSimActionComboResponse> {
            return LoanPaymentPlanSimApiFp(configuration).getSimActionCombo(loanPaymentPlanSimActionComboRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Print Payment Plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPaymentPlan(options?: any): AxiosPromise<LoanPaymentPlanSimPrintResponse> {
            return LoanPaymentPlanSimApiFp(configuration).printPaymentPlan(options)(axios, basePath);
        },
    };
};

/**
 * LoanPaymentPlanSimApi - object-oriented interface
 * @export
 * @class LoanPaymentPlanSimApi
 * @extends {BaseAPI}
 */
export class LoanPaymentPlanSimApi extends BaseAPI {
    /**
     * 
     * @summary Calculate Auchan Loan Payment Plan
     * @param {LoanPaymentPlanSimAuchanCalculateRequest} loanPaymentPlanSimAuchanCalculateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest: LoanPaymentPlanSimAuchanCalculateRequest, options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).calculateAuchanLoanPaymentPlan(loanPaymentPlanSimAuchanCalculateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Calculate Car Loan Payment Plan
     * @param {LoanPaymentPlanSimCarCalculateRequest} loanPaymentPlanSimCarCalculateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest: LoanPaymentPlanSimCarCalculateRequest, options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).calculateCarLoanPaymentPlan(loanPaymentPlanSimCarCalculateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Calculate Holiday Loan Payment Plan
     * @param {LoanPaymentPlanSimHolidayCalculateRequest} loanPaymentPlanSimHolidayCalculateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest: LoanPaymentPlanSimHolidayCalculateRequest, options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).calculateHolidayLoanPaymentPlan(loanPaymentPlanSimHolidayCalculateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Calculate Instant Loan Payment Plan
     * @param {LoanPaymentPlanSimInstantCalculateRequest} loanPaymentPlanSimInstantCalculateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest: LoanPaymentPlanSimInstantCalculateRequest, options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).calculateInstantLoanPaymentPlan(loanPaymentPlanSimInstantCalculateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Initial Payment Rate
     * @param {LoanPaymentPlanSimInitialPaymentRateRequest} loanPaymentPlanSimInitialPaymentRateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest: LoanPaymentPlanSimInitialPaymentRateRequest, options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).getInitialPaymentRate(loanPaymentPlanSimInitialPaymentRateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Action Type Combo Values
     * @param {LoanPaymentPlanSimActionComboRequest} loanPaymentPlanSimActionComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public getSimActionCombo(loanPaymentPlanSimActionComboRequest: LoanPaymentPlanSimActionComboRequest, options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).getSimActionCombo(loanPaymentPlanSimActionComboRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Print Payment Plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPaymentPlanSimApi
     */
    public printPaymentPlan(options?: any) {
        return LoanPaymentPlanSimApiFp(this.configuration).printPaymentPlan(options)(this.axios, this.basePath);
    }

}


/**
 * LoanProductGlobalBonusPageValidationApi - axios parameter creator
 * @export
 */
export const LoanProductGlobalBonusPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan product global bonus page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanProductGlobalBonusPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-product-global-bonus-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan product global bonus page data
         * @param {ValidateLoanProductGlobalBonusPageDataRequest} validateLoanProductGlobalBonusPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest: ValidateLoanProductGlobalBonusPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanProductGlobalBonusPageDataRequest' is not null or undefined
            if (validateLoanProductGlobalBonusPageDataRequest === null || validateLoanProductGlobalBonusPageDataRequest === undefined) {
                throw new RequiredError('validateLoanProductGlobalBonusPageDataRequest','Required parameter validateLoanProductGlobalBonusPageDataRequest was null or undefined when calling validateLoanProductGlobalBonusPageData.');
            }
            const localVarPath = `/validate-loan-product-global-bonus-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanProductGlobalBonusPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanProductGlobalBonusPageDataRequest !== undefined ? validateLoanProductGlobalBonusPageDataRequest : {}) : (validateLoanProductGlobalBonusPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanProductGlobalBonusPageValidationApi - functional programming interface
 * @export
 */
export const LoanProductGlobalBonusPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan product global bonus page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanProductGlobalBonusPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductGlobalBonusPageDataResponse> {
            const localVarAxiosArgs = LoanProductGlobalBonusPageValidationApiAxiosParamCreator(configuration).getLoanProductGlobalBonusPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan product global bonus page data
         * @param {ValidateLoanProductGlobalBonusPageDataRequest} validateLoanProductGlobalBonusPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest: ValidateLoanProductGlobalBonusPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanProductGlobalBonusPageDataResponse> {
            const localVarAxiosArgs = LoanProductGlobalBonusPageValidationApiAxiosParamCreator(configuration).validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanProductGlobalBonusPageValidationApi - factory interface
 * @export
 */
export const LoanProductGlobalBonusPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan product global bonus page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanProductGlobalBonusPageData(options?: any): AxiosPromise<LoanProductGlobalBonusPageDataResponse> {
            return LoanProductGlobalBonusPageValidationApiFp(configuration).getLoanProductGlobalBonusPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan product global bonus page data
         * @param {ValidateLoanProductGlobalBonusPageDataRequest} validateLoanProductGlobalBonusPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest: ValidateLoanProductGlobalBonusPageDataRequest, options?: any): AxiosPromise<ValidateLoanProductGlobalBonusPageDataResponse> {
            return LoanProductGlobalBonusPageValidationApiFp(configuration).validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoanProductGlobalBonusPageValidationApi - object-oriented interface
 * @export
 * @class LoanProductGlobalBonusPageValidationApi
 * @extends {BaseAPI}
 */
export class LoanProductGlobalBonusPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get loan product global bonus page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductGlobalBonusPageValidationApi
     */
    public getLoanProductGlobalBonusPageData(options?: any) {
        return LoanProductGlobalBonusPageValidationApiFp(this.configuration).getLoanProductGlobalBonusPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan product global bonus page data
     * @param {ValidateLoanProductGlobalBonusPageDataRequest} validateLoanProductGlobalBonusPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductGlobalBonusPageValidationApi
     */
    public validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest: ValidateLoanProductGlobalBonusPageDataRequest, options?: any) {
        return LoanProductGlobalBonusPageValidationApiFp(this.configuration).validateLoanProductGlobalBonusPageData(validateLoanProductGlobalBonusPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LoanProductPageValidationApi - axios parameter creator
 * @export
 */
export const LoanProductPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan product page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanProductPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-product-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan product page data
         * @param {ValidateLoanProductPageDataRequest} validateLoanProductPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanProductPageData(validateLoanProductPageDataRequest: ValidateLoanProductPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanProductPageDataRequest' is not null or undefined
            if (validateLoanProductPageDataRequest === null || validateLoanProductPageDataRequest === undefined) {
                throw new RequiredError('validateLoanProductPageDataRequest','Required parameter validateLoanProductPageDataRequest was null or undefined when calling validateLoanProductPageData.');
            }
            const localVarPath = `/validate-loan-product-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanProductPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanProductPageDataRequest !== undefined ? validateLoanProductPageDataRequest : {}) : (validateLoanProductPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanProductPageValidationApi - functional programming interface
 * @export
 */
export const LoanProductPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan product page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanProductPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductPageDataResponse> {
            const localVarAxiosArgs = LoanProductPageValidationApiAxiosParamCreator(configuration).getLoanProductPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan product page data
         * @param {ValidateLoanProductPageDataRequest} validateLoanProductPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanProductPageData(validateLoanProductPageDataRequest: ValidateLoanProductPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanProductPageDataResponse> {
            const localVarAxiosArgs = LoanProductPageValidationApiAxiosParamCreator(configuration).validateLoanProductPageData(validateLoanProductPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanProductPageValidationApi - factory interface
 * @export
 */
export const LoanProductPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan product page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanProductPageData(options?: any): AxiosPromise<LoanProductPageDataResponse> {
            return LoanProductPageValidationApiFp(configuration).getLoanProductPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan product page data
         * @param {ValidateLoanProductPageDataRequest} validateLoanProductPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanProductPageData(validateLoanProductPageDataRequest: ValidateLoanProductPageDataRequest, options?: any): AxiosPromise<ValidateLoanProductPageDataResponse> {
            return LoanProductPageValidationApiFp(configuration).validateLoanProductPageData(validateLoanProductPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoanProductPageValidationApi - object-oriented interface
 * @export
 * @class LoanProductPageValidationApi
 * @extends {BaseAPI}
 */
export class LoanProductPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get loan product page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductPageValidationApi
     */
    public getLoanProductPageData(options?: any) {
        return LoanProductPageValidationApiFp(this.configuration).getLoanProductPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan product page data
     * @param {ValidateLoanProductPageDataRequest} validateLoanProductPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductPageValidationApi
     */
    public validateLoanProductPageData(validateLoanProductPageDataRequest: ValidateLoanProductPageDataRequest, options?: any) {
        return LoanProductPageValidationApiFp(this.configuration).validateLoanProductPageData(validateLoanProductPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LoanPurchaseReturnApi - axios parameter creator
 * @export
 */
export const LoanPurchaseReturnApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds to Pool
         * @param {LoanPurchaseReturnAddPoolRequest} loanPurchaseReturnAddPoolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPool(loanPurchaseReturnAddPoolRequest: LoanPurchaseReturnAddPoolRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPurchaseReturnAddPoolRequest' is not null or undefined
            if (loanPurchaseReturnAddPoolRequest === null || loanPurchaseReturnAddPoolRequest === undefined) {
                throw new RequiredError('loanPurchaseReturnAddPoolRequest','Required parameter loanPurchaseReturnAddPoolRequest was null or undefined when calling addPool.');
            }
            const localVarPath = `/loan-purchase-return/add-pool`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPurchaseReturnAddPoolRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPurchaseReturnAddPoolRequest !== undefined ? loanPurchaseReturnAddPoolRequest : {}) : (loanPurchaseReturnAddPoolRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check Document
         * @param {LoanPurchaseReturnCheckDocumentRequest} loanPurchaseReturnCheckDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDocuments(loanPurchaseReturnCheckDocumentRequest: LoanPurchaseReturnCheckDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPurchaseReturnCheckDocumentRequest' is not null or undefined
            if (loanPurchaseReturnCheckDocumentRequest === null || loanPurchaseReturnCheckDocumentRequest === undefined) {
                throw new RequiredError('loanPurchaseReturnCheckDocumentRequest','Required parameter loanPurchaseReturnCheckDocumentRequest was null or undefined when calling checkDocuments.');
            }
            const localVarPath = `/loan-purchase-return/check-documents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPurchaseReturnCheckDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPurchaseReturnCheckDocumentRequest !== undefined ? loanPurchaseReturnCheckDocumentRequest : {}) : (loanPurchaseReturnCheckDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loan Detail
         * @param {LoanPurchaseReturnLoanInfoRequest} loanPurchaseReturnLoanInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanInfo(loanPurchaseReturnLoanInfoRequest: LoanPurchaseReturnLoanInfoRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPurchaseReturnLoanInfoRequest' is not null or undefined
            if (loanPurchaseReturnLoanInfoRequest === null || loanPurchaseReturnLoanInfoRequest === undefined) {
                throw new RequiredError('loanPurchaseReturnLoanInfoRequest','Required parameter loanPurchaseReturnLoanInfoRequest was null or undefined when calling getLoanInfo.');
            }
            const localVarPath = `/loan-purchase-return/loan-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPurchaseReturnLoanInfoRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPurchaseReturnLoanInfoRequest !== undefined ? loanPurchaseReturnLoanInfoRequest : {}) : (loanPurchaseReturnLoanInfoRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Related Docs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedDocuments(options: any = {}): RequestArgs {
            const localVarPath = `/loan-purchase-return/get-related-docs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loan Query
         * @param {LoanPurchaseReturnQueryLoanRequest} loanPurchaseReturnQueryLoanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryLoan(loanPurchaseReturnQueryLoanRequest: LoanPurchaseReturnQueryLoanRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanPurchaseReturnQueryLoanRequest' is not null or undefined
            if (loanPurchaseReturnQueryLoanRequest === null || loanPurchaseReturnQueryLoanRequest === undefined) {
                throw new RequiredError('loanPurchaseReturnQueryLoanRequest','Required parameter loanPurchaseReturnQueryLoanRequest was null or undefined when calling queryLoan.');
            }
            const localVarPath = `/loan-purchase-return/query-loan`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanPurchaseReturnQueryLoanRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanPurchaseReturnQueryLoanRequest !== undefined ? loanPurchaseReturnQueryLoanRequest : {}) : (loanPurchaseReturnQueryLoanRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanPurchaseReturnApi - functional programming interface
 * @export
 */
export const LoanPurchaseReturnApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds to Pool
         * @param {LoanPurchaseReturnAddPoolRequest} loanPurchaseReturnAddPoolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPool(loanPurchaseReturnAddPoolRequest: LoanPurchaseReturnAddPoolRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPurchaseReturnAddPoolResponse> {
            const localVarAxiosArgs = LoanPurchaseReturnApiAxiosParamCreator(configuration).addPool(loanPurchaseReturnAddPoolRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Check Document
         * @param {LoanPurchaseReturnCheckDocumentRequest} loanPurchaseReturnCheckDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDocuments(loanPurchaseReturnCheckDocumentRequest: LoanPurchaseReturnCheckDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPurchaseReturnCheckDocumentResponse> {
            const localVarAxiosArgs = LoanPurchaseReturnApiAxiosParamCreator(configuration).checkDocuments(loanPurchaseReturnCheckDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Loan Detail
         * @param {LoanPurchaseReturnLoanInfoRequest} loanPurchaseReturnLoanInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanInfo(loanPurchaseReturnLoanInfoRequest: LoanPurchaseReturnLoanInfoRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPurchaseReturnLoanInfoResponse> {
            const localVarAxiosArgs = LoanPurchaseReturnApiAxiosParamCreator(configuration).getLoanInfo(loanPurchaseReturnLoanInfoRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets Related Docs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedDocuments(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPurchaseReturnGetRelatedDocsResponse> {
            const localVarAxiosArgs = LoanPurchaseReturnApiAxiosParamCreator(configuration).getRelatedDocuments(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Loan Query
         * @param {LoanPurchaseReturnQueryLoanRequest} loanPurchaseReturnQueryLoanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryLoan(loanPurchaseReturnQueryLoanRequest: LoanPurchaseReturnQueryLoanRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPurchaseReturnQueryLoanResponse> {
            const localVarAxiosArgs = LoanPurchaseReturnApiAxiosParamCreator(configuration).queryLoan(loanPurchaseReturnQueryLoanRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanPurchaseReturnApi - factory interface
 * @export
 */
export const LoanPurchaseReturnApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Adds to Pool
         * @param {LoanPurchaseReturnAddPoolRequest} loanPurchaseReturnAddPoolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPool(loanPurchaseReturnAddPoolRequest: LoanPurchaseReturnAddPoolRequest, options?: any): AxiosPromise<LoanPurchaseReturnAddPoolResponse> {
            return LoanPurchaseReturnApiFp(configuration).addPool(loanPurchaseReturnAddPoolRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Check Document
         * @param {LoanPurchaseReturnCheckDocumentRequest} loanPurchaseReturnCheckDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDocuments(loanPurchaseReturnCheckDocumentRequest: LoanPurchaseReturnCheckDocumentRequest, options?: any): AxiosPromise<LoanPurchaseReturnCheckDocumentResponse> {
            return LoanPurchaseReturnApiFp(configuration).checkDocuments(loanPurchaseReturnCheckDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Loan Detail
         * @param {LoanPurchaseReturnLoanInfoRequest} loanPurchaseReturnLoanInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanInfo(loanPurchaseReturnLoanInfoRequest: LoanPurchaseReturnLoanInfoRequest, options?: any): AxiosPromise<LoanPurchaseReturnLoanInfoResponse> {
            return LoanPurchaseReturnApiFp(configuration).getLoanInfo(loanPurchaseReturnLoanInfoRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Gets Related Docs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedDocuments(options?: any): AxiosPromise<LoanPurchaseReturnGetRelatedDocsResponse> {
            return LoanPurchaseReturnApiFp(configuration).getRelatedDocuments(options)(axios, basePath);
        },
        /**
         * 
         * @summary Loan Query
         * @param {LoanPurchaseReturnQueryLoanRequest} loanPurchaseReturnQueryLoanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryLoan(loanPurchaseReturnQueryLoanRequest: LoanPurchaseReturnQueryLoanRequest, options?: any): AxiosPromise<LoanPurchaseReturnQueryLoanResponse> {
            return LoanPurchaseReturnApiFp(configuration).queryLoan(loanPurchaseReturnQueryLoanRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoanPurchaseReturnApi - object-oriented interface
 * @export
 * @class LoanPurchaseReturnApi
 * @extends {BaseAPI}
 */
export class LoanPurchaseReturnApi extends BaseAPI {
    /**
     * 
     * @summary Adds to Pool
     * @param {LoanPurchaseReturnAddPoolRequest} loanPurchaseReturnAddPoolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPurchaseReturnApi
     */
    public addPool(loanPurchaseReturnAddPoolRequest: LoanPurchaseReturnAddPoolRequest, options?: any) {
        return LoanPurchaseReturnApiFp(this.configuration).addPool(loanPurchaseReturnAddPoolRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Check Document
     * @param {LoanPurchaseReturnCheckDocumentRequest} loanPurchaseReturnCheckDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPurchaseReturnApi
     */
    public checkDocuments(loanPurchaseReturnCheckDocumentRequest: LoanPurchaseReturnCheckDocumentRequest, options?: any) {
        return LoanPurchaseReturnApiFp(this.configuration).checkDocuments(loanPurchaseReturnCheckDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Loan Detail
     * @param {LoanPurchaseReturnLoanInfoRequest} loanPurchaseReturnLoanInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPurchaseReturnApi
     */
    public getLoanInfo(loanPurchaseReturnLoanInfoRequest: LoanPurchaseReturnLoanInfoRequest, options?: any) {
        return LoanPurchaseReturnApiFp(this.configuration).getLoanInfo(loanPurchaseReturnLoanInfoRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Gets Related Docs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPurchaseReturnApi
     */
    public getRelatedDocuments(options?: any) {
        return LoanPurchaseReturnApiFp(this.configuration).getRelatedDocuments(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Loan Query
     * @param {LoanPurchaseReturnQueryLoanRequest} loanPurchaseReturnQueryLoanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanPurchaseReturnApi
     */
    public queryLoan(loanPurchaseReturnQueryLoanRequest: LoanPurchaseReturnQueryLoanRequest, options?: any) {
        return LoanPurchaseReturnApiFp(this.configuration).queryLoan(loanPurchaseReturnQueryLoanRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LoanScoringApi - axios parameter creator
 * @export
 */
export const LoanScoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer additional job page info for loan scoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerAdditionalJobInfo(options: any = {}): RequestArgs {
            const localVarPath = `/loan-scoring/additional-info/job`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanScoringApi - functional programming interface
 * @export
 */
export const LoanScoringApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer additional job page info for loan scoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerAdditionalJobInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanScoringAdditionalJobInfoResponse> {
            const localVarAxiosArgs = LoanScoringApiAxiosParamCreator(configuration).getLoanCustomerAdditionalJobInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanScoringApi - factory interface
 * @export
 */
export const LoanScoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get customer additional job page info for loan scoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerAdditionalJobInfo(options?: any): AxiosPromise<LoanScoringAdditionalJobInfoResponse> {
            return LoanScoringApiFp(configuration).getLoanCustomerAdditionalJobInfo(options)(axios, basePath);
        },
    };
};

/**
 * LoanScoringApi - object-oriented interface
 * @export
 * @class LoanScoringApi
 * @extends {BaseAPI}
 */
export class LoanScoringApi extends BaseAPI {
    /**
     * 
     * @summary Get customer additional job page info for loan scoring
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanScoringApi
     */
    public getLoanCustomerAdditionalJobInfo(options?: any) {
        return LoanScoringApiFp(this.configuration).getLoanCustomerAdditionalJobInfo(options)(this.axios, this.basePath);
    }

}


/**
 * LoanSummaryApi - axios parameter creator
 * @export
 */
export const LoanSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Loan Summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSummaryInfo(options: any = {}): RequestArgs {
            const localVarPath = `/loan-summary`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Loan Summary Print Buttons Visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSummaryPrintButtons(options: any = {}): RequestArgs {
            const localVarPath = `/loan-summary/print-buttons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanSummaryApi - functional programming interface
 * @export
 */
export const LoanSummaryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Loan Summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSummaryInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanSummaryInfoResponse> {
            const localVarAxiosArgs = LoanSummaryApiAxiosParamCreator(configuration).getLoanSummaryInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Loan Summary Print Buttons Visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSummaryPrintButtons(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanSummaryPrintButtonsResponse> {
            const localVarAxiosArgs = LoanSummaryApiAxiosParamCreator(configuration).getLoanSummaryPrintButtons(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanSummaryApi - factory interface
 * @export
 */
export const LoanSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Loan Summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSummaryInfo(options?: any): AxiosPromise<LoanSummaryInfoResponse> {
            return LoanSummaryApiFp(configuration).getLoanSummaryInfo(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Loan Summary Print Buttons Visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSummaryPrintButtons(options?: any): AxiosPromise<LoanSummaryPrintButtonsResponse> {
            return LoanSummaryApiFp(configuration).getLoanSummaryPrintButtons(options)(axios, basePath);
        },
    };
};

/**
 * LoanSummaryApi - object-oriented interface
 * @export
 * @class LoanSummaryApi
 * @extends {BaseAPI}
 */
export class LoanSummaryApi extends BaseAPI {
    /**
     * 
     * @summary Get Loan Summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanSummaryApi
     */
    public getLoanSummaryInfo(options?: any) {
        return LoanSummaryApiFp(this.configuration).getLoanSummaryInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Loan Summary Print Buttons Visibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanSummaryApi
     */
    public getLoanSummaryPrintButtons(options?: any) {
        return LoanSummaryApiFp(this.configuration).getLoanSummaryPrintButtons(options)(this.axios, this.basePath);
    }

}


/**
 * LoanTotalCostApi - axios parameter creator
 * @export
 */
export const LoanTotalCostApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate Loan Deposit and Interest
         * @param {LoanTotalCostCalculateCarRequest} loanTotalCostCalculateCarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest: LoanTotalCostCalculateCarRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanTotalCostCalculateCarRequest' is not null or undefined
            if (loanTotalCostCalculateCarRequest === null || loanTotalCostCalculateCarRequest === undefined) {
                throw new RequiredError('loanTotalCostCalculateCarRequest','Required parameter loanTotalCostCalculateCarRequest was null or undefined when calling calculateCarDepositAndInterest.');
            }
            const localVarPath = `/loan-total-cost/calculate-car`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanTotalCostCalculateCarRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanTotalCostCalculateCarRequest !== undefined ? loanTotalCostCalculateCarRequest : {}) : (loanTotalCostCalculateCarRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate Loan Deposit and Interest
         * @param {LoanTotalCostCalculateRequest} loanTotalCostCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDepositAndInterest(loanTotalCostCalculateRequest: LoanTotalCostCalculateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loanTotalCostCalculateRequest' is not null or undefined
            if (loanTotalCostCalculateRequest === null || loanTotalCostCalculateRequest === undefined) {
                throw new RequiredError('loanTotalCostCalculateRequest','Required parameter loanTotalCostCalculateRequest was null or undefined when calling calculateDepositAndInterest.');
            }
            const localVarPath = `/loan-total-cost/calculate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loanTotalCostCalculateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loanTotalCostCalculateRequest !== undefined ? loanTotalCostCalculateRequest : {}) : (loanTotalCostCalculateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Loan Total Cost Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(options: any = {}): RequestArgs {
            const localVarPath = `/loan-total-cost/summary`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Loan Total Cost Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryCar(options: any = {}): RequestArgs {
            const localVarPath = `/loan-total-cost/summary-car`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanTotalCostApi - functional programming interface
 * @export
 */
export const LoanTotalCostApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate Loan Deposit and Interest
         * @param {LoanTotalCostCalculateCarRequest} loanTotalCostCalculateCarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest: LoanTotalCostCalculateCarRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanTotalCostCalculateCarResponse> {
            const localVarAxiosArgs = LoanTotalCostApiAxiosParamCreator(configuration).calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Calculate Loan Deposit and Interest
         * @param {LoanTotalCostCalculateRequest} loanTotalCostCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDepositAndInterest(loanTotalCostCalculateRequest: LoanTotalCostCalculateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanTotalCostCalculateResponse> {
            const localVarAxiosArgs = LoanTotalCostApiAxiosParamCreator(configuration).calculateDepositAndInterest(loanTotalCostCalculateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Loan Total Cost Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanTotalCostSummaryResponse> {
            const localVarAxiosArgs = LoanTotalCostApiAxiosParamCreator(configuration).getSummary(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Loan Total Cost Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryCar(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanTotalCostSummaryCarResponse> {
            const localVarAxiosArgs = LoanTotalCostApiAxiosParamCreator(configuration).getSummaryCar(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanTotalCostApi - factory interface
 * @export
 */
export const LoanTotalCostApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Calculate Loan Deposit and Interest
         * @param {LoanTotalCostCalculateCarRequest} loanTotalCostCalculateCarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest: LoanTotalCostCalculateCarRequest, options?: any): AxiosPromise<LoanTotalCostCalculateCarResponse> {
            return LoanTotalCostApiFp(configuration).calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Calculate Loan Deposit and Interest
         * @param {LoanTotalCostCalculateRequest} loanTotalCostCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDepositAndInterest(loanTotalCostCalculateRequest: LoanTotalCostCalculateRequest, options?: any): AxiosPromise<LoanTotalCostCalculateResponse> {
            return LoanTotalCostApiFp(configuration).calculateDepositAndInterest(loanTotalCostCalculateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Loan Total Cost Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(options?: any): AxiosPromise<LoanTotalCostSummaryResponse> {
            return LoanTotalCostApiFp(configuration).getSummary(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Loan Total Cost Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryCar(options?: any): AxiosPromise<LoanTotalCostSummaryCarResponse> {
            return LoanTotalCostApiFp(configuration).getSummaryCar(options)(axios, basePath);
        },
    };
};

/**
 * LoanTotalCostApi - object-oriented interface
 * @export
 * @class LoanTotalCostApi
 * @extends {BaseAPI}
 */
export class LoanTotalCostApi extends BaseAPI {
    /**
     * 
     * @summary Calculate Loan Deposit and Interest
     * @param {LoanTotalCostCalculateCarRequest} loanTotalCostCalculateCarRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanTotalCostApi
     */
    public calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest: LoanTotalCostCalculateCarRequest, options?: any) {
        return LoanTotalCostApiFp(this.configuration).calculateCarDepositAndInterest(loanTotalCostCalculateCarRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Calculate Loan Deposit and Interest
     * @param {LoanTotalCostCalculateRequest} loanTotalCostCalculateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanTotalCostApi
     */
    public calculateDepositAndInterest(loanTotalCostCalculateRequest: LoanTotalCostCalculateRequest, options?: any) {
        return LoanTotalCostApiFp(this.configuration).calculateDepositAndInterest(loanTotalCostCalculateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Loan Total Cost Summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanTotalCostApi
     */
    public getSummary(options?: any) {
        return LoanTotalCostApiFp(this.configuration).getSummary(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Loan Total Cost Summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanTotalCostApi
     */
    public getSummaryCar(options?: any) {
        return LoanTotalCostApiFp(this.configuration).getSummaryCar(options)(this.axios, this.basePath);
    }

}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest?: LoginRequest, options: any = {}): RequestArgs {
            const localVarPath = `/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loginRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loginRequest !== undefined ? loginRequest : {}) : (loginRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest?: LoginRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse> {
            const localVarAxiosArgs = LoginApiAxiosParamCreator(configuration).login(loginRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Login
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest?: LoginRequest, options?: any): AxiosPromise<LoginResponse> {
            return LoginApiFp(configuration).login(loginRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 
     * @summary Login
     * @param {LoginRequest} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public login(loginRequest?: LoginRequest, options?: any) {
        return LoginApiFp(this.configuration).login(loginRequest, options)(this.axios, this.basePath);
    }

}


/**
 * LogoutApi - axios parameter creator
 * @export
 */
export const LogoutApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options: any = {}): RequestArgs {
            const localVarPath = `/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogoutApi - functional programming interface
 * @export
 */
export const LogoutApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = LogoutApiAxiosParamCreator(configuration).logout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LogoutApi - factory interface
 * @export
 */
export const LogoutApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<Response> {
            return LogoutApiFp(configuration).logout(options)(axios, basePath);
        },
    };
};

/**
 * LogoutApi - object-oriented interface
 * @export
 * @class LogoutApi
 * @extends {BaseAPI}
 */
export class LogoutApi extends BaseAPI {
    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoutApi
     */
    public logout(options?: any) {
        return LogoutApiFp(this.configuration).logout(options)(this.axios, this.basePath);
    }

}


/**
 * NewObserveApi - axios parameter creator
 * @export
 */
export const NewObserveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Button action on new observe screen
         * @param {NewObserveButtonActionRequest} newObserveButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buttonAction(newObserveButtonActionRequest: NewObserveButtonActionRequest, options: any = {}): RequestArgs {
            // verify required parameter 'newObserveButtonActionRequest' is not null or undefined
            if (newObserveButtonActionRequest === null || newObserveButtonActionRequest === undefined) {
                throw new RequiredError('newObserveButtonActionRequest','Required parameter newObserveButtonActionRequest was null or undefined when calling buttonAction.');
            }
            const localVarPath = `/new-observe/button-action`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newObserveButtonActionRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newObserveButtonActionRequest !== undefined ? newObserveButtonActionRequest : {}) : (newObserveButtonActionRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get buttons visibility on new observe screen
         * @param {NewObserveButtonVisibilityRequest} newObserveButtonVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getButtonsVisibility(newObserveButtonVisibilityRequest: NewObserveButtonVisibilityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'newObserveButtonVisibilityRequest' is not null or undefined
            if (newObserveButtonVisibilityRequest === null || newObserveButtonVisibilityRequest === undefined) {
                throw new RequiredError('newObserveButtonVisibilityRequest','Required parameter newObserveButtonVisibilityRequest was null or undefined when calling getButtonsVisibility.');
            }
            const localVarPath = `/new-observe/buttons-visibility`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newObserveButtonVisibilityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newObserveButtonVisibilityRequest !== undefined ? newObserveButtonVisibilityRequest : {}) : (newObserveButtonVisibilityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get loans new observe screen
         * @param {NewObserveSearchRequest} newObserveSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoansData(newObserveSearchRequest: NewObserveSearchRequest, options: any = {}): RequestArgs {
            // verify required parameter 'newObserveSearchRequest' is not null or undefined
            if (newObserveSearchRequest === null || newObserveSearchRequest === undefined) {
                throw new RequiredError('newObserveSearchRequest','Required parameter newObserveSearchRequest was null or undefined when calling getLoansData.');
            }
            const localVarPath = `/new-observe/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newObserveSearchRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newObserveSearchRequest !== undefined ? newObserveSearchRequest : {}) : (newObserveSearchRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewObserveApi - functional programming interface
 * @export
 */
export const NewObserveApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Button action on new observe screen
         * @param {NewObserveButtonActionRequest} newObserveButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buttonAction(newObserveButtonActionRequest: NewObserveButtonActionRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewObserveButtonActionResponse> {
            const localVarAxiosArgs = NewObserveApiAxiosParamCreator(configuration).buttonAction(newObserveButtonActionRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get buttons visibility on new observe screen
         * @param {NewObserveButtonVisibilityRequest} newObserveButtonVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getButtonsVisibility(newObserveButtonVisibilityRequest: NewObserveButtonVisibilityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewObserveButtonVisibilityResponse> {
            const localVarAxiosArgs = NewObserveApiAxiosParamCreator(configuration).getButtonsVisibility(newObserveButtonVisibilityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get loans new observe screen
         * @param {NewObserveSearchRequest} newObserveSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoansData(newObserveSearchRequest: NewObserveSearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewObserveSearchResponse> {
            const localVarAxiosArgs = NewObserveApiAxiosParamCreator(configuration).getLoansData(newObserveSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewObserveApi - factory interface
 * @export
 */
export const NewObserveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Button action on new observe screen
         * @param {NewObserveButtonActionRequest} newObserveButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buttonAction(newObserveButtonActionRequest: NewObserveButtonActionRequest, options?: any): AxiosPromise<NewObserveButtonActionResponse> {
            return NewObserveApiFp(configuration).buttonAction(newObserveButtonActionRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get buttons visibility on new observe screen
         * @param {NewObserveButtonVisibilityRequest} newObserveButtonVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getButtonsVisibility(newObserveButtonVisibilityRequest: NewObserveButtonVisibilityRequest, options?: any): AxiosPromise<NewObserveButtonVisibilityResponse> {
            return NewObserveApiFp(configuration).getButtonsVisibility(newObserveButtonVisibilityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get loans new observe screen
         * @param {NewObserveSearchRequest} newObserveSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoansData(newObserveSearchRequest: NewObserveSearchRequest, options?: any): AxiosPromise<NewObserveSearchResponse> {
            return NewObserveApiFp(configuration).getLoansData(newObserveSearchRequest, options)(axios, basePath);
        },
    };
};

/**
 * NewObserveApi - object-oriented interface
 * @export
 * @class NewObserveApi
 * @extends {BaseAPI}
 */
export class NewObserveApi extends BaseAPI {
    /**
     * 
     * @summary Button action on new observe screen
     * @param {NewObserveButtonActionRequest} newObserveButtonActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewObserveApi
     */
    public buttonAction(newObserveButtonActionRequest: NewObserveButtonActionRequest, options?: any) {
        return NewObserveApiFp(this.configuration).buttonAction(newObserveButtonActionRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get buttons visibility on new observe screen
     * @param {NewObserveButtonVisibilityRequest} newObserveButtonVisibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewObserveApi
     */
    public getButtonsVisibility(newObserveButtonVisibilityRequest: NewObserveButtonVisibilityRequest, options?: any) {
        return NewObserveApiFp(this.configuration).getButtonsVisibility(newObserveButtonVisibilityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get loans new observe screen
     * @param {NewObserveSearchRequest} newObserveSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewObserveApi
     */
    public getLoansData(newObserveSearchRequest: NewObserveSearchRequest, options?: any) {
        return NewObserveApiFp(this.configuration).getLoansData(newObserveSearchRequest, options)(this.axios, this.basePath);
    }

}


/**
 * NewSettlementApi - axios parameter creator
 * @export
 */
export const NewSettlementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary generate new settlement report
         * @param {NewSettlementReportRequest} newSettlementReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNewSettlementReport(newSettlementReportRequest: NewSettlementReportRequest, options: any = {}): RequestArgs {
            // verify required parameter 'newSettlementReportRequest' is not null or undefined
            if (newSettlementReportRequest === null || newSettlementReportRequest === undefined) {
                throw new RequiredError('newSettlementReportRequest','Required parameter newSettlementReportRequest was null or undefined when calling generateNewSettlementReport.');
            }
            const localVarPath = `/new-settlement/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newSettlementReportRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newSettlementReportRequest !== undefined ? newSettlementReportRequest : {}) : (newSettlementReportRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get New Settlement Combos
         * @param {NewSettlementComboRequest} newSettlementComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewSettlementCombo(newSettlementComboRequest: NewSettlementComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'newSettlementComboRequest' is not null or undefined
            if (newSettlementComboRequest === null || newSettlementComboRequest === undefined) {
                throw new RequiredError('newSettlementComboRequest','Required parameter newSettlementComboRequest was null or undefined when calling getNewSettlementCombo.');
            }
            const localVarPath = `/new-settlement/combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newSettlementComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newSettlementComboRequest !== undefined ? newSettlementComboRequest : {}) : (newSettlementComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewSettlementApi - functional programming interface
 * @export
 */
export const NewSettlementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary generate new settlement report
         * @param {NewSettlementReportRequest} newSettlementReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNewSettlementReport(newSettlementReportRequest: NewSettlementReportRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewSettlementReportResponse> {
            const localVarAxiosArgs = NewSettlementApiAxiosParamCreator(configuration).generateNewSettlementReport(newSettlementReportRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get New Settlement Combos
         * @param {NewSettlementComboRequest} newSettlementComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewSettlementCombo(newSettlementComboRequest: NewSettlementComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewSettlementComboResponse> {
            const localVarAxiosArgs = NewSettlementApiAxiosParamCreator(configuration).getNewSettlementCombo(newSettlementComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewSettlementApi - factory interface
 * @export
 */
export const NewSettlementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary generate new settlement report
         * @param {NewSettlementReportRequest} newSettlementReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNewSettlementReport(newSettlementReportRequest: NewSettlementReportRequest, options?: any): AxiosPromise<NewSettlementReportResponse> {
            return NewSettlementApiFp(configuration).generateNewSettlementReport(newSettlementReportRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get New Settlement Combos
         * @param {NewSettlementComboRequest} newSettlementComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewSettlementCombo(newSettlementComboRequest: NewSettlementComboRequest, options?: any): AxiosPromise<NewSettlementComboResponse> {
            return NewSettlementApiFp(configuration).getNewSettlementCombo(newSettlementComboRequest, options)(axios, basePath);
        },
    };
};

/**
 * NewSettlementApi - object-oriented interface
 * @export
 * @class NewSettlementApi
 * @extends {BaseAPI}
 */
export class NewSettlementApi extends BaseAPI {
    /**
     * 
     * @summary generate new settlement report
     * @param {NewSettlementReportRequest} newSettlementReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewSettlementApi
     */
    public generateNewSettlementReport(newSettlementReportRequest: NewSettlementReportRequest, options?: any) {
        return NewSettlementApiFp(this.configuration).generateNewSettlementReport(newSettlementReportRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get New Settlement Combos
     * @param {NewSettlementComboRequest} newSettlementComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewSettlementApi
     */
    public getNewSettlementCombo(newSettlementComboRequest: NewSettlementComboRequest, options?: any) {
        return NewSettlementApiFp(this.configuration).getNewSettlementCombo(newSettlementComboRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ParameterApi - axios parameter creator
 * @export
 */
export const ParameterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get parameters
         * @param {ParameterRequest} parameterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter(parameterRequest: ParameterRequest, options: any = {}): RequestArgs {
            // verify required parameter 'parameterRequest' is not null or undefined
            if (parameterRequest === null || parameterRequest === undefined) {
                throw new RequiredError('parameterRequest','Required parameter parameterRequest was null or undefined when calling getParameter.');
            }
            const localVarPath = `/parameter`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof parameterRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(parameterRequest !== undefined ? parameterRequest : {}) : (parameterRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reference data
         * @param {ReferenceDataRequest} referenceDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceData(referenceDataRequest: ReferenceDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'referenceDataRequest' is not null or undefined
            if (referenceDataRequest === null || referenceDataRequest === undefined) {
                throw new RequiredError('referenceDataRequest','Required parameter referenceDataRequest was null or undefined when calling getReferenceData.');
            }
            const localVarPath = `/parameter/reference-data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof referenceDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(referenceDataRequest !== undefined ? referenceDataRequest : {}) : (referenceDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParameterApi - functional programming interface
 * @export
 */
export const ParameterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get parameters
         * @param {ParameterRequest} parameterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter(parameterRequest: ParameterRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParameterResponse> {
            const localVarAxiosArgs = ParameterApiAxiosParamCreator(configuration).getParameter(parameterRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get reference data
         * @param {ReferenceDataRequest} referenceDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceData(referenceDataRequest: ReferenceDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDataResponse> {
            const localVarAxiosArgs = ParameterApiAxiosParamCreator(configuration).getReferenceData(referenceDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ParameterApi - factory interface
 * @export
 */
export const ParameterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get parameters
         * @param {ParameterRequest} parameterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter(parameterRequest: ParameterRequest, options?: any): AxiosPromise<ParameterResponse> {
            return ParameterApiFp(configuration).getParameter(parameterRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get reference data
         * @param {ReferenceDataRequest} referenceDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceData(referenceDataRequest: ReferenceDataRequest, options?: any): AxiosPromise<ReferenceDataResponse> {
            return ParameterApiFp(configuration).getReferenceData(referenceDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ParameterApi - object-oriented interface
 * @export
 * @class ParameterApi
 * @extends {BaseAPI}
 */
export class ParameterApi extends BaseAPI {
    /**
     * 
     * @summary Get parameters
     * @param {ParameterRequest} parameterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    public getParameter(parameterRequest: ParameterRequest, options?: any) {
        return ParameterApiFp(this.configuration).getParameter(parameterRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get reference data
     * @param {ReferenceDataRequest} referenceDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    public getReferenceData(referenceDataRequest: ReferenceDataRequest, options?: any) {
        return ParameterApiFp(this.configuration).getReferenceData(referenceDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * PlasticCardApi - axios parameter creator
 * @export
 */
export const PlasticCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Plastic Card Account Document
         * @param {PlasticCardAccountDocumentRequest} plasticCardAccountDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest: PlasticCardAccountDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'plasticCardAccountDocumentRequest' is not null or undefined
            if (plasticCardAccountDocumentRequest === null || plasticCardAccountDocumentRequest === undefined) {
                throw new RequiredError('plasticCardAccountDocumentRequest','Required parameter plasticCardAccountDocumentRequest was null or undefined when calling generatePlasticCardAccountDocument.');
            }
            const localVarPath = `/plastic-card/account-document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof plasticCardAccountDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(plasticCardAccountDocumentRequest !== undefined ? plasticCardAccountDocumentRequest : {}) : (plasticCardAccountDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Plastic Card Application
         * @param {PlasticCardApplyRequest} plasticCardApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePlasticCardApplication(plasticCardApplyRequest: PlasticCardApplyRequest, options: any = {}): RequestArgs {
            // verify required parameter 'plasticCardApplyRequest' is not null or undefined
            if (plasticCardApplyRequest === null || plasticCardApplyRequest === undefined) {
                throw new RequiredError('plasticCardApplyRequest','Required parameter plasticCardApplyRequest was null or undefined when calling generatePlasticCardApplication.');
            }
            const localVarPath = `/plastic-card/apply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof plasticCardApplyRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(plasticCardApplyRequest !== undefined ? plasticCardApplyRequest : {}) : (plasticCardApplyRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Act Number Combo
         * @param {PlasticCardActNumberComboRequest} plasticCardActNumberComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActNumberCombo(plasticCardActNumberComboRequest: PlasticCardActNumberComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'plasticCardActNumberComboRequest' is not null or undefined
            if (plasticCardActNumberComboRequest === null || plasticCardActNumberComboRequest === undefined) {
                throw new RequiredError('plasticCardActNumberComboRequest','Required parameter plasticCardActNumberComboRequest was null or undefined when calling getActNumberCombo.');
            }
            const localVarPath = `/plastic-card/act-number-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof plasticCardActNumberComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(plasticCardActNumberComboRequest !== undefined ? plasticCardActNumberComboRequest : {}) : (plasticCardActNumberComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Additional Info Components on plastic card screen
         * @param {PlasticCardAdditionalInfoComponentsRequest} plasticCardAdditionalInfoComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest: PlasticCardAdditionalInfoComponentsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'plasticCardAdditionalInfoComponentsRequest' is not null or undefined
            if (plasticCardAdditionalInfoComponentsRequest === null || plasticCardAdditionalInfoComponentsRequest === undefined) {
                throw new RequiredError('plasticCardAdditionalInfoComponentsRequest','Required parameter plasticCardAdditionalInfoComponentsRequest was null or undefined when calling getAdditionalInfoComponents.');
            }
            const localVarPath = `/plastic-card/additional-info-components`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof plasticCardAdditionalInfoComponentsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(plasticCardAdditionalInfoComponentsRequest !== undefined ? plasticCardAdditionalInfoComponentsRequest : {}) : (plasticCardAdditionalInfoComponentsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Plastic Card Account List
         * @param {PlasticCardAccountsSearchRequest} plasticCardAccountsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlasticCardAccountList(plasticCardAccountsSearchRequest: PlasticCardAccountsSearchRequest, options: any = {}): RequestArgs {
            // verify required parameter 'plasticCardAccountsSearchRequest' is not null or undefined
            if (plasticCardAccountsSearchRequest === null || plasticCardAccountsSearchRequest === undefined) {
                throw new RequiredError('plasticCardAccountsSearchRequest','Required parameter plasticCardAccountsSearchRequest was null or undefined when calling getPlasticCardAccountList.');
            }
            const localVarPath = `/plastic-card/accounts-search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof plasticCardAccountsSearchRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(plasticCardAccountsSearchRequest !== undefined ? plasticCardAccountsSearchRequest : {}) : (plasticCardAccountsSearchRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Plastic Card Operation List
         * @param {PlasticCardOperationsSearchRequest} plasticCardOperationsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlasticCardOperationList(plasticCardOperationsSearchRequest: PlasticCardOperationsSearchRequest, options: any = {}): RequestArgs {
            // verify required parameter 'plasticCardOperationsSearchRequest' is not null or undefined
            if (plasticCardOperationsSearchRequest === null || plasticCardOperationsSearchRequest === undefined) {
                throw new RequiredError('plasticCardOperationsSearchRequest','Required parameter plasticCardOperationsSearchRequest was null or undefined when calling getPlasticCardOperationList.');
            }
            const localVarPath = `/plastic-card/operations-search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof plasticCardOperationsSearchRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(plasticCardOperationsSearchRequest !== undefined ? plasticCardOperationsSearchRequest : {}) : (plasticCardOperationsSearchRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlasticCardApi - functional programming interface
 * @export
 */
export const PlasticCardApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Plastic Card Account Document
         * @param {PlasticCardAccountDocumentRequest} plasticCardAccountDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest: PlasticCardAccountDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlasticCardAccountDocumentResponse> {
            const localVarAxiosArgs = PlasticCardApiAxiosParamCreator(configuration).generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generate Plastic Card Application
         * @param {PlasticCardApplyRequest} plasticCardApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePlasticCardApplication(plasticCardApplyRequest: PlasticCardApplyRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlasticCardApplyResponse> {
            const localVarAxiosArgs = PlasticCardApiAxiosParamCreator(configuration).generatePlasticCardApplication(plasticCardApplyRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Act Number Combo
         * @param {PlasticCardActNumberComboRequest} plasticCardActNumberComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActNumberCombo(plasticCardActNumberComboRequest: PlasticCardActNumberComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlasticCardActNumberComboResponse> {
            const localVarAxiosArgs = PlasticCardApiAxiosParamCreator(configuration).getActNumberCombo(plasticCardActNumberComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Additional Info Components on plastic card screen
         * @param {PlasticCardAdditionalInfoComponentsRequest} plasticCardAdditionalInfoComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest: PlasticCardAdditionalInfoComponentsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlasticCardAdditionalInfoComponentsResponse> {
            const localVarAxiosArgs = PlasticCardApiAxiosParamCreator(configuration).getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Plastic Card Account List
         * @param {PlasticCardAccountsSearchRequest} plasticCardAccountsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlasticCardAccountList(plasticCardAccountsSearchRequest: PlasticCardAccountsSearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlasticCardAccountsSearchResponse> {
            const localVarAxiosArgs = PlasticCardApiAxiosParamCreator(configuration).getPlasticCardAccountList(plasticCardAccountsSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Plastic Card Operation List
         * @param {PlasticCardOperationsSearchRequest} plasticCardOperationsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlasticCardOperationList(plasticCardOperationsSearchRequest: PlasticCardOperationsSearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlasticCardOperationsSearchResponse> {
            const localVarAxiosArgs = PlasticCardApiAxiosParamCreator(configuration).getPlasticCardOperationList(plasticCardOperationsSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PlasticCardApi - factory interface
 * @export
 */
export const PlasticCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Generate Plastic Card Account Document
         * @param {PlasticCardAccountDocumentRequest} plasticCardAccountDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest: PlasticCardAccountDocumentRequest, options?: any): AxiosPromise<PlasticCardAccountDocumentResponse> {
            return PlasticCardApiFp(configuration).generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Generate Plastic Card Application
         * @param {PlasticCardApplyRequest} plasticCardApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePlasticCardApplication(plasticCardApplyRequest: PlasticCardApplyRequest, options?: any): AxiosPromise<PlasticCardApplyResponse> {
            return PlasticCardApiFp(configuration).generatePlasticCardApplication(plasticCardApplyRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Act Number Combo
         * @param {PlasticCardActNumberComboRequest} plasticCardActNumberComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActNumberCombo(plasticCardActNumberComboRequest: PlasticCardActNumberComboRequest, options?: any): AxiosPromise<PlasticCardActNumberComboResponse> {
            return PlasticCardApiFp(configuration).getActNumberCombo(plasticCardActNumberComboRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Additional Info Components on plastic card screen
         * @param {PlasticCardAdditionalInfoComponentsRequest} plasticCardAdditionalInfoComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest: PlasticCardAdditionalInfoComponentsRequest, options?: any): AxiosPromise<PlasticCardAdditionalInfoComponentsResponse> {
            return PlasticCardApiFp(configuration).getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Plastic Card Account List
         * @param {PlasticCardAccountsSearchRequest} plasticCardAccountsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlasticCardAccountList(plasticCardAccountsSearchRequest: PlasticCardAccountsSearchRequest, options?: any): AxiosPromise<PlasticCardAccountsSearchResponse> {
            return PlasticCardApiFp(configuration).getPlasticCardAccountList(plasticCardAccountsSearchRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Plastic Card Operation List
         * @param {PlasticCardOperationsSearchRequest} plasticCardOperationsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlasticCardOperationList(plasticCardOperationsSearchRequest: PlasticCardOperationsSearchRequest, options?: any): AxiosPromise<PlasticCardOperationsSearchResponse> {
            return PlasticCardApiFp(configuration).getPlasticCardOperationList(plasticCardOperationsSearchRequest, options)(axios, basePath);
        },
    };
};

/**
 * PlasticCardApi - object-oriented interface
 * @export
 * @class PlasticCardApi
 * @extends {BaseAPI}
 */
export class PlasticCardApi extends BaseAPI {
    /**
     * 
     * @summary Generate Plastic Card Account Document
     * @param {PlasticCardAccountDocumentRequest} plasticCardAccountDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlasticCardApi
     */
    public generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest: PlasticCardAccountDocumentRequest, options?: any) {
        return PlasticCardApiFp(this.configuration).generatePlasticCardAccountDocument(plasticCardAccountDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Generate Plastic Card Application
     * @param {PlasticCardApplyRequest} plasticCardApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlasticCardApi
     */
    public generatePlasticCardApplication(plasticCardApplyRequest: PlasticCardApplyRequest, options?: any) {
        return PlasticCardApiFp(this.configuration).generatePlasticCardApplication(plasticCardApplyRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Act Number Combo
     * @param {PlasticCardActNumberComboRequest} plasticCardActNumberComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlasticCardApi
     */
    public getActNumberCombo(plasticCardActNumberComboRequest: PlasticCardActNumberComboRequest, options?: any) {
        return PlasticCardApiFp(this.configuration).getActNumberCombo(plasticCardActNumberComboRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Additional Info Components on plastic card screen
     * @param {PlasticCardAdditionalInfoComponentsRequest} plasticCardAdditionalInfoComponentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlasticCardApi
     */
    public getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest: PlasticCardAdditionalInfoComponentsRequest, options?: any) {
        return PlasticCardApiFp(this.configuration).getAdditionalInfoComponents(plasticCardAdditionalInfoComponentsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Plastic Card Account List
     * @param {PlasticCardAccountsSearchRequest} plasticCardAccountsSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlasticCardApi
     */
    public getPlasticCardAccountList(plasticCardAccountsSearchRequest: PlasticCardAccountsSearchRequest, options?: any) {
        return PlasticCardApiFp(this.configuration).getPlasticCardAccountList(plasticCardAccountsSearchRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Plastic Card Operation List
     * @param {PlasticCardOperationsSearchRequest} plasticCardOperationsSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlasticCardApi
     */
    public getPlasticCardOperationList(plasticCardOperationsSearchRequest: PlasticCardOperationsSearchRequest, options?: any) {
        return PlasticCardApiFp(this.configuration).getPlasticCardOperationList(plasticCardOperationsSearchRequest, options)(this.axios, this.basePath);
    }

}


/**
 * PosActivationApi - axios parameter creator
 * @export
 */
export const PosActivationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary activate card
         * @param {PosActivateRequest} posActivateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCard(posActivateRequest: PosActivateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'posActivateRequest' is not null or undefined
            if (posActivateRequest === null || posActivateRequest === undefined) {
                throw new RequiredError('posActivateRequest','Required parameter posActivateRequest was null or undefined when calling activateCard.');
            }
            const localVarPath = `/pos-activation/activate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof posActivateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(posActivateRequest !== undefined ? posActivateRequest : {}) : (posActivateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generate pos activation document
         * @param {PosActivationDocumentRequest} posActivationDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePosActivationDocument(posActivationDocumentRequest: PosActivationDocumentRequest, options: any = {}): RequestArgs {
            // verify required parameter 'posActivationDocumentRequest' is not null or undefined
            if (posActivationDocumentRequest === null || posActivationDocumentRequest === undefined) {
                throw new RequiredError('posActivationDocumentRequest','Required parameter posActivationDocumentRequest was null or undefined when calling generatePosActivationDocument.');
            }
            const localVarPath = `/pos-activation/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof posActivationDocumentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(posActivationDocumentRequest !== undefined ? posActivationDocumentRequest : {}) : (posActivationDocumentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary lists cards
         * @param {PosCardsRequest} posCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosCards(posCardsRequest: PosCardsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'posCardsRequest' is not null or undefined
            if (posCardsRequest === null || posCardsRequest === undefined) {
                throw new RequiredError('posCardsRequest','Required parameter posCardsRequest was null or undefined when calling getPosCards.');
            }
            const localVarPath = `/pos-activation/cards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof posCardsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(posCardsRequest !== undefined ? posCardsRequest : {}) : (posCardsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request pos activation
         * @param {PosActivationRequest} posActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPosActivation(posActivationRequest: PosActivationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'posActivationRequest' is not null or undefined
            if (posActivationRequest === null || posActivationRequest === undefined) {
                throw new RequiredError('posActivationRequest','Required parameter posActivationRequest was null or undefined when calling requestPosActivation.');
            }
            const localVarPath = `/pos-activation/request`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof posActivationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(posActivationRequest !== undefined ? posActivationRequest : {}) : (posActivationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PosActivationApi - functional programming interface
 * @export
 */
export const PosActivationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary activate card
         * @param {PosActivateRequest} posActivateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCard(posActivateRequest: PosActivateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosActivateResponse> {
            const localVarAxiosArgs = PosActivationApiAxiosParamCreator(configuration).activateCard(posActivateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary generate pos activation document
         * @param {PosActivationDocumentRequest} posActivationDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePosActivationDocument(posActivationDocumentRequest: PosActivationDocumentRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosActivationDocumentResponse> {
            const localVarAxiosArgs = PosActivationApiAxiosParamCreator(configuration).generatePosActivationDocument(posActivationDocumentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary lists cards
         * @param {PosCardsRequest} posCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosCards(posCardsRequest: PosCardsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosCardsResponse> {
            const localVarAxiosArgs = PosActivationApiAxiosParamCreator(configuration).getPosCards(posCardsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary request pos activation
         * @param {PosActivationRequest} posActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPosActivation(posActivationRequest: PosActivationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosActivationResponse> {
            const localVarAxiosArgs = PosActivationApiAxiosParamCreator(configuration).requestPosActivation(posActivationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PosActivationApi - factory interface
 * @export
 */
export const PosActivationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary activate card
         * @param {PosActivateRequest} posActivateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCard(posActivateRequest: PosActivateRequest, options?: any): AxiosPromise<PosActivateResponse> {
            return PosActivationApiFp(configuration).activateCard(posActivateRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary generate pos activation document
         * @param {PosActivationDocumentRequest} posActivationDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePosActivationDocument(posActivationDocumentRequest: PosActivationDocumentRequest, options?: any): AxiosPromise<PosActivationDocumentResponse> {
            return PosActivationApiFp(configuration).generatePosActivationDocument(posActivationDocumentRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary lists cards
         * @param {PosCardsRequest} posCardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosCards(posCardsRequest: PosCardsRequest, options?: any): AxiosPromise<PosCardsResponse> {
            return PosActivationApiFp(configuration).getPosCards(posCardsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary request pos activation
         * @param {PosActivationRequest} posActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPosActivation(posActivationRequest: PosActivationRequest, options?: any): AxiosPromise<PosActivationResponse> {
            return PosActivationApiFp(configuration).requestPosActivation(posActivationRequest, options)(axios, basePath);
        },
    };
};

/**
 * PosActivationApi - object-oriented interface
 * @export
 * @class PosActivationApi
 * @extends {BaseAPI}
 */
export class PosActivationApi extends BaseAPI {
    /**
     * 
     * @summary activate card
     * @param {PosActivateRequest} posActivateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosActivationApi
     */
    public activateCard(posActivateRequest: PosActivateRequest, options?: any) {
        return PosActivationApiFp(this.configuration).activateCard(posActivateRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary generate pos activation document
     * @param {PosActivationDocumentRequest} posActivationDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosActivationApi
     */
    public generatePosActivationDocument(posActivationDocumentRequest: PosActivationDocumentRequest, options?: any) {
        return PosActivationApiFp(this.configuration).generatePosActivationDocument(posActivationDocumentRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary lists cards
     * @param {PosCardsRequest} posCardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosActivationApi
     */
    public getPosCards(posCardsRequest: PosCardsRequest, options?: any) {
        return PosActivationApiFp(this.configuration).getPosCards(posCardsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary request pos activation
     * @param {PosActivationRequest} posActivationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosActivationApi
     */
    public requestPosActivation(posActivationRequest: PosActivationRequest, options?: any) {
        return PosActivationApiFp(this.configuration).requestPosActivation(posActivationRequest, options)(this.axios, this.basePath);
    }

}


/**
 * PosActivationSearchPageValidationApi - axios parameter creator
 * @export
 */
export const PosActivationSearchPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get pos activation search page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosSearchPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-pos-activation-search-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate pos activation search page data
         * @param {ValidatePosSearchPageDataRequest} validatePosSearchPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePosActivationSearchPageData(validatePosSearchPageDataRequest: ValidatePosSearchPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validatePosSearchPageDataRequest' is not null or undefined
            if (validatePosSearchPageDataRequest === null || validatePosSearchPageDataRequest === undefined) {
                throw new RequiredError('validatePosSearchPageDataRequest','Required parameter validatePosSearchPageDataRequest was null or undefined when calling validatePosActivationSearchPageData.');
            }
            const localVarPath = `/validate-pos-activation-search-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validatePosSearchPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validatePosSearchPageDataRequest !== undefined ? validatePosSearchPageDataRequest : {}) : (validatePosSearchPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PosActivationSearchPageValidationApi - functional programming interface
 * @export
 */
export const PosActivationSearchPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get pos activation search page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosSearchPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosSearchPageDataResponse> {
            const localVarAxiosArgs = PosActivationSearchPageValidationApiAxiosParamCreator(configuration).getPosSearchPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate pos activation search page data
         * @param {ValidatePosSearchPageDataRequest} validatePosSearchPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePosActivationSearchPageData(validatePosSearchPageDataRequest: ValidatePosSearchPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePosSearchPageDataResponse> {
            const localVarAxiosArgs = PosActivationSearchPageValidationApiAxiosParamCreator(configuration).validatePosActivationSearchPageData(validatePosSearchPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PosActivationSearchPageValidationApi - factory interface
 * @export
 */
export const PosActivationSearchPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get pos activation search page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosSearchPageData(options?: any): AxiosPromise<PosSearchPageDataResponse> {
            return PosActivationSearchPageValidationApiFp(configuration).getPosSearchPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate pos activation search page data
         * @param {ValidatePosSearchPageDataRequest} validatePosSearchPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePosActivationSearchPageData(validatePosSearchPageDataRequest: ValidatePosSearchPageDataRequest, options?: any): AxiosPromise<ValidatePosSearchPageDataResponse> {
            return PosActivationSearchPageValidationApiFp(configuration).validatePosActivationSearchPageData(validatePosSearchPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * PosActivationSearchPageValidationApi - object-oriented interface
 * @export
 * @class PosActivationSearchPageValidationApi
 * @extends {BaseAPI}
 */
export class PosActivationSearchPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get pos activation search page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosActivationSearchPageValidationApi
     */
    public getPosSearchPageData(options?: any) {
        return PosActivationSearchPageValidationApiFp(this.configuration).getPosSearchPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate pos activation search page data
     * @param {ValidatePosSearchPageDataRequest} validatePosSearchPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosActivationSearchPageValidationApi
     */
    public validatePosActivationSearchPageData(validatePosSearchPageDataRequest: ValidatePosSearchPageDataRequest, options?: any) {
        return PosActivationSearchPageValidationApiFp(this.configuration).validatePosActivationSearchPageData(validatePosSearchPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get card image details
         * @param {CardImageRequest} cardImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardImageDetails(cardImageRequest: CardImageRequest, options: any = {}): RequestArgs {
            // verify required parameter 'cardImageRequest' is not null or undefined
            if (cardImageRequest === null || cardImageRequest === undefined) {
                throw new RequiredError('cardImageRequest','Required parameter cardImageRequest was null or undefined when calling getCardImageDetails.');
            }
            const localVarPath = `/product/cards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cardImageRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cardImageRequest !== undefined ? cardImageRequest : {}) : (cardImageRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product of Sale Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOSData(options: any = {}): RequestArgs {
            const localVarPath = `/product/pos`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product of Sale Data Details
         * @param {string} posId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosDataDetails(posId: string, options: any = {}): RequestArgs {
            // verify required parameter 'posId' is not null or undefined
            if (posId === null || posId === undefined) {
                throw new RequiredError('posId','Required parameter posId was null or undefined when calling getPosDataDetails.');
            }
            const localVarPath = `/product/pos/{posId}`
                .replace(`{${"posId"}}`, encodeURIComponent(String(posId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product Combos
         * @param {ProductComboRequest} productComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCombo(productComboRequest: ProductComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productComboRequest' is not null or undefined
            if (productComboRequest === null || productComboRequest === undefined) {
                throw new RequiredError('productComboRequest','Required parameter productComboRequest was null or undefined when calling getProductCombo.');
            }
            const localVarPath = `/product/combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productComboRequest !== undefined ? productComboRequest : {}) : (productComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get product line details
         * @param {ProductLineDetailRequest} productLineDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLineDetails(productLineDetailRequest: ProductLineDetailRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productLineDetailRequest' is not null or undefined
            if (productLineDetailRequest === null || productLineDetailRequest === undefined) {
                throw new RequiredError('productLineDetailRequest','Required parameter productLineDetailRequest was null or undefined when calling getProductLineDetails.');
            }
            const localVarPath = `/product/line-details`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productLineDetailRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productLineDetailRequest !== undefined ? productLineDetailRequest : {}) : (productLineDetailRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get product salary line
         * @param {ProductSalaryLineRequest} productSalaryLineRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSalaryLine(productSalaryLineRequest: ProductSalaryLineRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productSalaryLineRequest' is not null or undefined
            if (productSalaryLineRequest === null || productSalaryLineRequest === undefined) {
                throw new RequiredError('productSalaryLineRequest','Required parameter productSalaryLineRequest was null or undefined when calling getProductSalaryLine.');
            }
            const localVarPath = `/product/salary`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productSalaryLineRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productSalaryLineRequest !== undefined ? productSalaryLineRequest : {}) : (productSalaryLineRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get card image details
         * @param {CardImageRequest} cardImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardImageDetails(cardImageRequest: CardImageRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardImageResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getCardImageDetails(cardImageRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Product of Sale Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOSData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosDataResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getPOSData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Product of Sale Data Details
         * @param {string} posId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosDataDetails(posId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PosDataDetailResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getPosDataDetails(posId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Product Combos
         * @param {ProductComboRequest} productComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCombo(productComboRequest: ProductComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductComboResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getProductCombo(productComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get product line details
         * @param {ProductLineDetailRequest} productLineDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLineDetails(productLineDetailRequest: ProductLineDetailRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductLineDetailResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getProductLineDetails(productLineDetailRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get product salary line
         * @param {ProductSalaryLineRequest} productSalaryLineRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSalaryLine(productSalaryLineRequest: ProductSalaryLineRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSalaryLineResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getProductSalaryLine(productSalaryLineRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary get card image details
         * @param {CardImageRequest} cardImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardImageDetails(cardImageRequest: CardImageRequest, options?: any): AxiosPromise<CardImageResponse> {
            return ProductApiFp(configuration).getCardImageDetails(cardImageRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Product of Sale Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOSData(options?: any): AxiosPromise<PosDataResponse> {
            return ProductApiFp(configuration).getPOSData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Product of Sale Data Details
         * @param {string} posId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosDataDetails(posId: string, options?: any): AxiosPromise<PosDataDetailResponse> {
            return ProductApiFp(configuration).getPosDataDetails(posId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Product Combos
         * @param {ProductComboRequest} productComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCombo(productComboRequest: ProductComboRequest, options?: any): AxiosPromise<ProductComboResponse> {
            return ProductApiFp(configuration).getProductCombo(productComboRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary get product line details
         * @param {ProductLineDetailRequest} productLineDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLineDetails(productLineDetailRequest: ProductLineDetailRequest, options?: any): AxiosPromise<ProductLineDetailResponse> {
            return ProductApiFp(configuration).getProductLineDetails(productLineDetailRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary get product salary line
         * @param {ProductSalaryLineRequest} productSalaryLineRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSalaryLine(productSalaryLineRequest: ProductSalaryLineRequest, options?: any): AxiosPromise<ProductSalaryLineResponse> {
            return ProductApiFp(configuration).getProductSalaryLine(productSalaryLineRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @summary get card image details
     * @param {CardImageRequest} cardImageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getCardImageDetails(cardImageRequest: CardImageRequest, options?: any) {
        return ProductApiFp(this.configuration).getCardImageDetails(cardImageRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Product of Sale Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getPOSData(options?: any) {
        return ProductApiFp(this.configuration).getPOSData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Product of Sale Data Details
     * @param {string} posId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getPosDataDetails(posId: string, options?: any) {
        return ProductApiFp(this.configuration).getPosDataDetails(posId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Product Combos
     * @param {ProductComboRequest} productComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductCombo(productComboRequest: ProductComboRequest, options?: any) {
        return ProductApiFp(this.configuration).getProductCombo(productComboRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get product line details
     * @param {ProductLineDetailRequest} productLineDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductLineDetails(productLineDetailRequest: ProductLineDetailRequest, options?: any) {
        return ProductApiFp(this.configuration).getProductLineDetails(productLineDetailRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get product salary line
     * @param {ProductSalaryLineRequest} productSalaryLineRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductSalaryLine(productSalaryLineRequest: ProductSalaryLineRequest, options?: any) {
        return ProductApiFp(this.configuration).getProductSalaryLine(productSalaryLineRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOfferApi - axios parameter creator
 * @export
 */
export const ProductOfferApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get Document for Product Offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductOfferDocument(options: any = {}): RequestArgs {
            const localVarPath = `/product-offer/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product Offer Visibility
         * @param {ProductOfferVisibilityRequest} productOfferVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOfferVisibility(productOfferVisibilityRequest: ProductOfferVisibilityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productOfferVisibilityRequest' is not null or undefined
            if (productOfferVisibilityRequest === null || productOfferVisibilityRequest === undefined) {
                throw new RequiredError('productOfferVisibilityRequest','Required parameter productOfferVisibilityRequest was null or undefined when calling getProductOfferVisibility.');
            }
            const localVarPath = `/product-offer/visibility`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productOfferVisibilityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productOfferVisibilityRequest !== undefined ? productOfferVisibilityRequest : {}) : (productOfferVisibilityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary customer scoring and get product offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOffersWithScore(options: any = {}): RequestArgs {
            const localVarPath = `/product-offer/scoring`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOfferApi - functional programming interface
 * @export
 */
export const ProductOfferApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get Document for Product Offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductOfferDocument(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOfferDocumentResponse> {
            const localVarAxiosArgs = ProductOfferApiAxiosParamCreator(configuration).generateProductOfferDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Product Offer Visibility
         * @param {ProductOfferVisibilityRequest} productOfferVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOfferVisibility(productOfferVisibilityRequest: ProductOfferVisibilityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOfferVisibilityResponse> {
            const localVarAxiosArgs = ProductOfferApiAxiosParamCreator(configuration).getProductOfferVisibility(productOfferVisibilityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary customer scoring and get product offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOffersWithScore(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOfferScoringResponse> {
            const localVarAxiosArgs = ProductOfferApiAxiosParamCreator(configuration).getProductOffersWithScore(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOfferApi - factory interface
 * @export
 */
export const ProductOfferApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary get Document for Product Offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductOfferDocument(options?: any): AxiosPromise<ProductOfferDocumentResponse> {
            return ProductOfferApiFp(configuration).generateProductOfferDocument(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Product Offer Visibility
         * @param {ProductOfferVisibilityRequest} productOfferVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOfferVisibility(productOfferVisibilityRequest: ProductOfferVisibilityRequest, options?: any): AxiosPromise<ProductOfferVisibilityResponse> {
            return ProductOfferApiFp(configuration).getProductOfferVisibility(productOfferVisibilityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary customer scoring and get product offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOffersWithScore(options?: any): AxiosPromise<ProductOfferScoringResponse> {
            return ProductOfferApiFp(configuration).getProductOffersWithScore(options)(axios, basePath);
        },
    };
};

/**
 * ProductOfferApi - object-oriented interface
 * @export
 * @class ProductOfferApi
 * @extends {BaseAPI}
 */
export class ProductOfferApi extends BaseAPI {
    /**
     * 
     * @summary get Document for Product Offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOfferApi
     */
    public generateProductOfferDocument(options?: any) {
        return ProductOfferApiFp(this.configuration).generateProductOfferDocument(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Product Offer Visibility
     * @param {ProductOfferVisibilityRequest} productOfferVisibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOfferApi
     */
    public getProductOfferVisibility(productOfferVisibilityRequest: ProductOfferVisibilityRequest, options?: any) {
        return ProductOfferApiFp(this.configuration).getProductOfferVisibility(productOfferVisibilityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary customer scoring and get product offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOfferApi
     */
    public getProductOffersWithScore(options?: any) {
        return ProductOfferApiFp(this.configuration).getProductOffersWithScore(options)(this.axios, this.basePath);
    }

}


/**
 * ProductOfferPageValidationApi - axios parameter creator
 * @export
 */
export const ProductOfferPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get product offer page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOfferPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-product-offer-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate product offer page data
         * @param {ValidateProductOfferPageDataRequest} validateProductOfferPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductOfferPageData(validateProductOfferPageDataRequest: ValidateProductOfferPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateProductOfferPageDataRequest' is not null or undefined
            if (validateProductOfferPageDataRequest === null || validateProductOfferPageDataRequest === undefined) {
                throw new RequiredError('validateProductOfferPageDataRequest','Required parameter validateProductOfferPageDataRequest was null or undefined when calling validateProductOfferPageData.');
            }
            const localVarPath = `/validate-product-offer-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateProductOfferPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateProductOfferPageDataRequest !== undefined ? validateProductOfferPageDataRequest : {}) : (validateProductOfferPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOfferPageValidationApi - functional programming interface
 * @export
 */
export const ProductOfferPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get product offer page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOfferPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOfferPageDataResponse> {
            const localVarAxiosArgs = ProductOfferPageValidationApiAxiosParamCreator(configuration).getProductOfferPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate product offer page data
         * @param {ValidateProductOfferPageDataRequest} validateProductOfferPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductOfferPageData(validateProductOfferPageDataRequest: ValidateProductOfferPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateProductOfferPageDataResponse> {
            const localVarAxiosArgs = ProductOfferPageValidationApiAxiosParamCreator(configuration).validateProductOfferPageData(validateProductOfferPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOfferPageValidationApi - factory interface
 * @export
 */
export const ProductOfferPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get product offer page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOfferPageData(options?: any): AxiosPromise<ProductOfferPageDataResponse> {
            return ProductOfferPageValidationApiFp(configuration).getProductOfferPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate product offer page data
         * @param {ValidateProductOfferPageDataRequest} validateProductOfferPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductOfferPageData(validateProductOfferPageDataRequest: ValidateProductOfferPageDataRequest, options?: any): AxiosPromise<ValidateProductOfferPageDataResponse> {
            return ProductOfferPageValidationApiFp(configuration).validateProductOfferPageData(validateProductOfferPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOfferPageValidationApi - object-oriented interface
 * @export
 * @class ProductOfferPageValidationApi
 * @extends {BaseAPI}
 */
export class ProductOfferPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get product offer page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOfferPageValidationApi
     */
    public getProductOfferPageData(options?: any) {
        return ProductOfferPageValidationApiFp(this.configuration).getProductOfferPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate product offer page data
     * @param {ValidateProductOfferPageDataRequest} validateProductOfferPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOfferPageValidationApi
     */
    public validateProductOfferPageData(validateProductOfferPageDataRequest: ValidateProductOfferPageDataRequest, options?: any) {
        return ProductOfferPageValidationApiFp(this.configuration).validateProductOfferPageData(validateProductOfferPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsApi - axios parameter creator
 * @export
 */
export const ProductOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel product operation
         * @param {CancelProductOperationRequest} cancelProductOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelProductOperation(cancelProductOperationRequest: CancelProductOperationRequest, options: any = {}): RequestArgs {
            // verify required parameter 'cancelProductOperationRequest' is not null or undefined
            if (cancelProductOperationRequest === null || cancelProductOperationRequest === undefined) {
                throw new RequiredError('cancelProductOperationRequest','Required parameter cancelProductOperationRequest was null or undefined when calling cancelProductOperation.');
            }
            const localVarPath = `/product-operations/cancel`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelProductOperationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelProductOperationRequest !== undefined ? cancelProductOperationRequest : {}) : (cancelProductOperationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product criterias
         * @param {ProductOperationCriteriaRequest} productOperationCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCriterias(productOperationCriteriaRequest: ProductOperationCriteriaRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productOperationCriteriaRequest' is not null or undefined
            if (productOperationCriteriaRequest === null || productOperationCriteriaRequest === undefined) {
                throw new RequiredError('productOperationCriteriaRequest','Required parameter productOperationCriteriaRequest was null or undefined when calling getProductCriterias.');
            }
            const localVarPath = `/product-operations/criteria`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productOperationCriteriaRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productOperationCriteriaRequest !== undefined ? productOperationCriteriaRequest : {}) : (productOperationCriteriaRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product operations
         * @param {ProductOperationsRequest} productOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOperations(productOperationsRequest: ProductOperationsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productOperationsRequest' is not null or undefined
            if (productOperationsRequest === null || productOperationsRequest === undefined) {
                throw new RequiredError('productOperationsRequest','Required parameter productOperationsRequest was null or undefined when calling getProductOperations.');
            }
            const localVarPath = `/product-operations/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productOperationsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productOperationsRequest !== undefined ? productOperationsRequest : {}) : (productOperationsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product operations status
         * @param {ProductOperationsStatusRequest} productOperationsStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOperationsStatus(productOperationsStatusRequest: ProductOperationsStatusRequest, options: any = {}): RequestArgs {
            // verify required parameter 'productOperationsStatusRequest' is not null or undefined
            if (productOperationsStatusRequest === null || productOperationsStatusRequest === undefined) {
                throw new RequiredError('productOperationsStatusRequest','Required parameter productOperationsStatusRequest was null or undefined when calling getProductOperationsStatus.');
            }
            const localVarPath = `/product-operations/status`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productOperationsStatusRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productOperationsStatusRequest !== undefined ? productOperationsStatusRequest : {}) : (productOperationsStatusRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsApi - functional programming interface
 * @export
 */
export const ProductOperationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel product operation
         * @param {CancelProductOperationRequest} cancelProductOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelProductOperation(cancelProductOperationRequest: CancelProductOperationRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelProductOperationResponse> {
            const localVarAxiosArgs = ProductOperationsApiAxiosParamCreator(configuration).cancelProductOperation(cancelProductOperationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get product criterias
         * @param {ProductOperationCriteriaRequest} productOperationCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCriterias(productOperationCriteriaRequest: ProductOperationCriteriaRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOperationCriteriaResponse> {
            const localVarAxiosArgs = ProductOperationsApiAxiosParamCreator(configuration).getProductCriterias(productOperationCriteriaRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get product operations
         * @param {ProductOperationsRequest} productOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOperations(productOperationsRequest: ProductOperationsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOperationsResponse> {
            const localVarAxiosArgs = ProductOperationsApiAxiosParamCreator(configuration).getProductOperations(productOperationsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get product operations status
         * @param {ProductOperationsStatusRequest} productOperationsStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOperationsStatus(productOperationsStatusRequest: ProductOperationsStatusRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOperationsStatusResponse> {
            const localVarAxiosArgs = ProductOperationsApiAxiosParamCreator(configuration).getProductOperationsStatus(productOperationsStatusRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsApi - factory interface
 * @export
 */
export const ProductOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Cancel product operation
         * @param {CancelProductOperationRequest} cancelProductOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelProductOperation(cancelProductOperationRequest: CancelProductOperationRequest, options?: any): AxiosPromise<CancelProductOperationResponse> {
            return ProductOperationsApiFp(configuration).cancelProductOperation(cancelProductOperationRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get product criterias
         * @param {ProductOperationCriteriaRequest} productOperationCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCriterias(productOperationCriteriaRequest: ProductOperationCriteriaRequest, options?: any): AxiosPromise<ProductOperationCriteriaResponse> {
            return ProductOperationsApiFp(configuration).getProductCriterias(productOperationCriteriaRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get product operations
         * @param {ProductOperationsRequest} productOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOperations(productOperationsRequest: ProductOperationsRequest, options?: any): AxiosPromise<ProductOperationsResponse> {
            return ProductOperationsApiFp(configuration).getProductOperations(productOperationsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get product operations status
         * @param {ProductOperationsStatusRequest} productOperationsStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductOperationsStatus(productOperationsStatusRequest: ProductOperationsStatusRequest, options?: any): AxiosPromise<ProductOperationsStatusResponse> {
            return ProductOperationsApiFp(configuration).getProductOperationsStatus(productOperationsStatusRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsApi - object-oriented interface
 * @export
 * @class ProductOperationsApi
 * @extends {BaseAPI}
 */
export class ProductOperationsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel product operation
     * @param {CancelProductOperationRequest} cancelProductOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsApi
     */
    public cancelProductOperation(cancelProductOperationRequest: CancelProductOperationRequest, options?: any) {
        return ProductOperationsApiFp(this.configuration).cancelProductOperation(cancelProductOperationRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get product criterias
     * @param {ProductOperationCriteriaRequest} productOperationCriteriaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsApi
     */
    public getProductCriterias(productOperationCriteriaRequest: ProductOperationCriteriaRequest, options?: any) {
        return ProductOperationsApiFp(this.configuration).getProductCriterias(productOperationCriteriaRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get product operations
     * @param {ProductOperationsRequest} productOperationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsApi
     */
    public getProductOperations(productOperationsRequest: ProductOperationsRequest, options?: any) {
        return ProductOperationsApiFp(this.configuration).getProductOperations(productOperationsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get product operations status
     * @param {ProductOperationsStatusRequest} productOperationsStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsApi
     */
    public getProductOperationsStatus(productOperationsStatusRequest: ProductOperationsStatusRequest, options?: any) {
        return ProductOperationsApiFp(this.configuration).getProductOperationsStatus(productOperationsStatusRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsCardApplyApi - axios parameter creator
 * @export
 */
export const ProductOperationsCardApplyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get card application data
         * @param {OperationsCardApplicationGetRequest} operationsCardApplicationGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest: OperationsCardApplicationGetRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsCardApplicationGetRequest' is not null or undefined
            if (operationsCardApplicationGetRequest === null || operationsCardApplicationGetRequest === undefined) {
                throw new RequiredError('operationsCardApplicationGetRequest','Required parameter operationsCardApplicationGetRequest was null or undefined when calling getCardApplicationDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-card-apply/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsCardApplicationGetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsCardApplicationGetRequest !== undefined ? operationsCardApplicationGetRequest : {}) : (operationsCardApplicationGetRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsCardApplyApi - functional programming interface
 * @export
 */
export const ProductOperationsCardApplyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get card application data
         * @param {OperationsCardApplicationGetRequest} operationsCardApplicationGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest: OperationsCardApplicationGetRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsCardApplicationGetResponse> {
            const localVarAxiosArgs = ProductOperationsCardApplyApiAxiosParamCreator(configuration).getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsCardApplyApi - factory interface
 * @export
 */
export const ProductOperationsCardApplyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get card application data
         * @param {OperationsCardApplicationGetRequest} operationsCardApplicationGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest: OperationsCardApplicationGetRequest, options?: any): AxiosPromise<OperationsCardApplicationGetResponse> {
            return ProductOperationsCardApplyApiFp(configuration).getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsCardApplyApi - object-oriented interface
 * @export
 * @class ProductOperationsCardApplyApi
 * @extends {BaseAPI}
 */
export class ProductOperationsCardApplyApi extends BaseAPI {
    /**
     * 
     * @summary Get card application data
     * @param {OperationsCardApplicationGetRequest} operationsCardApplicationGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsCardApplyApi
     */
    public getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest: OperationsCardApplicationGetRequest, options?: any) {
        return ProductOperationsCardApplyApiFp(this.configuration).getCardApplicationDataByReferenceNumber(operationsCardApplicationGetRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsCardApplySummaryApi - axios parameter creator
 * @export
 */
export const ProductOperationsCardApplySummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary prepare card application summary data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareSummaryData(options: any = {}): RequestArgs {
            const localVarPath = `/product-operations-card-apply-summary/prepare`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsCardApplySummaryApi - functional programming interface
 * @export
 */
export const ProductOperationsCardApplySummaryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary prepare card application summary data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareSummaryData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsCardApplicationSummaryResponse> {
            const localVarAxiosArgs = ProductOperationsCardApplySummaryApiAxiosParamCreator(configuration).prepareSummaryData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsCardApplySummaryApi - factory interface
 * @export
 */
export const ProductOperationsCardApplySummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary prepare card application summary data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareSummaryData(options?: any): AxiosPromise<OperationsCardApplicationSummaryResponse> {
            return ProductOperationsCardApplySummaryApiFp(configuration).prepareSummaryData(options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsCardApplySummaryApi - object-oriented interface
 * @export
 * @class ProductOperationsCardApplySummaryApi
 * @extends {BaseAPI}
 */
export class ProductOperationsCardApplySummaryApi extends BaseAPI {
    /**
     * 
     * @summary prepare card application summary data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsCardApplySummaryApi
     */
    public prepareSummaryData(options?: any) {
        return ProductOperationsCardApplySummaryApiFp(this.configuration).prepareSummaryData(options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsCardApplyUpdateApi - axios parameter creator
 * @export
 */
export const ProductOperationsCardApplyUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update card application data
         * @param {OperationsCardApplyUpdateRequest} operationsCardApplyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest: OperationsCardApplyUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsCardApplyUpdateRequest' is not null or undefined
            if (operationsCardApplyUpdateRequest === null || operationsCardApplyUpdateRequest === undefined) {
                throw new RequiredError('operationsCardApplyUpdateRequest','Required parameter operationsCardApplyUpdateRequest was null or undefined when calling updateCardApplyDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-card-apply-update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsCardApplyUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsCardApplyUpdateRequest !== undefined ? operationsCardApplyUpdateRequest : {}) : (operationsCardApplyUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsCardApplyUpdateApi - functional programming interface
 * @export
 */
export const ProductOperationsCardApplyUpdateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update card application data
         * @param {OperationsCardApplyUpdateRequest} operationsCardApplyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest: OperationsCardApplyUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsCardApplyUpdateResponse> {
            const localVarAxiosArgs = ProductOperationsCardApplyUpdateApiAxiosParamCreator(configuration).updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsCardApplyUpdateApi - factory interface
 * @export
 */
export const ProductOperationsCardApplyUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Update card application data
         * @param {OperationsCardApplyUpdateRequest} operationsCardApplyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest: OperationsCardApplyUpdateRequest, options?: any): AxiosPromise<OperationsCardApplyUpdateResponse> {
            return ProductOperationsCardApplyUpdateApiFp(configuration).updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsCardApplyUpdateApi - object-oriented interface
 * @export
 * @class ProductOperationsCardApplyUpdateApi
 * @extends {BaseAPI}
 */
export class ProductOperationsCardApplyUpdateApi extends BaseAPI {
    /**
     * 
     * @summary Update card application data
     * @param {OperationsCardApplyUpdateRequest} operationsCardApplyUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsCardApplyUpdateApi
     */
    public updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest: OperationsCardApplyUpdateRequest, options?: any) {
        return ProductOperationsCardApplyUpdateApiFp(this.configuration).updateCardApplyDataByReferenceNumber(operationsCardApplyUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsClientInfoChangeApi - axios parameter creator
 * @export
 */
export const ProductOperationsClientInfoChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get client info change data by product reference number
         * @param {OperationsClientInfoChangeGetRequest} operationsClientInfoChangeGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest: OperationsClientInfoChangeGetRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsClientInfoChangeGetRequest' is not null or undefined
            if (operationsClientInfoChangeGetRequest === null || operationsClientInfoChangeGetRequest === undefined) {
                throw new RequiredError('operationsClientInfoChangeGetRequest','Required parameter operationsClientInfoChangeGetRequest was null or undefined when calling getClientInfoDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-client-info-change/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsClientInfoChangeGetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsClientInfoChangeGetRequest !== undefined ? operationsClientInfoChangeGetRequest : {}) : (operationsClientInfoChangeGetRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update client info change data
         * @param {OperationsClientInfoChangeUpdateRequest} operationsClientInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest: OperationsClientInfoChangeUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsClientInfoChangeUpdateRequest' is not null or undefined
            if (operationsClientInfoChangeUpdateRequest === null || operationsClientInfoChangeUpdateRequest === undefined) {
                throw new RequiredError('operationsClientInfoChangeUpdateRequest','Required parameter operationsClientInfoChangeUpdateRequest was null or undefined when calling updateClientInfoDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-client-info-change/update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsClientInfoChangeUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsClientInfoChangeUpdateRequest !== undefined ? operationsClientInfoChangeUpdateRequest : {}) : (operationsClientInfoChangeUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsClientInfoChangeApi - functional programming interface
 * @export
 */
export const ProductOperationsClientInfoChangeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get client info change data by product reference number
         * @param {OperationsClientInfoChangeGetRequest} operationsClientInfoChangeGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest: OperationsClientInfoChangeGetRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsClientInfoChangeGetResponse> {
            const localVarAxiosArgs = ProductOperationsClientInfoChangeApiAxiosParamCreator(configuration).getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update client info change data
         * @param {OperationsClientInfoChangeUpdateRequest} operationsClientInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest: OperationsClientInfoChangeUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsClientInfoChangeUpdateResponse> {
            const localVarAxiosArgs = ProductOperationsClientInfoChangeApiAxiosParamCreator(configuration).updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsClientInfoChangeApi - factory interface
 * @export
 */
export const ProductOperationsClientInfoChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get client info change data by product reference number
         * @param {OperationsClientInfoChangeGetRequest} operationsClientInfoChangeGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest: OperationsClientInfoChangeGetRequest, options?: any): AxiosPromise<OperationsClientInfoChangeGetResponse> {
            return ProductOperationsClientInfoChangeApiFp(configuration).getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update client info change data
         * @param {OperationsClientInfoChangeUpdateRequest} operationsClientInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest: OperationsClientInfoChangeUpdateRequest, options?: any): AxiosPromise<OperationsClientInfoChangeUpdateResponse> {
            return ProductOperationsClientInfoChangeApiFp(configuration).updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsClientInfoChangeApi - object-oriented interface
 * @export
 * @class ProductOperationsClientInfoChangeApi
 * @extends {BaseAPI}
 */
export class ProductOperationsClientInfoChangeApi extends BaseAPI {
    /**
     * 
     * @summary Get client info change data by product reference number
     * @param {OperationsClientInfoChangeGetRequest} operationsClientInfoChangeGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsClientInfoChangeApi
     */
    public getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest: OperationsClientInfoChangeGetRequest, options?: any) {
        return ProductOperationsClientInfoChangeApiFp(this.configuration).getClientInfoDataByReferenceNumber(operationsClientInfoChangeGetRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update client info change data
     * @param {OperationsClientInfoChangeUpdateRequest} operationsClientInfoChangeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsClientInfoChangeApi
     */
    public updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest: OperationsClientInfoChangeUpdateRequest, options?: any) {
        return ProductOperationsClientInfoChangeApiFp(this.configuration).updateClientInfoDataByReferenceNumber(operationsClientInfoChangeUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsContactInfoChangeApi - axios parameter creator
 * @export
 */
export const ProductOperationsContactInfoChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact info change data
         * @param {OperationsContactInfoChangeGetRequest} operationsContactInfoChangeGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoChangeData(operationsContactInfoChangeGetRequest: OperationsContactInfoChangeGetRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsContactInfoChangeGetRequest' is not null or undefined
            if (operationsContactInfoChangeGetRequest === null || operationsContactInfoChangeGetRequest === undefined) {
                throw new RequiredError('operationsContactInfoChangeGetRequest','Required parameter operationsContactInfoChangeGetRequest was null or undefined when calling getContactInfoChangeData.');
            }
            const localVarPath = `/product-operations-contact-info-change/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsContactInfoChangeGetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsContactInfoChangeGetRequest !== undefined ? operationsContactInfoChangeGetRequest : {}) : (operationsContactInfoChangeGetRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update contact info change data
         * @param {OperationsContactInfoChangeUpdateRequest} operationsContactInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest: OperationsContactInfoChangeUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsContactInfoChangeUpdateRequest' is not null or undefined
            if (operationsContactInfoChangeUpdateRequest === null || operationsContactInfoChangeUpdateRequest === undefined) {
                throw new RequiredError('operationsContactInfoChangeUpdateRequest','Required parameter operationsContactInfoChangeUpdateRequest was null or undefined when calling updateContactInfoChangeDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-contact-info-change/update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsContactInfoChangeUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsContactInfoChangeUpdateRequest !== undefined ? operationsContactInfoChangeUpdateRequest : {}) : (operationsContactInfoChangeUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsContactInfoChangeApi - functional programming interface
 * @export
 */
export const ProductOperationsContactInfoChangeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact info change data
         * @param {OperationsContactInfoChangeGetRequest} operationsContactInfoChangeGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoChangeData(operationsContactInfoChangeGetRequest: OperationsContactInfoChangeGetRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsContactInfoChangeGetResponse> {
            const localVarAxiosArgs = ProductOperationsContactInfoChangeApiAxiosParamCreator(configuration).getContactInfoChangeData(operationsContactInfoChangeGetRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update contact info change data
         * @param {OperationsContactInfoChangeUpdateRequest} operationsContactInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest: OperationsContactInfoChangeUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsContactInfoChangeUpdateResponse> {
            const localVarAxiosArgs = ProductOperationsContactInfoChangeApiAxiosParamCreator(configuration).updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsContactInfoChangeApi - factory interface
 * @export
 */
export const ProductOperationsContactInfoChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get contact info change data
         * @param {OperationsContactInfoChangeGetRequest} operationsContactInfoChangeGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfoChangeData(operationsContactInfoChangeGetRequest: OperationsContactInfoChangeGetRequest, options?: any): AxiosPromise<OperationsContactInfoChangeGetResponse> {
            return ProductOperationsContactInfoChangeApiFp(configuration).getContactInfoChangeData(operationsContactInfoChangeGetRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update contact info change data
         * @param {OperationsContactInfoChangeUpdateRequest} operationsContactInfoChangeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest: OperationsContactInfoChangeUpdateRequest, options?: any): AxiosPromise<OperationsContactInfoChangeUpdateResponse> {
            return ProductOperationsContactInfoChangeApiFp(configuration).updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsContactInfoChangeApi - object-oriented interface
 * @export
 * @class ProductOperationsContactInfoChangeApi
 * @extends {BaseAPI}
 */
export class ProductOperationsContactInfoChangeApi extends BaseAPI {
    /**
     * 
     * @summary Get contact info change data
     * @param {OperationsContactInfoChangeGetRequest} operationsContactInfoChangeGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsContactInfoChangeApi
     */
    public getContactInfoChangeData(operationsContactInfoChangeGetRequest: OperationsContactInfoChangeGetRequest, options?: any) {
        return ProductOperationsContactInfoChangeApiFp(this.configuration).getContactInfoChangeData(operationsContactInfoChangeGetRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update contact info change data
     * @param {OperationsContactInfoChangeUpdateRequest} operationsContactInfoChangeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsContactInfoChangeApi
     */
    public updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest: OperationsContactInfoChangeUpdateRequest, options?: any) {
        return ProductOperationsContactInfoChangeApiFp(this.configuration).updateContactInfoChangeDataByReferenceNumber(operationsContactInfoChangeUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductOperationsReissueApi - axios parameter creator
 * @export
 */
export const ProductOperationsReissueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get reissue data by product reference number
         * @param {OperationsReissueGetRequest} operationsReissueGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReissueDataByReferenceNumber(operationsReissueGetRequest: OperationsReissueGetRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsReissueGetRequest' is not null or undefined
            if (operationsReissueGetRequest === null || operationsReissueGetRequest === undefined) {
                throw new RequiredError('operationsReissueGetRequest','Required parameter operationsReissueGetRequest was null or undefined when calling getReissueDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-reissue/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsReissueGetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsReissueGetRequest !== undefined ? operationsReissueGetRequest : {}) : (operationsReissueGetRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update reissue data
         * @param {OperationsReissueUpdateRequest} operationsReissueUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReissueDataByReferenceNumber(operationsReissueUpdateRequest: OperationsReissueUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'operationsReissueUpdateRequest' is not null or undefined
            if (operationsReissueUpdateRequest === null || operationsReissueUpdateRequest === undefined) {
                throw new RequiredError('operationsReissueUpdateRequest','Required parameter operationsReissueUpdateRequest was null or undefined when calling updateReissueDataByReferenceNumber.');
            }
            const localVarPath = `/product-operations-reissue/update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof operationsReissueUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(operationsReissueUpdateRequest !== undefined ? operationsReissueUpdateRequest : {}) : (operationsReissueUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOperationsReissueApi - functional programming interface
 * @export
 */
export const ProductOperationsReissueApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get reissue data by product reference number
         * @param {OperationsReissueGetRequest} operationsReissueGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReissueDataByReferenceNumber(operationsReissueGetRequest: OperationsReissueGetRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsReissueGetResponse> {
            const localVarAxiosArgs = ProductOperationsReissueApiAxiosParamCreator(configuration).getReissueDataByReferenceNumber(operationsReissueGetRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update reissue data
         * @param {OperationsReissueUpdateRequest} operationsReissueUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReissueDataByReferenceNumber(operationsReissueUpdateRequest: OperationsReissueUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationsReissueUpdateResponse> {
            const localVarAxiosArgs = ProductOperationsReissueApiAxiosParamCreator(configuration).updateReissueDataByReferenceNumber(operationsReissueUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductOperationsReissueApi - factory interface
 * @export
 */
export const ProductOperationsReissueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get reissue data by product reference number
         * @param {OperationsReissueGetRequest} operationsReissueGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReissueDataByReferenceNumber(operationsReissueGetRequest: OperationsReissueGetRequest, options?: any): AxiosPromise<OperationsReissueGetResponse> {
            return ProductOperationsReissueApiFp(configuration).getReissueDataByReferenceNumber(operationsReissueGetRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update reissue data
         * @param {OperationsReissueUpdateRequest} operationsReissueUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReissueDataByReferenceNumber(operationsReissueUpdateRequest: OperationsReissueUpdateRequest, options?: any): AxiosPromise<OperationsReissueUpdateResponse> {
            return ProductOperationsReissueApiFp(configuration).updateReissueDataByReferenceNumber(operationsReissueUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductOperationsReissueApi - object-oriented interface
 * @export
 * @class ProductOperationsReissueApi
 * @extends {BaseAPI}
 */
export class ProductOperationsReissueApi extends BaseAPI {
    /**
     * 
     * @summary Get reissue data by product reference number
     * @param {OperationsReissueGetRequest} operationsReissueGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsReissueApi
     */
    public getReissueDataByReferenceNumber(operationsReissueGetRequest: OperationsReissueGetRequest, options?: any) {
        return ProductOperationsReissueApiFp(this.configuration).getReissueDataByReferenceNumber(operationsReissueGetRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update reissue data
     * @param {OperationsReissueUpdateRequest} operationsReissueUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductOperationsReissueApi
     */
    public updateReissueDataByReferenceNumber(operationsReissueUpdateRequest: OperationsReissueUpdateRequest, options?: any) {
        return ProductOperationsReissueApiFp(this.configuration).updateReissueDataByReferenceNumber(operationsReissueUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ProductPageValidationApi - axios parameter creator
 * @export
 */
export const ProductPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get product page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-product-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate product page data
         * @param {ValidateProductPageDataRequest} validateProductPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductPageData(validateProductPageDataRequest: ValidateProductPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateProductPageDataRequest' is not null or undefined
            if (validateProductPageDataRequest === null || validateProductPageDataRequest === undefined) {
                throw new RequiredError('validateProductPageDataRequest','Required parameter validateProductPageDataRequest was null or undefined when calling validateProductPageData.');
            }
            const localVarPath = `/validate-product-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateProductPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateProductPageDataRequest !== undefined ? validateProductPageDataRequest : {}) : (validateProductPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPageValidationApi - functional programming interface
 * @export
 */
export const ProductPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get product page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPageDataResponse> {
            const localVarAxiosArgs = ProductPageValidationApiAxiosParamCreator(configuration).getProductPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate product page data
         * @param {ValidateProductPageDataRequest} validateProductPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductPageData(validateProductPageDataRequest: ValidateProductPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateProductPageDataResponse> {
            const localVarAxiosArgs = ProductPageValidationApiAxiosParamCreator(configuration).validateProductPageData(validateProductPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductPageValidationApi - factory interface
 * @export
 */
export const ProductPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get product page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPageData(options?: any): AxiosPromise<ProductPageDataResponse> {
            return ProductPageValidationApiFp(configuration).getProductPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate product page data
         * @param {ValidateProductPageDataRequest} validateProductPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductPageData(validateProductPageDataRequest: ValidateProductPageDataRequest, options?: any): AxiosPromise<ValidateProductPageDataResponse> {
            return ProductPageValidationApiFp(configuration).validateProductPageData(validateProductPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ProductPageValidationApi - object-oriented interface
 * @export
 * @class ProductPageValidationApi
 * @extends {BaseAPI}
 */
export class ProductPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get product page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPageValidationApi
     */
    public getProductPageData(options?: any) {
        return ProductPageValidationApiFp(this.configuration).getProductPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate product page data
     * @param {ValidateProductPageDataRequest} validateProductPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPageValidationApi
     */
    public validateProductPageData(validateProductPageDataRequest: ValidateProductPageDataRequest, options?: any) {
        return ProductPageValidationApiFp(this.configuration).validateProductPageData(validateProductPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * PtsApi - axios parameter creator
 * @export
 */
export const PtsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Pts check customer
         * @param {PtsCustomerChangeRequest} ptsCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCustomer(ptsCustomerChangeRequest: PtsCustomerChangeRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsCustomerChangeRequest' is not null or undefined
            if (ptsCustomerChangeRequest === null || ptsCustomerChangeRequest === undefined) {
                throw new RequiredError('ptsCustomerChangeRequest','Required parameter ptsCustomerChangeRequest was null or undefined when calling checkCustomer.');
            }
            const localVarPath = `/pts/is-customer-changed`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsCustomerChangeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsCustomerChangeRequest !== undefined ? ptsCustomerChangeRequest : {}) : (ptsCustomerChangeRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check record status
         * @param {PtsRecordCheckLockStatusRequest} ptsRecordCheckLockStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPtsRecordStatus(ptsRecordCheckLockStatusRequest: PtsRecordCheckLockStatusRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsRecordCheckLockStatusRequest' is not null or undefined
            if (ptsRecordCheckLockStatusRequest === null || ptsRecordCheckLockStatusRequest === undefined) {
                throw new RequiredError('ptsRecordCheckLockStatusRequest','Required parameter ptsRecordCheckLockStatusRequest was null or undefined when calling checkPtsRecordStatus.');
            }
            const localVarPath = `/pts/record-check-lock-status`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsRecordCheckLockStatusRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsRecordCheckLockStatusRequest !== undefined ? ptsRecordCheckLockStatusRequest : {}) : (ptsRecordCheckLockStatusRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pts Components Changeable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsComponentsChangeable(options: any = {}): RequestArgs {
            const localVarPath = `/pts/component-changeable`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pts Component\'s Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsComponentsValues(options: any = {}): RequestArgs {
            const localVarPath = `/pts/components-values`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pts Documents
         * @param {PtsDocumentsRequest} ptsDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsDocuments(ptsDocumentsRequest: PtsDocumentsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsDocumentsRequest' is not null or undefined
            if (ptsDocumentsRequest === null || ptsDocumentsRequest === undefined) {
                throw new RequiredError('ptsDocumentsRequest','Required parameter ptsDocumentsRequest was null or undefined when calling getPtsDocuments.');
            }
            const localVarPath = `/pts/documents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsDocumentsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsDocumentsRequest !== undefined ? ptsDocumentsRequest : {}) : (ptsDocumentsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pts Level Three combo
         * @param {PtsLevelThreeComboRequest} ptsLevelThreeComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsLevelThreeCombo(ptsLevelThreeComboRequest: PtsLevelThreeComboRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsLevelThreeComboRequest' is not null or undefined
            if (ptsLevelThreeComboRequest === null || ptsLevelThreeComboRequest === undefined) {
                throw new RequiredError('ptsLevelThreeComboRequest','Required parameter ptsLevelThreeComboRequest was null or undefined when calling getPtsLevelThreeCombo.');
            }
            const localVarPath = `/pts/level-three-combo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsLevelThreeComboRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsLevelThreeComboRequest !== undefined ? ptsLevelThreeComboRequest : {}) : (ptsLevelThreeComboRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pts Record History
         * @param {PtsRecordHistoryRequest} ptsRecordHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsRecordHistory(ptsRecordHistoryRequest: PtsRecordHistoryRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsRecordHistoryRequest' is not null or undefined
            if (ptsRecordHistoryRequest === null || ptsRecordHistoryRequest === undefined) {
                throw new RequiredError('ptsRecordHistoryRequest','Required parameter ptsRecordHistoryRequest was null or undefined when calling getPtsRecordHistory.');
            }
            const localVarPath = `/pts/record-history`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsRecordHistoryRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsRecordHistoryRequest !== undefined ? ptsRecordHistoryRequest : {}) : (ptsRecordHistoryRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pts Sms Check Box Visibility
         * @param {PtsSmsCheckBoxVisibilityRequest} ptsSmsCheckBoxVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest: PtsSmsCheckBoxVisibilityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsSmsCheckBoxVisibilityRequest' is not null or undefined
            if (ptsSmsCheckBoxVisibilityRequest === null || ptsSmsCheckBoxVisibilityRequest === undefined) {
                throw new RequiredError('ptsSmsCheckBoxVisibilityRequest','Required parameter ptsSmsCheckBoxVisibilityRequest was null or undefined when calling getPtsSmsCheckBoxVisibility.');
            }
            const localVarPath = `/pts/sms-checkbox-visibility`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsSmsCheckBoxVisibilityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsSmsCheckBoxVisibilityRequest !== undefined ? ptsSmsCheckBoxVisibilityRequest : {}) : (ptsSmsCheckBoxVisibilityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change record status from unlocked to locked
         * @param {PtsLockRecordRequest} ptsLockRecordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockPtsRecord(ptsLockRecordRequest: PtsLockRecordRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsLockRecordRequest' is not null or undefined
            if (ptsLockRecordRequest === null || ptsLockRecordRequest === undefined) {
                throw new RequiredError('ptsLockRecordRequest','Required parameter ptsLockRecordRequest was null or undefined when calling lockPtsRecord.');
            }
            const localVarPath = `/pts/lock-record`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsLockRecordRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsLockRecordRequest !== undefined ? ptsLockRecordRequest : {}) : (ptsLockRecordRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Pts Record
         * @param {PtsSaveRequest} ptsSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePtsRecord(ptsSaveRequest: PtsSaveRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsSaveRequest' is not null or undefined
            if (ptsSaveRequest === null || ptsSaveRequest === undefined) {
                throw new RequiredError('ptsSaveRequest','Required parameter ptsSaveRequest was null or undefined when calling savePtsRecord.');
            }
            const localVarPath = `/pts/save`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsSaveRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsSaveRequest !== undefined ? ptsSaveRequest : {}) : (ptsSaveRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Pts Records
         * @param {PtsSearchRequest} ptsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPtsRecords(ptsSearchRequest: PtsSearchRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsSearchRequest' is not null or undefined
            if (ptsSearchRequest === null || ptsSearchRequest === undefined) {
                throw new RequiredError('ptsSearchRequest','Required parameter ptsSearchRequest was null or undefined when calling searchPtsRecords.');
            }
            const localVarPath = `/pts/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsSearchRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsSearchRequest !== undefined ? ptsSearchRequest : {}) : (ptsSearchRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change record status from locked to unlocked
         * @param {PtsUnlockRecordRequest} ptsUnlockRecordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockPtsRecord(ptsUnlockRecordRequest: PtsUnlockRecordRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsUnlockRecordRequest' is not null or undefined
            if (ptsUnlockRecordRequest === null || ptsUnlockRecordRequest === undefined) {
                throw new RequiredError('ptsUnlockRecordRequest','Required parameter ptsUnlockRecordRequest was null or undefined when calling unlockPtsRecord.');
            }
            const localVarPath = `/pts/unlock-record`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsUnlockRecordRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsUnlockRecordRequest !== undefined ? ptsUnlockRecordRequest : {}) : (ptsUnlockRecordRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Pts Record
         * @param {PtsUpdateRequest} ptsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePtsRecord(ptsUpdateRequest: PtsUpdateRequest, options: any = {}): RequestArgs {
            // verify required parameter 'ptsUpdateRequest' is not null or undefined
            if (ptsUpdateRequest === null || ptsUpdateRequest === undefined) {
                throw new RequiredError('ptsUpdateRequest','Required parameter ptsUpdateRequest was null or undefined when calling updatePtsRecord.');
            }
            const localVarPath = `/pts/update`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ptsUpdateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ptsUpdateRequest !== undefined ? ptsUpdateRequest : {}) : (ptsUpdateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PtsApi - functional programming interface
 * @export
 */
export const PtsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Pts check customer
         * @param {PtsCustomerChangeRequest} ptsCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCustomer(ptsCustomerChangeRequest: PtsCustomerChangeRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsCustomerChangeResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).checkCustomer(ptsCustomerChangeRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Check record status
         * @param {PtsRecordCheckLockStatusRequest} ptsRecordCheckLockStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPtsRecordStatus(ptsRecordCheckLockStatusRequest: PtsRecordCheckLockStatusRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsRecordCheckLockStatusResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).checkPtsRecordStatus(ptsRecordCheckLockStatusRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Pts Components Changeable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsComponentsChangeable(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsComponentsChangeableResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).getPtsComponentsChangeable(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Pts Component\'s Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsComponentsValues(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsComponentsValuesResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).getPtsComponentsValues(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Pts Documents
         * @param {PtsDocumentsRequest} ptsDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsDocuments(ptsDocumentsRequest: PtsDocumentsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsDocumentsResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).getPtsDocuments(ptsDocumentsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Pts Level Three combo
         * @param {PtsLevelThreeComboRequest} ptsLevelThreeComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsLevelThreeCombo(ptsLevelThreeComboRequest: PtsLevelThreeComboRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsLevelThreeComboResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).getPtsLevelThreeCombo(ptsLevelThreeComboRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Pts Record History
         * @param {PtsRecordHistoryRequest} ptsRecordHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsRecordHistory(ptsRecordHistoryRequest: PtsRecordHistoryRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsRecordHistoryResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).getPtsRecordHistory(ptsRecordHistoryRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Pts Sms Check Box Visibility
         * @param {PtsSmsCheckBoxVisibilityRequest} ptsSmsCheckBoxVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest: PtsSmsCheckBoxVisibilityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsSmsCheckBoxVisibilityResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Change record status from unlocked to locked
         * @param {PtsLockRecordRequest} ptsLockRecordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockPtsRecord(ptsLockRecordRequest: PtsLockRecordRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsLockRecordResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).lockPtsRecord(ptsLockRecordRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Save Pts Record
         * @param {PtsSaveRequest} ptsSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePtsRecord(ptsSaveRequest: PtsSaveRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsSaveResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).savePtsRecord(ptsSaveRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Search Pts Records
         * @param {PtsSearchRequest} ptsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPtsRecords(ptsSearchRequest: PtsSearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsSearchResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).searchPtsRecords(ptsSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Change record status from locked to unlocked
         * @param {PtsUnlockRecordRequest} ptsUnlockRecordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockPtsRecord(ptsUnlockRecordRequest: PtsUnlockRecordRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsUnlockRecordResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).unlockPtsRecord(ptsUnlockRecordRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update Pts Record
         * @param {PtsUpdateRequest} ptsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePtsRecord(ptsUpdateRequest: PtsUpdateRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtsUpdateResponse> {
            const localVarAxiosArgs = PtsApiAxiosParamCreator(configuration).updatePtsRecord(ptsUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PtsApi - factory interface
 * @export
 */
export const PtsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Pts check customer
         * @param {PtsCustomerChangeRequest} ptsCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCustomer(ptsCustomerChangeRequest: PtsCustomerChangeRequest, options?: any): AxiosPromise<PtsCustomerChangeResponse> {
            return PtsApiFp(configuration).checkCustomer(ptsCustomerChangeRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Check record status
         * @param {PtsRecordCheckLockStatusRequest} ptsRecordCheckLockStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPtsRecordStatus(ptsRecordCheckLockStatusRequest: PtsRecordCheckLockStatusRequest, options?: any): AxiosPromise<PtsRecordCheckLockStatusResponse> {
            return PtsApiFp(configuration).checkPtsRecordStatus(ptsRecordCheckLockStatusRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Pts Components Changeable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsComponentsChangeable(options?: any): AxiosPromise<PtsComponentsChangeableResponse> {
            return PtsApiFp(configuration).getPtsComponentsChangeable(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Pts Component\'s Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsComponentsValues(options?: any): AxiosPromise<PtsComponentsValuesResponse> {
            return PtsApiFp(configuration).getPtsComponentsValues(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Pts Documents
         * @param {PtsDocumentsRequest} ptsDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsDocuments(ptsDocumentsRequest: PtsDocumentsRequest, options?: any): AxiosPromise<PtsDocumentsResponse> {
            return PtsApiFp(configuration).getPtsDocuments(ptsDocumentsRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Pts Level Three combo
         * @param {PtsLevelThreeComboRequest} ptsLevelThreeComboRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsLevelThreeCombo(ptsLevelThreeComboRequest: PtsLevelThreeComboRequest, options?: any): AxiosPromise<PtsLevelThreeComboResponse> {
            return PtsApiFp(configuration).getPtsLevelThreeCombo(ptsLevelThreeComboRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Pts Record History
         * @param {PtsRecordHistoryRequest} ptsRecordHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsRecordHistory(ptsRecordHistoryRequest: PtsRecordHistoryRequest, options?: any): AxiosPromise<PtsRecordHistoryResponse> {
            return PtsApiFp(configuration).getPtsRecordHistory(ptsRecordHistoryRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Pts Sms Check Box Visibility
         * @param {PtsSmsCheckBoxVisibilityRequest} ptsSmsCheckBoxVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest: PtsSmsCheckBoxVisibilityRequest, options?: any): AxiosPromise<PtsSmsCheckBoxVisibilityResponse> {
            return PtsApiFp(configuration).getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Change record status from unlocked to locked
         * @param {PtsLockRecordRequest} ptsLockRecordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockPtsRecord(ptsLockRecordRequest: PtsLockRecordRequest, options?: any): AxiosPromise<PtsLockRecordResponse> {
            return PtsApiFp(configuration).lockPtsRecord(ptsLockRecordRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Save Pts Record
         * @param {PtsSaveRequest} ptsSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePtsRecord(ptsSaveRequest: PtsSaveRequest, options?: any): AxiosPromise<PtsSaveResponse> {
            return PtsApiFp(configuration).savePtsRecord(ptsSaveRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Search Pts Records
         * @param {PtsSearchRequest} ptsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPtsRecords(ptsSearchRequest: PtsSearchRequest, options?: any): AxiosPromise<PtsSearchResponse> {
            return PtsApiFp(configuration).searchPtsRecords(ptsSearchRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Change record status from locked to unlocked
         * @param {PtsUnlockRecordRequest} ptsUnlockRecordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockPtsRecord(ptsUnlockRecordRequest: PtsUnlockRecordRequest, options?: any): AxiosPromise<PtsUnlockRecordResponse> {
            return PtsApiFp(configuration).unlockPtsRecord(ptsUnlockRecordRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update Pts Record
         * @param {PtsUpdateRequest} ptsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePtsRecord(ptsUpdateRequest: PtsUpdateRequest, options?: any): AxiosPromise<PtsUpdateResponse> {
            return PtsApiFp(configuration).updatePtsRecord(ptsUpdateRequest, options)(axios, basePath);
        },
    };
};

/**
 * PtsApi - object-oriented interface
 * @export
 * @class PtsApi
 * @extends {BaseAPI}
 */
export class PtsApi extends BaseAPI {
    /**
     * 
     * @summary Pts check customer
     * @param {PtsCustomerChangeRequest} ptsCustomerChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public checkCustomer(ptsCustomerChangeRequest: PtsCustomerChangeRequest, options?: any) {
        return PtsApiFp(this.configuration).checkCustomer(ptsCustomerChangeRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Check record status
     * @param {PtsRecordCheckLockStatusRequest} ptsRecordCheckLockStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public checkPtsRecordStatus(ptsRecordCheckLockStatusRequest: PtsRecordCheckLockStatusRequest, options?: any) {
        return PtsApiFp(this.configuration).checkPtsRecordStatus(ptsRecordCheckLockStatusRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Pts Components Changeable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public getPtsComponentsChangeable(options?: any) {
        return PtsApiFp(this.configuration).getPtsComponentsChangeable(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Pts Component\'s Values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public getPtsComponentsValues(options?: any) {
        return PtsApiFp(this.configuration).getPtsComponentsValues(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Pts Documents
     * @param {PtsDocumentsRequest} ptsDocumentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public getPtsDocuments(ptsDocumentsRequest: PtsDocumentsRequest, options?: any) {
        return PtsApiFp(this.configuration).getPtsDocuments(ptsDocumentsRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Pts Level Three combo
     * @param {PtsLevelThreeComboRequest} ptsLevelThreeComboRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public getPtsLevelThreeCombo(ptsLevelThreeComboRequest: PtsLevelThreeComboRequest, options?: any) {
        return PtsApiFp(this.configuration).getPtsLevelThreeCombo(ptsLevelThreeComboRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Pts Record History
     * @param {PtsRecordHistoryRequest} ptsRecordHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public getPtsRecordHistory(ptsRecordHistoryRequest: PtsRecordHistoryRequest, options?: any) {
        return PtsApiFp(this.configuration).getPtsRecordHistory(ptsRecordHistoryRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Pts Sms Check Box Visibility
     * @param {PtsSmsCheckBoxVisibilityRequest} ptsSmsCheckBoxVisibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest: PtsSmsCheckBoxVisibilityRequest, options?: any) {
        return PtsApiFp(this.configuration).getPtsSmsCheckBoxVisibility(ptsSmsCheckBoxVisibilityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Change record status from unlocked to locked
     * @param {PtsLockRecordRequest} ptsLockRecordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public lockPtsRecord(ptsLockRecordRequest: PtsLockRecordRequest, options?: any) {
        return PtsApiFp(this.configuration).lockPtsRecord(ptsLockRecordRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Save Pts Record
     * @param {PtsSaveRequest} ptsSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public savePtsRecord(ptsSaveRequest: PtsSaveRequest, options?: any) {
        return PtsApiFp(this.configuration).savePtsRecord(ptsSaveRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Search Pts Records
     * @param {PtsSearchRequest} ptsSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public searchPtsRecords(ptsSearchRequest: PtsSearchRequest, options?: any) {
        return PtsApiFp(this.configuration).searchPtsRecords(ptsSearchRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Change record status from locked to unlocked
     * @param {PtsUnlockRecordRequest} ptsUnlockRecordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public unlockPtsRecord(ptsUnlockRecordRequest: PtsUnlockRecordRequest, options?: any) {
        return PtsApiFp(this.configuration).unlockPtsRecord(ptsUnlockRecordRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update Pts Record
     * @param {PtsUpdateRequest} ptsUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PtsApi
     */
    public updatePtsRecord(ptsUpdateRequest: PtsUpdateRequest, options?: any) {
        return PtsApiFp(this.configuration).updatePtsRecord(ptsUpdateRequest, options)(this.axios, this.basePath);
    }

}


/**
 * RootApi - axios parameter creator
 * @export
 */
export const RootApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Root url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        root(options: any = {}): RequestArgs {
            const localVarPath = `/`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RootApi - functional programming interface
 * @export
 */
export const RootApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Root url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        root(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExceptionResponse> {
            const localVarAxiosArgs = RootApiAxiosParamCreator(configuration).root(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RootApi - factory interface
 * @export
 */
export const RootApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Root url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        root(options?: any): AxiosPromise<ExceptionResponse> {
            return RootApiFp(configuration).root(options)(axios, basePath);
        },
    };
};

/**
 * RootApi - object-oriented interface
 * @export
 * @class RootApi
 * @extends {BaseAPI}
 */
export class RootApi extends BaseAPI {
    /**
     * 
     * @summary Root url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RootApi
     */
    public root(options?: any) {
        return RootApiFp(this.configuration).root(options)(this.axios, this.basePath);
    }

}


/**
 * ScoringApi - axios parameter creator
 * @export
 */
export const ScoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get customer additional job page info for scoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAdditionalJobInfo(options: any = {}): RequestArgs {
            const localVarPath = `/scoring/additional-info/job`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoringApi - functional programming interface
 * @export
 */
export const ScoringApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get customer additional job page info for scoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAdditionalJobInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalJobInfoResponse> {
            const localVarAxiosArgs = ScoringApiAxiosParamCreator(configuration).getCustomerAdditionalJobInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ScoringApi - factory interface
 * @export
 */
export const ScoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary get customer additional job page info for scoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAdditionalJobInfo(options?: any): AxiosPromise<AdditionalJobInfoResponse> {
            return ScoringApiFp(configuration).getCustomerAdditionalJobInfo(options)(axios, basePath);
        },
    };
};

/**
 * ScoringApi - object-oriented interface
 * @export
 * @class ScoringApi
 * @extends {BaseAPI}
 */
export class ScoringApi extends BaseAPI {
    /**
     * 
     * @summary get customer additional job page info for scoring
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringApi
     */
    public getCustomerAdditionalJobInfo(options?: any) {
        return ScoringApiFp(this.configuration).getCustomerAdditionalJobInfo(options)(this.axios, this.basePath);
    }

}


/**
 * ScoringJobPageValidationApi - axios parameter creator
 * @export
 */
export const ScoringJobPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get scoring job page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringJobPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-scoring-job-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate scoring job page data
         * @param {ValidateScoringJobPageDataRequest} validateScoringJobPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateScoringJobPageData(validateScoringJobPageDataRequest: ValidateScoringJobPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateScoringJobPageDataRequest' is not null or undefined
            if (validateScoringJobPageDataRequest === null || validateScoringJobPageDataRequest === undefined) {
                throw new RequiredError('validateScoringJobPageDataRequest','Required parameter validateScoringJobPageDataRequest was null or undefined when calling validateScoringJobPageData.');
            }
            const localVarPath = `/validate-scoring-job-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateScoringJobPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateScoringJobPageDataRequest !== undefined ? validateScoringJobPageDataRequest : {}) : (validateScoringJobPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoringJobPageValidationApi - functional programming interface
 * @export
 */
export const ScoringJobPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get scoring job page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringJobPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringJobPageDataResponse> {
            const localVarAxiosArgs = ScoringJobPageValidationApiAxiosParamCreator(configuration).getScoringJobPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate scoring job page data
         * @param {ValidateScoringJobPageDataRequest} validateScoringJobPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateScoringJobPageData(validateScoringJobPageDataRequest: ValidateScoringJobPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateScoringJobPageDataResponse> {
            const localVarAxiosArgs = ScoringJobPageValidationApiAxiosParamCreator(configuration).validateScoringJobPageData(validateScoringJobPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ScoringJobPageValidationApi - factory interface
 * @export
 */
export const ScoringJobPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get scoring job page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringJobPageData(options?: any): AxiosPromise<ScoringJobPageDataResponse> {
            return ScoringJobPageValidationApiFp(configuration).getScoringJobPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate scoring job page data
         * @param {ValidateScoringJobPageDataRequest} validateScoringJobPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateScoringJobPageData(validateScoringJobPageDataRequest: ValidateScoringJobPageDataRequest, options?: any): AxiosPromise<ValidateScoringJobPageDataResponse> {
            return ScoringJobPageValidationApiFp(configuration).validateScoringJobPageData(validateScoringJobPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ScoringJobPageValidationApi - object-oriented interface
 * @export
 * @class ScoringJobPageValidationApi
 * @extends {BaseAPI}
 */
export class ScoringJobPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get scoring job page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringJobPageValidationApi
     */
    public getScoringJobPageData(options?: any) {
        return ScoringJobPageValidationApiFp(this.configuration).getScoringJobPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate scoring job page data
     * @param {ValidateScoringJobPageDataRequest} validateScoringJobPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringJobPageValidationApi
     */
    public validateScoringJobPageData(validateScoringJobPageDataRequest: ValidateScoringJobPageDataRequest, options?: any) {
        return ScoringJobPageValidationApiFp(this.configuration).validateScoringJobPageData(validateScoringJobPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * SessionApi - axios parameter creator
 * @export
 */
export const SessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary clear card application session data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionCardApplicationData(options: any = {}): RequestArgs {
            const localVarPath = `/session/clear-card-application`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear session data
         * @param {SessionClearRequest} sessionClearRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionData(sessionClearRequest: SessionClearRequest, options: any = {}): RequestArgs {
            // verify required parameter 'sessionClearRequest' is not null or undefined
            if (sessionClearRequest === null || sessionClearRequest === undefined) {
                throw new RequiredError('sessionClearRequest','Required parameter sessionClearRequest was null or undefined when calling clearSessionData.');
            }
            const localVarPath = `/session/clear`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sessionClearRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sessionClearRequest !== undefined ? sessionClearRequest : {}) : (sessionClearRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionApi - functional programming interface
 * @export
 */
export const SessionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary clear card application session data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionCardApplicationData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionCardApplicationResponse> {
            const localVarAxiosArgs = SessionApiAxiosParamCreator(configuration).clearSessionCardApplicationData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Clear session data
         * @param {SessionClearRequest} sessionClearRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionData(sessionClearRequest: SessionClearRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionClearResponse> {
            const localVarAxiosArgs = SessionApiAxiosParamCreator(configuration).clearSessionData(sessionClearRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SessionApi - factory interface
 * @export
 */
export const SessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary clear card application session data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionCardApplicationData(options?: any): AxiosPromise<SessionCardApplicationResponse> {
            return SessionApiFp(configuration).clearSessionCardApplicationData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Clear session data
         * @param {SessionClearRequest} sessionClearRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionData(sessionClearRequest: SessionClearRequest, options?: any): AxiosPromise<SessionClearResponse> {
            return SessionApiFp(configuration).clearSessionData(sessionClearRequest, options)(axios, basePath);
        },
    };
};

/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
export class SessionApi extends BaseAPI {
    /**
     * 
     * @summary clear card application session data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public clearSessionCardApplicationData(options?: any) {
        return SessionApiFp(this.configuration).clearSessionCardApplicationData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Clear session data
     * @param {SessionClearRequest} sessionClearRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public clearSessionData(sessionClearRequest: SessionClearRequest, options?: any) {
        return SessionApiFp(this.configuration).clearSessionData(sessionClearRequest, options)(this.axios, this.basePath);
    }

}


/**
 * SummaryApi - axios parameter creator
 * @export
 */
export const SummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryInfo(options: any = {}): RequestArgs {
            const localVarPath = `/summary`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummaryApi - functional programming interface
 * @export
 */
export const SummaryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryInfoResponse> {
            const localVarAxiosArgs = SummaryApiAxiosParamCreator(configuration).getSummaryInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SummaryApi - factory interface
 * @export
 */
export const SummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryInfo(options?: any): AxiosPromise<SummaryInfoResponse> {
            return SummaryApiFp(configuration).getSummaryInfo(options)(axios, basePath);
        },
    };
};

/**
 * SummaryApi - object-oriented interface
 * @export
 * @class SummaryApi
 * @extends {BaseAPI}
 */
export class SummaryApi extends BaseAPI {
    /**
     * 
     * @summary Get Summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryApi
     */
    public getSummaryInfo(options?: any) {
        return SummaryApiFp(this.configuration).getSummaryInfo(options)(this.axios, this.basePath);
    }

}


/**
 * SummaryConfirmationPageValidationApi - axios parameter creator
 * @export
 */
export const SummaryConfirmationPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate summary confirmation page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSummaryPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-summary-confirmation-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummaryConfirmationPageValidationApi - functional programming interface
 * @export
 */
export const SummaryConfirmationPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate summary confirmation page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSummaryPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateSummaryPageDataResponse> {
            const localVarAxiosArgs = SummaryConfirmationPageValidationApiAxiosParamCreator(configuration).validateSummaryPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SummaryConfirmationPageValidationApi - factory interface
 * @export
 */
export const SummaryConfirmationPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Validate summary confirmation page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSummaryPageData(options?: any): AxiosPromise<ValidateSummaryPageDataResponse> {
            return SummaryConfirmationPageValidationApiFp(configuration).validateSummaryPageData(options)(axios, basePath);
        },
    };
};

/**
 * SummaryConfirmationPageValidationApi - object-oriented interface
 * @export
 * @class SummaryConfirmationPageValidationApi
 * @extends {BaseAPI}
 */
export class SummaryConfirmationPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Validate summary confirmation page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryConfirmationPageValidationApi
     */
    public validateSummaryPageData(options?: any) {
        return SummaryConfirmationPageValidationApiFp(this.configuration).validateSummaryPageData(options)(this.axios, this.basePath);
    }

}


/**
 * TaxInfoPageValidationApi - axios parameter creator
 * @export
 */
export const TaxInfoPageValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tax info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxInfoPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-tax-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate tax info page data
         * @param {ValidateTaxInfoPageDataRequest} validateTaxInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxInfoPageData(validateTaxInfoPageDataRequest: ValidateTaxInfoPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateTaxInfoPageDataRequest' is not null or undefined
            if (validateTaxInfoPageDataRequest === null || validateTaxInfoPageDataRequest === undefined) {
                throw new RequiredError('validateTaxInfoPageDataRequest','Required parameter validateTaxInfoPageDataRequest was null or undefined when calling validateTaxInfoPageData.');
            }
            const localVarPath = `/validate-tax-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateTaxInfoPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateTaxInfoPageDataRequest !== undefined ? validateTaxInfoPageDataRequest : {}) : (validateTaxInfoPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxInfoPageValidationApi - functional programming interface
 * @export
 */
export const TaxInfoPageValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tax info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxInfoPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxInfoPageDataResponse> {
            const localVarAxiosArgs = TaxInfoPageValidationApiAxiosParamCreator(configuration).getTaxInfoPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate tax info page data
         * @param {ValidateTaxInfoPageDataRequest} validateTaxInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxInfoPageData(validateTaxInfoPageDataRequest: ValidateTaxInfoPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateTaxInfoPageDataResponse> {
            const localVarAxiosArgs = TaxInfoPageValidationApiAxiosParamCreator(configuration).validateTaxInfoPageData(validateTaxInfoPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TaxInfoPageValidationApi - factory interface
 * @export
 */
export const TaxInfoPageValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get tax info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxInfoPageData(options?: any): AxiosPromise<TaxInfoPageDataResponse> {
            return TaxInfoPageValidationApiFp(configuration).getTaxInfoPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate tax info page data
         * @param {ValidateTaxInfoPageDataRequest} validateTaxInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxInfoPageData(validateTaxInfoPageDataRequest: ValidateTaxInfoPageDataRequest, options?: any): AxiosPromise<ValidateTaxInfoPageDataResponse> {
            return TaxInfoPageValidationApiFp(configuration).validateTaxInfoPageData(validateTaxInfoPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * TaxInfoPageValidationApi - object-oriented interface
 * @export
 * @class TaxInfoPageValidationApi
 * @extends {BaseAPI}
 */
export class TaxInfoPageValidationApi extends BaseAPI {
    /**
     * 
     * @summary Get tax info page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxInfoPageValidationApi
     */
    public getTaxInfoPageData(options?: any) {
        return TaxInfoPageValidationApiFp(this.configuration).getTaxInfoPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate tax info page data
     * @param {ValidateTaxInfoPageDataRequest} validateTaxInfoPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxInfoPageValidationApi
     */
    public validateTaxInfoPageData(validateTaxInfoPageDataRequest: ValidateTaxInfoPageDataRequest, options?: any) {
        return TaxInfoPageValidationApiFp(this.configuration).validateTaxInfoPageData(validateTaxInfoPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change User Password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest?: ChangePasswordRequest, options: any = {}): RequestArgs {
            const localVarPath = `/user/password-change`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changePasswordRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changePasswordRequest !== undefined ? changePasswordRequest : {}) : (changePasswordRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change User Password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest?: ChangePasswordRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangePasswordResponse> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).changePassword(changePasswordRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Change User Password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest?: ChangePasswordRequest, options?: any): AxiosPromise<ChangePasswordResponse> {
            return UserApiFp(configuration).changePassword(changePasswordRequest, options)(axios, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Change User Password
     * @param {ChangePasswordRequest} [changePasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public changePassword(changePasswordRequest?: ChangePasswordRequest, options?: any) {
        return UserApiFp(this.configuration).changePassword(changePasswordRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanAdditionalEquipmentPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanAdditionalEquipmentPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan additional equipment page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdditionalEquipmentPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-additional-equipment-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan additional equipment page data
         * @param {ValidateLoanAdditionalEquipmentPageDataRequest} validateLoanAdditionalEquipmentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest: ValidateLoanAdditionalEquipmentPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanAdditionalEquipmentPageDataRequest' is not null or undefined
            if (validateLoanAdditionalEquipmentPageDataRequest === null || validateLoanAdditionalEquipmentPageDataRequest === undefined) {
                throw new RequiredError('validateLoanAdditionalEquipmentPageDataRequest','Required parameter validateLoanAdditionalEquipmentPageDataRequest was null or undefined when calling validateLoanAdditionalEquipmentPageData.');
            }
            const localVarPath = `/validate-loan-additional-equipment-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanAdditionalEquipmentPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanAdditionalEquipmentPageDataRequest !== undefined ? validateLoanAdditionalEquipmentPageDataRequest : {}) : (validateLoanAdditionalEquipmentPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanAdditionalEquipmentPageApi - functional programming interface
 * @export
 */
export const ValidateLoanAdditionalEquipmentPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan additional equipment page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdditionalEquipmentPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanAdditionalEquipmentPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanAdditionalEquipmentPageApiAxiosParamCreator(configuration).getLoanAdditionalEquipmentPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan additional equipment page data
         * @param {ValidateLoanAdditionalEquipmentPageDataRequest} validateLoanAdditionalEquipmentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest: ValidateLoanAdditionalEquipmentPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanAdditionalEquipmentPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanAdditionalEquipmentPageApiAxiosParamCreator(configuration).validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanAdditionalEquipmentPageApi - factory interface
 * @export
 */
export const ValidateLoanAdditionalEquipmentPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan additional equipment page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdditionalEquipmentPageData(options?: any): AxiosPromise<LoanAdditionalEquipmentPageDataResponse> {
            return ValidateLoanAdditionalEquipmentPageApiFp(configuration).getLoanAdditionalEquipmentPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan additional equipment page data
         * @param {ValidateLoanAdditionalEquipmentPageDataRequest} validateLoanAdditionalEquipmentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest: ValidateLoanAdditionalEquipmentPageDataRequest, options?: any): AxiosPromise<ValidateLoanAdditionalEquipmentPageDataResponse> {
            return ValidateLoanAdditionalEquipmentPageApiFp(configuration).validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanAdditionalEquipmentPageApi - object-oriented interface
 * @export
 * @class ValidateLoanAdditionalEquipmentPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanAdditionalEquipmentPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan additional equipment page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanAdditionalEquipmentPageApi
     */
    public getLoanAdditionalEquipmentPageData(options?: any) {
        return ValidateLoanAdditionalEquipmentPageApiFp(this.configuration).getLoanAdditionalEquipmentPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan additional equipment page data
     * @param {ValidateLoanAdditionalEquipmentPageDataRequest} validateLoanAdditionalEquipmentPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanAdditionalEquipmentPageApi
     */
    public validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest: ValidateLoanAdditionalEquipmentPageDataRequest, options?: any) {
        return ValidateLoanAdditionalEquipmentPageApiFp(this.configuration).validateLoanAdditionalEquipmentPageData(validateLoanAdditionalEquipmentPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanAdditionalServicesPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanAdditionalServicesPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan additional services page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdditionalServicesPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-additional-services-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan additional services page data
         * @param {ValidateLoanAdditionalServicesPageDataRequest} validateLoanAdditionalServicesPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest: ValidateLoanAdditionalServicesPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanAdditionalServicesPageDataRequest' is not null or undefined
            if (validateLoanAdditionalServicesPageDataRequest === null || validateLoanAdditionalServicesPageDataRequest === undefined) {
                throw new RequiredError('validateLoanAdditionalServicesPageDataRequest','Required parameter validateLoanAdditionalServicesPageDataRequest was null or undefined when calling validateLoanAdditionalServicesPageData.');
            }
            const localVarPath = `/validate-loan-additional-services-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanAdditionalServicesPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanAdditionalServicesPageDataRequest !== undefined ? validateLoanAdditionalServicesPageDataRequest : {}) : (validateLoanAdditionalServicesPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanAdditionalServicesPageApi - functional programming interface
 * @export
 */
export const ValidateLoanAdditionalServicesPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan additional services page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdditionalServicesPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanAdditionalServicesPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanAdditionalServicesPageApiAxiosParamCreator(configuration).getLoanAdditionalServicesPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan additional services page data
         * @param {ValidateLoanAdditionalServicesPageDataRequest} validateLoanAdditionalServicesPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest: ValidateLoanAdditionalServicesPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanAdditionalServicesPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanAdditionalServicesPageApiAxiosParamCreator(configuration).validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanAdditionalServicesPageApi - factory interface
 * @export
 */
export const ValidateLoanAdditionalServicesPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan additional services page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdditionalServicesPageData(options?: any): AxiosPromise<LoanAdditionalServicesPageDataResponse> {
            return ValidateLoanAdditionalServicesPageApiFp(configuration).getLoanAdditionalServicesPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan additional services page data
         * @param {ValidateLoanAdditionalServicesPageDataRequest} validateLoanAdditionalServicesPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest: ValidateLoanAdditionalServicesPageDataRequest, options?: any): AxiosPromise<ValidateLoanAdditionalServicesPageDataResponse> {
            return ValidateLoanAdditionalServicesPageApiFp(configuration).validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanAdditionalServicesPageApi - object-oriented interface
 * @export
 * @class ValidateLoanAdditionalServicesPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanAdditionalServicesPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan additional services page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanAdditionalServicesPageApi
     */
    public getLoanAdditionalServicesPageData(options?: any) {
        return ValidateLoanAdditionalServicesPageApiFp(this.configuration).getLoanAdditionalServicesPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan additional services page data
     * @param {ValidateLoanAdditionalServicesPageDataRequest} validateLoanAdditionalServicesPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanAdditionalServicesPageApi
     */
    public validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest: ValidateLoanAdditionalServicesPageDataRequest, options?: any) {
        return ValidateLoanAdditionalServicesPageApiFp(this.configuration).validateLoanAdditionalServicesPageData(validateLoanAdditionalServicesPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanAddressPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanAddressPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get  loan address page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAddressPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-address-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan address page data
         * @param {ValidateLoanAddressPageDataRequest} validateLoanAddressPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAddressPageData(validateLoanAddressPageDataRequest: ValidateLoanAddressPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanAddressPageDataRequest' is not null or undefined
            if (validateLoanAddressPageDataRequest === null || validateLoanAddressPageDataRequest === undefined) {
                throw new RequiredError('validateLoanAddressPageDataRequest','Required parameter validateLoanAddressPageDataRequest was null or undefined when calling validateLoanAddressPageData.');
            }
            const localVarPath = `/validate-loan-address-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanAddressPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanAddressPageDataRequest !== undefined ? validateLoanAddressPageDataRequest : {}) : (validateLoanAddressPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanAddressPageApi - functional programming interface
 * @export
 */
export const ValidateLoanAddressPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get  loan address page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAddressPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanAddressPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanAddressPageApiAxiosParamCreator(configuration).getLoanAddressPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan address page data
         * @param {ValidateLoanAddressPageDataRequest} validateLoanAddressPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAddressPageData(validateLoanAddressPageDataRequest: ValidateLoanAddressPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanAddressPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanAddressPageApiAxiosParamCreator(configuration).validateLoanAddressPageData(validateLoanAddressPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanAddressPageApi - factory interface
 * @export
 */
export const ValidateLoanAddressPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get  loan address page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAddressPageData(options?: any): AxiosPromise<LoanAddressPageDataResponse> {
            return ValidateLoanAddressPageApiFp(configuration).getLoanAddressPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan address page data
         * @param {ValidateLoanAddressPageDataRequest} validateLoanAddressPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAddressPageData(validateLoanAddressPageDataRequest: ValidateLoanAddressPageDataRequest, options?: any): AxiosPromise<ValidateLoanAddressPageDataResponse> {
            return ValidateLoanAddressPageApiFp(configuration).validateLoanAddressPageData(validateLoanAddressPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanAddressPageApi - object-oriented interface
 * @export
 * @class ValidateLoanAddressPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanAddressPageApi extends BaseAPI {
    /**
     * 
     * @summary Get  loan address page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanAddressPageApi
     */
    public getLoanAddressPageData(options?: any) {
        return ValidateLoanAddressPageApiFp(this.configuration).getLoanAddressPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan address page data
     * @param {ValidateLoanAddressPageDataRequest} validateLoanAddressPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanAddressPageApi
     */
    public validateLoanAddressPageData(validateLoanAddressPageDataRequest: ValidateLoanAddressPageDataRequest, options?: any) {
        return ValidateLoanAddressPageApiFp(this.configuration).validateLoanAddressPageData(validateLoanAddressPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanApplicationDocumentPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanApplicationDocumentPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan application document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationDocumentPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-application-document-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan application document page data
         * @param {ValidateLoanApplicationDocumentPageDataRequest} validateLoanApplicationDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest: ValidateLoanApplicationDocumentPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanApplicationDocumentPageDataRequest' is not null or undefined
            if (validateLoanApplicationDocumentPageDataRequest === null || validateLoanApplicationDocumentPageDataRequest === undefined) {
                throw new RequiredError('validateLoanApplicationDocumentPageDataRequest','Required parameter validateLoanApplicationDocumentPageDataRequest was null or undefined when calling validateLoanApplicationDocumentPageData.');
            }
            const localVarPath = `/validate-loan-application-document-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanApplicationDocumentPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanApplicationDocumentPageDataRequest !== undefined ? validateLoanApplicationDocumentPageDataRequest : {}) : (validateLoanApplicationDocumentPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanApplicationDocumentPageApi - functional programming interface
 * @export
 */
export const ValidateLoanApplicationDocumentPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan application document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationDocumentPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDocumentPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanApplicationDocumentPageApiAxiosParamCreator(configuration).getLoanApplicationDocumentPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan application document page data
         * @param {ValidateLoanApplicationDocumentPageDataRequest} validateLoanApplicationDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest: ValidateLoanApplicationDocumentPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanApplicationDocumentPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanApplicationDocumentPageApiAxiosParamCreator(configuration).validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanApplicationDocumentPageApi - factory interface
 * @export
 */
export const ValidateLoanApplicationDocumentPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan application document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationDocumentPageData(options?: any): AxiosPromise<LoanApplicationDocumentPageDataResponse> {
            return ValidateLoanApplicationDocumentPageApiFp(configuration).getLoanApplicationDocumentPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan application document page data
         * @param {ValidateLoanApplicationDocumentPageDataRequest} validateLoanApplicationDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest: ValidateLoanApplicationDocumentPageDataRequest, options?: any): AxiosPromise<ValidateLoanApplicationDocumentPageDataResponse> {
            return ValidateLoanApplicationDocumentPageApiFp(configuration).validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanApplicationDocumentPageApi - object-oriented interface
 * @export
 * @class ValidateLoanApplicationDocumentPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanApplicationDocumentPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan application document page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanApplicationDocumentPageApi
     */
    public getLoanApplicationDocumentPageData(options?: any) {
        return ValidateLoanApplicationDocumentPageApiFp(this.configuration).getLoanApplicationDocumentPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan application document page data
     * @param {ValidateLoanApplicationDocumentPageDataRequest} validateLoanApplicationDocumentPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanApplicationDocumentPageApi
     */
    public validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest: ValidateLoanApplicationDocumentPageDataRequest, options?: any) {
        return ValidateLoanApplicationDocumentPageApiFp(this.configuration).validateLoanApplicationDocumentPageData(validateLoanApplicationDocumentPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanBenefitsThirdPartyPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanBenefitsThirdPartyPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan benefits third party page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanBenefitsThirdPartyPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-benefits-third-party-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan benefits third party page data
         * @param {ValidateLoanBenefitsThirdPartyPageDataRequest} validateLoanBenefitsThirdPartyPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest: ValidateLoanBenefitsThirdPartyPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanBenefitsThirdPartyPageDataRequest' is not null or undefined
            if (validateLoanBenefitsThirdPartyPageDataRequest === null || validateLoanBenefitsThirdPartyPageDataRequest === undefined) {
                throw new RequiredError('validateLoanBenefitsThirdPartyPageDataRequest','Required parameter validateLoanBenefitsThirdPartyPageDataRequest was null or undefined when calling validateLoanBenefitsThirdPartyPageData.');
            }
            const localVarPath = `/validate-loan-benefits-third-party-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanBenefitsThirdPartyPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanBenefitsThirdPartyPageDataRequest !== undefined ? validateLoanBenefitsThirdPartyPageDataRequest : {}) : (validateLoanBenefitsThirdPartyPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanBenefitsThirdPartyPageApi - functional programming interface
 * @export
 */
export const ValidateLoanBenefitsThirdPartyPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan benefits third party page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanBenefitsThirdPartyPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanBenefitsThirdPartyPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanBenefitsThirdPartyPageApiAxiosParamCreator(configuration).getLoanBenefitsThirdPartyPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan benefits third party page data
         * @param {ValidateLoanBenefitsThirdPartyPageDataRequest} validateLoanBenefitsThirdPartyPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest: ValidateLoanBenefitsThirdPartyPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanBenefitsThirdPartyPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanBenefitsThirdPartyPageApiAxiosParamCreator(configuration).validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanBenefitsThirdPartyPageApi - factory interface
 * @export
 */
export const ValidateLoanBenefitsThirdPartyPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan benefits third party page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanBenefitsThirdPartyPageData(options?: any): AxiosPromise<LoanBenefitsThirdPartyPageDataResponse> {
            return ValidateLoanBenefitsThirdPartyPageApiFp(configuration).getLoanBenefitsThirdPartyPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan benefits third party page data
         * @param {ValidateLoanBenefitsThirdPartyPageDataRequest} validateLoanBenefitsThirdPartyPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest: ValidateLoanBenefitsThirdPartyPageDataRequest, options?: any): AxiosPromise<ValidateLoanBenefitsThirdPartyPageDataResponse> {
            return ValidateLoanBenefitsThirdPartyPageApiFp(configuration).validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanBenefitsThirdPartyPageApi - object-oriented interface
 * @export
 * @class ValidateLoanBenefitsThirdPartyPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanBenefitsThirdPartyPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan benefits third party page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanBenefitsThirdPartyPageApi
     */
    public getLoanBenefitsThirdPartyPageData(options?: any) {
        return ValidateLoanBenefitsThirdPartyPageApiFp(this.configuration).getLoanBenefitsThirdPartyPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan benefits third party page data
     * @param {ValidateLoanBenefitsThirdPartyPageDataRequest} validateLoanBenefitsThirdPartyPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanBenefitsThirdPartyPageApi
     */
    public validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest: ValidateLoanBenefitsThirdPartyPageDataRequest, options?: any) {
        return ValidateLoanBenefitsThirdPartyPageApiFp(this.configuration).validateLoanBenefitsThirdPartyPageData(validateLoanBenefitsThirdPartyPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanCarDocumentsPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanCarDocumentsPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan car documents page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCarDocumentsPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-car-documents-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan car document page data
         * @param {ValidateLoanCarDocumentsPageDataRequest} validateLoanCarDocumentsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest: ValidateLoanCarDocumentsPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanCarDocumentsPageDataRequest' is not null or undefined
            if (validateLoanCarDocumentsPageDataRequest === null || validateLoanCarDocumentsPageDataRequest === undefined) {
                throw new RequiredError('validateLoanCarDocumentsPageDataRequest','Required parameter validateLoanCarDocumentsPageDataRequest was null or undefined when calling validateLoanCarDocumentsPageData.');
            }
            const localVarPath = `/validate-loan-car-documents-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanCarDocumentsPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanCarDocumentsPageDataRequest !== undefined ? validateLoanCarDocumentsPageDataRequest : {}) : (validateLoanCarDocumentsPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanCarDocumentsPageApi - functional programming interface
 * @export
 */
export const ValidateLoanCarDocumentsPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan car documents page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCarDocumentsPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCarDocumentsPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanCarDocumentsPageApiAxiosParamCreator(configuration).getLoanCarDocumentsPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan car document page data
         * @param {ValidateLoanCarDocumentsPageDataRequest} validateLoanCarDocumentsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest: ValidateLoanCarDocumentsPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanCarDocumentsPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanCarDocumentsPageApiAxiosParamCreator(configuration).validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanCarDocumentsPageApi - factory interface
 * @export
 */
export const ValidateLoanCarDocumentsPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan car documents page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCarDocumentsPageData(options?: any): AxiosPromise<LoanCarDocumentsPageDataResponse> {
            return ValidateLoanCarDocumentsPageApiFp(configuration).getLoanCarDocumentsPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan car document page data
         * @param {ValidateLoanCarDocumentsPageDataRequest} validateLoanCarDocumentsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest: ValidateLoanCarDocumentsPageDataRequest, options?: any): AxiosPromise<ValidateLoanCarDocumentsPageDataResponse> {
            return ValidateLoanCarDocumentsPageApiFp(configuration).validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanCarDocumentsPageApi - object-oriented interface
 * @export
 * @class ValidateLoanCarDocumentsPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanCarDocumentsPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan car documents page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanCarDocumentsPageApi
     */
    public getLoanCarDocumentsPageData(options?: any) {
        return ValidateLoanCarDocumentsPageApiFp(this.configuration).getLoanCarDocumentsPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan car document page data
     * @param {ValidateLoanCarDocumentsPageDataRequest} validateLoanCarDocumentsPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanCarDocumentsPageApi
     */
    public validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest: ValidateLoanCarDocumentsPageDataRequest, options?: any) {
        return ValidateLoanCarDocumentsPageApiFp(this.configuration).validateLoanCarDocumentsPageData(validateLoanCarDocumentsPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanCarTotalCostPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanCarTotalCostPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan total cost page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCarTotalCostPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-car-total-cost-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan total cost page data
         * @param {ValidateLoanCarTotalCostPageDataRequest} validateLoanCarTotalCostPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest: ValidateLoanCarTotalCostPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanCarTotalCostPageDataRequest' is not null or undefined
            if (validateLoanCarTotalCostPageDataRequest === null || validateLoanCarTotalCostPageDataRequest === undefined) {
                throw new RequiredError('validateLoanCarTotalCostPageDataRequest','Required parameter validateLoanCarTotalCostPageDataRequest was null or undefined when calling validateLoanCarTotalCostPageData.');
            }
            const localVarPath = `/validate-loan-car-total-cost-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanCarTotalCostPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanCarTotalCostPageDataRequest !== undefined ? validateLoanCarTotalCostPageDataRequest : {}) : (validateLoanCarTotalCostPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanCarTotalCostPageApi - functional programming interface
 * @export
 */
export const ValidateLoanCarTotalCostPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan total cost page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCarTotalCostPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCarTotalCostPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanCarTotalCostPageApiAxiosParamCreator(configuration).getLoanCarTotalCostPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan total cost page data
         * @param {ValidateLoanCarTotalCostPageDataRequest} validateLoanCarTotalCostPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest: ValidateLoanCarTotalCostPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanCarTotalCostPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanCarTotalCostPageApiAxiosParamCreator(configuration).validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanCarTotalCostPageApi - factory interface
 * @export
 */
export const ValidateLoanCarTotalCostPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan total cost page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCarTotalCostPageData(options?: any): AxiosPromise<LoanCarTotalCostPageDataResponse> {
            return ValidateLoanCarTotalCostPageApiFp(configuration).getLoanCarTotalCostPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan total cost page data
         * @param {ValidateLoanCarTotalCostPageDataRequest} validateLoanCarTotalCostPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest: ValidateLoanCarTotalCostPageDataRequest, options?: any): AxiosPromise<ValidateLoanCarTotalCostPageDataResponse> {
            return ValidateLoanCarTotalCostPageApiFp(configuration).validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanCarTotalCostPageApi - object-oriented interface
 * @export
 * @class ValidateLoanCarTotalCostPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanCarTotalCostPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan total cost page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanCarTotalCostPageApi
     */
    public getLoanCarTotalCostPageData(options?: any) {
        return ValidateLoanCarTotalCostPageApiFp(this.configuration).getLoanCarTotalCostPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan total cost page data
     * @param {ValidateLoanCarTotalCostPageDataRequest} validateLoanCarTotalCostPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanCarTotalCostPageApi
     */
    public validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest: ValidateLoanCarTotalCostPageDataRequest, options?: any) {
        return ValidateLoanCarTotalCostPageApiFp(this.configuration).validateLoanCarTotalCostPageData(validateLoanCarTotalCostPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanContactInfoPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanContactInfoPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan contact info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanContactInfoPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-contact-info-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan contact info page data
         * @param {ValidateLoanContactInfoPageDataRequest} validateLoanContactInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest: ValidateLoanContactInfoPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanContactInfoPageDataRequest' is not null or undefined
            if (validateLoanContactInfoPageDataRequest === null || validateLoanContactInfoPageDataRequest === undefined) {
                throw new RequiredError('validateLoanContactInfoPageDataRequest','Required parameter validateLoanContactInfoPageDataRequest was null or undefined when calling validateLoanContactInfoPageData.');
            }
            const localVarPath = `/validate-loan-contact-info-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanContactInfoPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanContactInfoPageDataRequest !== undefined ? validateLoanContactInfoPageDataRequest : {}) : (validateLoanContactInfoPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanContactInfoPageApi - functional programming interface
 * @export
 */
export const ValidateLoanContactInfoPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan contact info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanContactInfoPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanContactInfoPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanContactInfoPageApiAxiosParamCreator(configuration).getLoanContactInfoPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan contact info page data
         * @param {ValidateLoanContactInfoPageDataRequest} validateLoanContactInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest: ValidateLoanContactInfoPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanContactInfoPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanContactInfoPageApiAxiosParamCreator(configuration).validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanContactInfoPageApi - factory interface
 * @export
 */
export const ValidateLoanContactInfoPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan contact info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanContactInfoPageData(options?: any): AxiosPromise<LoanContactInfoPageDataResponse> {
            return ValidateLoanContactInfoPageApiFp(configuration).getLoanContactInfoPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan contact info page data
         * @param {ValidateLoanContactInfoPageDataRequest} validateLoanContactInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest: ValidateLoanContactInfoPageDataRequest, options?: any): AxiosPromise<ValidateLoanContactInfoPageDataResponse> {
            return ValidateLoanContactInfoPageApiFp(configuration).validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanContactInfoPageApi - object-oriented interface
 * @export
 * @class ValidateLoanContactInfoPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanContactInfoPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan contact info page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanContactInfoPageApi
     */
    public getLoanContactInfoPageData(options?: any) {
        return ValidateLoanContactInfoPageApiFp(this.configuration).getLoanContactInfoPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan contact info page data
     * @param {ValidateLoanContactInfoPageDataRequest} validateLoanContactInfoPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanContactInfoPageApi
     */
    public validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest: ValidateLoanContactInfoPageDataRequest, options?: any) {
        return ValidateLoanContactInfoPageApiFp(this.configuration).validateLoanContactInfoPageData(validateLoanContactInfoPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanCustomerDetailPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanCustomerDetailPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan customer detail page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerDetailPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-customer-detail-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan customer detail page data
         * @param {ValidateLoanCustomerDetailPageDataRequest} validateLoanCustomerDetailPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest: ValidateLoanCustomerDetailPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanCustomerDetailPageDataRequest' is not null or undefined
            if (validateLoanCustomerDetailPageDataRequest === null || validateLoanCustomerDetailPageDataRequest === undefined) {
                throw new RequiredError('validateLoanCustomerDetailPageDataRequest','Required parameter validateLoanCustomerDetailPageDataRequest was null or undefined when calling validateLoanCustomerDetailPageData.');
            }
            const localVarPath = `/validate-loan-customer-detail-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanCustomerDetailPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanCustomerDetailPageDataRequest !== undefined ? validateLoanCustomerDetailPageDataRequest : {}) : (validateLoanCustomerDetailPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanCustomerDetailPageApi - functional programming interface
 * @export
 */
export const ValidateLoanCustomerDetailPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan customer detail page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerDetailPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanCustomerDetailPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanCustomerDetailPageApiAxiosParamCreator(configuration).getLoanCustomerDetailPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan customer detail page data
         * @param {ValidateLoanCustomerDetailPageDataRequest} validateLoanCustomerDetailPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest: ValidateLoanCustomerDetailPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanCustomerDetailPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanCustomerDetailPageApiAxiosParamCreator(configuration).validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanCustomerDetailPageApi - factory interface
 * @export
 */
export const ValidateLoanCustomerDetailPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan customer detail page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanCustomerDetailPageData(options?: any): AxiosPromise<LoanCustomerDetailPageDataResponse> {
            return ValidateLoanCustomerDetailPageApiFp(configuration).getLoanCustomerDetailPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan customer detail page data
         * @param {ValidateLoanCustomerDetailPageDataRequest} validateLoanCustomerDetailPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest: ValidateLoanCustomerDetailPageDataRequest, options?: any): AxiosPromise<ValidateLoanCustomerDetailPageDataResponse> {
            return ValidateLoanCustomerDetailPageApiFp(configuration).validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanCustomerDetailPageApi - object-oriented interface
 * @export
 * @class ValidateLoanCustomerDetailPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanCustomerDetailPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan customer detail page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanCustomerDetailPageApi
     */
    public getLoanCustomerDetailPageData(options?: any) {
        return ValidateLoanCustomerDetailPageApiFp(this.configuration).getLoanCustomerDetailPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan customer detail page data
     * @param {ValidateLoanCustomerDetailPageDataRequest} validateLoanCustomerDetailPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanCustomerDetailPageApi
     */
    public validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest: ValidateLoanCustomerDetailPageDataRequest, options?: any) {
        return ValidateLoanCustomerDetailPageApiFp(this.configuration).validateLoanCustomerDetailPageData(validateLoanCustomerDetailPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanDetailsPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanDetailsPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan details page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDetailsPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-details-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan details page data
         * @param {ValidateLoanDetailsPageDataRequest} validateLoanDetailsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanDetailsPageData(validateLoanDetailsPageDataRequest: ValidateLoanDetailsPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanDetailsPageDataRequest' is not null or undefined
            if (validateLoanDetailsPageDataRequest === null || validateLoanDetailsPageDataRequest === undefined) {
                throw new RequiredError('validateLoanDetailsPageDataRequest','Required parameter validateLoanDetailsPageDataRequest was null or undefined when calling validateLoanDetailsPageData.');
            }
            const localVarPath = `/validate-loan-details-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanDetailsPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanDetailsPageDataRequest !== undefined ? validateLoanDetailsPageDataRequest : {}) : (validateLoanDetailsPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanDetailsPageApi - functional programming interface
 * @export
 */
export const ValidateLoanDetailsPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan details page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDetailsPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDetailsPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanDetailsPageApiAxiosParamCreator(configuration).getLoanDetailsPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan details page data
         * @param {ValidateLoanDetailsPageDataRequest} validateLoanDetailsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanDetailsPageData(validateLoanDetailsPageDataRequest: ValidateLoanDetailsPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanDetailsPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanDetailsPageApiAxiosParamCreator(configuration).validateLoanDetailsPageData(validateLoanDetailsPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanDetailsPageApi - factory interface
 * @export
 */
export const ValidateLoanDetailsPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan details page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDetailsPageData(options?: any): AxiosPromise<LoanDetailsPageDataResponse> {
            return ValidateLoanDetailsPageApiFp(configuration).getLoanDetailsPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan details page data
         * @param {ValidateLoanDetailsPageDataRequest} validateLoanDetailsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanDetailsPageData(validateLoanDetailsPageDataRequest: ValidateLoanDetailsPageDataRequest, options?: any): AxiosPromise<ValidateLoanDetailsPageDataResponse> {
            return ValidateLoanDetailsPageApiFp(configuration).validateLoanDetailsPageData(validateLoanDetailsPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanDetailsPageApi - object-oriented interface
 * @export
 * @class ValidateLoanDetailsPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanDetailsPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan details page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanDetailsPageApi
     */
    public getLoanDetailsPageData(options?: any) {
        return ValidateLoanDetailsPageApiFp(this.configuration).getLoanDetailsPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan details page data
     * @param {ValidateLoanDetailsPageDataRequest} validateLoanDetailsPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanDetailsPageApi
     */
    public validateLoanDetailsPageData(validateLoanDetailsPageDataRequest: ValidateLoanDetailsPageDataRequest, options?: any) {
        return ValidateLoanDetailsPageApiFp(this.configuration).validateLoanDetailsPageData(validateLoanDetailsPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanDocumentPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanDocumentPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get  loan document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-document-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate adding identity data
         * @param {ValidateLoanAddIdentityRequest} validateLoanAddIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAddIdentityData(validateLoanAddIdentityRequest: ValidateLoanAddIdentityRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanAddIdentityRequest' is not null or undefined
            if (validateLoanAddIdentityRequest === null || validateLoanAddIdentityRequest === undefined) {
                throw new RequiredError('validateLoanAddIdentityRequest','Required parameter validateLoanAddIdentityRequest was null or undefined when calling validateLoanAddIdentityData.');
            }
            const localVarPath = `/validate-loan-document-page/add-identity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanAddIdentityRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanAddIdentityRequest !== undefined ? validateLoanAddIdentityRequest : {}) : (validateLoanAddIdentityRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan document page data
         * @param {ValidateLoanDocumentPageDataRequest} validateLoanDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanDocumentPageData(validateLoanDocumentPageDataRequest: ValidateLoanDocumentPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanDocumentPageDataRequest' is not null or undefined
            if (validateLoanDocumentPageDataRequest === null || validateLoanDocumentPageDataRequest === undefined) {
                throw new RequiredError('validateLoanDocumentPageDataRequest','Required parameter validateLoanDocumentPageDataRequest was null or undefined when calling validateLoanDocumentPageData.');
            }
            const localVarPath = `/validate-loan-document-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanDocumentPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanDocumentPageDataRequest !== undefined ? validateLoanDocumentPageDataRequest : {}) : (validateLoanDocumentPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanDocumentPageApi - functional programming interface
 * @export
 */
export const ValidateLoanDocumentPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get  loan document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDocumentPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanDocumentPageApiAxiosParamCreator(configuration).getLoanDocumentPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate adding identity data
         * @param {ValidateLoanAddIdentityRequest} validateLoanAddIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAddIdentityData(validateLoanAddIdentityRequest: ValidateLoanAddIdentityRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanAddIdentityResponse> {
            const localVarAxiosArgs = ValidateLoanDocumentPageApiAxiosParamCreator(configuration).validateLoanAddIdentityData(validateLoanAddIdentityRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan document page data
         * @param {ValidateLoanDocumentPageDataRequest} validateLoanDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanDocumentPageData(validateLoanDocumentPageDataRequest: ValidateLoanDocumentPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanDocumentPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanDocumentPageApiAxiosParamCreator(configuration).validateLoanDocumentPageData(validateLoanDocumentPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanDocumentPageApi - factory interface
 * @export
 */
export const ValidateLoanDocumentPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get  loan document page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanDocumentPageData(options?: any): AxiosPromise<LoanDocumentPageDataResponse> {
            return ValidateLoanDocumentPageApiFp(configuration).getLoanDocumentPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate adding identity data
         * @param {ValidateLoanAddIdentityRequest} validateLoanAddIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanAddIdentityData(validateLoanAddIdentityRequest: ValidateLoanAddIdentityRequest, options?: any): AxiosPromise<ValidateLoanAddIdentityResponse> {
            return ValidateLoanDocumentPageApiFp(configuration).validateLoanAddIdentityData(validateLoanAddIdentityRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan document page data
         * @param {ValidateLoanDocumentPageDataRequest} validateLoanDocumentPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanDocumentPageData(validateLoanDocumentPageDataRequest: ValidateLoanDocumentPageDataRequest, options?: any): AxiosPromise<ValidateLoanDocumentPageDataResponse> {
            return ValidateLoanDocumentPageApiFp(configuration).validateLoanDocumentPageData(validateLoanDocumentPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanDocumentPageApi - object-oriented interface
 * @export
 * @class ValidateLoanDocumentPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanDocumentPageApi extends BaseAPI {
    /**
     * 
     * @summary Get  loan document page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanDocumentPageApi
     */
    public getLoanDocumentPageData(options?: any) {
        return ValidateLoanDocumentPageApiFp(this.configuration).getLoanDocumentPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate adding identity data
     * @param {ValidateLoanAddIdentityRequest} validateLoanAddIdentityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanDocumentPageApi
     */
    public validateLoanAddIdentityData(validateLoanAddIdentityRequest: ValidateLoanAddIdentityRequest, options?: any) {
        return ValidateLoanDocumentPageApiFp(this.configuration).validateLoanAddIdentityData(validateLoanAddIdentityRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan document page data
     * @param {ValidateLoanDocumentPageDataRequest} validateLoanDocumentPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanDocumentPageApi
     */
    public validateLoanDocumentPageData(validateLoanDocumentPageDataRequest: ValidateLoanDocumentPageDataRequest, options?: any) {
        return ValidateLoanDocumentPageApiFp(this.configuration).validateLoanDocumentPageData(validateLoanDocumentPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanGoodsPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanGoodsPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan goods page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanGoodsPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-goods-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan goods page data
         * @param {ValidateLoanGoodsPageDataRequest} validateLoanGoodsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanGoodsPageData(validateLoanGoodsPageDataRequest: ValidateLoanGoodsPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanGoodsPageDataRequest' is not null or undefined
            if (validateLoanGoodsPageDataRequest === null || validateLoanGoodsPageDataRequest === undefined) {
                throw new RequiredError('validateLoanGoodsPageDataRequest','Required parameter validateLoanGoodsPageDataRequest was null or undefined when calling validateLoanGoodsPageData.');
            }
            const localVarPath = `/validate-loan-goods-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanGoodsPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanGoodsPageDataRequest !== undefined ? validateLoanGoodsPageDataRequest : {}) : (validateLoanGoodsPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanGoodsPageApi - functional programming interface
 * @export
 */
export const ValidateLoanGoodsPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan goods page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanGoodsPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanGoodsPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanGoodsPageApiAxiosParamCreator(configuration).getLoanGoodsPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan goods page data
         * @param {ValidateLoanGoodsPageDataRequest} validateLoanGoodsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanGoodsPageData(validateLoanGoodsPageDataRequest: ValidateLoanGoodsPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanGoodsPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanGoodsPageApiAxiosParamCreator(configuration).validateLoanGoodsPageData(validateLoanGoodsPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanGoodsPageApi - factory interface
 * @export
 */
export const ValidateLoanGoodsPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan goods page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanGoodsPageData(options?: any): AxiosPromise<LoanGoodsPageDataResponse> {
            return ValidateLoanGoodsPageApiFp(configuration).getLoanGoodsPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan goods page data
         * @param {ValidateLoanGoodsPageDataRequest} validateLoanGoodsPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanGoodsPageData(validateLoanGoodsPageDataRequest: ValidateLoanGoodsPageDataRequest, options?: any): AxiosPromise<ValidateLoanGoodsPageDataResponse> {
            return ValidateLoanGoodsPageApiFp(configuration).validateLoanGoodsPageData(validateLoanGoodsPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanGoodsPageApi - object-oriented interface
 * @export
 * @class ValidateLoanGoodsPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanGoodsPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan goods page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanGoodsPageApi
     */
    public getLoanGoodsPageData(options?: any) {
        return ValidateLoanGoodsPageApiFp(this.configuration).getLoanGoodsPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan goods page data
     * @param {ValidateLoanGoodsPageDataRequest} validateLoanGoodsPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanGoodsPageApi
     */
    public validateLoanGoodsPageData(validateLoanGoodsPageDataRequest: ValidateLoanGoodsPageDataRequest, options?: any) {
        return ValidateLoanGoodsPageApiFp(this.configuration).validateLoanGoodsPageData(validateLoanGoodsPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanGuarantorPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanGuarantorPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan guarantor page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanGuarantorPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-guarantor-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan guarantor page data
         * @param {ValidateLoanGuarantorPageDataRequest} validateLoanGuarantorPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest: ValidateLoanGuarantorPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanGuarantorPageDataRequest' is not null or undefined
            if (validateLoanGuarantorPageDataRequest === null || validateLoanGuarantorPageDataRequest === undefined) {
                throw new RequiredError('validateLoanGuarantorPageDataRequest','Required parameter validateLoanGuarantorPageDataRequest was null or undefined when calling validateLoanGuarantorPageData.');
            }
            const localVarPath = `/validate-loan-guarantor-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanGuarantorPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanGuarantorPageDataRequest !== undefined ? validateLoanGuarantorPageDataRequest : {}) : (validateLoanGuarantorPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanGuarantorPageApi - functional programming interface
 * @export
 */
export const ValidateLoanGuarantorPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan guarantor page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanGuarantorPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanGuarantorPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanGuarantorPageApiAxiosParamCreator(configuration).getLoanGuarantorPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan guarantor page data
         * @param {ValidateLoanGuarantorPageDataRequest} validateLoanGuarantorPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest: ValidateLoanGuarantorPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanGuarantorPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanGuarantorPageApiAxiosParamCreator(configuration).validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanGuarantorPageApi - factory interface
 * @export
 */
export const ValidateLoanGuarantorPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan guarantor page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanGuarantorPageData(options?: any): AxiosPromise<LoanGuarantorPageDataResponse> {
            return ValidateLoanGuarantorPageApiFp(configuration).getLoanGuarantorPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan guarantor page data
         * @param {ValidateLoanGuarantorPageDataRequest} validateLoanGuarantorPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest: ValidateLoanGuarantorPageDataRequest, options?: any): AxiosPromise<ValidateLoanGuarantorPageDataResponse> {
            return ValidateLoanGuarantorPageApiFp(configuration).validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanGuarantorPageApi - object-oriented interface
 * @export
 * @class ValidateLoanGuarantorPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanGuarantorPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan guarantor page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanGuarantorPageApi
     */
    public getLoanGuarantorPageData(options?: any) {
        return ValidateLoanGuarantorPageApiFp(this.configuration).getLoanGuarantorPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan guarantor page data
     * @param {ValidateLoanGuarantorPageDataRequest} validateLoanGuarantorPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanGuarantorPageApi
     */
    public validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest: ValidateLoanGuarantorPageDataRequest, options?: any) {
        return ValidateLoanGuarantorPageApiFp(this.configuration).validateLoanGuarantorPageData(validateLoanGuarantorPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanHolidayPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanHolidayPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan holiday page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanHolidayPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-holiday-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan holiday page data
         * @param {ValidateLoanHolidayPageDataRequest} validateLoanHolidayPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanHolidayPageData(validateLoanHolidayPageDataRequest: ValidateLoanHolidayPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanHolidayPageDataRequest' is not null or undefined
            if (validateLoanHolidayPageDataRequest === null || validateLoanHolidayPageDataRequest === undefined) {
                throw new RequiredError('validateLoanHolidayPageDataRequest','Required parameter validateLoanHolidayPageDataRequest was null or undefined when calling validateLoanHolidayPageData.');
            }
            const localVarPath = `/validate-loan-holiday-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanHolidayPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanHolidayPageDataRequest !== undefined ? validateLoanHolidayPageDataRequest : {}) : (validateLoanHolidayPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanHolidayPageApi - functional programming interface
 * @export
 */
export const ValidateLoanHolidayPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan holiday page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanHolidayPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanHolidayPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanHolidayPageApiAxiosParamCreator(configuration).getLoanHolidayPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan holiday page data
         * @param {ValidateLoanHolidayPageDataRequest} validateLoanHolidayPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanHolidayPageData(validateLoanHolidayPageDataRequest: ValidateLoanHolidayPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanHolidayPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanHolidayPageApiAxiosParamCreator(configuration).validateLoanHolidayPageData(validateLoanHolidayPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanHolidayPageApi - factory interface
 * @export
 */
export const ValidateLoanHolidayPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan holiday page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanHolidayPageData(options?: any): AxiosPromise<LoanHolidayPageDataResponse> {
            return ValidateLoanHolidayPageApiFp(configuration).getLoanHolidayPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan holiday page data
         * @param {ValidateLoanHolidayPageDataRequest} validateLoanHolidayPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanHolidayPageData(validateLoanHolidayPageDataRequest: ValidateLoanHolidayPageDataRequest, options?: any): AxiosPromise<ValidateLoanHolidayPageDataResponse> {
            return ValidateLoanHolidayPageApiFp(configuration).validateLoanHolidayPageData(validateLoanHolidayPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanHolidayPageApi - object-oriented interface
 * @export
 * @class ValidateLoanHolidayPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanHolidayPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan holiday page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanHolidayPageApi
     */
    public getLoanHolidayPageData(options?: any) {
        return ValidateLoanHolidayPageApiFp(this.configuration).getLoanHolidayPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan holiday page data
     * @param {ValidateLoanHolidayPageDataRequest} validateLoanHolidayPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanHolidayPageApi
     */
    public validateLoanHolidayPageData(validateLoanHolidayPageDataRequest: ValidateLoanHolidayPageDataRequest, options?: any) {
        return ValidateLoanHolidayPageApiFp(this.configuration).validateLoanHolidayPageData(validateLoanHolidayPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanIndividualPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanIndividualPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanIndividualPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-individual-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate individual loan page data
         * @param {ValidateLoanIndividualPageDataRequest} validateLoanIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanIndividualPageData(validateLoanIndividualPageDataRequest: ValidateLoanIndividualPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanIndividualPageDataRequest' is not null or undefined
            if (validateLoanIndividualPageDataRequest === null || validateLoanIndividualPageDataRequest === undefined) {
                throw new RequiredError('validateLoanIndividualPageDataRequest','Required parameter validateLoanIndividualPageDataRequest was null or undefined when calling validateLoanIndividualPageData.');
            }
            const localVarPath = `/validate-loan-individual-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanIndividualPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanIndividualPageDataRequest !== undefined ? validateLoanIndividualPageDataRequest : {}) : (validateLoanIndividualPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan individual page data for customer change
         * @param {ValidateLoanIndividualPageCustomerChangeRequest} validateLoanIndividualPageCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest: ValidateLoanIndividualPageCustomerChangeRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanIndividualPageCustomerChangeRequest' is not null or undefined
            if (validateLoanIndividualPageCustomerChangeRequest === null || validateLoanIndividualPageCustomerChangeRequest === undefined) {
                throw new RequiredError('validateLoanIndividualPageCustomerChangeRequest','Required parameter validateLoanIndividualPageCustomerChangeRequest was null or undefined when calling validateLoanIndividualPageDataForCustomerChange.');
            }
            const localVarPath = `/validate-loan-individual-page/is-customer-changed`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanIndividualPageCustomerChangeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanIndividualPageCustomerChangeRequest !== undefined ? validateLoanIndividualPageCustomerChangeRequest : {}) : (validateLoanIndividualPageCustomerChangeRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanIndividualPageApi - functional programming interface
 * @export
 */
export const ValidateLoanIndividualPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanIndividualPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanIndividualPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanIndividualPageApiAxiosParamCreator(configuration).getLoanIndividualPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate individual loan page data
         * @param {ValidateLoanIndividualPageDataRequest} validateLoanIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanIndividualPageData(validateLoanIndividualPageDataRequest: ValidateLoanIndividualPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanIndividualPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanIndividualPageApiAxiosParamCreator(configuration).validateLoanIndividualPageData(validateLoanIndividualPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan individual page data for customer change
         * @param {ValidateLoanIndividualPageCustomerChangeRequest} validateLoanIndividualPageCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest: ValidateLoanIndividualPageCustomerChangeRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanIndividualPageCustomerChangeResponse> {
            const localVarAxiosArgs = ValidateLoanIndividualPageApiAxiosParamCreator(configuration).validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanIndividualPageApi - factory interface
 * @export
 */
export const ValidateLoanIndividualPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan individual page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanIndividualPageData(options?: any): AxiosPromise<LoanIndividualPageDataResponse> {
            return ValidateLoanIndividualPageApiFp(configuration).getLoanIndividualPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate individual loan page data
         * @param {ValidateLoanIndividualPageDataRequest} validateLoanIndividualPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanIndividualPageData(validateLoanIndividualPageDataRequest: ValidateLoanIndividualPageDataRequest, options?: any): AxiosPromise<ValidateLoanIndividualPageDataResponse> {
            return ValidateLoanIndividualPageApiFp(configuration).validateLoanIndividualPageData(validateLoanIndividualPageDataRequest, options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan individual page data for customer change
         * @param {ValidateLoanIndividualPageCustomerChangeRequest} validateLoanIndividualPageCustomerChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest: ValidateLoanIndividualPageCustomerChangeRequest, options?: any): AxiosPromise<ValidateLoanIndividualPageCustomerChangeResponse> {
            return ValidateLoanIndividualPageApiFp(configuration).validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanIndividualPageApi - object-oriented interface
 * @export
 * @class ValidateLoanIndividualPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanIndividualPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan individual page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanIndividualPageApi
     */
    public getLoanIndividualPageData(options?: any) {
        return ValidateLoanIndividualPageApiFp(this.configuration).getLoanIndividualPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate individual loan page data
     * @param {ValidateLoanIndividualPageDataRequest} validateLoanIndividualPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanIndividualPageApi
     */
    public validateLoanIndividualPageData(validateLoanIndividualPageDataRequest: ValidateLoanIndividualPageDataRequest, options?: any) {
        return ValidateLoanIndividualPageApiFp(this.configuration).validateLoanIndividualPageData(validateLoanIndividualPageDataRequest, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan individual page data for customer change
     * @param {ValidateLoanIndividualPageCustomerChangeRequest} validateLoanIndividualPageCustomerChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanIndividualPageApi
     */
    public validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest: ValidateLoanIndividualPageCustomerChangeRequest, options?: any) {
        return ValidateLoanIndividualPageApiFp(this.configuration).validateLoanIndividualPageDataForCustomerChange(validateLoanIndividualPageCustomerChangeRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanInsurancePageApi - axios parameter creator
 * @export
 */
export const ValidateLoanInsurancePageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan insurance page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanInsurancePageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-insurance-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan insurance page data
         * @param {ValidateLoanInsurancePageDataRequest} validateLoanInsurancePageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanInsurancePageData(validateLoanInsurancePageDataRequest: ValidateLoanInsurancePageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanInsurancePageDataRequest' is not null or undefined
            if (validateLoanInsurancePageDataRequest === null || validateLoanInsurancePageDataRequest === undefined) {
                throw new RequiredError('validateLoanInsurancePageDataRequest','Required parameter validateLoanInsurancePageDataRequest was null or undefined when calling validateLoanInsurancePageData.');
            }
            const localVarPath = `/validate-loan-insurance-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanInsurancePageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanInsurancePageDataRequest !== undefined ? validateLoanInsurancePageDataRequest : {}) : (validateLoanInsurancePageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanInsurancePageApi - functional programming interface
 * @export
 */
export const ValidateLoanInsurancePageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan insurance page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanInsurancePageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanInsurancePageDataResponse> {
            const localVarAxiosArgs = ValidateLoanInsurancePageApiAxiosParamCreator(configuration).getLoanInsurancePageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan insurance page data
         * @param {ValidateLoanInsurancePageDataRequest} validateLoanInsurancePageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanInsurancePageData(validateLoanInsurancePageDataRequest: ValidateLoanInsurancePageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanInsurancePageDataResponse> {
            const localVarAxiosArgs = ValidateLoanInsurancePageApiAxiosParamCreator(configuration).validateLoanInsurancePageData(validateLoanInsurancePageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanInsurancePageApi - factory interface
 * @export
 */
export const ValidateLoanInsurancePageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan insurance page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanInsurancePageData(options?: any): AxiosPromise<LoanInsurancePageDataResponse> {
            return ValidateLoanInsurancePageApiFp(configuration).getLoanInsurancePageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan insurance page data
         * @param {ValidateLoanInsurancePageDataRequest} validateLoanInsurancePageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanInsurancePageData(validateLoanInsurancePageDataRequest: ValidateLoanInsurancePageDataRequest, options?: any): AxiosPromise<ValidateLoanInsurancePageDataResponse> {
            return ValidateLoanInsurancePageApiFp(configuration).validateLoanInsurancePageData(validateLoanInsurancePageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanInsurancePageApi - object-oriented interface
 * @export
 * @class ValidateLoanInsurancePageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanInsurancePageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan insurance page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanInsurancePageApi
     */
    public getLoanInsurancePageData(options?: any) {
        return ValidateLoanInsurancePageApiFp(this.configuration).getLoanInsurancePageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan insurance page data
     * @param {ValidateLoanInsurancePageDataRequest} validateLoanInsurancePageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanInsurancePageApi
     */
    public validateLoanInsurancePageData(validateLoanInsurancePageDataRequest: ValidateLoanInsurancePageDataRequest, options?: any) {
        return ValidateLoanInsurancePageApiFp(this.configuration).validateLoanInsurancePageData(validateLoanInsurancePageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanScoringJobPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanScoringJobPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan scoring job page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanScoringJobPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-scoring-job-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan scoring job page data
         * @param {ValidateLoanScoringJobPageDataRequest} validateLoanScoringJobPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest: ValidateLoanScoringJobPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanScoringJobPageDataRequest' is not null or undefined
            if (validateLoanScoringJobPageDataRequest === null || validateLoanScoringJobPageDataRequest === undefined) {
                throw new RequiredError('validateLoanScoringJobPageDataRequest','Required parameter validateLoanScoringJobPageDataRequest was null or undefined when calling validateLoanScoringJobPageData.');
            }
            const localVarPath = `/validate-loan-scoring-job-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanScoringJobPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanScoringJobPageDataRequest !== undefined ? validateLoanScoringJobPageDataRequest : {}) : (validateLoanScoringJobPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanScoringJobPageApi - functional programming interface
 * @export
 */
export const ValidateLoanScoringJobPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan scoring job page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanScoringJobPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanScoringJobPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanScoringJobPageApiAxiosParamCreator(configuration).getLoanScoringJobPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan scoring job page data
         * @param {ValidateLoanScoringJobPageDataRequest} validateLoanScoringJobPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest: ValidateLoanScoringJobPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanScoringJobPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanScoringJobPageApiAxiosParamCreator(configuration).validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanScoringJobPageApi - factory interface
 * @export
 */
export const ValidateLoanScoringJobPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan scoring job page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanScoringJobPageData(options?: any): AxiosPromise<LoanScoringJobPageDataResponse> {
            return ValidateLoanScoringJobPageApiFp(configuration).getLoanScoringJobPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan scoring job page data
         * @param {ValidateLoanScoringJobPageDataRequest} validateLoanScoringJobPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest: ValidateLoanScoringJobPageDataRequest, options?: any): AxiosPromise<ValidateLoanScoringJobPageDataResponse> {
            return ValidateLoanScoringJobPageApiFp(configuration).validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanScoringJobPageApi - object-oriented interface
 * @export
 * @class ValidateLoanScoringJobPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanScoringJobPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan scoring job page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanScoringJobPageApi
     */
    public getLoanScoringJobPageData(options?: any) {
        return ValidateLoanScoringJobPageApiFp(this.configuration).getLoanScoringJobPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan scoring job page data
     * @param {ValidateLoanScoringJobPageDataRequest} validateLoanScoringJobPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanScoringJobPageApi
     */
    public validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest: ValidateLoanScoringJobPageDataRequest, options?: any) {
        return ValidateLoanScoringJobPageApiFp(this.configuration).validateLoanScoringJobPageData(validateLoanScoringJobPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanSummaryConfirmationPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanSummaryConfirmationPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate loan summary confirmation page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanSummaryPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-summary-confirmation-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanSummaryConfirmationPageApi - functional programming interface
 * @export
 */
export const ValidateLoanSummaryConfirmationPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate loan summary confirmation page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanSummaryPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanSummaryConfirmationPageResponse> {
            const localVarAxiosArgs = ValidateLoanSummaryConfirmationPageApiAxiosParamCreator(configuration).validateLoanSummaryPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanSummaryConfirmationPageApi - factory interface
 * @export
 */
export const ValidateLoanSummaryConfirmationPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Validate loan summary confirmation page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanSummaryPageData(options?: any): AxiosPromise<ValidateLoanSummaryConfirmationPageResponse> {
            return ValidateLoanSummaryConfirmationPageApiFp(configuration).validateLoanSummaryPageData(options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanSummaryConfirmationPageApi - object-oriented interface
 * @export
 * @class ValidateLoanSummaryConfirmationPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanSummaryConfirmationPageApi extends BaseAPI {
    /**
     * 
     * @summary Validate loan summary confirmation page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanSummaryConfirmationPageApi
     */
    public validateLoanSummaryPageData(options?: any) {
        return ValidateLoanSummaryConfirmationPageApiFp(this.configuration).validateLoanSummaryPageData(options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanTaxInfoPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanTaxInfoPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan tax info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanTaxInfoPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-tax-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan tax info page data
         * @param {ValidateLoanTaxInfoPageDataRequest} validateLoanTaxInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest: ValidateLoanTaxInfoPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanTaxInfoPageDataRequest' is not null or undefined
            if (validateLoanTaxInfoPageDataRequest === null || validateLoanTaxInfoPageDataRequest === undefined) {
                throw new RequiredError('validateLoanTaxInfoPageDataRequest','Required parameter validateLoanTaxInfoPageDataRequest was null or undefined when calling validateLoanTaxInfoPageData.');
            }
            const localVarPath = `/validate-loan-tax-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanTaxInfoPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanTaxInfoPageDataRequest !== undefined ? validateLoanTaxInfoPageDataRequest : {}) : (validateLoanTaxInfoPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanTaxInfoPageApi - functional programming interface
 * @export
 */
export const ValidateLoanTaxInfoPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan tax info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanTaxInfoPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanTaxInfoPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanTaxInfoPageApiAxiosParamCreator(configuration).getLoanTaxInfoPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan tax info page data
         * @param {ValidateLoanTaxInfoPageDataRequest} validateLoanTaxInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest: ValidateLoanTaxInfoPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanTaxInfoPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanTaxInfoPageApiAxiosParamCreator(configuration).validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanTaxInfoPageApi - factory interface
 * @export
 */
export const ValidateLoanTaxInfoPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan tax info page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanTaxInfoPageData(options?: any): AxiosPromise<LoanTaxInfoPageDataResponse> {
            return ValidateLoanTaxInfoPageApiFp(configuration).getLoanTaxInfoPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan tax info page data
         * @param {ValidateLoanTaxInfoPageDataRequest} validateLoanTaxInfoPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest: ValidateLoanTaxInfoPageDataRequest, options?: any): AxiosPromise<ValidateLoanTaxInfoPageDataResponse> {
            return ValidateLoanTaxInfoPageApiFp(configuration).validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanTaxInfoPageApi - object-oriented interface
 * @export
 * @class ValidateLoanTaxInfoPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanTaxInfoPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan tax info page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanTaxInfoPageApi
     */
    public getLoanTaxInfoPageData(options?: any) {
        return ValidateLoanTaxInfoPageApiFp(this.configuration).getLoanTaxInfoPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan tax info page data
     * @param {ValidateLoanTaxInfoPageDataRequest} validateLoanTaxInfoPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanTaxInfoPageApi
     */
    public validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest: ValidateLoanTaxInfoPageDataRequest, options?: any) {
        return ValidateLoanTaxInfoPageApiFp(this.configuration).validateLoanTaxInfoPageData(validateLoanTaxInfoPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanTotalCostPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanTotalCostPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan total cost page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanTotalCostPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-total-cost-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan total cost page data
         * @param {ValidateLoanTotalCostPageDataRequest} validateLoanTotalCostPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest: ValidateLoanTotalCostPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanTotalCostPageDataRequest' is not null or undefined
            if (validateLoanTotalCostPageDataRequest === null || validateLoanTotalCostPageDataRequest === undefined) {
                throw new RequiredError('validateLoanTotalCostPageDataRequest','Required parameter validateLoanTotalCostPageDataRequest was null or undefined when calling validateLoanTotalCostPageData.');
            }
            const localVarPath = `/validate-loan-total-cost-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanTotalCostPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanTotalCostPageDataRequest !== undefined ? validateLoanTotalCostPageDataRequest : {}) : (validateLoanTotalCostPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanTotalCostPageApi - functional programming interface
 * @export
 */
export const ValidateLoanTotalCostPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan total cost page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanTotalCostPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanTotalCostPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanTotalCostPageApiAxiosParamCreator(configuration).getLoanTotalCostPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan total cost page data
         * @param {ValidateLoanTotalCostPageDataRequest} validateLoanTotalCostPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest: ValidateLoanTotalCostPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanTotalCostPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanTotalCostPageApiAxiosParamCreator(configuration).validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanTotalCostPageApi - factory interface
 * @export
 */
export const ValidateLoanTotalCostPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan total cost page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanTotalCostPageData(options?: any): AxiosPromise<LoanTotalCostPageDataResponse> {
            return ValidateLoanTotalCostPageApiFp(configuration).getLoanTotalCostPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan total cost page data
         * @param {ValidateLoanTotalCostPageDataRequest} validateLoanTotalCostPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest: ValidateLoanTotalCostPageDataRequest, options?: any): AxiosPromise<ValidateLoanTotalCostPageDataResponse> {
            return ValidateLoanTotalCostPageApiFp(configuration).validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanTotalCostPageApi - object-oriented interface
 * @export
 * @class ValidateLoanTotalCostPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanTotalCostPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan total cost page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanTotalCostPageApi
     */
    public getLoanTotalCostPageData(options?: any) {
        return ValidateLoanTotalCostPageApiFp(this.configuration).getLoanTotalCostPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan total cost page data
     * @param {ValidateLoanTotalCostPageDataRequest} validateLoanTotalCostPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanTotalCostPageApi
     */
    public validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest: ValidateLoanTotalCostPageDataRequest, options?: any) {
        return ValidateLoanTotalCostPageApiFp(this.configuration).validateLoanTotalCostPageData(validateLoanTotalCostPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ValidateLoanVehicleInformationPageApi - axios parameter creator
 * @export
 */
export const ValidateLoanVehicleInformationPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan vehicle information page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanVehicleInformationPageData(options: any = {}): RequestArgs {
            const localVarPath = `/validate-loan-vehicle-information-page/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate loan vehicle information page data
         * @param {ValidateLoanVehicleInformationPageDataRequest} validateLoanVehicleInformationPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest: ValidateLoanVehicleInformationPageDataRequest, options: any = {}): RequestArgs {
            // verify required parameter 'validateLoanVehicleInformationPageDataRequest' is not null or undefined
            if (validateLoanVehicleInformationPageDataRequest === null || validateLoanVehicleInformationPageDataRequest === undefined) {
                throw new RequiredError('validateLoanVehicleInformationPageDataRequest','Required parameter validateLoanVehicleInformationPageDataRequest was null or undefined when calling validateLoanVehicleInformationPageData.');
            }
            const localVarPath = `/validate-loan-vehicle-information-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validateLoanVehicleInformationPageDataRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validateLoanVehicleInformationPageDataRequest !== undefined ? validateLoanVehicleInformationPageDataRequest : {}) : (validateLoanVehicleInformationPageDataRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateLoanVehicleInformationPageApi - functional programming interface
 * @export
 */
export const ValidateLoanVehicleInformationPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loan vehicle information page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanVehicleInformationPageData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanVehicleInformationPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanVehicleInformationPageApiAxiosParamCreator(configuration).getLoanVehicleInformationPageData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate loan vehicle information page data
         * @param {ValidateLoanVehicleInformationPageDataRequest} validateLoanVehicleInformationPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest: ValidateLoanVehicleInformationPageDataRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLoanVehicleInformationPageDataResponse> {
            const localVarAxiosArgs = ValidateLoanVehicleInformationPageApiAxiosParamCreator(configuration).validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateLoanVehicleInformationPageApi - factory interface
 * @export
 */
export const ValidateLoanVehicleInformationPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get loan vehicle information page data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanVehicleInformationPageData(options?: any): AxiosPromise<LoanVehicleInformationPageDataResponse> {
            return ValidateLoanVehicleInformationPageApiFp(configuration).getLoanVehicleInformationPageData(options)(axios, basePath);
        },
        /**
         * 
         * @summary Validate loan vehicle information page data
         * @param {ValidateLoanVehicleInformationPageDataRequest} validateLoanVehicleInformationPageDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest: ValidateLoanVehicleInformationPageDataRequest, options?: any): AxiosPromise<ValidateLoanVehicleInformationPageDataResponse> {
            return ValidateLoanVehicleInformationPageApiFp(configuration).validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest, options)(axios, basePath);
        },
    };
};

/**
 * ValidateLoanVehicleInformationPageApi - object-oriented interface
 * @export
 * @class ValidateLoanVehicleInformationPageApi
 * @extends {BaseAPI}
 */
export class ValidateLoanVehicleInformationPageApi extends BaseAPI {
    /**
     * 
     * @summary Get loan vehicle information page data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanVehicleInformationPageApi
     */
    public getLoanVehicleInformationPageData(options?: any) {
        return ValidateLoanVehicleInformationPageApiFp(this.configuration).getLoanVehicleInformationPageData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Validate loan vehicle information page data
     * @param {ValidateLoanVehicleInformationPageDataRequest} validateLoanVehicleInformationPageDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateLoanVehicleInformationPageApi
     */
    public validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest: ValidateLoanVehicleInformationPageDataRequest, options?: any) {
        return ValidateLoanVehicleInformationPageApiFp(this.configuration).validateLoanVehicleInformationPageData(validateLoanVehicleInformationPageDataRequest, options)(this.axios, this.basePath);
    }

}


/**
 * ViewCreditsApi - axios parameter creator
 * @export
 */
export const ViewCreditsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Credits and Details
         * @param {ViewCreditsDetailsRequest} viewCreditsDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditsDetails(viewCreditsDetailsRequest: ViewCreditsDetailsRequest, options: any = {}): RequestArgs {
            // verify required parameter 'viewCreditsDetailsRequest' is not null or undefined
            if (viewCreditsDetailsRequest === null || viewCreditsDetailsRequest === undefined) {
                throw new RequiredError('viewCreditsDetailsRequest','Required parameter viewCreditsDetailsRequest was null or undefined when calling getCreditsDetails.');
            }
            const localVarPath = `/view-credits/details`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof viewCreditsDetailsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(viewCreditsDetailsRequest !== undefined ? viewCreditsDetailsRequest : {}) : (viewCreditsDetailsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewCreditsApi - functional programming interface
 * @export
 */
export const ViewCreditsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Credits and Details
         * @param {ViewCreditsDetailsRequest} viewCreditsDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditsDetails(viewCreditsDetailsRequest: ViewCreditsDetailsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewCreditsDetailsResponse> {
            const localVarAxiosArgs = ViewCreditsApiAxiosParamCreator(configuration).getCreditsDetails(viewCreditsDetailsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ViewCreditsApi - factory interface
 * @export
 */
export const ViewCreditsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Credits and Details
         * @param {ViewCreditsDetailsRequest} viewCreditsDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditsDetails(viewCreditsDetailsRequest: ViewCreditsDetailsRequest, options?: any): AxiosPromise<ViewCreditsDetailsResponse> {
            return ViewCreditsApiFp(configuration).getCreditsDetails(viewCreditsDetailsRequest, options)(axios, basePath);
        },
    };
};

/**
 * ViewCreditsApi - object-oriented interface
 * @export
 * @class ViewCreditsApi
 * @extends {BaseAPI}
 */
export class ViewCreditsApi extends BaseAPI {
    /**
     * 
     * @summary Get Credits and Details
     * @param {ViewCreditsDetailsRequest} viewCreditsDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewCreditsApi
     */
    public getCreditsDetails(viewCreditsDetailsRequest: ViewCreditsDetailsRequest, options?: any) {
        return ViewCreditsApiFp(this.configuration).getCreditsDetails(viewCreditsDetailsRequest, options)(this.axios, this.basePath);
    }

}


